/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Foundational REST API
 * REST API for the Foundational Data Model
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customFetch } from './custom-fetcher';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

/**
 * Another suggestion for the prompt, as Review draft's pop-up and the
 * cards name it.
 */
export interface IncorporationSuggestion {
  id: number;
  theme_title: string;
  theme_description: string;
}

/**
 * A shipped suggestion with its org x prompt edit rates when drafted
 * (baseline) and now (Eval Results' last 90 days).
 */
export interface AcceptedPromptSuggestion {
  id: number;
  organization_id: number;
  organization_name: string;
  prompt_key: string;
  prompt_name: string;
  theme_title: string;
  /** @nullable */
  shipped_at: string | null;
  pipelines_pr_url: string;
  api_django_pr_url: string;
  /** @nullable */
  baseline_pct_fields_edited: number | null;
  /** @nullable */
  baseline_avg_edit_percentage: number | null;
  /** @nullable */
  baseline_sample_size: number | null;
  /** @nullable */
  readonly current_pct_fields_edited: number | null;
  /** @nullable */
  readonly current_avg_edit_percentage: number | null;
  /** @nullable */
  readonly current_sample_size: number | null;
  /** @nullable */
  readonly current_computed_at: string | null;
  readonly incorporated: readonly IncorporationSuggestion[];
}

export interface AddFieldInput {
  template_id: number;
  section_id: number;
  field_identifier: string;
  title?: string;
  field_type: string;
  /** @nullable */
  rank_order?: number | null;
  /** @nullable */
  content?: string | null;
  is_required?: boolean;
  /** @nullable */
  input_dependency?: string[] | null;
  /** @nullable */
  prompt_id?: number | null;
  /** @nullable */
  table_key?: string | null;
  /** @nullable */
  sample_data?: string | null;
}

export interface AddSectionInput {
  template_id: number;
  /** @nullable */
  key?: string | null;
  title?: string;
  page_location: string;
  /** @nullable */
  rank_order?: number | null;
  /** @nullable */
  input_dependency?: string[] | null;
}

/**
 * * `FRONTERA_HEALTH` - FRONTERA_HEALTH
 * * `PASSAGE_HEALTH` - PASSAGE_HEALTH
 * * `ARTEMIS` - ARTEMIS
 * * `THERAPZ` - THERAPZ
 * * `HI_RASMUS` - HI_RASMUS
 * * `MOTIVITY` - MOTIVITY
 * * `CENTRAL_REACH` - CENTRAL_REACH
 * * `MEASUREPM` - MEASUREPM
 * * `ENSORA` - ENSORA
 * * `FRONTERA_CLARITY` - FRONTERA_CLARITY
 * * `HIPP_HEALTH` - HIPP_HEALTH
 * * `RETHINK` - RETHINK
 * * `FRONTERA_EHR` - FRONTERA_EHR
 */
export type OrganizationTypeEnum = typeof OrganizationTypeEnum[keyof typeof OrganizationTypeEnum];


export const OrganizationTypeEnum = {
  FRONTERA_HEALTH: 'FRONTERA_HEALTH',
  PASSAGE_HEALTH: 'PASSAGE_HEALTH',
  ARTEMIS: 'ARTEMIS',
  THERAPZ: 'THERAPZ',
  HI_RASMUS: 'HI_RASMUS',
  MOTIVITY: 'MOTIVITY',
  CENTRAL_REACH: 'CENTRAL_REACH',
  MEASUREPM: 'MEASUREPM',
  ENSORA: 'ENSORA',
  FRONTERA_CLARITY: 'FRONTERA_CLARITY',
  HIPP_HEALTH: 'HIPP_HEALTH',
  RETHINK: 'RETHINK',
  FRONTERA_EHR: 'FRONTERA_EHR',
} as const;

/**
 * * `username_password` - username_password
 * * `google_oauth` - google_oauth
 */
export type ConnectionTypeEnum = typeof ConnectionTypeEnum[keyof typeof ConnectionTypeEnum];


export const ConnectionTypeEnum = {
  username_password: 'username_password',
  google_oauth: 'google_oauth',
} as const;

export interface ApproveClinicListingRequestInput {
  clinic_listing_id: string;
  org_id?: string;
  name?: string;
  /** @nullable */
  display_name?: string | null;
  organization_type?: OrganizationTypeEnum;
  /** @nullable */
  hubspot_company_id?: string | null;
  /** @nullable */
  logo_url?: string | null;
  /** @nullable */
  primary_color?: string | null;
  /** @nullable */
  background_color?: string | null;
  connection_types?: ConnectionTypeEnum[];
}

/**
 * * `baseline` - baseline
 * * `candidate` - candidate
 */
export type ArmEnum = typeof ArmEnum[keyof typeof ArmEnum];


export const ArmEnum = {
  baseline: 'baseline',
  candidate: 'candidate',
} as const;

/**
 * * `Official Scoring File` - Official Scoring File
 * * `Frontera Health Template` - Frontera Health Template
 * * `Custom Template` - Custom Template
 */
export type AssessmentTemplateTypeEnum = typeof AssessmentTemplateTypeEnum[keyof typeof AssessmentTemplateTypeEnum];


export const AssessmentTemplateTypeEnum = {
  Official_Scoring_File: 'Official Scoring File',
  Frontera_Health_Template: 'Frontera Health Template',
  Custom_Template: 'Custom Template',
} as const;

export interface Auth0Role {
  id: string;
  name: string;
}

export interface AutocompleteResults {
  place_id: string;
  address: string;
}

export interface AvailableInputsOutput {
  inputs: unknown[];
}

export interface AvailableModel {
  id: string;
  label: string;
  provider: string;
  is_default: boolean;
}

export interface BaseQACriteriaItem {
  id: number;
  name: string;
  category: string;
  content: string;
}

export interface BasecampAutocompleteResults {
  place_id: string;
  address: string;
}

export interface BasecampGetGoogleMapsAutocompleteResultsOutput {
  results: BasecampAutocompleteResults[];
}

export interface BasecampGetPlaceMetadataOutput {
  formatted_address: string;
}

export type BlankEnum = typeof BlankEnum[keyof typeof BlankEnum];


export const BlankEnum = {
  '': '',
} as const;

export interface StagingClinicListingRecordInput {
  run_id: string;
  name: string;
  address_str: string;
  /** @nullable */
  google_place_id?: string | null;
  /** @nullable */
  phone_number?: string | null;
  /** @nullable */
  website_url?: string | null;
  /** @nullable */
  google_rating?: number | null;
  /** @nullable */
  google_review_count?: number | null;
  /** @nullable */
  latitude?: number | null;
  /** @nullable */
  longitude?: number | null;
}

export interface BulkInsertStagingClinicListingInput {
  records: StagingClinicListingRecordInput[];
}

export type BulkInsertStagingClinicListingOutputFailedItem = {[key: string]: unknown};

export interface StagingClinicListingLocation {
  id: number;
  address_line_1: string;
  /** @nullable */
  address_line_2?: string | null;
  city: string;
  state: string;
  postal_code: string;
}

export interface ClinicListingStaging {
  id: number;
  name: string;
  /** @nullable */
  google_place_id?: string | null;
  /** @nullable */
  website_url?: string | null;
  /** @nullable */
  phone_number?: string | null;
  /** @nullable */
  google_rating?: number | null;
  /** @nullable */
  google_review_count?: number | null;
  location: StagingClinicListingLocation | null;
}

export interface BulkInsertStagingClinicListingOutput {
  created: ClinicListingStaging[];
  existing: ClinicListingStaging[];
  failed: BulkInsertStagingClinicListingOutputFailedItem[];
}

export interface CancelClinicListingVerificationInput {
  /** This is the graphql encoded ID */
  clinic_listing_id: string;
}

export interface CareNavCoverageEligibilityInput {
  /**
     * @minLength 5
     * @maxLength 10
     */
  postal_code: string;
}

export interface CareNavCoverageEligibilityOutput {
  postal_code: string;
  status: string;
}

export interface ClinicListingLocation {
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
}

export interface ClinicListing {
  public_id: string;
  name: string;
  website_url: string;
  phone_number: string;
  verification_status: string;
  location: ClinicListingLocation;
}

export interface ClinicLead {
  public_id: string;
  created_date: string;
  readonly requested_modality_types: readonly unknown[];
  readonly requested_service_types: readonly unknown[];
  payor: string;
  clinic_listing: ClinicListing;
  readonly location: string;
}

export interface CloneInput {
  name?: string;
  /** @nullable */
  organization_id?: number | null;
  /** @nullable */
  scoped_prompt_key?: string | null;
}

export interface CommunityEventDetailOutput {
  circle_event_id: string;
  /** @nullable */
  circle_space_id: string | null;
  name: string;
  /** @nullable */
  starts_at: string | null;
  /** @nullable */
  url: string | null;
}

export interface CommunityPreviewPostsOutput {
  id: number;
  space_id: number;
  title: string;
  space_name: string;
  comment_count: number;
  author_name: string;
}

export interface CommunityUpcomingEventsOutput {
  circle_event_id: string;
  /** @nullable */
  circle_space_id: string | null;
  name: string;
  /** @nullable */
  starts_at: string | null;
  /** @nullable */
  ends_at: string | null;
  /** @nullable */
  url: string | null;
  /** @nullable */
  cover_image_url: string | null;
  /** @nullable */
  location_type: string | null;
  /** @nullable */
  virtual_location_url: string | null;
  /** @nullable */
  in_person_location: string | null;
  /** @nullable */
  location_text: string | null;
}

/**
 * * `pending` - pending
 * * `running` - running
 * * `complete` - complete
 * * `failed` - failed
 */
export type PairwiseStatusEnum = typeof PairwiseStatusEnum[keyof typeof PairwiseStatusEnum];


export const PairwiseStatusEnum = {
  pending: 'pending',
  running: 'running',
  complete: 'complete',
  failed: 'failed',
} as const;

export const ComparisonFieldPairwiseStatus = {...PairwiseStatusEnum,} as const
/**
 * * `same` - same
 * * `better` - better
 * * `worse` - worse
 * * `unsure` - unsure
 */
export type PairwiseVerdictEnum = typeof PairwiseVerdictEnum[keyof typeof PairwiseVerdictEnum];


export const PairwiseVerdictEnum = {
  same: 'same',
  better: 'better',
  worse: 'worse',
  unsure: 'unsure',
} as const;

export const ComparisonFieldPairwiseVerdict = {...PairwiseVerdictEnum,} as const
export interface EvalCheckResult {
  metric_name: string;
  metric_type: string;
  score: number;
  /** @nullable */
  passed: boolean | null;
  reason: string;
  /** @nullable */
  threshold: number | null;
  details: unknown;
  spans: string[];
}

/**
 * One arm of one field: enough to render output + checks side by side.
 */
export interface ComparisonRun {
  run_id: number;
  status: string;
  /** @nullable */
  result: string | null;
  model: string;
  check_results: EvalCheckResult[];
}

export interface ComparisonPick {
  winner: string;
  note: string;
}

export type NullEnum = typeof NullEnum[keyof typeof NullEnum];


export const NullEnum = {
} as const;

/**
 * * `format` - format
 * * `instruction` - instruction
 * * `missing` - missing
 * * `changed` - changed
 * * `added` - added
 * * `contradicts_source` - contradicts_source
 * * `wording` - wording
 */
export type PairwiseDifferenceKindEnum = typeof PairwiseDifferenceKindEnum[keyof typeof PairwiseDifferenceKindEnum];


export const PairwiseDifferenceKindEnum = {
  format: 'format',
  instruction: 'instruction',
  missing: 'missing',
  changed: 'changed',
  added: 'added',
  contradicts_source: 'contradicts_source',
  wording: 'wording',
} as const;

/**
 * * `worse` - worse
 * * `better` - better
 * * `neutral` - neutral
 */
export type EffectEnum = typeof EffectEnum[keyof typeof EffectEnum];


export const EffectEnum = {
  worse: 'worse',
  better: 'better',
  neutral: 'neutral',
} as const;

/**
 * * `material` - material
 * * `minor` - minor
 */
export type SeverityEnum = typeof SeverityEnum[keyof typeof SeverityEnum];


export const SeverityEnum = {
  material: 'material',
  minor: 'minor',
} as const;

export const PairwiseDifferenceEffect = {...EffectEnum,} as const
export const PairwiseDifferenceSeverity = {...SeverityEnum,} as const
export interface PairwiseDifference {
  kind: PairwiseDifferenceKindEnum;
  effect: typeof PairwiseDifferenceEffect[keyof typeof PairwiseDifferenceEffect] | null;
  severity: typeof PairwiseDifferenceSeverity[keyof typeof PairwiseDifferenceSeverity] | null;
  /** @nullable */
  current_quote: string | null;
  /** @nullable */
  candidate_quote: string | null;
  explanation: string;
}

export interface ComparisonField {
  prompt_key: string;
  field_identifier: string;
  field_title: string;
  page_location?: string;
  baseline: ComparisonRun | null;
  candidate: ComparisonRun | null;
  pick: ComparisonPick | null;
  needs_review: boolean;
  pairwise_status: typeof ComparisonFieldPairwiseStatus[keyof typeof ComparisonFieldPairwiseStatus] | null;
  pairwise_verdict: typeof ComparisonFieldPairwiseVerdict[keyof typeof ComparisonFieldPairwiseVerdict] | null;
  /** @nullable */
  pairwise_summary: string | null;
  pairwise_differences: PairwiseDifference[];
}

export interface ComparisonFieldSlot {
  prompt_key: string;
  field_identifier: string;
  field_title: string;
  page_location?: string;
}

export interface ComparisonPickInput {
  prompt_key: string;
  winner: string;
  note?: string;
}

export interface ComparisonPromptSeenInput {
  prompt_key: string;
}

export interface ComparisonPromptSeenOutput {
  marked: boolean;
}

/**
 * Rollup of the judge's per-slot verdicts.
 */
export interface ComparisonScoreSummary {
  /** @nullable */
  average: number | null;
  /** @nullable */
  adjusted_average: number | null;
  total: number;
  scored: number;
  passed: number;
  worse: number;
  unsure: number;
  not_judged: number;
  flagged: number;
  disqualified: number;
  unresolved_disqualified: number;
}

export interface CopyFieldInput {
  source_field_id: number;
  target_section_id: number;
}

export interface CopySectionInput {
  source_section_id: number;
  target_template_id: number;
}

export interface CreateAssessmentInputWithPRInput {
  /** Lowercase snake_case identifier for the new input. Appended under ``inputs.yaml → assessments:`` and used as ``assessments.<key>`` in prompt yamls. Usually a lowercased ``file_kind`` (e.g. ``wnat_8`` for ``WNAT_8``) but can differ if the caller wants a semantically-named input (e.g. ``combined_vineland`` keyed off a ``VINELAND`` upload). */
  key: string;
  /** ``ApiLearnerFileFileKindChoices`` enum member name (UPPER_SNAKE_CASE, e.g. ``WNAT_8``). Validated server-side against the actual FDM enum parsed from ``schema.graphql`` — no more "open a PR and hope pipelines CI accepts it." Basecamp's dialog surfaces the authoritative list via ``list_assessment_file_kinds``. */
  file_kind: string;
}

export interface CreateBaseQACriteriaInput {
  name: string;
  content: string;
  category?: string;
}

/**
 * * `IN_HOME` - IN_HOME
 * * `IN_CLINIC` - IN_CLINIC
 * * `TELEHEALTH` - TELEHEALTH
 * * `IN_SCHOOL` - IN_SCHOOL
 */
export type ModalityTypesEnum = typeof ModalityTypesEnum[keyof typeof ModalityTypesEnum];


export const ModalityTypesEnum = {
  IN_HOME: 'IN_HOME',
  IN_CLINIC: 'IN_CLINIC',
  TELEHEALTH: 'TELEHEALTH',
  IN_SCHOOL: 'IN_SCHOOL',
} as const;

/**
 * * `BCBS` - BCBS
 * * `UNITED_HEALTHCARE` - UNITED_HEALTHCARE
 * * `AETNA` - AETNA
 * * `CIGNA` - CIGNA
 * * `HUMANA` - HUMANA
 * * `ANTHEM` - ANTHEM
 * * `KAISER_PERMANENTE` - KAISER_PERMANENTE
 * * `TRICARE` - TRICARE
 * * `MAGELLAN_HEALTH` - MAGELLAN_HEALTH
 * * `BEACON_HEALTH_OPTIONS` - BEACON_HEALTH_OPTIONS
 * * `MEDICAID` - MEDICAID
 * * `CATALIGHT` - CATALIGHT
 * * `OPTUM` - OPTUM
 * * `BSW` - BSW
 * * `EVERNORTH` - EVERNORTH
 * * `MOLINA` - MOLINA
 * * `EMI_HEALTH` - EMI_HEALTH
 */
export type PayorsEnum = typeof PayorsEnum[keyof typeof PayorsEnum];


export const PayorsEnum = {
  BCBS: 'BCBS',
  UNITED_HEALTHCARE: 'UNITED_HEALTHCARE',
  AETNA: 'AETNA',
  CIGNA: 'CIGNA',
  HUMANA: 'HUMANA',
  ANTHEM: 'ANTHEM',
  KAISER_PERMANENTE: 'KAISER_PERMANENTE',
  TRICARE: 'TRICARE',
  MAGELLAN_HEALTH: 'MAGELLAN_HEALTH',
  BEACON_HEALTH_OPTIONS: 'BEACON_HEALTH_OPTIONS',
  MEDICAID: 'MEDICAID',
  CATALIGHT: 'CATALIGHT',
  OPTUM: 'OPTUM',
  BSW: 'BSW',
  EVERNORTH: 'EVERNORTH',
  MOLINA: 'MOLINA',
  EMI_HEALTH: 'EMI_HEALTH',
} as const;

/**
 * * `ABA_THERAPY` - ABA_THERAPY
 * * `DIAGNOSTIC_EVALUATIONS` - DIAGNOSTIC_EVALUATIONS
 * * `PARENT_TRAINING` - PARENT_TRAINING
 * * `SPEECH_THERAPY` - SPEECH_THERAPY
 * * `OCCUPATIONAL_THERAPY` - OCCUPATIONAL_THERAPY
 * * `PHYSICAL_THERAPY` - PHYSICAL_THERAPY
 */
export type ServicesOfferedEnum = typeof ServicesOfferedEnum[keyof typeof ServicesOfferedEnum];


export const ServicesOfferedEnum = {
  ABA_THERAPY: 'ABA_THERAPY',
  DIAGNOSTIC_EVALUATIONS: 'DIAGNOSTIC_EVALUATIONS',
  PARENT_TRAINING: 'PARENT_TRAINING',
  SPEECH_THERAPY: 'SPEECH_THERAPY',
  OCCUPATIONAL_THERAPY: 'OCCUPATIONAL_THERAPY',
  PHYSICAL_THERAPY: 'PHYSICAL_THERAPY',
} as const;

export interface LocationInput {
  address_line_1: string;
  /** @nullable */
  address_line_2?: string | null;
  city: string;
  /** @maxLength 2 */
  state: string;
  /** @maxLength 2 */
  country?: string;
  /** @maxLength 10 */
  postal_code: string;
}

/**
 * * `UNVERIFIED` - UNVERIFIED
 * * `PENDING` - PENDING
 * * `VERIFIED` - VERIFIED
 */
export type VerificationStatusEnum = typeof VerificationStatusEnum[keyof typeof VerificationStatusEnum];


export const VerificationStatusEnum = {
  UNVERIFIED: 'UNVERIFIED',
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
} as const;

export interface CreateClinicListingInput {
  name: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  website_url?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  phone_number?: string | null;
  /** @nullable */
  contact_email?: string | null;
  modality_types?: ModalityTypesEnum[];
  payors?: PayorsEnum[];
  services_offered?: ServicesOfferedEnum[];
  /** @nullable */
  google_rating?: number | null;
  /** @nullable */
  google_review_count?: number | null;
  /** @nullable */
  google_place_id?: string | null;
  /** @nullable */
  full_address?: string | null;
  location?: LocationInput | null;
  /** creates clinic listing with the associated organization in pending status. */
  with_organization?: boolean;
  /**
     * Verification status for the clinic listing.
     *
     * * `UNVERIFIED` - UNVERIFIED
     * * `PENDING` - PENDING
     * * `VERIFIED` - VERIFIED
     */
  verification_status?: VerificationStatusEnum;
}

export interface LocationOutput {
  address_line_1: string;
  /** @nullable */
  address_line_2: string | null;
  city: string;
  state: string;
  country: string;
  postal_code: string;
}

export interface CreateClinicListingOutput {
  id: number;
  public_id: string;
  name: string;
  location: LocationOutput | null;
}

export interface CreateEvalModelComparisonInput {
  /** @nullable */
  organization_id?: number | null;
  template_id: number;
  learner_test_profile_id: number;
  candidate_model: string;
}

/**
 * A field the comparison will not run: the profile has no file for it.
 */
export interface SkippedComparisonFieldSlot {
  prompt_key: string;
  field_identifier: string;
  field_title: string;
  page_location?: string;
  missing_file_kinds: string[];
}

export interface CreateEvalModelComparisonOutput {
  id: number;
  /** @nullable */
  organization_id: number | null;
  /** @nullable */
  multi_model_test_id: number | null;
  template_id: number;
  template_name: string;
  report_type: string;
  /** @nullable */
  learner_test_profile_id: number | null;
  baseline_model: string;
  candidate_model: string;
  verdict: string;
  notes: string;
  created_date: string;
  score_summary: ComparisonScoreSummary;
  fields: ComparisonFieldSlot[];
  skipped_fields: SkippedComparisonFieldSlot[];
}

export interface CreateOrgQACriteriaInput {
  organization_id: number;
  name: string;
  content: string;
  category?: string;
}

export interface CreateOrganizationClinicInput {
  name: string;
  org_id: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  website_url?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  phone_number?: string | null;
  /** @nullable */
  contact_email?: string | null;
  modality_types?: ModalityTypesEnum[];
  payors?: PayorsEnum[];
  services_offered?: ServicesOfferedEnum[];
  /** @nullable */
  full_address?: string | null;
  location?: LocationInput | null;
  /**
     * Verification status for the clinic listing.
     *
     * * `UNVERIFIED` - UNVERIFIED
     * * `PENDING` - PENDING
     * * `VERIFIED` - VERIFIED
     */
  verification_status?: VerificationStatusEnum;
}

export interface CreateOrganizationClinicOutput {
  public_id: string;
  name: string;
  location: LocationOutput | null;
}

export interface CreateOrganizationInput {
  name: string;
  /** @nullable */
  display_name?: string | null;
  organization_type: OrganizationTypeEnum;
  /** @nullable */
  hubspot_company_id?: string | null;
  /** @nullable */
  logo_url?: string | null;
  /** @nullable */
  primary_color?: string | null;
  /** @nullable */
  background_color?: string | null;
  connection_types?: ConnectionTypeEnum[];
  ehr_sync_enabled?: boolean;
  /**
     * Vertical organization id. Frontera EHR organizations only.
     * @nullable
     */
  external_id?: string | null;
}

export interface CreateOrganizationOutput {
  id: string;
  name: string;
  /** @nullable */
  external_id: string | null;
}

/**
 * * `admin` - admin
 * * `assessment-bcba` - assessment-bcba
 * * `bcba` - bcba
 * * `caregiver` - caregiver
 * * `director` - director
 * * `frontera-internal` - frontera-internal
 * * `psychologist` - psychologist
 * * `evaluation-psychologist` - evaluation-psychologist
 * * `rbt` - rbt
 * * `intake` - intake
 * * `enterprise-admin` - enterprise-admin
 */
export type RolesEnum = typeof RolesEnum[keyof typeof RolesEnum];


export const RolesEnum = {
  admin: 'admin',
  'assessment-bcba': 'assessment-bcba',
  bcba: 'bcba',
  caregiver: 'caregiver',
  director: 'director',
  'frontera-internal': 'frontera-internal',
  psychologist: 'psychologist',
  'evaluation-psychologist': 'evaluation-psychologist',
  rbt: 'rbt',
  intake: 'intake',
  'enterprise-admin': 'enterprise-admin',
} as const;

export interface CreateOrganizationUserInput {
  professional_title?: string;
  license_number?: string;
  organization_id: string;
  email: string;
  first_name: string;
  last_name: string;
  connection_type: ConnectionTypeEnum;
  roles: RolesEnum[];
}

/**
 * * `DIAGNOSIS_EVALUATION` - DIAGNOSIS_EVALUATION
 * * `INITIAL_ASSESSMENT` - INITIAL_ASSESSMENT
 * * `REASSESSMENT` - REASSESSMENT
 */
export type ReportTypeEnum = typeof ReportTypeEnum[keyof typeof ReportTypeEnum];


export const ReportTypeEnum = {
  DIAGNOSIS_EVALUATION: 'DIAGNOSIS_EVALUATION',
  INITIAL_ASSESSMENT: 'INITIAL_ASSESSMENT',
  REASSESSMENT: 'REASSESSMENT',
} as const;

export interface CreatePromptInput {
  name: string;
  response_schema?: unknown | null;
  /** @nullable */
  fallback_text?: string | null;
  /** @nullable */
  sample_output?: string | null;
  /** @nullable */
  organization_id?: string | null;
  report_types: ReportTypeEnum[];
  key: string;
}

export interface CreatePromptM2MInput {
  name: string;
  response_schema?: unknown | null;
  /** @nullable */
  fallback_text?: string | null;
  /** @nullable */
  sample_output?: string | null;
  /** @nullable */
  organization_id?: string | null;
  report_types?: ReportTypeEnum[];
  key: string;
  /** @nullable */
  requesting_user_auth0id?: string | null;
}

export interface PromptInputEntry {
  key: string;
}

/**
 * One prompt inside a bulk create-with-PR request.
 *
 * Mirrors ``_CreatePromptWithPRInputSerializer`` but carries the
 * ``target_yaml_filename`` per prompt — the bulk endpoint groups
 * entries by yaml file so a single copy operation can split
 * duplicates across multiple yamls (e.g., a global one lands in
 * ``global.yaml`` while the org-scoped ones go to
 * ``report_builder.yaml``). Rio's UX defaults every entry to the
 * same yaml file, but leaves the door open for user overrides.
 */
export interface CreatePromptWithPRBulkEntry {
  prompt_key: string;
  name: string;
  target_yaml_filename: string;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  templated_instructions?: string | null;
  instructions: string;
  /** @nullable */
  technical_instructions?: string | null;
  inputs?: PromptInputEntry[];
  /** @nullable */
  sample_output?: string | null;
  response_schema?: unknown | null;
  /** @nullable */
  organization_id?: string | null;
}

export interface CreatePromptWithPRBulkInput {
  prompts: CreatePromptWithPRBulkEntry[];
}

export type CreatePromptWithPRBulkM2MInputPromptsItem = {[key: string]: string};

export interface CreatePromptWithPRBulkM2MInput {
  /** @minItems 1 */
  prompts: CreatePromptWithPRBulkM2MInputPromptsItem[];
}

export interface CreatePromptWithPRInput {
  prompt_key: string;
  name: string;
  target_yaml_filename: string;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  templated_instructions?: string | null;
  instructions: string;
  /** @nullable */
  technical_instructions?: string | null;
  inputs?: PromptInputEntry[];
  /** @nullable */
  sample_output?: string | null;
  response_schema?: unknown | null;
  /** @nullable */
  organization_id?: string | null;
}

export interface CreatePromptWithPRM2MInput {
  prompt_key: string;
  target_yaml_filename: string;
}

export type CreatePromptsWithPRFromDraftsBulkInputPromptsItem = {[key: string]: string};

export interface CreatePromptsWithPRFromDraftsBulkInput {
  /** @minItems 1 */
  prompts: CreatePromptsWithPRFromDraftsBulkInputPromptsItem[];
}

export interface CreateRuleInput {
  rule_set_id: number;
  name: string;
  category?: string;
  report_types?: string[];
  location?: string;
  scan_for?: string;
  feedback?: string;
}

export interface CreateTemplateExportFileInput {
  template_id: number;
  file_size: number;
  mime_type: string;
  original_file_name: string;
}

export interface CreateTemplateExportFileOutput {
  file_url: string;
}

export interface CreateTemplateLogoInput {
  template_id: number;
  file_size: number;
  mime_type: string;
  original_file_name: string;
}

export interface CreateTemplateLogoOutput {
  file_url: string;
}

export interface CreateTemplateQACriteriaInput {
  template_id: number;
  name: string;
  content: string;
  category?: string;
}

export interface Curriculum {
  id: number;
  name: string;
  organization_id: number;
  organization_name: string;
}

export interface DeleteDraftPromptOutput {
  deleted: boolean;
  prompt_key: string;
}

export interface DeleteTemplateInput {
  template_id: number;
}

export interface DeleteTemplateQACriteriaInput {
  id: number;
}

export interface DigestPopular {
  postId: string;
  spaceId: string;
  description: string;
  postTitle: string;
  postAuthor: string;
  spaceName: string;
  totalComments: number;
  totalLikes: number;
}

export interface DigestPost {
  postId: string;
  spaceId: string;
  postTitle: string;
  postAuthor: string;
  spaceName: string;
  totalComments: number;
  totalLikes: number;
}

export interface DigestSection {
  sectionTitle: string;
  sectionColor: string;
  posts: DigestPost[];
}

/**
 * * `pdf` - pdf
 * * `docx` - docx
 */
export type DoctypeEnum = typeof DoctypeEnum[keyof typeof DoctypeEnum];


export const DoctypeEnum = {
  pdf: 'pdf',
  docx: 'docx',
} as const;

export interface DuplicatePromptInput {
  new_key: string;
  new_name?: string;
  /** @nullable */
  organization_id?: string | null;
  report_types?: ReportTypeEnum[];
}

export interface DuplicateRulePackageInput {
  id: number;
}

export interface DuplicateTemplateInput {
  template_id: number;
  organization_id: number;
}

export type EditPromptYamlAndOpenPRBulkM2MInputPromptsItem = {[key: string]: string};

export interface EditPromptYamlAndOpenPRBulkM2MInput {
  /** @minItems 1 */
  prompts: EditPromptYamlAndOpenPRBulkM2MInputPromptsItem[];
}

/**
 * One prompt inside a bulk edit-with-PR request.
 *
 * Mirrors ``_EditPromptYamlInputSerializer`` but carries the
 * ``prompt_key`` per entry. All edit fields stay optional — bulk-edit
 * is meant to bundle small drafts (e.g., an ``inputs``-only change
 * on N sibling prompts) without forcing every entry to carry every
 * field. Missing fields = no edit to that field on that prompt.
 */
export interface EditPromptYamlBulkEntry {
  prompt_key: string;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  templated_instructions?: string | null;
  /** @nullable */
  instructions?: string | null;
  /** @nullable */
  technical_instructions?: string | null;
  inputs?: PromptInputEntry[];
  /** @nullable */
  sample_output?: string | null;
  response_schema?: unknown | null;
}

export interface EditPromptYamlBulkInput {
  prompts: EditPromptYamlBulkEntry[];
}

export interface EditPromptYamlInput {
  /** @nullable */
  role?: string | null;
  /** @nullable */
  templated_instructions?: string | null;
  /** @nullable */
  instructions?: string | null;
  /** @nullable */
  technical_instructions?: string | null;
  inputs?: PromptInputEntry[];
  /** @nullable */
  sample_output?: string | null;
  response_schema?: unknown | null;
}

export type EditPromptsWithPRFromDraftsBulkInputPromptsItem = {[key: string]: string};

export interface EditPromptsWithPRFromDraftsBulkInput {
  /** @minItems 1 */
  prompts: EditPromptsWithPRFromDraftsBulkInputPromptsItem[];
}

/**
 * * `STANDARD` - STANDARD
 * * `DATA_WAREHOUSE` - DATA_WAREHOUSE
 * * `ORG_USERNAME_PASSWORD` - ORG_USERNAME_PASSWORD
 */
export type EhrIntegrationTypeEnum = typeof EhrIntegrationTypeEnum[keyof typeof EhrIntegrationTypeEnum];


export const EhrIntegrationTypeEnum = {
  STANDARD: 'STANDARD',
  DATA_WAREHOUSE: 'DATA_WAREHOUSE',
  ORG_USERNAME_PASSWORD: 'ORG_USERNAME_PASSWORD',
} as const;

export interface Error {
  detail: string;
}

export interface EvalCheckMetricRate {
  metric_name: string;
  evaluated: number;
  failed: number;
}

export interface EvalDimensionScore {
  dimension: string;
  /**
     * @minimum 1
     * @maximum 5
     */
  value: number;
  comment?: string;
}

export interface EvalJudgeScore {
  dimension: string;
  /** @nullable */
  value: number | null;
  reason: string;
  spans: string[];
}

export interface EvalModelComparisonDetail {
  id: number;
  /** @nullable */
  organization_id: number | null;
  /** @nullable */
  multi_model_test_id: number | null;
  template_id: number;
  template_name: string;
  report_type: string;
  /** @nullable */
  learner_test_profile_id: number | null;
  baseline_model: string;
  candidate_model: string;
  verdict: string;
  notes: string;
  created_date: string;
  score_summary: ComparisonScoreSummary;
  fields: ComparisonField[];
}

export interface EvalModelComparisonSummary {
  id: number;
  /** @nullable */
  organization_id: number | null;
  /** @nullable */
  multi_model_test_id: number | null;
  template_id: number;
  template_name: string;
  report_type: string;
  /** @nullable */
  learner_test_profile_id: number | null;
  baseline_model: string;
  candidate_model: string;
  verdict: string;
  notes: string;
  created_date: string;
  score_summary: ComparisonScoreSummary;
}

export const MultiModelTestReviewItemPairwiseStatus = {...PairwiseStatusEnum,} as const
export const MultiModelTestReviewItemPairwiseVerdict = {...PairwiseVerdictEnum,} as const
export interface MultiModelTestReviewItem {
  comparison_id: number;
  template_name: string;
  prompt_key: string;
  field_title: string;
  disqualified: boolean;
  pairwise_status: typeof MultiModelTestReviewItemPairwiseStatus[keyof typeof MultiModelTestReviewItemPairwiseStatus] | null;
  pairwise_verdict: typeof MultiModelTestReviewItemPairwiseVerdict[keyof typeof MultiModelTestReviewItemPairwiseVerdict] | null;
  /** @nullable */
  pairwise_summary: string | null;
  /** @nullable */
  winner: string | null;
  seen: boolean;
}

export interface MultiModelTestModelRollup {
  candidate_model: string;
  /** @nullable */
  average: number | null;
  /** @nullable */
  adjusted_average: number | null;
  scored_templates: number;
  total_templates: number;
  flagged: number;
  reviewed: number;
  disqualified: number;
  unresolved_disqualified: number;
  poor: boolean;
  review: MultiModelTestReviewItem[];
}

export interface MultiModelTestCellProgress {
  total: number;
  pending: number;
  complete: number;
  running: number;
  failed: number;
  judging: number;
}

export interface MultiModelTestCell {
  comparison_id: number;
  template_id: number;
  template_name: string;
  candidate_model: string;
  /** @nullable */
  learner_test_profile_id: number | null;
  /** @nullable */
  learner_test_profile_name: string | null;
  score_summary: ComparisonScoreSummary;
  progress: MultiModelTestCellProgress;
}

export interface EvalMultiModelTestDetail {
  id: number;
  name: string;
  candidate_models: string[];
  created_date: string;
  models: MultiModelTestModelRollup[];
  cells: MultiModelTestCell[];
}

export interface EvalMultiModelTestSummary {
  id: number;
  name: string;
  candidate_models: string[];
  template_count: number;
  created_date: string;
}

export interface EvalPromptCheckRate {
  prompt_key: string;
  run_count: number;
  metrics: EvalCheckMetricRate[];
}

/**
 * A substitution edit picked by the pipeline; texts truncated to 500 chars.
 */
export interface EvalPromptEditExample {
  /** @nullable */
  ai_text: string | null;
  /** @nullable */
  user_text: string | null;
  /** @nullable */
  reason: string | null;
  /** @nullable */
  report_id: string | null;
  /** @nullable */
  report_type: string | null;
}

/**
 * A recurring edit pattern the pipeline found (PROC-228).
 */
export interface EvalPromptTheme {
  title: string;
  description: string;
  categories: string[];
  support: number;
  group_size: number;
}

/**
 * Production edit rollup (real reports) -- a different population from
 * the test-bed fields beside it. See
 * ``eval_prompt_metrics_service.production_metrics_by_prompt``.
 */
export interface EvalPromptProductionMetrics {
  sample_size: number;
  pct_fields_edited: number;
  avg_edit_percentage: number;
  avg_quality_score: number;
  /** @nullable */
  pct_fields_total_rewrite: number | null;
  /** @nullable */
  top_category: string | null;
  /** @nullable */
  top_category_description: string | null;
  /** @nullable */
  top_category_prompt_action: string | null;
  top_category_examples: EvalPromptEditExample[];
  themes: EvalPromptTheme[];
  computed_at: string;
}

export interface EvalPromptRanking {
  prompt_key: string;
  run_count: number;
  scored_count: number;
  /** @nullable */
  rule_failure_rate: number | null;
  /** @nullable */
  human_mean: number | null;
  /** @nullable */
  judge_mean: number | null;
  /** @nullable */
  override_rate: number | null;
  production: EvalPromptProductionMetrics | null;
  /** @nullable */
  owner_organization_name: string | null;
}

export interface EvalResultsDimension {
  dimension: string;
  label: string;
  n: number;
  /** @nullable */
  human_mean: number | null;
  /** @nullable */
  judge_mean: number | null;
  low_count: number;
  compared_count: number;
  overridden_count: number;
}

export interface EvalResultsScopeOrganization {
  id: number;
  name: string;
}

export interface EvalResultsScopeTemplate {
  id: number;
  name: string;
  status: string;
  organization_ids: number[];
}

export interface EvalResultsScopeOptionsOutput {
  organizations: EvalResultsScopeOrganization[];
  templates: EvalResultsScopeTemplate[];
}

export interface EvalReviewScore {
  id: number;
  item_id: number;
  outcome: string;
  rubric_version: number;
  rubric_content_hash: string;
  overall_notes: string;
  failure_tags: unknown;
  skip_reason_code: string;
  dimension_scores: EvalDimensionScore[];
  created_date: string;
}

export interface EvalReviewItem {
  id: number;
  batch_label: string;
  target_kind: string;
  target_id: number;
  check_results: EvalCheckResult[];
  my_score: EvalReviewScore | null;
  judge_scores: EvalJudgeScore[];
}

export interface EvalRubricSummary {
  id: number;
  name: string;
  version: number;
  status: string;
  notes: string;
  content_hash: string;
  /** @nullable */
  activated_at: string | null;
  criteria_count: number;
}

export interface EvalScoredItemDimension {
  dimension: string;
  label: string;
  value: number;
  /** @nullable */
  judge_value: number | null;
}

export interface EvalScoredItem {
  score_id: number;
  item_id: number;
  batch_label: string;
  prompt_key: string;
  /** @nullable */
  run_id: number | null;
  reviewer: string;
  rubric_version: number;
  failure_tags: unknown;
  overall_notes: string;
  /** @nullable */
  time_spent_seconds: number | null;
  created_date: string;
  scores: EvalScoredItemDimension[];
}

export type EvalScoringDimensionLevelAnchors = {[key: string]: string};

/**
 * One scored criterion. Built-in or added; they are siblings.
 */
export interface EvalScoringDimension {
  dimension: string;
  label: string;
  scale_anchors: string;
  level_anchors: EvalScoringDimensionLevelAnchors;
  /** @nullable */
  criterion_id: number | null;
  is_builtin: boolean;
}

export interface EvalScoringStandard {
  source: string;
  name: string;
  version: number;
  dimensions: EvalScoringDimension[];
}

export interface ExpertChatMessageAuthor {
  first_name: string;
  last_name: string;
  is_provider: boolean;
  is_caregiver: boolean;
}

export interface ExpertChatMessageFile {
  original_file_name: string;
  /** @nullable */
  mime_type: string | null;
  /** @nullable */
  file_size: number | null;
  is_image: boolean;
  /** @nullable */
  signed_url: string | null;
}

export interface ExpertChatMessageMedia {
  /** @nullable */
  thumbnail_url: string | null;
  /** @nullable */
  duration: number | null;
  /** @nullable */
  upload_status: string | null;
}

/**
 * A role=COMMENT message echoed from a comment left on a video.
 */
export interface ExpertChatMessageComment {
  /** @nullable */
  media_start_time: number | null;
  is_reply: boolean;
}

export interface ExpertChatMessage {
  id: number;
  /** @nullable */
  sequence_number: number | null;
  role: string;
  content: string;
  created_date: string;
  /** @nullable */
  read_at: string | null;
  edited: boolean;
  author: ExpertChatMessageAuthor;
  file: ExpertChatMessageFile | null;
  media: ExpertChatMessageMedia | null;
  media_comment: ExpertChatMessageComment | null;
}

export interface ExpertChatOversightRow {
  chat_id: number;
  /** @nullable */
  learner_id: number | null;
  learner_name: string;
  caregiver_name: string;
  /** @nullable */
  caregiver_email: string | null;
  /** @nullable */
  assigned_provider_id: number | null;
  /** @nullable */
  assigned_provider_name: string | null;
  organization_id: number;
  organization_name: string;
  status: string;
  is_unread: boolean;
  needs_review: boolean;
  /** @nullable */
  last_activity: string | null;
}

export interface ExpertChatProvider {
  provider_id: number;
  name: string;
  /** @nullable */
  email: string | null;
  archived: boolean;
}

/**
 * * `GOOGLE_DOCS` - GOOGLE_DOCS
 * * `HANDLEBARS` - HANDLEBARS
 * * `DOCXTEMPLATER` - DOCXTEMPLATER
 */
export type ExportFrameworkEnum = typeof ExportFrameworkEnum[keyof typeof ExportFrameworkEnum];


export const ExportFrameworkEnum = {
  GOOGLE_DOCS: 'GOOGLE_DOCS',
  HANDLEBARS: 'HANDLEBARS',
  DOCXTEMPLATER: 'DOCXTEMPLATER',
} as const;

export interface ExportTestStatusOutput {
  status: string;
  /** @nullable */
  download_url: string | null;
  /** @nullable */
  error_message: string | null;
}

/**
 * * `SIMPLE_TEXT` - SIMPLE_TEXT
 * * `WYSIWYG` - WYSIWYG
 * * `TABLE` - TABLE
 * * `IMAGE` - IMAGE
 * * `SELECT` - SELECT
 * * `CHECKBOX` - CHECKBOX
 * * `RADIO` - RADIO
 * * `DATE` - DATE
 * * `DATETIME` - DATETIME
 */
export type FieldTypeEnum = typeof FieldTypeEnum[keyof typeof FieldTypeEnum];


export const FieldTypeEnum = {
  SIMPLE_TEXT: 'SIMPLE_TEXT',
  WYSIWYG: 'WYSIWYG',
  TABLE: 'TABLE',
  IMAGE: 'IMAGE',
  SELECT: 'SELECT',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
} as const;

/**
 * * `template` - template
 * * `example` - example
 */
export type FileKindEnum = typeof FileKindEnum[keyof typeof FileKindEnum];


export const FileKindEnum = {
  template: 'template',
  example: 'example',
} as const;

/**
 * * `CALIBRI` - CALIBRI
 * * `ARIAL` - ARIAL
 * * `TIMES_NEW_ROMAN` - TIMES_NEW_ROMAN
 * * `GEORGIA` - GEORGIA
 * * `PUBLIC_SANS` - PUBLIC_SANS
 * * `CENTURY_GOTHIC` - CENTURY_GOTHIC
 */
export type FontEnum = typeof FontEnum[keyof typeof FontEnum];


export const FontEnum = {
  CALIBRI: 'CALIBRI',
  ARIAL: 'ARIAL',
  TIMES_NEW_ROMAN: 'TIMES_NEW_ROMAN',
  GEORGIA: 'GEORGIA',
  PUBLIC_SANS: 'PUBLIC_SANS',
  CENTURY_GOTHIC: 'CENTURY_GOTHIC',
} as const;

export interface Roles {
  id: string;
  name: string;
  description: string;
}

export interface GetAuth0UserRolesOutput {
  roles: Roles[];
}

export interface GetBaseQACriteriaOutput {
  count: number;
  results: BaseQACriteriaItem[];
}

export interface GetCareNavigationListingsLocation {
  id: string;
  address_line_1: string;
  /** @nullable */
  address_line_2: string | null;
  city: string;
  state: string;
  postal_code: string;
  /** @nullable */
  latitude: number | null;
  /** @nullable */
  longitude: number | null;
}

export interface GetCareNavigationListingsOutput {
  id: string;
  name: string;
  verification_status: VerificationStatusEnum;
  location: GetCareNavigationListingsLocation | null;
  /** @nullable */
  website_url: string | null;
  /** @nullable */
  phone_number: string | null;
  /** @nullable */
  contact_email: string | null;
  /** @nullable */
  description: string | null;
  modality_types: string[];
  payors: string[];
  services_offered: string[];
  /** @nullable */
  google_rating: number | null;
  /** @nullable */
  google_review_count: number | null;
  /** @nullable */
  distance_miles?: number | null;
}

export interface Location {
  id: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
}

export interface Organization {
  id: string;
  name: string;
}

export interface ClaimedBy {
  id: string;
  organization: Organization;
}

export interface GetClinicListingsOutput {
  id: string;
  created_date: string;
  name: string;
  verification_status: VerificationStatusEnum;
  location: Location | null;
  /** @nullable */
  website_url: string | null;
  /** @nullable */
  phone_number: string | null;
  /** @nullable */
  contact_email: string | null;
  /** @nullable */
  description: string | null;
  modality_types: string[];
  payors: string[];
  services_offered: string[];
  claimed_by: ClaimedBy | null;
}

export interface GetCommunityPostsOutput {
  id: number;
  name: string;
  space_id: number;
  space_name: string;
  user_name: string;
  comment_count: number;
  like_count: number;
  /** @nullable */
  published_at: string | null;
}

export interface GetEvalResultsOutput {
  scored_count: number;
  reviewer_count: number;
  check_rates: EvalPromptCheckRate[];
  dimensions: EvalResultsDimension[];
  items: EvalScoredItem[];
  rankings: EvalPromptRanking[];
}

export interface GetEvalReviewForRunOutput {
  item: EvalReviewItem | null;
  standard: EvalScoringStandard;
}

export interface GetEvalReviewProgressOutput {
  total_items: number;
  remaining_for_me: number;
  my_scored: number;
  my_skipped: number;
}

export interface GetExpertChatMessagesOutput {
  chat: ExpertChatOversightRow;
  messages: ExpertChatMessage[];
}

/**
 * * `core` - core
 * * `platform` - platform
 * * `not_text` - not_text
 */
export type LockReasonEnum = typeof LockReasonEnum[keyof typeof LockReasonEnum];


export const LockReasonEnum = {
  core: 'core',
  platform: 'platform',
  not_text: 'not_text',
} as const;

/**
 * * `template` - template
 * * `org` - org
 */
export type InstructionsSourceEnum = typeof InstructionsSourceEnum[keyof typeof InstructionsSourceEnum];


export const InstructionsSourceEnum = {
  template: 'template',
  org: 'org',
} as const;

/**
 * * `INITIAL_ASSESSMENT` - INITIAL_ASSESSMENT
 * * `REASSESSMENT` - REASSESSMENT
 */
export type GoalGenerationRulesGoalFieldReportTypeEnum = typeof GoalGenerationRulesGoalFieldReportTypeEnum[keyof typeof GoalGenerationRulesGoalFieldReportTypeEnum];


export const GoalGenerationRulesGoalFieldReportTypeEnum = {
  INITIAL_ASSESSMENT: 'INITIAL_ASSESSMENT',
  REASSESSMENT: 'REASSESSMENT',
} as const;

export const GoalGenerationRulesGoalFieldLockReason = {...LockReasonEnum,} as const
export const GoalGenerationRulesGoalFieldInstructionsSource = {...InstructionsSourceEnum,} as const
export interface GoalGenerationRulesGoalField {
  key: string;
  field_identifier: string;
  /** @nullable */
  title: string | null;
  ai: boolean;
  custom: boolean;
  editable: boolean;
  lock_reason: typeof GoalGenerationRulesGoalFieldLockReason[keyof typeof GoalGenerationRulesGoalFieldLockReason] | null;
  can_turn_off: boolean;
  /** @nullable */
  instructions?: string | null;
  instructions_source: typeof GoalGenerationRulesGoalFieldInstructionsSource[keyof typeof GoalGenerationRulesGoalFieldInstructionsSource] | null;
  is_enabled: boolean;
  /** @nullable */
  template_name: string | null;
  report_type: GoalGenerationRulesGoalFieldReportTypeEnum;
  template_id: string;
}

export const GoalGenerationRulesSharedGoalFieldLockReason = {...LockReasonEnum,} as const
/**
 * One entry per field EVERY shown template carries (enabled) — the
 * "Shared across templates" section, which edits the org-level ``fields``
 * map (the default under per-template rows). Same per-key meta as the
 * rows; ``org_instructions`` is the org-map text itself, NOT resolved
 * against any template row.
 */
export interface GoalGenerationRulesSharedGoalField {
  key: string;
  field_identifier: string;
  /** @nullable */
  title: string | null;
  ai: boolean;
  custom: boolean;
  editable: boolean;
  lock_reason: typeof GoalGenerationRulesSharedGoalFieldLockReason[keyof typeof GoalGenerationRulesSharedGoalFieldLockReason] | null;
  can_turn_off: boolean;
  /** @nullable */
  org_instructions: string | null;
}

export interface GetGoalGenerationRulesOutput {
  /** @nullable */
  general: string | null;
  fields: GoalGenerationRulesGoalField[];
  shared_fields: GoalGenerationRulesSharedGoalField[];
}

export interface GetGoogleMapsAutocompleteResultsOutput {
  results: AutocompleteResults[];
}

export interface SuggestionCriteriaNested {
  id: number;
  name: string;
  category: string;
  content: string;
  is_base_criteria: boolean;
  related_org_names: string[];
}

export interface OrgQACriteriaItem {
  id: number;
  enabled: boolean;
  is_virtual: boolean;
  suggestion_criteria: SuggestionCriteriaNested;
}

export interface GetOrgQACriteriaOutput {
  count: number;
  results: OrgQACriteriaItem[];
}

export interface GetOrganizationUsersOutput {
  /** @nullable */
  auth0_id: string | null;
  /** @nullable */
  full_name: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  login_count: number | null;
  /** @nullable */
  last_login: string | null;
  identities: string[];
  fdm_provider: boolean;
  fdm_caregiver: boolean;
  /** @nullable */
  invitation_status: string | null;
  roles: Auth0Role[];
  /** @nullable */
  professional_title: string | null;
  /** @nullable */
  license_number: string | null;
}

export interface GetOrganizationsOutput {
  ehr_integration_type: EhrIntegrationTypeEnum;
  readonly allowed_ehr_integration_types: readonly EhrIntegrationTypeEnum[];
  id: string;
  name: string;
  /** @nullable */
  external_id: string | null;
  created_date: string;
  staff_count: number;
  active_clients: number;
  require_all_qa_resolved: boolean;
  peer_review_enabled: boolean;
  require_approval_before_export: boolean;
  final_approver_waits_for_reviewers: boolean;
  require_admin_analytics: boolean;
  ehr_sync_enabled: boolean;
  organization_type: OrganizationTypeEnum;
  ehr_sync_cleared: boolean;
}

export interface GetOrphanedOrganizationUsersOutput {
  /** @nullable */
  auth0_id: string | null;
  /** @nullable */
  full_name: string | null;
  /** @nullable */
  email: string | null;
  /** @nullable */
  invitation_status: string | null;
  provider_id: string;
}

export interface GetParsedTestFileOutput {
  /** @nullable */
  parsed_json: string | null;
}

export interface GetPlaceMetadataOutput {
  formatted_address: string;
}

export interface PromptOrganization {
  id: string;
  name: string;
}

/**
 * * `matched` - matched
 * * `missing` - missing
 */
export type RegistryStatusEnum = typeof RegistryStatusEnum[keyof typeof RegistryStatusEnum];


export const RegistryStatusEnum = {
  matched: 'matched',
  missing: 'missing',
} as const;

export interface PromptRegistryInput {
  key: string;
  source: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  value_schema?: string | null;
  /** @nullable */
  file_kind?: string | null;
  /** @nullable */
  is_enriched?: boolean | null;
  /** @nullable */
  is_curriculum_based?: boolean | null;
  /** @nullable */
  section_identifier?: string | null;
  /** @nullable */
  nested_keys?: string[] | null;
  /** @nullable */
  produced_by?: string | null;
}

export interface GetPromptDetailsOutput {
  id: number;
  key: string;
  name: string;
  organization: PromptOrganization | null;
  report_types: ReportTypeEnum[];
  registry_status: RegistryStatusEnum;
  /** @nullable */
  role: string | null;
  /** @nullable */
  templated_instructions: string | null;
  /** @nullable */
  instructions: string | null;
  /** @nullable */
  sample_output: string | null;
  response_schema: unknown | null;
  /** @nullable */
  technical_instructions: string | null;
  inputs: PromptRegistryInput[];
  input_keys: string[];
}

/**
 * Response shape for the draft endpoints.
 *
 * ``draft_by_name`` mirrors ``ReportTemplateSerializer.get_updated_by_name``
 * — it resolves through ``Auth0User.name()`` (which walks the user's
 * provider→providermetadata FK for a first/last name). Same reason,
 * same pattern: the local ``Auth0User.email`` / ``first_name`` fields
 * are typically empty for basecamp admins, so the real display info
 * lives on the linked ``ProviderMetadata`` row.
 */
export interface GetPromptDraftOutput {
  key: string;
  draft_overrides: unknown | null;
  /** @nullable */
  draft_by_id: number | null;
  /** @nullable */
  readonly draft_by_name: string | null;
  /** @nullable */
  draft_updated_at: string | null;
  /** @nullable */
  base_instructions: string | null;
}

export interface GetPromptsOutput {
  id: number;
  key: string;
  name: string;
  response_schema: unknown | null;
  /** @nullable */
  fallback_text: string | null;
  /** @nullable */
  sample_output: string | null;
  organization: PromptOrganization | null;
  report_types: ReportTypeEnum[];
  created_date: string;
  last_updated_date: string;
  readonly has_draft: boolean;
  readonly registry_status: string;
}

export interface GetPromptsPaginatedOutput {
  count: number;
  results: GetPromptsOutput[];
}

export interface QACriteria {
  id: number;
  name: string;
  category: string;
  content: string;
  enabled: boolean;
  is_base_criteria: boolean;
  created_date: string;
  last_updated_date: string;
}

export interface GetTemplateQACriteriaOutput {
  count: number;
  results: QACriteria[];
}

export interface OrganizationSummary {
  id: number;
  name: string;
  ehr_sync_parent_folder_name?: string;
}

export interface TemplateListItem {
  id: number;
  name: string;
  /** @nullable */
  description: string | null;
  report_type: string;
  status: string;
  /** @nullable */
  export_framework: string | null;
  /** @nullable */
  template_url: string | null;
  is_base_template: boolean;
  enterprise_template: boolean;
  require_all_qa_resolved: boolean;
  /** @nullable */
  require_approval_before_export: boolean | null;
  /** @nullable */
  final_approver_waits_for_reviewers: boolean | null;
  unified_export: boolean;
  created_date: string;
  last_updated_date: string;
  readonly organizations: readonly OrganizationSummary[];
  /** @nullable */
  readonly updated_by_name: string | null;
}

export interface GetTemplatesPaginatedOutput {
  count: number;
  results: TemplateListItem[];
}

export interface GetUserMetaDataOutput {
  /** @nullable */
  first_name: string | null;
  /** @nullable */
  last_name: string | null;
  /** @nullable */
  email: string | null;
}

export interface ImportTemplateJsonInput {
  json_data: string;
  organization_ids?: number[];
}

export interface IncorporatePromptSuggestionsInput {
  incorporate_ids?: number[];
  dismiss_ids?: number[];
}

export type InputTestFilesItem = {[key: string]: unknown};

export type InputMockLearnerData = {[key: string]: unknown};

export interface Input {
  prompt_key: string;
  test_files: InputTestFilesItem[];
  mock_learner_data?: InputMockLearnerData;
  prompt_override?: string;
}

export interface KeyedLookupEntry {
  key: string;
  text: string;
}

export interface KeyedLookupsOutput {
  items: KeyedLookupEntry[];
}

/**
 * * `GOAL` - GOAL
 * * `TARGET` - TARGET
 */
export type Kind18dEnum = typeof Kind18dEnum[keyof typeof Kind18dEnum];


export const Kind18dEnum = {
  GOAL: 'GOAL',
  TARGET: 'TARGET',
} as const;

/**
 * * `FRONTERA_TEMPLATE_PDF` - Frontera template exported as PDF
 */
export type ProcessingFailureCodeEnum = typeof ProcessingFailureCodeEnum[keyof typeof ProcessingFailureCodeEnum];


export const ProcessingFailureCodeEnum = {
  FRONTERA_TEMPLATE_PDF: 'FRONTERA_TEMPLATE_PDF',
} as const;

export const LearnerFileProcessingFailureCode = {...ProcessingFailureCodeEnum,...BlankEnum,} as const
export const LearnerFileAssessmentTemplateType = {...AssessmentTemplateTypeEnum,...BlankEnum,} as const
/**
 * * `TEACHER` - TEACHER
 * * `PARENT` - PARENT
 */
export type RespondentEnum = typeof RespondentEnum[keyof typeof RespondentEnum];


export const RespondentEnum = {
  TEACHER: 'TEACHER',
  PARENT: 'PARENT',
} as const;

export const LearnerFileRespondent = {...RespondentEnum,...BlankEnum,} as const
/**
 * * `generating` - generating
 * * `completed` - completed
 * * `failed` - failed
 */
export type PdfPreviewStatusEnum = typeof PdfPreviewStatusEnum[keyof typeof PdfPreviewStatusEnum];


export const PdfPreviewStatusEnum = {
  generating: 'generating',
  completed: 'completed',
  failed: 'failed',
} as const;

export const LearnerFilePdfPreviewStatus = {...PdfPreviewStatusEnum,} as const
export interface User {
  email: string;
  /** @maxLength 100 */
  username: string;
  id: number;
}

/**
 * * `pending` - pending
 * * `uploaded` - uploaded
 * * `classifying` - classifying
 * * `classifying_error` - classifying_error
 * * `classifying_success` - classifying_success
 * * `processing` - processing
 * * `process_error` - process_error
 * * `process_success` - process_success
 * * `ai_generating` - ai_generating
 * * `ai_generating_error` - ai_generating_error
 */
export type LearnerFileStatusEnum = typeof LearnerFileStatusEnum[keyof typeof LearnerFileStatusEnum];


export const LearnerFileStatusEnum = {
  pending: 'pending',
  uploaded: 'uploaded',
  classifying: 'classifying',
  classifying_error: 'classifying_error',
  classifying_success: 'classifying_success',
  processing: 'processing',
  process_error: 'process_error',
  process_success: 'process_success',
  ai_generating: 'ai_generating',
  ai_generating_error: 'ai_generating_error',
} as const;

export interface LearnerFile {
  readonly id: number;
  readonly created_by: User;
  readonly created_date: string;
  readonly last_updated_date: string;
  readonly s3_key: string;
  /** @maxLength 100 */
  mime_type: string;
  /** @maxLength 512 */
  original_file_name: string;
  /**
     * @minimum -9223372036854776000
     * @maximum 9223372036854776000
     */
  file_size: number;
  /** @nullable */
  processing_failure_reason?: string | null;
  /**
     * Stable machine code for the failure reason, for clients to switch on without matching prose.
     *
     * * `FRONTERA_TEMPLATE_PDF` - Frontera template exported as PDF
     */
  processing_failure_code?: typeof LearnerFileProcessingFailureCode[keyof typeof LearnerFileProcessingFailureCode] | null;
  metadata?: unknown | null;
  /**
     * Stores output from the FileParsingWorkflow
     * @nullable
     */
  parsed_result?: string | null;
  /** @maxLength 60 */
  file_kind: string;
  status?: LearnerFileStatusEnum;
  assessment_template_type?: typeof LearnerFileAssessmentTemplateType[keyof typeof LearnerFileAssessmentTemplateType] | null;
  /** Stores parsed table output for assessments from the FileParsingWorkflow */
  parsed_tables?: unknown | null;
  /** Enriched assessment data derived from parsed_result (descriptions, cutoffs, derived scores) */
  parsed_result_enriched?: unknown | null;
  /**
     * This file's own parsed result only (single _assessment_1_results), sliced out of the merged sister-file parsed_result. The review panel reads this so each file shows its own data; parsed_result stays the merged blob for report generation.
     * @nullable
     */
  parsed_result_scoped?: string | null;
  /**
     * Administration date of the assessment, derived from parsed_result. Distinct from created_date (upload time).
     * @nullable
     */
  effective_date?: string | null;
  /**
     * When parser-derived metadata (effective_date, respondent) was overridden out-of-band. Non-NULL means re-parse must not clobber those fields.
     * @nullable
     */
  clinician_edited_at?: string | null;
  /**
     * Denormalized respondent (TEACHER/PARENT) from the parser's report-type field, for history queries.
     *
     * * `TEACHER` - TEACHER
     * * `PARENT` - PARENT
     */
  respondent?: typeof LearnerFileRespondent[keyof typeof LearnerFileRespondent] | null;
  /** @nullable */
  readonly pdf_preview_file: string | null;
  readonly pdf_preview_status: typeof LearnerFilePdfPreviewStatus[keyof typeof LearnerFilePdfPreviewStatus] | null;
  organization: number;
  learner: number;
  /** @nullable */
  parent_file?: number | null;
  reports: number[];
}

export type LearnerTestProfileTestFilesItem = {[key: string]: unknown};

/**
 * Output shape + input for creates. See ``LearnerTestProfilePatchSerializer``
 * for the partial-update variant PUT uses.
 */
export interface LearnerTestProfile {
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  /** @nullable */
  organization_id?: number | null;
  mock_learner_data?: unknown;
  test_files?: LearnerTestProfileTestFilesItem[];
  report_types?: string[];
  notes?: string;
  /** @nullable */
  scoped_prompt_key?: string | null;
  readonly created_date: string;
  readonly last_updated_date: string;
}

export type LearnerTestProfilePatchTestFilesItem = {[key: string]: unknown};

/**
 * Input shape for PUT — every field optional so callers can send just
 * the columns they want to change (e.g. bumping ``notes`` alone shouldn't
 * require re-sending ``name``).
 */
export interface LearnerTestProfilePatch {
  /** @maxLength 255 */
  name?: string;
  /** @nullable */
  organization_id?: number | null;
  mock_learner_data?: unknown;
  test_files?: LearnerTestProfilePatchTestFilesItem[];
  report_types?: string[];
  notes?: string;
  /** @nullable */
  scoped_prompt_key?: string | null;
}

export interface LinkOrganizationClinicInput {
  clinic_listing_id: string;
  org_id: string;
}

export interface ListAcceptedPromptSuggestionsOutput {
  suggestions: AcceptedPromptSuggestion[];
}

export interface ListAvailableModelsOutput {
  models: AvailableModel[];
  default_model: string;
}

export interface ListEvalModelComparisonsOutput {
  results: EvalModelComparisonSummary[];
}

export interface ListEvalMultiModelTestsOutput {
  results: EvalMultiModelTestSummary[];
}

export interface ListEvalRubricsOutput {
  count: number;
  results: EvalRubricSummary[];
}

export interface ListExpertChatsPaginatedOutput {
  count: number;
  results: ExpertChatOversightRow[];
}

export interface ListPayorTypesOutput {
  results: string[];
}

export const PromptSuggestionTestPairwiseStatus = {...PairwiseStatusEnum,} as const
export const PromptSuggestionTestPairwiseVerdict = {...PairwiseVerdictEnum,} as const
/**
 * One Review & test: the live prompt and the draft side by side on one
 * profile and model.
 */
export interface PromptSuggestionTest {
  id: number;
  created_date: string;
  /** @nullable */
  learner_test_profile_id: number | null;
  /** @nullable */
  learner_test_profile_name: string | null;
  model: string;
  draft: unknown;
  /** @nullable */
  live_run_id: number | null;
  /** @nullable */
  draft_run_id: number | null;
  /** @nullable */
  live_status: string | null;
  /** @nullable */
  draft_status: string | null;
  pairwise_status: typeof PromptSuggestionTestPairwiseStatus[keyof typeof PromptSuggestionTestPairwiseStatus] | null;
  pairwise_verdict: typeof PromptSuggestionTestPairwiseVerdict[keyof typeof PromptSuggestionTestPairwiseVerdict] | null;
  /** @nullable */
  pairwise_summary: string | null;
}

export interface ListPromptSuggestionTestsOutput {
  tests: PromptSuggestionTest[];
}

/**
 * * `edit_org_prompt` - Edit the org's prompt
 * * `org_copy` - Create an org copy
 */
export type PromptSuggestionKindEnum = typeof PromptSuggestionKindEnum[keyof typeof PromptSuggestionKindEnum];


export const PromptSuggestionKindEnum = {
  edit_org_prompt: 'edit_org_prompt',
  org_copy: 'org_copy',
} as const;

/**
 * * `new` - New
 * * `dismissed` - Dismissed
 * * `testing` - Testing
 * * `approved` - Approved
 * * `incorporated` - Incorporated
 * * `shipped` - Shipped
 */
export type PromptSuggestionStatusEnum = typeof PromptSuggestionStatusEnum[keyof typeof PromptSuggestionStatusEnum];


export const PromptSuggestionStatusEnum = {
  new: 'new',
  dismissed: 'dismissed',
  testing: 'testing',
  approved: 'approved',
  incorporated: 'incorporated',
  shipped: 'shipped',
} as const;

/**
 * One clinician edit behind the theme. AI text only is a deletion,
 * user text only an addition.
 */
export interface PromptSuggestionExample {
  category: string;
  /** @nullable */
  reason: string | null;
  ai_text: string;
  user_text: string;
}

export interface PromptSuggestion {
  id: number;
  organization_id: number;
  organization_name: string;
  prompt_key: string;
  prompt_name: string;
  kind: PromptSuggestionKindEnum;
  status: PromptSuggestionStatusEnum;
  theme_title: string;
  theme_description: string;
  theme_categories: string[];
  theme_support: number;
  theme_group_size: number;
  theme_computed_at: string;
  theme_examples: PromptSuggestionExample[];
  /** @nullable */
  category_substitution_count: number | null;
  /** @nullable */
  category_deletion_count: number | null;
  /** @nullable */
  category_addition_count: number | null;
  draft: unknown;
  base_prompt: unknown | null;
  /** @nullable */
  baseline_pct_fields_edited: number | null;
  /** @nullable */
  baseline_avg_edit_percentage: number | null;
  /** @nullable */
  baseline_sample_size: number | null;
  created_date: string;
  /** @nullable */
  shipped_at: string | null;
  pipelines_pr_url: string;
  api_django_pr_url: string;
  readonly prompt_has_draft: boolean;
  /** @nullable */
  readonly redraft_reason: string | null;
  /** @nullable */
  redrafted_at: string | null;
  readonly redraft_in_progress: boolean;
  readonly incorporable: readonly IncorporationSuggestion[];
  readonly incorporating: readonly IncorporationSuggestion[];
  readonly incorporated: readonly IncorporationSuggestion[];
  readonly being_incorporated_into: IncorporationSuggestion | null;
  readonly can_dismiss: boolean;
  readonly can_edit_draft: boolean;
  readonly can_test: boolean;
  readonly can_open_pr: boolean;
  readonly can_redraft: boolean;
  /** There are others to incorporate or dismiss, and it can take them. */
  readonly can_incorporate: boolean;
}

export interface ListPromptSuggestionsOutput {
  suggestions: PromptSuggestion[];
}

export interface RulePackageRule {
  id: number;
  rule_set_id: number;
  name: string;
  category: string;
  /** Empty means all of the package's. */
  report_types: string[];
  location: string;
  /** Markdown. A rule with none is not sent. */
  scan_for: string;
  feedback: string;
  order: number;
  /** @nullable */
  archived_at: string | null;
  /** @nullable */
  legacy_criteria_id: number | null;
}

export interface RulePackage {
  id: number;
  name: string;
  description: string;
  instructions: string;
  /** base | insurance | custom */
  package_type: string;
  report_types: string[];
  payor_types: string[];
  /** @nullable */
  archived_at: string | null;
  rules: RulePackageRule[];
  /** Orgs this package is attached to. */
  readonly org_count: number;
  /** Templates this package is attached to. */
  readonly template_count: number;
  /**
     * Set when this custom package is attached to exactly one org and no templates.
     * @nullable
     */
  readonly exclusive_organization_id: number | null;
  /**
     * Set when this custom package is attached to exactly one template and no orgs.
     * @nullable
     */
  readonly exclusive_report_template_id: number | null;
}

export interface ListRulePackagesOutput {
  count: number;
  results: RulePackage[];
}

export interface ListYamlFilesOutput {
  filenames: string[];
}

export interface M2MAddGoalFieldInput {
  template_id: number;
  /** @nullable */
  domain_id?: number | null;
  title: string;
  field_type?: FieldTypeEnum;
  kind?: Kind18dEnum;
  /** @nullable */
  options?: string[] | null;
}

export interface M2MAddTPDomainInput {
  template_id: number;
  name: string;
  /** @nullable */
  description?: string | null;
}

export interface M2MRemoveGoalFieldInput {
  template_id: number;
  field_id: number;
  kind?: Kind18dEnum;
}

export interface M2MRemoveTPDomainInput {
  template_id: number;
  domain_id: number;
}

export type M2MSearchPromptsOutputResultsItem = {[key: string]: unknown};

export interface M2MSearchPromptsOutput {
  results: M2MSearchPromptsOutputResultsItem[];
}

export type M2MSearchTemplatesOutputResultsItem = {[key: string]: unknown};

export interface M2MSearchTemplatesOutput {
  results: M2MSearchTemplatesOutputResultsItem[];
}

export interface M2MTemplateMetaOutput {
  id: number;
  status: string;
  last_updated_date: string;
}

export interface M2MTreatmentPlanDomain {
  id: number;
  name: string;
  /** @nullable */
  description: string | null;
  rank_order: number;
}

export interface M2MTreatmentPlanField {
  id: number;
  /** @nullable */
  title: string | null;
  field_identifier: string;
  field_type: string;
  type: string;
  rank_order: number;
  is_enabled: boolean;
  report_goal_field: boolean;
  report_target_field?: boolean;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  domain_id: number | null;
}

export interface M2MUpdateGoalFieldInput {
  template_id: number;
  field_id: number;
  title?: string;
  field_type?: FieldTypeEnum;
  is_enabled?: boolean;
  kind?: Kind18dEnum;
  /** @nullable */
  options?: string[] | null;
}

export interface M2MUpdateTPDomainInput {
  template_id: number;
  domain_id: number;
  name?: string;
  /** @nullable */
  description?: string | null;
}

export interface M2MUpdateTemplateDescriptionInput {
  template_id: number;
  description: string;
}

export interface M2MUpdateTemplateDescriptionOutput {
  id: number;
  description: string;
}

/**
 * * `ENGLISH` - ENGLISH
 * * `SPANISH` - SPANISH
 * * `HINDI` - HINDI
 * * `ARABIC` - ARABIC
 */
export type MediaLanguageEnum = typeof MediaLanguageEnum[keyof typeof MediaLanguageEnum];


export const MediaLanguageEnum = {
  ENGLISH: 'ENGLISH',
  SPANISH: 'SPANISH',
  HINDI: 'HINDI',
  ARABIC: 'ARABIC',
} as const;

export const MediaMediaLanguage = {...MediaLanguageEnum,...BlankEnum,} as const
/**
 * * `inprogress` - inprogress
 * * `completed` - completed
 */
export type VideoUploadStatusEnum = typeof VideoUploadStatusEnum[keyof typeof VideoUploadStatusEnum];


export const VideoUploadStatusEnum = {
  inprogress: 'inprogress',
  completed: 'completed',
} as const;

export const MediaVideoUploadStatus = {...VideoUploadStatusEnum,} as const
/**
 * * `GOOGLE_DRIVE` - GOOGLE_DRIVE
 * * `VIDEO_CAPTURE_APP` - VIDEO_CAPTURE_APP
 * * `ANNOTATION_TOOL` - ANNOTATION_TOOL
 * * `OLD_ANNOTATION_TOOL` - OLD_ANNOTATION_TOOL
 * * `SWIVL` - SWIVL
 * * `GCP_BUCKET` - GCP_BUCKET
 * * `ZOOM_CLOUD_RECORDING` - ZOOM_CLOUD_RECORDING
 * * `GOOGLE_CLOUD_RECORDING` - GOOGLE_CLOUD_RECORDING
 * * `IN_CLINIC_VIDEO_CAPTURE` - IN_CLINIC_VIDEO_CAPTURE
 * * `EXPERT_CHAT_UPLOAD` - EXPERT_CHAT_UPLOAD
 * * `OTHER` - OTHER
 */
export type MediaSourceEnum = typeof MediaSourceEnum[keyof typeof MediaSourceEnum];


export const MediaSourceEnum = {
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',
  VIDEO_CAPTURE_APP: 'VIDEO_CAPTURE_APP',
  ANNOTATION_TOOL: 'ANNOTATION_TOOL',
  OLD_ANNOTATION_TOOL: 'OLD_ANNOTATION_TOOL',
  SWIVL: 'SWIVL',
  GCP_BUCKET: 'GCP_BUCKET',
  ZOOM_CLOUD_RECORDING: 'ZOOM_CLOUD_RECORDING',
  GOOGLE_CLOUD_RECORDING: 'GOOGLE_CLOUD_RECORDING',
  IN_CLINIC_VIDEO_CAPTURE: 'IN_CLINIC_VIDEO_CAPTURE',
  EXPERT_CHAT_UPLOAD: 'EXPERT_CHAT_UPLOAD',
  OTHER: 'OTHER',
} as const;

export const MediaMediaSource = {...MediaSourceEnum,} as const
/**
 * * `ACTIVE` - ACTIVE
 * * `DONE` - DONE
 * * `ARCHIVED` - ARCHIVED
 */
export type MediaStatusEnum = typeof MediaStatusEnum[keyof typeof MediaStatusEnum];


export const MediaStatusEnum = {
  ACTIVE: 'ACTIVE',
  DONE: 'DONE',
  ARCHIVED: 'ARCHIVED',
} as const;

/**
 * * `video` - video
 * * `combined` - combined
 * * `annotation_upload` - annotation upload
 * * `caregiver_intake_upload` - caregiver intake upload
 */
export type MediaTypeEnum = typeof MediaTypeEnum[keyof typeof MediaTypeEnum];


export const MediaTypeEnum = {
  video: 'video',
  combined: 'combined',
  annotation_upload: 'annotation_upload',
  caregiver_intake_upload: 'caregiver_intake_upload',
} as const;

export interface Media {
  readonly id: number;
  readonly created_by: User;
  readonly created_date: string;
  readonly last_updated_date: string;
  /** @nullable */
  start_datetime?: string | null;
  /** @nullable */
  end_datetime?: string | null;
  /**
     * @maxLength 255
     * @nullable
     */
  recording_id?: string | null;
  media_language?: typeof MediaMediaLanguage[keyof typeof MediaMediaLanguage] | null;
  media_status?: MediaStatusEnum;
  media_type: MediaTypeEnum;
  readonly blob_id: string;
  /** @nullable */
  file_path?: string | null;
  video_upload_status?: typeof MediaVideoUploadStatus[keyof typeof MediaVideoUploadStatus] | null;
  media_source?: typeof MediaMediaSource[keyof typeof MediaMediaSource] | null;
  /** @nullable */
  total_duration?: number | null;
  /** @nullable */
  multiple_people_including_child_duration?: number | null;
  is_viewed?: boolean;
  /** @nullable */
  viewed_at?: string | null;
  /** @nullable */
  thumbnail_manifest_path?: string | null;
  organization: number;
  /** @nullable */
  video_session?: number | null;
  /** @nullable */
  media_group?: number | null;
  /** @nullable */
  viewed_by?: number | null;
}

export interface MoveFieldInput {
  template_id: number;
  section_id: number;
  field_id: number;
  rank_order: number;
  /** @nullable */
  new_section_id?: number | null;
}

export interface MoveSectionInput {
  template_id: number;
  section_id: number;
  rank_order: number;
}

export interface MultiModelTestAdvanceOutput {
  advanced: boolean;
  settled: boolean;
}

export type MultiModelTestCreateInputItemsItem = {[key: string]: unknown};

export interface MultiModelTestCreateInput {
  /** @maxLength 255 */
  name?: string;
  candidate_models: string[];
  items: MultiModelTestCreateInputItemsItem[];
}

export interface MultiModelTestProfileOption {
  learner_test_profile_id: number;
  profile_name: string;
  runnable: number;
  skipped: number;
}

export interface MultiModelTestTemplateSuggestion {
  template_id: number;
  template_name: string;
  total_slots: number;
  suggested: MultiModelTestProfileOption | null;
  profiles: MultiModelTestProfileOption[];
}

export interface MultiModelTestSuggestionsOutput {
  templates: MultiModelTestTemplateSuggestion[];
}

export interface OpenAssessmentInputPROutput {
  pipelines_pr_url: string;
  api_django_pr_url: string;
}

export interface OpenPRBulkOutput {
  pipelines_pr_url: string;
  api_django_pr_url: string;
  prompt_keys: string[];
}

export interface OpenPROutput {
  pipelines_pr_url: string;
  api_django_pr_url: string;
}

export type OpenPromptsPRBulkFromDraftsInputPromptsItem = {[key: string]: string};

export interface OpenPromptsPRBulkFromDraftsInput {
  /** @minItems 1 */
  prompts: OpenPromptsPRBulkFromDraftsInputPromptsItem[];
}

export interface Output {
  workflow_id: string;
}

/**
 * * `IN_PROGRESS` - IN_PROGRESS
 * * `COMPLETED` - COMPLETED
 * * `FAILED` - FAILED
 */
export type ReviewStatusEnum = typeof ReviewStatusEnum[keyof typeof ReviewStatusEnum];


export const ReviewStatusEnum = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export const PaginatedGetCareNavigationListingsOutputCoverageStatus = {...ReviewStatusEnum,} as const
export interface PaginatedGetCareNavigationListingsOutput {
  count: number;
  /** @nullable */
  next: string | null;
  /** @nullable */
  previous: string | null;
  results: GetCareNavigationListingsOutput[];
  coverage_status: typeof PaginatedGetCareNavigationListingsOutputCoverageStatus[keyof typeof PaginatedGetCareNavigationListingsOutputCoverageStatus] | null;
}

export const PatchedLearnerFileProcessingFailureCode = {...ProcessingFailureCodeEnum,...BlankEnum,} as const
export const PatchedLearnerFileAssessmentTemplateType = {...AssessmentTemplateTypeEnum,...BlankEnum,} as const
export const PatchedLearnerFileRespondent = {...RespondentEnum,...BlankEnum,} as const
export const PatchedLearnerFilePdfPreviewStatus = {...PdfPreviewStatusEnum,} as const
export interface PatchedLearnerFile {
  readonly id?: number;
  readonly created_by?: User;
  readonly created_date?: string;
  readonly last_updated_date?: string;
  readonly s3_key?: string;
  /** @maxLength 100 */
  mime_type?: string;
  /** @maxLength 512 */
  original_file_name?: string;
  /**
     * @minimum -9223372036854776000
     * @maximum 9223372036854776000
     */
  file_size?: number;
  /** @nullable */
  processing_failure_reason?: string | null;
  /**
     * Stable machine code for the failure reason, for clients to switch on without matching prose.
     *
     * * `FRONTERA_TEMPLATE_PDF` - Frontera template exported as PDF
     */
  processing_failure_code?: typeof PatchedLearnerFileProcessingFailureCode[keyof typeof PatchedLearnerFileProcessingFailureCode] | null;
  metadata?: unknown | null;
  /**
     * Stores output from the FileParsingWorkflow
     * @nullable
     */
  parsed_result?: string | null;
  /** @maxLength 60 */
  file_kind?: string;
  status?: LearnerFileStatusEnum;
  assessment_template_type?: typeof PatchedLearnerFileAssessmentTemplateType[keyof typeof PatchedLearnerFileAssessmentTemplateType] | null;
  /** Stores parsed table output for assessments from the FileParsingWorkflow */
  parsed_tables?: unknown | null;
  /** Enriched assessment data derived from parsed_result (descriptions, cutoffs, derived scores) */
  parsed_result_enriched?: unknown | null;
  /**
     * This file's own parsed result only (single _assessment_1_results), sliced out of the merged sister-file parsed_result. The review panel reads this so each file shows its own data; parsed_result stays the merged blob for report generation.
     * @nullable
     */
  parsed_result_scoped?: string | null;
  /**
     * Administration date of the assessment, derived from parsed_result. Distinct from created_date (upload time).
     * @nullable
     */
  effective_date?: string | null;
  /**
     * When parser-derived metadata (effective_date, respondent) was overridden out-of-band. Non-NULL means re-parse must not clobber those fields.
     * @nullable
     */
  clinician_edited_at?: string | null;
  /**
     * Denormalized respondent (TEACHER/PARENT) from the parser's report-type field, for history queries.
     *
     * * `TEACHER` - TEACHER
     * * `PARENT` - PARENT
     */
  respondent?: typeof PatchedLearnerFileRespondent[keyof typeof PatchedLearnerFileRespondent] | null;
  /** @nullable */
  readonly pdf_preview_file?: string | null;
  readonly pdf_preview_status?: typeof PatchedLearnerFilePdfPreviewStatus[keyof typeof PatchedLearnerFilePdfPreviewStatus] | null;
  organization?: number;
  learner?: number;
  /** @nullable */
  parent_file?: number | null;
  reports?: number[];
}

export const PatchedMediaMediaLanguage = {...MediaLanguageEnum,...BlankEnum,} as const
export const PatchedMediaVideoUploadStatus = {...VideoUploadStatusEnum,} as const
export const PatchedMediaMediaSource = {...MediaSourceEnum,} as const
export interface PatchedMedia {
  readonly id?: number;
  readonly created_by?: User;
  readonly created_date?: string;
  readonly last_updated_date?: string;
  /** @nullable */
  start_datetime?: string | null;
  /** @nullable */
  end_datetime?: string | null;
  /**
     * @maxLength 255
     * @nullable
     */
  recording_id?: string | null;
  media_language?: typeof PatchedMediaMediaLanguage[keyof typeof PatchedMediaMediaLanguage] | null;
  media_status?: MediaStatusEnum;
  media_type?: MediaTypeEnum;
  readonly blob_id?: string;
  /** @nullable */
  file_path?: string | null;
  video_upload_status?: typeof PatchedMediaVideoUploadStatus[keyof typeof PatchedMediaVideoUploadStatus] | null;
  media_source?: typeof PatchedMediaMediaSource[keyof typeof PatchedMediaMediaSource] | null;
  /** @nullable */
  total_duration?: number | null;
  /** @nullable */
  multiple_people_including_child_duration?: number | null;
  is_viewed?: boolean;
  /** @nullable */
  viewed_at?: string | null;
  /** @nullable */
  thumbnail_manifest_path?: string | null;
  organization?: number;
  /** @nullable */
  video_session?: number | null;
  /** @nullable */
  media_group?: number | null;
  /** @nullable */
  viewed_by?: number | null;
}

export interface PatchedPatchEvalModelComparisonInput {
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  verdict?: string | null;
  picks?: ComparisonPickInput[];
}

export interface PatchedUpdateBaseQACriteriaInput {
  id?: number;
  name?: string;
  content?: string;
  category?: string;
}

export interface PatchedUpdateOrgQACriteriaInput {
  id?: number;
  enabled?: boolean;
  content?: string;
  category?: string;
}

/**
 * * `CREATED` - CREATED
 * * `RECORDING` - RECORDING
 * * `PARTIAL_CAPTURE_ERROR` - PARTIAL_CAPTURE_ERROR
 * * `FULL_CAPTURE_ERROR` - FULL_CAPTURE_ERROR
 * * `UPLOADING` - UPLOADING
 * * `PARTIAL_UPLOAD_ERROR` - PARTIAL_UPLOAD_ERROR
 * * `SCHEDULED` - SCHEDULED
 * * `PROCESSING` - PROCESSING
 * * `COMPLETED` - COMPLETED
 * * `FAILED` - FAILED
 */
export type SessionStatusEnum = typeof SessionStatusEnum[keyof typeof SessionStatusEnum];


export const SessionStatusEnum = {
  CREATED: 'CREATED',
  RECORDING: 'RECORDING',
  PARTIAL_CAPTURE_ERROR: 'PARTIAL_CAPTURE_ERROR',
  FULL_CAPTURE_ERROR: 'FULL_CAPTURE_ERROR',
  UPLOADING: 'UPLOADING',
  PARTIAL_UPLOAD_ERROR: 'PARTIAL_UPLOAD_ERROR',
  SCHEDULED: 'SCHEDULED',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export const PatchedVideoSessionSessionStatus = {...SessionStatusEnum,} as const
/**
 * * `USER_VIDEO_UPLOAD` - USER_VIDEO_UPLOAD
 * * `IN_APP_VIDEO_RECORDING` - IN_APP_VIDEO_RECORDING
 */
export type SourceTypeEnum = typeof SourceTypeEnum[keyof typeof SourceTypeEnum];


export const SourceTypeEnum = {
  USER_VIDEO_UPLOAD: 'USER_VIDEO_UPLOAD',
  IN_APP_VIDEO_RECORDING: 'IN_APP_VIDEO_RECORDING',
} as const;

export const PatchedVideoSessionSourceType = {...SourceTypeEnum,...BlankEnum,} as const
/**
 * * `CAREGIVER` - CAREGIVER
 * * `THERAPIST` - THERAPIST
 * * `INCLINIC` - INCLINIC
 * * `OTHER` - OTHER
 */
export type RecorderTypeEnum = typeof RecorderTypeEnum[keyof typeof RecorderTypeEnum];


export const RecorderTypeEnum = {
  CAREGIVER: 'CAREGIVER',
  THERAPIST: 'THERAPIST',
  INCLINIC: 'INCLINIC',
  OTHER: 'OTHER',
} as const;

export const PatchedVideoSessionRecorderType = {...RecorderTypeEnum,...BlankEnum,} as const
export interface PatchedVideoSession {
  readonly id?: number;
  readonly created_by?: User;
  readonly created_date?: string;
  readonly last_updated_date?: string;
  date?: string;
  /** @nullable */
  start_datetime?: string | null;
  /** @nullable */
  end_datetime?: string | null;
  session_status?: typeof PatchedVideoSessionSessionStatus[keyof typeof PatchedVideoSessionSessionStatus] | null;
  /** @nullable */
  engagement_score?: number | null;
  /** @nullable */
  engagement_score_version?: string | null;
  /**
     * @minimum -2147483648
     * @maximum 2147483647
     * @nullable
     */
  session_rating?: number | null;
  /** @nullable */
  comment?: string | null;
  source_type?: typeof PatchedVideoSessionSourceType[keyof typeof PatchedVideoSessionSourceType] | null;
  recorder_type?: typeof PatchedVideoSessionRecorderType[keyof typeof PatchedVideoSessionRecorderType] | null;
  /**
     * Meeting ID from Zoom or other meeting platform
     * @maxLength 255
     * @nullable
     */
  meeting_id?: string | null;
  organization?: number;
  /** @nullable */
  final_media?: number | null;
  /** @nullable */
  therapy_session?: number | null;
}

/**
 * * `BCBS` - BCBS
 * * `UNITED_HEALTHCARE` - UNITED_HEALTHCARE
 * * `AETNA` - AETNA
 * * `CIGNA` - CIGNA
 * * `HUMANA` - HUMANA
 * * `ANTHEM` - ANTHEM
 * * `KAISER_PERMANENTE` - KAISER_PERMANENTE
 * * `TRICARE` - TRICARE
 * * `MAGELLAN_HEALTH` - MAGELLAN_HEALTH
 * * `BEACON_HEALTH_OPTIONS` - BEACON_HEALTH_OPTIONS
 * * `MEDICAID` - MEDICAID
 * * `CATALIGHT` - CATALIGHT
 * * `OPTUM` - OPTUM
 * * `BSW` - BSW
 * * `EVERNORTH` - EVERNORTH
 * * `MOLINA` - MOLINA
 * * `EMI_HEALTH` - EMI_HEALTH
 */
export type PayorTypeEnum = typeof PayorTypeEnum[keyof typeof PayorTypeEnum];


export const PayorTypeEnum = {
  BCBS: 'BCBS',
  UNITED_HEALTHCARE: 'UNITED_HEALTHCARE',
  AETNA: 'AETNA',
  CIGNA: 'CIGNA',
  HUMANA: 'HUMANA',
  ANTHEM: 'ANTHEM',
  KAISER_PERMANENTE: 'KAISER_PERMANENTE',
  TRICARE: 'TRICARE',
  MAGELLAN_HEALTH: 'MAGELLAN_HEALTH',
  BEACON_HEALTH_OPTIONS: 'BEACON_HEALTH_OPTIONS',
  MEDICAID: 'MEDICAID',
  CATALIGHT: 'CATALIGHT',
  OPTUM: 'OPTUM',
  BSW: 'BSW',
  EVERNORTH: 'EVERNORTH',
  MOLINA: 'MOLINA',
  EMI_HEALTH: 'EMI_HEALTH',
} as const;

export interface PreviewCommunityDigestOutput {
  html: string;
}

export interface PreviewEvalModelComparisonOutput {
  fields: ComparisonFieldSlot[];
  skipped_fields: SkippedComparisonFieldSlot[];
}

export interface PreviewQARulesInput {
  /** @nullable */
  organization_id?: number | null;
  /** @nullable */
  report_template_id?: number | null;
  /** @nullable */
  report_type?: string | null;
  /** @nullable */
  payor_type?: string | null;
}

export interface QAPreviewRule {
  rule: RulePackageRule;
  included: boolean;
  /**
     * organization_package | template_package | organization_rule | template_rule
     * @nullable
     */
  turned_off_by: string | null;
  /** @nullable */
  org_enabled: boolean | null;
  /** @nullable */
  template_enabled: boolean | null;
}

export interface QAPreviewPackage {
  id: number;
  name: string;
  package_type: string;
  instructions: string;
  /** Why it applies: base | insurance | organization | template */
  sources: string[];
  /**
     * The org's row for this package, if any.
     * @nullable
     */
  org_enabled: boolean | null;
  /**
     * The template's row for this package, if any.
     * @nullable
     */
  template_enabled: boolean | null;
  rules: QAPreviewRule[];
}

export interface PreviewQARulesOutput {
  /** @nullable */
  report_type: string | null;
  /** @nullable */
  payor_type: string | null;
  packages: QAPreviewPackage[];
}

export interface PromoteTemplateInput {
  template_id: number;
  /** @nullable */
  previous_template_id?: number | null;
}

export interface PromoteTemplateOutput {
  success: boolean;
  message: string;
}

export interface PromptOutput {
  id: number;
  key: string;
  name: string;
}

export type PromptSuggestionDraftM2MOutputDraftOverrides = {[key: string]: unknown};

export interface PromptSuggestionDraftM2MOutput {
  draft_overrides: PromptSuggestionDraftM2MOutputDraftOverrides;
}

export interface PromptSummary {
  id: number;
  key: string;
  name: string;
}

export type PromptTestRunTestFileUuidsSnapshotItem = {[key: string]: unknown};

export interface PromptTestRun {
  readonly id: number;
  readonly prompt_key: string;
  /** @nullable */
  learner_test_profile_id: number | null;
  workflow_id: string;
  status: string;
  /** @nullable */
  result: string | null;
  /** @nullable */
  draft_instructions_snapshot: string | null;
  model?: string;
  draft_overrides_snapshot: unknown | null;
  mock_learner_data_snapshot: unknown;
  test_file_uuids_snapshot: PromptTestRunTestFileUuidsSnapshotItem[];
  scope_report?: unknown;
  readonly created_date: string;
}

export interface PublishCommunityDigestInput {
  /** @maxLength 120 */
  email_subject: string;
  popular: DigestPopular;
  sections: DigestSection[];
}

export type PutGoalGenerationRulesInputAiFields = {[key: string]: boolean};

/**
 * Per-field goal-generation instructions. Nested shape {template_id: {key: text}} applies whole-map semantics per included template (org-linked templates write their rows; shared templates rewrite the org-level entries for the submitted keys). Legacy flat shape {key: text} replaces the org-level map wholesale.
 */
export type PutGoalGenerationRulesInputFieldInstructions = {[key: string]: unknown};

/**
 * Org-default per-field instructions ({key: text}) — the layer template rows fall back to. Merge semantics: submitted keys replace their org-level entry (blank text deletes it); unsubmitted keys are preserved. Cannot be combined with the legacy flat field_instructions shape.
 */
export type PutGoalGenerationRulesInputOrgFieldInstructions = {[key: string]: string};

export interface PutGoalGenerationRulesInput {
  /** @nullable */
  general?: string | null;
  ai_fields?: PutGoalGenerationRulesInputAiFields;
  /** Per-field goal-generation instructions. Nested shape {template_id: {key: text}} applies whole-map semantics per included template (org-linked templates write their rows; shared templates rewrite the org-level entries for the submitted keys). Legacy flat shape {key: text} replaces the org-level map wholesale. */
  field_instructions?: PutGoalGenerationRulesInputFieldInstructions;
  /** Org-default per-field instructions ({key: text}) — the layer template rows fall back to. Merge semantics: submitted keys replace their org-level entry (blank text deletes it); unsubmitted keys are preserved. Cannot be combined with the legacy flat field_instructions shape. */
  org_field_instructions?: PutGoalGenerationRulesInputOrgFieldInstructions;
}

export interface PutParsedTestFileInput {
  s3_prefix: string;
  parsed_json: string;
}

export interface PutParsedTestFileOutput {
  parsed_json: string;
}

export interface PutPromptDraftInput {
  draft_overrides?: unknown | null;
}

/**
 * M2M shape: single-field merge, not the full-dict REPLACE the SPA
 * uses. Rio calls this once per field-edit tool call, so the endpoint
 * does the read-modify-write internally to keep the client simple.
 */
export interface PutPromptDraftM2MInput {
  field: string;
  value: unknown | null;
}

export interface PutPromptSuggestionDraftM2MInput {
  field: string;
  value: unknown | null;
}

export interface QAPackageOrgLink {
  organization_id: number;
  organization_name: string;
  /** false = turned off for this org */
  enabled: boolean;
}

export interface QAPackageTemplateLink {
  report_template_id: number;
  report_template_name: string;
  report_template_status: string;
  /** false = turned off for this template */
  enabled: boolean;
}

/**
 * A single rule turned off for one org or one template.
 */
export interface QARuleOff {
  rule_id: number;
  /** @nullable */
  organization_id: number | null;
  /** @nullable */
  organization_name: string | null;
  /** @nullable */
  report_template_id: number | null;
  /** @nullable */
  report_template_name: string | null;
}

export interface QAToggleOutput {
  /**
     * null means no row: back to the default.
     * @nullable
     */
  enabled: boolean | null;
}

/**
 * * `no_source` - No source material to check against
 * * `not_ai_authored` - Does not look AI-authored
 * * `out_of_scope` - Out of scope for this rubric
 * * `needs_clinical_input` - Needs a clinician
 * * `other` - Other
 */
export type ReasonCodeEnum = typeof ReasonCodeEnum[keyof typeof ReasonCodeEnum];


export const ReasonCodeEnum = {
  no_source: 'no_source',
  not_ai_authored: 'not_ai_authored',
  out_of_scope: 'out_of_scope',
  needs_clinical_input: 'needs_clinical_input',
  other: 'other',
} as const;

export interface ReassignExpertChatInput {
  learner_id: number;
  provider_id: number;
}

export interface ReassignExpertChatOutput {
  chat_id: number;
  learner_id: number;
  new_provider_id: number;
}

/**
 * @nullable
 */
export type RecentExportOutputOverrides = {[key: string]: unknown} | null;

export interface RecentExportOutput {
  workflow_id: string;
  status: string;
  started_at: string;
  /** @nullable */
  closed_at: string | null;
  workflow_type: string;
  /** @nullable */
  report_id: string | null;
  /** @nullable */
  doctype: string | null;
  /** @nullable */
  overrides?: RecentExportOutputOverrides;
}

export interface RemoveFieldInput {
  template_id: number;
  section_id: number;
  field_id: number;
}

export interface RemoveFieldOutput {
  deleted_field_id: number;
}

export interface RemoveOrganizationUserInput {
  auth0_id: string;
  organization_id: string;
}

export interface RemoveSectionInput {
  template_id: number;
  section_id: number;
}

export interface RemoveSectionOutput {
  deleted_section_id: number;
}

export interface ReorderRulesInput {
  rule_set_id: number;
  /** New order for these rules; the package's other rules follow, keeping their order. */
  rule_ids: number[];
}

export interface RestoreOrphanedOrganizationUserInput {
  organization_id: string;
  provider_id: string;
  roles: RolesEnum[];
}

/**
 * Read-side attachment shape — the input triple plus a fresh
 * short-lived signed URL the SPA renders directly.
 */
export interface RioAttachmentPreview {
  file_uuid: string;
  filename: string;
  mime_type: string;
  signed_url: string;
}

/**
 * * `apply_add_section` - apply_add_section
 * * `apply_update_section` - apply_update_section
 * * `apply_remove_section` - apply_remove_section
 * * `apply_move_section` - apply_move_section
 * * `apply_add_field` - apply_add_field
 * * `apply_update_field` - apply_update_field
 * * `apply_remove_field` - apply_remove_field
 * * `apply_move_field` - apply_move_field
 * * `apply_update_template_description` - apply_update_template_description
 * * `apply_add_treatment_plan_domain` - apply_add_treatment_plan_domain
 * * `apply_update_treatment_plan_domain` - apply_update_treatment_plan_domain
 * * `apply_remove_treatment_plan_domain` - apply_remove_treatment_plan_domain
 * * `apply_add_goal_field` - apply_add_goal_field
 * * `apply_update_goal_field` - apply_update_goal_field
 * * `apply_remove_goal_field` - apply_remove_goal_field
 * * `apply_add_target_field` - apply_add_target_field
 * * `apply_update_target_field` - apply_update_target_field
 * * `apply_remove_target_field` - apply_remove_target_field
 * * `apply_edit_prompt_draft` - apply_edit_prompt_draft
 * * `apply_create_prompt` - apply_create_prompt
 * * `apply_start_test_run` - apply_start_test_run
 * * `apply_edit_learner_profile_mock` - apply_edit_learner_profile_mock
 * * `apply_toggle_test_file` - apply_toggle_test_file
 * * `apply_open_edit_prompt_pr` - apply_open_edit_prompt_pr
 * * `apply_open_new_prompt_pr` - apply_open_new_prompt_pr
 * * `apply_construct_prompt_draft` - apply_construct_prompt_draft
 */
export type ToolNameEnum = typeof ToolNameEnum[keyof typeof ToolNameEnum];


export const ToolNameEnum = {
  apply_add_section: 'apply_add_section',
  apply_update_section: 'apply_update_section',
  apply_remove_section: 'apply_remove_section',
  apply_move_section: 'apply_move_section',
  apply_add_field: 'apply_add_field',
  apply_update_field: 'apply_update_field',
  apply_remove_field: 'apply_remove_field',
  apply_move_field: 'apply_move_field',
  apply_update_template_description: 'apply_update_template_description',
  apply_add_treatment_plan_domain: 'apply_add_treatment_plan_domain',
  apply_update_treatment_plan_domain: 'apply_update_treatment_plan_domain',
  apply_remove_treatment_plan_domain: 'apply_remove_treatment_plan_domain',
  apply_add_goal_field: 'apply_add_goal_field',
  apply_update_goal_field: 'apply_update_goal_field',
  apply_remove_goal_field: 'apply_remove_goal_field',
  apply_add_target_field: 'apply_add_target_field',
  apply_update_target_field: 'apply_update_target_field',
  apply_remove_target_field: 'apply_remove_target_field',
  apply_edit_prompt_draft: 'apply_edit_prompt_draft',
  apply_create_prompt: 'apply_create_prompt',
  apply_start_test_run: 'apply_start_test_run',
  apply_edit_learner_profile_mock: 'apply_edit_learner_profile_mock',
  apply_toggle_test_file: 'apply_toggle_test_file',
  apply_open_edit_prompt_pr: 'apply_open_edit_prompt_pr',
  apply_open_new_prompt_pr: 'apply_open_new_prompt_pr',
  apply_construct_prompt_draft: 'apply_construct_prompt_draft',
} as const;

/**
 * Structured payload for SYSTEM tool-log rows (apply_* tool calls).
 *
 * `tool_name` is a ChoiceField so DRF Spectacular emits it as an OpenAPI
 * enum — Orval then generates a `RioToolName` TypeScript enum automatically.
 * Adding a new tool requires:
 *   1. Adding the value to `api.enum.rio_enums.RioToolName`.
 *   2. Running `make codegen` in basecamp — the TS enum updates itself.
 */
export interface RioToolPayload {
  /**
     * The apply_* tool Rio invoked.
     *
     * * `apply_add_section` - apply_add_section
     * * `apply_update_section` - apply_update_section
     * * `apply_remove_section` - apply_remove_section
     * * `apply_move_section` - apply_move_section
     * * `apply_add_field` - apply_add_field
     * * `apply_update_field` - apply_update_field
     * * `apply_remove_field` - apply_remove_field
     * * `apply_move_field` - apply_move_field
     * * `apply_update_template_description` - apply_update_template_description
     * * `apply_add_treatment_plan_domain` - apply_add_treatment_plan_domain
     * * `apply_update_treatment_plan_domain` - apply_update_treatment_plan_domain
     * * `apply_remove_treatment_plan_domain` - apply_remove_treatment_plan_domain
     * * `apply_add_goal_field` - apply_add_goal_field
     * * `apply_update_goal_field` - apply_update_goal_field
     * * `apply_remove_goal_field` - apply_remove_goal_field
     * * `apply_add_target_field` - apply_add_target_field
     * * `apply_update_target_field` - apply_update_target_field
     * * `apply_remove_target_field` - apply_remove_target_field
     * * `apply_edit_prompt_draft` - apply_edit_prompt_draft
     * * `apply_create_prompt` - apply_create_prompt
     * * `apply_start_test_run` - apply_start_test_run
     * * `apply_edit_learner_profile_mock` - apply_edit_learner_profile_mock
     * * `apply_toggle_test_file` - apply_toggle_test_file
     * * `apply_open_edit_prompt_pr` - apply_open_edit_prompt_pr
     * * `apply_open_new_prompt_pr` - apply_open_new_prompt_pr
     * * `apply_construct_prompt_draft` - apply_construct_prompt_draft
     */
  tool_name: ToolNameEnum;
  /** Parsed arguments the tool was called with. */
  args: unknown | null;
  /** Human-readable one-liner describing the outcome. */
  result_summary: string;
  /** Full snapshot of the deleted item; present on apply_remove_* rows. */
  pre_delete_state: unknown | null;
  /** Old values of just the mutated fields; present on apply_update_* rows. */
  pre_update_state?: unknown | null;
  /** @nullable */
  section_title?: string | null;
  /** @nullable */
  new_section_title?: string | null;
}

/**
 * Mirrors the workflow's ChatMessage shape.
 */
export interface RioMessage {
  role: string;
  content: string;
  /** @nullable */
  user_name?: string | null;
  message_id: string;
  edit?: RioToolPayload | null;
  attachments?: RioAttachmentPreview[];
}

export interface RioMessageList {
  messages: RioMessage[];
}

/**
 * * `USER` - USER
 * * `ASSISTANT` - ASSISTANT
 * * `SYSTEM` - SYSTEM
 */
export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


export const RoleEnum = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;

export interface RulePackageDetail {
  id: number;
  name: string;
  description: string;
  instructions: string;
  /** base | insurance | custom */
  package_type: string;
  report_types: string[];
  payor_types: string[];
  /** @nullable */
  archived_at: string | null;
  rules: RulePackageRule[];
  /** Orgs this package is attached to. */
  readonly org_count: number;
  /** Templates this package is attached to. */
  readonly template_count: number;
  /**
     * Set when this custom package is attached to exactly one org and no templates.
     * @nullable
     */
  readonly exclusive_organization_id: number | null;
  /**
     * Set when this custom package is attached to exactly one template and no orgs.
     * @nullable
     */
  readonly exclusive_report_template_id: number | null;
  org_links: QAPackageOrgLink[];
  template_links: QAPackageTemplateLink[];
  rule_offs: QARuleOff[];
}

/**
 * Editable package fields, shared by create and update.
 */
export interface RulePackageFields {
  /** @maxLength 255 */
  name: string;
  description?: string;
  instructions?: string;
  /** base | insurance | custom */
  package_type: string;
  report_types?: string[];
  payor_types?: string[];
}

export interface SaveRioMessageInput {
  role: RoleEnum;
  content: string;
  /** @nullable */
  user_name?: string | null;
  /** @maxLength 64 */
  message_id: string;
  tool_payload?: unknown | null;
  attachments?: unknown[];
}

export interface SaveRioMessageOutput {
  message_id: string;
  created: boolean;
}

export interface SaveRioPromptMessageInput {
  role: RoleEnum;
  content: string;
  /** @nullable */
  user_name?: string | null;
  /** @maxLength 64 */
  message_id: string;
  tool_payload?: unknown | null;
  attachments?: unknown[];
}

export interface SaveRioPromptMessageOutput {
  message_id: string;
  created: boolean;
}

export interface ScoreEvalReviewItemInput {
  dimension_scores: EvalDimensionScore[];
  overall_notes?: string;
  failure_tags?: string[];
  /** @nullable */
  time_spent_seconds?: number | null;
  reviewed_text?: string;
}

export interface SectionField {
  id: number;
  /** @nullable */
  field_identifier: string | null;
  title: string;
  rank_order: number;
  field_type: string;
  is_required: boolean;
  is_auditable: boolean;
  /** @nullable */
  content: string | null;
  input_dependency: unknown | null;
  /** @nullable */
  table_key: string | null;
  /** @nullable */
  sample_data: string | null;
  prompt: PromptSummary | null;
}

export interface Section {
  id: number;
  rank_order: number;
  /** @nullable */
  key: string | null;
  page_location: string;
  title: string;
  input_dependency: unknown | null;
  readonly section_fields: readonly SectionField[];
}

export interface SectionFieldInput {
  /** @nullable */
  id?: number | null;
  title?: string;
  rank_order?: number;
  field_type?: string;
  is_required?: boolean;
  is_auditable?: boolean;
  /** @nullable */
  content?: string | null;
  /** @nullable */
  field_identifier?: string | null;
  /** @nullable */
  input_dependency?: string[] | null;
  /** @nullable */
  prompt_id?: number | null;
  /** @nullable */
  table_key?: string | null;
  /** @nullable */
  sample_data?: string | null;
}

export interface SectionInput {
  /** @nullable */
  id?: number | null;
  page_location?: string;
  rank_order?: number;
  title?: string;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  input_dependency?: string[] | null;
  section_fields?: SectionFieldInput[];
}

export interface SendRioMessageInput {
  content: string;
  display_name?: string;
  /** @maxLength 64 */
  message_id?: string;
  attachments?: unknown[];
}

export interface SendRioMessageOutput {
  message_id: string;
}

export interface SendRioPromptMessageInput {
  content: string;
  display_name?: string;
  /** @maxLength 64 */
  message_id?: string;
  attachments?: unknown[];
}

export interface SendRioPromptMessageOutput {
  message_id: string;
}

export interface SetOrgRuleInput {
  organization_id: number;
  rule_id: number;
  /** @nullable */
  enabled: boolean | null;
}

export interface SetOrgRuleSetInput {
  organization_id: number;
  rule_set_id: number;
  /** @nullable */
  enabled: boolean | null;
}

export interface SetTemplateRuleInput {
  report_template_id: number;
  rule_id: number;
  /** @nullable */
  enabled: boolean | null;
}

export interface SetTemplateRuleSetInput {
  report_template_id: number;
  rule_set_id: number;
  /** @nullable */
  enabled: boolean | null;
}

export const SkipEvalReviewItemInputReasonCode = {...ReasonCodeEnum,...BlankEnum,} as const
export interface SkipEvalReviewItemInput {
  reason_code?: typeof SkipEvalReviewItemInputReasonCode[keyof typeof SkipEvalReviewItemInputReasonCode];
  reason?: string;
}

export const StartExportTestInputExportFramework = {...ExportFrameworkEnum,} as const
export const StartExportTestInputFont = {...FontEnum,} as const
export interface StartExportTestInput {
  report_id: string;
  doctype: DoctypeEnum;
  export_framework?: typeof StartExportTestInputExportFramework[keyof typeof StartExportTestInputExportFramework] | null;
  /** @nullable */
  template_url?: string | null;
  /** @nullable */
  template_logo_url?: string | null;
  /** @nullable */
  org_logo_url?: string | null;
  font?: typeof StartExportTestInputFont[keyof typeof StartExportTestInputFont] | null;
}

export interface StartExportTestOutput {
  workflow_id: string;
}

export type StartPromptSuggestionTestInputMockLearnerDataOverride = {[key: string]: unknown};

export type StartPromptSuggestionTestInputTestFilesOverrideItem = {[key: string]: unknown};

/**
 * What the Evaluations page's Save & run sends, less use_draft.
 */
export interface StartPromptSuggestionTestInput {
  /** @nullable */
  learner_test_profile_id?: number | null;
  model?: string;
  mock_learner_data_override?: StartPromptSuggestionTestInputMockLearnerDataOverride;
  test_files_override?: StartPromptSuggestionTestInputTestFilesOverrideItem[];
}

export interface StartPromptSuggestionTestM2MInput {
  profile_id: number;
}

export const StartPromptTestRunInputArm = {...ArmEnum,} as const
export type StartPromptTestRunInputMockLearnerDataOverride = {[key: string]: unknown};

export type StartPromptTestRunInputTestFilesOverrideItem = {[key: string]: unknown};

export interface StartPromptTestRunInput {
  /** @nullable */
  learner_test_profile_id?: number | null;
  model?: string;
  /** @nullable */
  comparison_id?: number | null;
  arm?: typeof StartPromptTestRunInputArm[keyof typeof StartPromptTestRunInputArm] | null;
  mock_learner_data_override?: StartPromptTestRunInputMockLearnerDataOverride;
  test_files_override?: StartPromptTestRunInputTestFilesOverrideItem[];
  prompt_inputs_override?: string[];
  use_draft?: boolean;
}

/**
 * M2M shape: Rio starts runs with just the profile id + use_draft
 * flag. All the SPA-only knobs (inline mock overrides, file overrides,
 * per-run input override) aren't needed for Rio's fire-and-forget
 * flow — profile + draft is the whole surface.
 */
export interface StartPromptTestRunM2MInput {
  profile_id: number;
  use_draft?: boolean;
}

export interface Success {
  detail: string;
}

export const TemplateDetailPayorType = {...PayorTypeEnum,} as const
export interface TreatmentPlanTemplateField {
  id: number;
  /** @nullable */
  title: string | null;
  field_type: string;
  rank_order: number;
  is_required: boolean;
  is_enabled: boolean;
  field_identifier: string;
  type: string;
  report_goal_field: boolean;
  report_target_field: boolean;
  /** @nullable */
  content: string | null;
}

export interface TreatmentPlanTemplateDomain {
  id: number;
  name: string;
  /** @nullable */
  description: string | null;
  rank_order: number;
  readonly template_fields: readonly TreatmentPlanTemplateField[];
}

export interface TreatmentPlanTemplateData {
  id: number;
  ai_generation_config: string;
  is_goal_bank_suggestions_enabled: boolean;
  is_add_targets_enabled: boolean;
  is_medical_necessity_enabled: boolean;
  is_gas_enabled: boolean;
  readonly default_fields: readonly TreatmentPlanTemplateField[];
  readonly domains: readonly TreatmentPlanTemplateDomain[];
}

export interface TemplateDetail {
  id: number;
  name: string;
  /** @nullable */
  description: string | null;
  report_type: string;
  status: string;
  /** @nullable */
  export_framework: string | null;
  /** @nullable */
  template_url: string | null;
  is_base_template: boolean;
  enterprise_template: boolean;
  require_all_qa_resolved: boolean;
  /** @nullable */
  require_approval_before_export: boolean | null;
  /** @nullable */
  final_approver_waits_for_reviewers: boolean | null;
  unified_export: boolean;
  created_date: string;
  last_updated_date: string;
  readonly organizations: readonly OrganizationSummary[];
  /** @nullable */
  readonly updated_by_name: string | null;
  /** @nullable */
  header_text: string | null;
  /** @nullable */
  footer_text: string | null;
  /** @nullable */
  export_template_font: string | null;
  readonly template_logo_signed_url: string;
  readonly template_export_file_signed_url: string;
  readonly sections: readonly Section[];
  readonly treatment_plan_template: TreatmentPlanTemplateData | null;
  curriculum: Curriculum | null;
  payor_type: typeof TemplateDetailPayorType[keyof typeof TemplateDetailPayorType] | null;
  default_payor_template: boolean;
}

export interface TemplateGenerationPresignInput {
  /** @pattern ^[a-z0-9][a-z0-9_\-]{0,127}$ */
  build_id: string;
  organization_id: string;
  file_kind: FileKindEnum;
  original_filename: string;
  mime_type: string;
}

export interface TemplateGenerationPresignOutput {
  upload_url: string;
  s3_uri: string;
  s3_key: string;
}

export interface TemplateGenerationStartInput {
  /** @pattern ^[a-z0-9][a-z0-9_\-]{0,127}$ */
  build_id: string;
  organization_id: string;
  /** @nullable */
  payor?: string | null;
  report_type: ReportTypeEnum;
  /** @nullable */
  template_s3_uri?: string | null;
  example_s3_uris?: string[];
  /**
     * @maxLength 200
     * @nullable
     */
  template_name?: string | null;
}

export interface TemplateGenerationStartOutput {
  workflow_id: string;
  status: string;
}

export interface TemplateGenerationStatusOutput {
  workflow_id: string;
  execution_status: string;
  /** @nullable */
  template_id?: string | null;
}

export interface ToggleTestFileM2MInput {
  file_uuid: string;
  enabled: boolean;
}

export interface UpdateLocationInput {
  address_line_1: string;
  /** @nullable */
  address_line_2?: string | null;
  city: string;
  /** @maxLength 2 */
  state: string;
  /** @maxLength 2 */
  country?: string;
  /** @maxLength 10 */
  postal_code: string;
}

export interface UpdateClinicListingInput {
  public_listing_id: string;
  name?: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  website_url?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  phone_number?: string | null;
  /** @nullable */
  contact_email?: string | null;
  modality_types?: ModalityTypesEnum[];
  payors?: PayorsEnum[];
  services_offered?: ServicesOfferedEnum[];
  /** @nullable */
  google_rating?: number | null;
  /** @nullable */
  google_review_count?: number | null;
  /** @nullable */
  google_place_id?: string | null;
  verification_status?: VerificationStatusEnum;
  /** @nullable */
  full_address?: string | null;
  location?: UpdateLocationInput | null;
}

export interface UpdateClinicListingOutput {
  public_id: string;
  name: string;
}

export interface UpdateCoverageStatusInput {
  /**
     * @minLength 5
     * @maxLength 10
     */
  postal_code: string;
  status: ReviewStatusEnum;
}

export interface UpdateCoverageStatusOutput {
  postal_code: string;
  status: string;
}

export interface UpdateFieldInput {
  template_id: number;
  section_id: number;
  field_id: number;
  field_identifier?: string;
  title?: string;
  field_type?: string;
  /** @nullable */
  content?: string | null;
  is_required?: boolean;
  /** @nullable */
  input_dependency?: string[] | null;
  /** @nullable */
  prompt_id?: number | null;
  /** @nullable */
  table_key?: string | null;
  /** @nullable */
  sample_data?: string | null;
}

export type UpdateMockDataM2MInputUpdates = {[key: string]: unknown};

/**
 * Rio's per-tool-call shape: an ``updates`` dict whose keys can be
 * dotted (``biographic_info.age``, ``custom_fields.CLINICAL_NOTES``)
 * to write nested paths. The endpoint deep-merges into the profile's
 * existing ``mock_learner_data`` — it does NOT replace the whole
 * dict, which would nuke fields Rio didn't touch.
 */
export interface UpdateMockDataM2MInput {
  updates: UpdateMockDataM2MInputUpdates;
}

export interface UpdateOrganizationClinicInput {
  clinic_listing_id: string;
  name?: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  website_url?: string | null;
  /**
     * @maxLength 20
     * @nullable
     */
  phone_number?: string | null;
  /** @nullable */
  contact_email?: string | null;
  modality_types?: ModalityTypesEnum[];
  payors?: PayorsEnum[];
  services_offered?: ServicesOfferedEnum[];
  /** @nullable */
  full_address?: string | null;
  location?: UpdateLocationInput | null;
}

export interface UpdateOrganizationClinicOutput {
  public_id: string;
  name: string;
}

export interface UpdateOrganizationInput {
  organization_id: string;
  require_all_qa_resolved?: boolean;
  peer_review_enabled?: boolean;
  require_approval_before_export?: boolean;
  final_approver_waits_for_reviewers?: boolean;
  require_admin_analytics?: boolean;
  ehr_sync_enabled?: boolean;
  ehr_integration_type?: EhrIntegrationTypeEnum;
  /**
     * Vertical organization id. Frontera EHR organizations only; null clears it.
     * @nullable
     */
  external_id?: string | null;
}

export interface UpdateOrganizationOutput {
  ehr_integration_type: EhrIntegrationTypeEnum;
  readonly allowed_ehr_integration_types: readonly EhrIntegrationTypeEnum[];
  id: string;
  name: string;
  /** @nullable */
  external_id: string | null;
  require_all_qa_resolved: boolean;
  peer_review_enabled: boolean;
  require_approval_before_export: boolean;
  final_approver_waits_for_reviewers: boolean;
  require_admin_analytics: boolean;
  ehr_sync_enabled: boolean;
  organization_type: OrganizationTypeEnum;
  ehr_sync_cleared: boolean;
}

export interface UpdateOrganizationUserInput {
  professional_title?: string;
  license_number?: string;
  auth0_id: string;
  organization_id: string;
  first_name: string;
  last_name: string;
  roles: RolesEnum[];
}

export interface UpdatePromptInput {
  name: string;
  response_schema?: unknown | null;
  /** @nullable */
  fallback_text?: string | null;
  /** @nullable */
  sample_output?: string | null;
  /** @nullable */
  organization_id?: string | null;
  report_types?: ReportTypeEnum[];
  id: number;
}

export type UpdatePromptSuggestionDraftInputDraft = {[key: string]: unknown};

export interface UpdatePromptSuggestionDraftInput {
  draft: UpdatePromptSuggestionDraftInputDraft;
}

export interface UpdateReportTemplateOrganizationFolderInput {
  report_template_id: number;
  organization_id: number;
  ehr_sync_parent_folder_name: string;
}

export interface UpdateReportTemplateOrganizationFolderOutput {
  organization_id: number;
  ehr_sync_parent_folder_name: string;
}

export interface UpdateRuleInput {
  id: number;
  name?: string;
  category?: string;
  report_types?: string[];
  location?: string;
  scan_for?: string;
  feedback?: string;
  archived?: boolean;
}

/**
 * Editable package fields, shared by create and update.
 */
export interface UpdateRulePackageInput {
  /** @maxLength 255 */
  name?: string;
  description?: string;
  instructions?: string;
  package_type?: string;
  report_types?: string[];
  payor_types?: string[];
  id: number;
  archived?: boolean;
}

export interface UpdateSectionInput {
  template_id: number;
  section_id: number;
  title?: string;
  page_location?: string;
  /** @nullable */
  key?: string | null;
  /** @nullable */
  input_dependency?: string[] | null;
}

export const UpdateStagingClinicListingInputCrawlStatus = {...ReviewStatusEnum,} as const
export const UpdateStagingClinicListingInputParseStatus = {...ReviewStatusEnum,} as const
export const UpdateStagingClinicListingInputReviewStatus = {...ReviewStatusEnum,} as const
export interface UpdateStagingClinicListingInput {
  id: number;
  /** @nullable */
  scraped_text?: string | null;
  crawl_status?: typeof UpdateStagingClinicListingInputCrawlStatus[keyof typeof UpdateStagingClinicListingInputCrawlStatus] | null;
  parse_status?: typeof UpdateStagingClinicListingInputParseStatus[keyof typeof UpdateStagingClinicListingInputParseStatus] | null;
  review_status?: typeof UpdateStagingClinicListingInputReviewStatus[keyof typeof UpdateStagingClinicListingInputReviewStatus] | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  contact_email?: string | null;
  /** @nullable */
  contact_form_url?: string | null;
  modality_types?: ModalityTypesEnum[];
  payors?: PayorsEnum[];
  services_offered?: ServicesOfferedEnum[];
  /** @nullable */
  quality_rating?: number | null;
  /** @nullable */
  quality_reasoning?: string | null;
  /** @nullable */
  clinic_listing_id?: number | null;
}

export interface UpdateStagingClinicListingOutput {
  id: number;
  /** @nullable */
  crawl_status?: string | null;
  /** @nullable */
  parse_status?: string | null;
  /** @nullable */
  review_status?: string | null;
}

export interface UpdateTemplateExportFileInput {
  template_id: number;
  original_file_name: string;
}

/**
 * @nullable
 */
export type UpdateTemplateInputTreatmentPlanSettings = {[key: string]: unknown} | null;

export const UpdateTemplateInputPayorType = {...PayorTypeEnum,...BlankEnum,} as const
export interface UpdateTemplateInput {
  template_id: number;
  name?: string;
  /** @nullable */
  description?: string | null;
  status?: string;
  /** @nullable */
  header_text?: string | null;
  /** @nullable */
  footer_text?: string | null;
  /** @nullable */
  export_template_font?: string | null;
  /** @nullable */
  export_framework?: string | null;
  /** @nullable */
  template_url?: string | null;
  /** @nullable */
  report_type?: string | null;
  is_base_template?: boolean;
  enterprise_template?: boolean;
  require_all_qa_resolved?: boolean;
  /** @nullable */
  require_approval_before_export?: boolean | null;
  /** @nullable */
  final_approver_waits_for_reviewers?: boolean | null;
  unified_export?: boolean;
  /** @nullable */
  organization_ids?: number[] | null;
  /** @nullable */
  report_template_sections?: SectionInput[] | null;
  /** @nullable */
  treatment_plan_settings?: UpdateTemplateInputTreatmentPlanSettings;
  /** @nullable */
  treatment_plan_domains?: unknown[] | null;
  /** @nullable */
  treatment_plan_default_fields?: unknown[] | null;
  /** @nullable */
  goal_bank_curriculum_id?: number | null;
  payor_type?: typeof UpdateTemplateInputPayorType[keyof typeof UpdateTemplateInputPayorType] | null;
  default_payor_template?: boolean;
}

export interface UpdateTemplateLogoInput {
  template_id: number;
  original_file_name: string;
}

export interface UpdateTemplateQACriteriaInput {
  id: number;
  name?: string;
  content?: string;
  category?: string;
  enabled?: boolean;
}

export type UpsertEvalCriterionInputLevelAnchors = {[key: string]: string};

export interface UpsertEvalCriterionInput {
  dimension?: string;
  name?: string;
  level_anchors: UpsertEvalCriterionInputLevelAnchors;
  /** @nullable */
  criterion_id?: number | null;
}

export interface UpsertOrgQACriteriaInput {
  organization_id: number;
  suggestion_criteria_id: number;
  enabled: boolean;
}

export interface VerifyClinicListingInput {
  /** This is the graphql encoded ID */
  clinic_listing_id: string;
}

export interface VerifyClinicListingOutput {
  public_id: string;
  verification_status: string;
}

export interface VerifyClinicListingPublicInput {
  clinic_listing_id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string;
  job_title?: string;
}

export const VideoSessionSessionStatus = {...SessionStatusEnum,} as const
export const VideoSessionSourceType = {...SourceTypeEnum,...BlankEnum,} as const
export const VideoSessionRecorderType = {...RecorderTypeEnum,...BlankEnum,} as const
export interface VideoSession {
  readonly id: number;
  readonly created_by: User;
  readonly created_date: string;
  readonly last_updated_date: string;
  date: string;
  /** @nullable */
  start_datetime?: string | null;
  /** @nullable */
  end_datetime?: string | null;
  session_status?: typeof VideoSessionSessionStatus[keyof typeof VideoSessionSessionStatus] | null;
  /** @nullable */
  engagement_score?: number | null;
  /** @nullable */
  engagement_score_version?: string | null;
  /**
     * @minimum -2147483648
     * @maximum 2147483647
     * @nullable
     */
  session_rating?: number | null;
  /** @nullable */
  comment?: string | null;
  source_type?: typeof VideoSessionSourceType[keyof typeof VideoSessionSourceType] | null;
  recorder_type?: typeof VideoSessionRecorderType[keyof typeof VideoSessionRecorderType] | null;
  /**
     * Meeting ID from Zoom or other meeting platform
     * @maxLength 255
     * @nullable
     */
  meeting_id?: string | null;
  organization: number;
  /** @nullable */
  final_media?: number | null;
  /** @nullable */
  therapy_session?: number | null;
}

export type Auth0UserRolesRetrieveParams = {
/**
 * @minLength 1
 */
auth0_user_id: string;
/**
 * @minLength 1
 */
org_id: string;
};

export type ListAssessmentToolsParams = {
/**
 * ``ReportTypeEnums`` value, e.g. ``INITIAL_ASSESSMENT`` / ``REASSESSMENT`` / ``DIAGNOSIS_EVALUATION``. Reassessment reuses the initial-assessment tools per ``AssessmentToolHelper``.
 */
report_type: string;
};

export type ListAssessmentTools200Item = {[key: string]: unknown};

export type ListAssessmentToolsM2mParams = {
/**
 * ``ReportTypeEnums`` value, e.g. ``INITIAL_ASSESSMENT`` / ``REASSESSMENT`` / ``DIAGNOSIS_EVALUATION``. Reassessment reuses the initial-assessment tools per ``AssessmentToolHelper``.
 */
report_type: string;
};

export type ListAssessmentToolsM2m200Item = {[key: string]: unknown};

export type BasecampClinicListingsRetrieveParams = {
/**
 * @minLength 1
 */
id?: string;
/**
 * @nullable
 */
is_claimed?: boolean | null;
/**
 * @minLength 1
 */
org_id?: string;
/**
 * @minLength 1
 */
search_term?: string;
/**
 * * `UNVERIFIED` - UNVERIFIED
 * * `PENDING` - PENDING
 * * `VERIFIED` - VERIFIED
 * @minLength 1
 */
verification_status?: BasecampClinicListingsRetrieveVerificationStatus;
};

export type BasecampClinicListingsRetrieveVerificationStatus = typeof BasecampClinicListingsRetrieveVerificationStatus[keyof typeof BasecampClinicListingsRetrieveVerificationStatus];


export const BasecampClinicListingsRetrieveVerificationStatus = {
  UNVERIFIED: 'UNVERIFIED',
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
} as const;

export type BasecampCommunityPostsListParams = {
/**
 * @minLength 1
 */
query: string;
};

export type ListOrgQaCriteriaParams = {
organization_id: number;
};

export type ListEvalModelComparisonsParams = {
/**
 * Only comparisons for this organization.
 */
organization_id?: number;
};

export type PreviewEvalModelComparisonParams = {
learner_test_profile_id: number;
template_id: number;
};

export type SuggestMultiModelTestProfilesParams = {
/**
 * comma-separated ids
 */
template_ids?: string;
};

export type GetEvalReviewProgressParams = {
/**
 * Limit counts to one cohort.
 */
batch_label?: string;
};

export type GetEvalResultsParams = {
/**
 * Limit results to one cohort.
 */
batch_label?: string;
/**
 * Scope to prompts used by this org's templates (PROC-196 half one).
 */
organization?: number;
/**
 * Scope to prompts used by this template (PROC-196 half one).
 */
template?: number;
};

export type ListPromptSuggestionsParams = {
organization: number;
};

export type ListRioSuggestionMessagesM2mParams = {
/**
 * @minimum 1
 */
limit?: number;
/**
 * * `USER` - USER
 * * `ASSISTANT` - ASSISTANT
 * * `SYSTEM` - SYSTEM
 * @minLength 1
 */
role?: ListRioSuggestionMessagesM2mRole;
};

export type ListRioSuggestionMessagesM2mRole = typeof ListRioSuggestionMessagesM2mRole[keyof typeof ListRioSuggestionMessagesM2mRole];


export const ListRioSuggestionMessagesM2mRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;

export type ListAcceptedPromptSuggestionsParams = {
organization?: number;
};

export type ListExpertChatsParams = {
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
page_size?: number;
provider_ids?: number[];
search?: string;
/**
 * * `OPEN` - OPEN
 * * `FINISHED` - FINISHED
 * @minLength 1
 */
status?: ListExpertChatsStatus;
};

export type ListExpertChatsStatus = typeof ListExpertChatsStatus[keyof typeof ListExpertChatsStatus];


export const ListExpertChatsStatus = {
  OPEN: 'OPEN',
  FINISHED: 'FINISHED',
} as const;

export type GetExpertChatMessagesParams = {
/**
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
/**
 * @minimum 0
 */
until_sequence_number?: number;
};

export type BasecampGoogleAutocompleteRetrieveParams = {
/**
 * @minLength 1
 */
search_term: string;
};

export type BasecampGooglePlaceMetadataRetrieveParams = {
/**
 * @minLength 1
 */
place_id: string;
};

export type ListLearnerTestProfilesParams = {
/**
 * Optional org id. When set, returns that org's profiles plus globals. When omitted, returns every visible profile.
 */
org_id?: number;
/**
 * Optional prompt key. When set, returns rows with ``scoped_prompt_key`` null (universal) OR equal to this key (that prompt's clones). When omitted, returns only rows with ``scoped_prompt_key`` null — per-prompt clones stay hidden from the global /evaluations/profiles list.
 */
prompt_key?: string;
/**
 * Optional ReportTypeEnum value. Filters to profiles whose ``report_types`` list is empty (universal) or contains this value.
 */
report_type?: string;
};

export type ListLearnerTestProfilesM2mParams = {
/**
 * Optional org id. When set, returns that org's profiles plus globals.
 */
organization_id?: number;
};

export type BasecampOrganizationUsersRetrieveParams = {
/**
 * @minLength 1
 */
auth0_id?: string;
/**
 * @minLength 1
 */
organization_id: string;
};

export type BasecampOrganizationUsersOrphanedRetrieveParams = {
/**
 * @minLength 1
 */
organization_id: string;
};

export type BasecampOrganizationsRetrieveParams = {
/**
 * @minLength 1
 */
id?: string;
};

export type ListPromptsParams = {
has_draft?: boolean;
organization?: string;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
page_size?: number;
/**
 * * `DIAGNOSIS_EVALUATION` - DIAGNOSIS_EVALUATION
 * * `INITIAL_ASSESSMENT` - INITIAL_ASSESSMENT
 * * `REASSESSMENT` - REASSESSMENT
 * * `__untagged__` - __untagged__
 * @minLength 1
 */
report_type?: ListPromptsReportType;
search?: string;
};

export type ListPromptsReportType = typeof ListPromptsReportType[keyof typeof ListPromptsReportType];


export const ListPromptsReportType = {
  DIAGNOSIS_EVALUATION: 'DIAGNOSIS_EVALUATION',
  INITIAL_ASSESSMENT: 'INITIAL_ASSESSMENT',
  REASSESSMENT: 'REASSESSMENT',
  __untagged__: '__untagged__',
} as const;

export type ListRioPromptMessagesM2mParams = {
/**
 * @minimum 1
 */
limit?: number;
/**
 * * `USER` - USER
 * * `ASSISTANT` - ASSISTANT
 * * `SYSTEM` - SYSTEM
 * @minLength 1
 */
role?: ListRioPromptMessagesM2mRole;
};

export type ListRioPromptMessagesM2mRole = typeof ListRioPromptMessagesM2mRole[keyof typeof ListRioPromptMessagesM2mRole];


export const ListRioPromptMessagesM2mRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;

export type ListRulePackagesParams = {
/**
 * Only packages attached (enabled) to this org.
 */
attached_to_organization_id?: number;
/**
 * Only packages attached (enabled) to this template.
 */
attached_to_report_template_id?: number;
include_archived?: boolean;
};

export type ListTemplatesParams = {
exclude_archived?: boolean;
/**
 * @minLength 1
 */
export_framework?: string;
is_base?: boolean;
is_base_or_enterprise?: boolean;
organization_id?: number;
/**
 * @minimum 1
 */
page?: number;
/**
 * @minimum 1
 * @maximum 100
 */
page_size?: number;
/**
 * @minLength 1
 */
report_type?: string;
search?: string;
/**
 * @minLength 1
 */
status?: string;
};

export type ListRioMessagesM2mParams = {
/**
 * @minimum 1
 */
limit?: number;
/**
 * * `USER` - USER
 * * `ASSISTANT` - ASSISTANT
 * * `SYSTEM` - SYSTEM
 * @minLength 1
 */
role?: ListRioMessagesM2mRole;
};

export type ListRioMessagesM2mRole = typeof ListRioMessagesM2mRole[keyof typeof ListRioMessagesM2mRole];


export const ListRioMessagesM2mRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;

export type M2mSearchPromptsParams = {
exclude_unmerged?: boolean;
has_draft?: boolean;
/**
 * @minimum 1
 * @maximum 1000
 */
limit?: number;
missing_sample_output?: boolean;
organization?: string;
/**
 * * `DIAGNOSIS_EVALUATION` - DIAGNOSIS_EVALUATION
 * * `INITIAL_ASSESSMENT` - INITIAL_ASSESSMENT
 * * `REASSESSMENT` - REASSESSMENT
 * @minLength 1
 */
report_type?: M2mSearchPromptsReportType;
search?: string;
};

export type M2mSearchPromptsReportType = typeof M2mSearchPromptsReportType[keyof typeof M2mSearchPromptsReportType];


export const M2mSearchPromptsReportType = {
  DIAGNOSIS_EVALUATION: 'DIAGNOSIS_EVALUATION',
  INITIAL_ASSESSMENT: 'INITIAL_ASSESSMENT',
  REASSESSMENT: 'REASSESSMENT',
} as const;

export type M2mSearchTemplatesParams = {
/**
 * @minimum 1
 * @maximum 50
 */
limit?: number;
organization_id?: string;
report_type?: string;
search?: string;
status?: string;
};

export type ListTestFiles200Item = {[key: string]: unknown};

export type GetParsedTestFileParams = {
/**
 * S3 prefix of the parsed test file, e.g. ``test-files/_global_/global/<uuid>``.
 */
s3_prefix: string;
};

export type ListSharedTestFiles200Item = {[key: string]: unknown};

export type CareNavigationClinicListingsRetrieveParams = {
/**
 * Fetch a single clinic by its database ID.
 */
id?: number;
/**
 * Number of results per page.
 */
limit?: number;
/**
 * @minimum 1
 */
max_distance_miles: number;
modality_types?: CareNavigationClinicListingsRetrieveModalityTypesItem[];
/**
 * Number of results to skip.
 */
offset?: number;
/**
 * * `BCBS` - BCBS
 * * `UNITED_HEALTHCARE` - UNITED_HEALTHCARE
 * * `AETNA` - AETNA
 * * `CIGNA` - CIGNA
 * * `HUMANA` - HUMANA
 * * `ANTHEM` - ANTHEM
 * * `KAISER_PERMANENTE` - KAISER_PERMANENTE
 * * `TRICARE` - TRICARE
 * * `MAGELLAN_HEALTH` - MAGELLAN_HEALTH
 * * `BEACON_HEALTH_OPTIONS` - BEACON_HEALTH_OPTIONS
 * * `MEDICAID` - MEDICAID
 * * `CATALIGHT` - CATALIGHT
 * * `OPTUM` - OPTUM
 * * `BSW` - BSW
 * * `EVERNORTH` - EVERNORTH
 * * `MOLINA` - MOLINA
 * * `EMI_HEALTH` - EMI_HEALTH
 * @minLength 1
 */
payor?: CareNavigationClinicListingsRetrievePayor;
/**
 * 5-digit US ZIP code. Only US postal codes supported.
 * @minLength 5
 * @maxLength 5
 */
postal_code: string;
/**
 * @minLength 1
 */
search_term?: string;
service_types?: CareNavigationClinicListingsRetrieveServiceTypesItem[];
/**
 * * `UNVERIFIED` - UNVERIFIED
 * * `PENDING` - PENDING
 * * `VERIFIED` - VERIFIED
 * @minLength 1
 */
verification_status?: CareNavigationClinicListingsRetrieveVerificationStatus;
};

/**
 * * `IN_HOME` - IN_HOME
 * * `IN_CLINIC` - IN_CLINIC
 * * `TELEHEALTH` - TELEHEALTH
 * * `IN_SCHOOL` - IN_SCHOOL
 */
export type CareNavigationClinicListingsRetrieveModalityTypesItem = typeof CareNavigationClinicListingsRetrieveModalityTypesItem[keyof typeof CareNavigationClinicListingsRetrieveModalityTypesItem];


export const CareNavigationClinicListingsRetrieveModalityTypesItem = {
  IN_HOME: 'IN_HOME',
  IN_CLINIC: 'IN_CLINIC',
  TELEHEALTH: 'TELEHEALTH',
  IN_SCHOOL: 'IN_SCHOOL',
} as const;

export type CareNavigationClinicListingsRetrievePayor = typeof CareNavigationClinicListingsRetrievePayor[keyof typeof CareNavigationClinicListingsRetrievePayor];


export const CareNavigationClinicListingsRetrievePayor = {
  BCBS: 'BCBS',
  UNITED_HEALTHCARE: 'UNITED_HEALTHCARE',
  AETNA: 'AETNA',
  CIGNA: 'CIGNA',
  HUMANA: 'HUMANA',
  ANTHEM: 'ANTHEM',
  KAISER_PERMANENTE: 'KAISER_PERMANENTE',
  TRICARE: 'TRICARE',
  MAGELLAN_HEALTH: 'MAGELLAN_HEALTH',
  BEACON_HEALTH_OPTIONS: 'BEACON_HEALTH_OPTIONS',
  MEDICAID: 'MEDICAID',
  CATALIGHT: 'CATALIGHT',
  OPTUM: 'OPTUM',
  BSW: 'BSW',
  EVERNORTH: 'EVERNORTH',
  MOLINA: 'MOLINA',
  EMI_HEALTH: 'EMI_HEALTH',
} as const;

/**
 * * `ABA_THERAPY` - ABA_THERAPY
 * * `DIAGNOSTIC_EVALUATIONS` - DIAGNOSTIC_EVALUATIONS
 * * `PARENT_TRAINING` - PARENT_TRAINING
 * * `SPEECH_THERAPY` - SPEECH_THERAPY
 * * `OCCUPATIONAL_THERAPY` - OCCUPATIONAL_THERAPY
 * * `PHYSICAL_THERAPY` - PHYSICAL_THERAPY
 */
export type CareNavigationClinicListingsRetrieveServiceTypesItem = typeof CareNavigationClinicListingsRetrieveServiceTypesItem[keyof typeof CareNavigationClinicListingsRetrieveServiceTypesItem];


export const CareNavigationClinicListingsRetrieveServiceTypesItem = {
  ABA_THERAPY: 'ABA_THERAPY',
  DIAGNOSTIC_EVALUATIONS: 'DIAGNOSTIC_EVALUATIONS',
  PARENT_TRAINING: 'PARENT_TRAINING',
  SPEECH_THERAPY: 'SPEECH_THERAPY',
  OCCUPATIONAL_THERAPY: 'OCCUPATIONAL_THERAPY',
  PHYSICAL_THERAPY: 'PHYSICAL_THERAPY',
} as const;

export type CareNavigationClinicListingsRetrieveVerificationStatus = typeof CareNavigationClinicListingsRetrieveVerificationStatus[keyof typeof CareNavigationClinicListingsRetrieveVerificationStatus];


export const CareNavigationClinicListingsRetrieveVerificationStatus = {
  UNVERIFIED: 'UNVERIFIED',
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
} as const;

export type CommunityPreviewPostsListParams = {
/**
 * @minimum 1
 * @maximum 10
 */
limit?: number;
};

export type CommunityUpcomingEventsListParams = {
/**
 * @minimum 1
 * @maximum 90
 */
days?: number;
};

export type GoogleMapsAutocompleteRetrieveParams = {
/**
 * @minLength 1
 */
search_term: string;
};

export type GooglePlaceMetadataRetrieveParams = {
/**
 * @minLength 1
 */
place_id: string;
};

export type PublicClinicLeadRetrieveParams = {
lead_id: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type auth0UserMetadataRetrieveResponse200 = {
  data: GetUserMetaDataOutput
  status: 200
}

export type auth0UserMetadataRetrieveResponseSuccess = (auth0UserMetadataRetrieveResponse200) & {
  headers: Headers;
};
;

export type auth0UserMetadataRetrieveResponse = (auth0UserMetadataRetrieveResponseSuccess)

export const getAuth0UserMetadataRetrieveUrl = () => {




  return `/api/auth0/user-metadata/`
}

export const auth0UserMetadataRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<auth0UserMetadataRetrieveResponse> => {

  return customFetch<auth0UserMetadataRetrieveResponse>(getAuth0UserMetadataRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuth0UserMetadataRetrieveQueryKey = () => {
    return [
    `/api/auth0/user-metadata/`
    ] as const;
    }


export const getAuth0UserMetadataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuth0UserMetadataRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>> = ({ signal }) => auth0UserMetadataRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Auth0UserMetadataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>>
export type Auth0UserMetadataRetrieveQueryError = unknown


export function useAuth0UserMetadataRetrieve<TData = Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuth0UserMetadataRetrieve<TData = Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuth0UserMetadataRetrieve<TData = Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuth0UserMetadataRetrieve<TData = Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuth0UserMetadataRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type auth0UserRolesRetrieveResponse200 = {
  data: GetAuth0UserRolesOutput
  status: 200
}

export type auth0UserRolesRetrieveResponse400 = {
  data: string
  status: 400
}

export type auth0UserRolesRetrieveResponseSuccess = (auth0UserRolesRetrieveResponse200) & {
  headers: Headers;
};
export type auth0UserRolesRetrieveResponseError = (auth0UserRolesRetrieveResponse400) & {
  headers: Headers;
};

export type auth0UserRolesRetrieveResponse = (auth0UserRolesRetrieveResponseSuccess | auth0UserRolesRetrieveResponseError)

export const getAuth0UserRolesRetrieveUrl = (params: Auth0UserRolesRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/auth0/user-roles/?${stringifiedParams}` : `/api/auth0/user-roles/`
}

export const auth0UserRolesRetrieve = async (params: Auth0UserRolesRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<auth0UserRolesRetrieveResponse> => {

  return customFetch<auth0UserRolesRetrieveResponse>(getAuth0UserRolesRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuth0UserRolesRetrieveQueryKey = (params?: Auth0UserRolesRetrieveParams,) => {
    return [
    `/api/auth0/user-roles/`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuth0UserRolesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError = string>(params: Auth0UserRolesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuth0UserRolesRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>> = ({ signal }) => auth0UserRolesRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type Auth0UserRolesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>>
export type Auth0UserRolesRetrieveQueryError = string


export function useAuth0UserRolesRetrieve<TData = Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError = string>(
 params: Auth0UserRolesRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auth0UserRolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof auth0UserRolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuth0UserRolesRetrieve<TData = Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError = string>(
 params: Auth0UserRolesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auth0UserRolesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof auth0UserRolesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuth0UserRolesRetrieve<TData = Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError = string>(
 params: Auth0UserRolesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAuth0UserRolesRetrieve<TData = Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError = string>(
 params: Auth0UserRolesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auth0UserRolesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuth0UserRolesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAssessmentToolsResponse200 = {
  data: ListAssessmentTools200Item[]
  status: 200
}

export type listAssessmentToolsResponseSuccess = (listAssessmentToolsResponse200) & {
  headers: Headers;
};
;

export type listAssessmentToolsResponse = (listAssessmentToolsResponseSuccess)

export const getListAssessmentToolsUrl = (params: ListAssessmentToolsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/assessment-tools?${stringifiedParams}` : `/api/basecamp/assessment-tools`
}

/**
 * Return assessment tools for a given report_type, mirroring resolve_assessment_tools.
 *
 * Basecamp SPA callers only. Rio (Temporal M2M) uses
 * ``ListAssessmentToolsM2MView`` at ``/api/basecamp/assessment-tools/m2m``.
 */
export const listAssessmentTools = async (params: ListAssessmentToolsParams, options?: Parameters<typeof customFetch>[1]): Promise<listAssessmentToolsResponse> => {

  return customFetch<listAssessmentToolsResponse>(getListAssessmentToolsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssessmentToolsQueryKey = (params?: ListAssessmentToolsParams,) => {
    return [
    `/api/basecamp/assessment-tools`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssessmentToolsQueryOptions = <TData = Awaited<ReturnType<typeof listAssessmentTools>>, TError = unknown>(params: ListAssessmentToolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTools>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssessmentToolsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssessmentTools>>> = ({ signal }) => listAssessmentTools(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTools>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssessmentToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssessmentTools>>>
export type ListAssessmentToolsQueryError = unknown


export function useListAssessmentTools<TData = Awaited<ReturnType<typeof listAssessmentTools>>, TError = unknown>(
 params: ListAssessmentToolsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTools>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentTools>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentTools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentTools<TData = Awaited<ReturnType<typeof listAssessmentTools>>, TError = unknown>(
 params: ListAssessmentToolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTools>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentTools>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentTools>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentTools<TData = Awaited<ReturnType<typeof listAssessmentTools>>, TError = unknown>(
 params: ListAssessmentToolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTools>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAssessmentTools<TData = Awaited<ReturnType<typeof listAssessmentTools>>, TError = unknown>(
 params: ListAssessmentToolsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentTools>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssessmentToolsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAssessmentToolsM2mResponse200 = {
  data: ListAssessmentToolsM2m200Item[]
  status: 200
}

export type listAssessmentToolsM2mResponseSuccess = (listAssessmentToolsM2mResponse200) & {
  headers: Headers;
};
;

export type listAssessmentToolsM2mResponse = (listAssessmentToolsM2mResponseSuccess)

export const getListAssessmentToolsM2mUrl = (params: ListAssessmentToolsM2mParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/assessment-tools/m2m?${stringifiedParams}` : `/api/basecamp/assessment-tools/m2m`
}

/**
 * Temporal M2M sibling of ``ListAssessmentToolsView``.
 *
 * Same JSON shape, same underlying ``AssessmentToolHelper`` config.
 * Split from the SPA endpoint because ``role_required_for_rest_apis``
 * with mixed ``allowed_roles`` doesn't cleanly enforce the M2M
 * client_name check — mirrors the SPA/M2M split in ``rio_chat_views``
 * for the same reason.
 *
 * Consumed by Rio's ``load_assessment_tools_for_report_type``
 * activity at workflow start so ``list_data_sources`` and downstream
 * ``input_dependency`` validation stay in sync with the SPA's
 * DataSourcesDialog.
 */
export const listAssessmentToolsM2m = async (params: ListAssessmentToolsM2mParams, options?: Parameters<typeof customFetch>[1]): Promise<listAssessmentToolsM2mResponse> => {

  return customFetch<listAssessmentToolsM2mResponse>(getListAssessmentToolsM2mUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssessmentToolsM2mQueryKey = (params?: ListAssessmentToolsM2mParams,) => {
    return [
    `/api/basecamp/assessment-tools/m2m`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAssessmentToolsM2mQueryOptions = <TData = Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError = unknown>(params: ListAssessmentToolsM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssessmentToolsM2mQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssessmentToolsM2m>>> = ({ signal }) => listAssessmentToolsM2m(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssessmentToolsM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listAssessmentToolsM2m>>>
export type ListAssessmentToolsM2mQueryError = unknown


export function useListAssessmentToolsM2m<TData = Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError = unknown>(
 params: ListAssessmentToolsM2mParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentToolsM2m>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentToolsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentToolsM2m<TData = Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError = unknown>(
 params: ListAssessmentToolsM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentToolsM2m>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentToolsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentToolsM2m<TData = Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError = unknown>(
 params: ListAssessmentToolsM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAssessmentToolsM2m<TData = Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError = unknown>(
 params: ListAssessmentToolsM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentToolsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssessmentToolsM2mQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampClinicListingsRetrieveResponse200 = {
  data: GetClinicListingsOutput
  status: 200
}

export type basecampClinicListingsRetrieveResponse400 = {
  data: Error
  status: 400
}

export type basecampClinicListingsRetrieveResponseSuccess = (basecampClinicListingsRetrieveResponse200) & {
  headers: Headers;
};
export type basecampClinicListingsRetrieveResponseError = (basecampClinicListingsRetrieveResponse400) & {
  headers: Headers;
};

export type basecampClinicListingsRetrieveResponse = (basecampClinicListingsRetrieveResponseSuccess | basecampClinicListingsRetrieveResponseError)

export const getBasecampClinicListingsRetrieveUrl = (params?: BasecampClinicListingsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/clinic-listings?${stringifiedParams}` : `/api/basecamp/clinic-listings`
}

export const basecampClinicListingsRetrieve = async (params?: BasecampClinicListingsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampClinicListingsRetrieveResponse> => {

  return customFetch<basecampClinicListingsRetrieveResponse>(getBasecampClinicListingsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampClinicListingsRetrieveQueryKey = (params?: BasecampClinicListingsRetrieveParams,) => {
    return [
    `/api/basecamp/clinic-listings`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampClinicListingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError = Error>(params?: BasecampClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampClinicListingsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>> = ({ signal }) => basecampClinicListingsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampClinicListingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>>
export type BasecampClinicListingsRetrieveQueryError = Error


export function useBasecampClinicListingsRetrieve<TData = Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError = Error>(
 params: undefined |  BasecampClinicListingsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampClinicListingsRetrieve<TData = Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError = Error>(
 params?: BasecampClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampClinicListingsRetrieve<TData = Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError = Error>(
 params?: BasecampClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampClinicListingsRetrieve<TData = Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError = Error>(
 params?: BasecampClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampClinicListingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampClinicListingsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampClinicListingsApproveCreateResponse204 = {
  data: void
  status: 204
}

export type basecampClinicListingsApproveCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampClinicListingsApproveCreateResponseSuccess = (basecampClinicListingsApproveCreateResponse204) & {
  headers: Headers;
};
export type basecampClinicListingsApproveCreateResponseError = (basecampClinicListingsApproveCreateResponse400) & {
  headers: Headers;
};

export type basecampClinicListingsApproveCreateResponse = (basecampClinicListingsApproveCreateResponseSuccess | basecampClinicListingsApproveCreateResponseError)

export const getBasecampClinicListingsApproveCreateUrl = () => {




  return `/api/basecamp/clinic-listings/approve`
}

export const basecampClinicListingsApproveCreate = async (approveClinicListingRequestInput: ApproveClinicListingRequestInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampClinicListingsApproveCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampClinicListingsApproveCreateResponse>(getBasecampClinicListingsApproveCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(approveClinicListingRequestInput)
  }
);}





export const getBasecampClinicListingsApproveCreateMutationKey = () => ['basecampClinicListingsApproveCreate'] as const;

export const getBasecampClinicListingsApproveCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsApproveCreate>>, TError,BasecampClinicListingsApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsApproveCreate>>, TError,BasecampClinicListingsApproveCreateMutationVariables, TContext> => {

const mutationKey = getBasecampClinicListingsApproveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampClinicListingsApproveCreate>>, BasecampClinicListingsApproveCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampClinicListingsApproveCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampClinicListingsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampClinicListingsApproveCreate>>>
    export type BasecampClinicListingsApproveCreateMutationBody = ApproveClinicListingRequestInput
    export type BasecampClinicListingsApproveCreateMutationError = Error
    export type BasecampClinicListingsApproveCreateMutationVariables = {data: ApproveClinicListingRequestInput}

    export const useBasecampClinicListingsApproveCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsApproveCreate>>, TError,BasecampClinicListingsApproveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampClinicListingsApproveCreate>>,
        TError,
        BasecampClinicListingsApproveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampClinicListingsApproveCreateMutationOptions(options), queryClient);
    }

export type basecampClinicListingsCreateCreateResponse201 = {
  data: CreateOrganizationClinicOutput
  status: 201
}

export type basecampClinicListingsCreateCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampClinicListingsCreateCreateResponseSuccess = (basecampClinicListingsCreateCreateResponse201) & {
  headers: Headers;
};
export type basecampClinicListingsCreateCreateResponseError = (basecampClinicListingsCreateCreateResponse400) & {
  headers: Headers;
};

export type basecampClinicListingsCreateCreateResponse = (basecampClinicListingsCreateCreateResponseSuccess | basecampClinicListingsCreateCreateResponseError)

export const getBasecampClinicListingsCreateCreateUrl = () => {




  return `/api/basecamp/clinic-listings/create`
}

export const basecampClinicListingsCreateCreate = async (createOrganizationClinicInput: CreateOrganizationClinicInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampClinicListingsCreateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampClinicListingsCreateCreateResponse>(getBasecampClinicListingsCreateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOrganizationClinicInput)
  }
);}





export const getBasecampClinicListingsCreateCreateMutationKey = () => ['basecampClinicListingsCreateCreate'] as const;

export const getBasecampClinicListingsCreateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsCreateCreate>>, TError,BasecampClinicListingsCreateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsCreateCreate>>, TError,BasecampClinicListingsCreateCreateMutationVariables, TContext> => {

const mutationKey = getBasecampClinicListingsCreateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampClinicListingsCreateCreate>>, BasecampClinicListingsCreateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampClinicListingsCreateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampClinicListingsCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampClinicListingsCreateCreate>>>
    export type BasecampClinicListingsCreateCreateMutationBody = CreateOrganizationClinicInput
    export type BasecampClinicListingsCreateCreateMutationError = Error
    export type BasecampClinicListingsCreateCreateMutationVariables = {data: CreateOrganizationClinicInput}

    export const useBasecampClinicListingsCreateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsCreateCreate>>, TError,BasecampClinicListingsCreateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampClinicListingsCreateCreate>>,
        TError,
        BasecampClinicListingsCreateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampClinicListingsCreateCreateMutationOptions(options), queryClient);
    }

export type basecampClinicListingsLinkCreateResponse204 = {
  data: void
  status: 204
}

export type basecampClinicListingsLinkCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampClinicListingsLinkCreateResponseSuccess = (basecampClinicListingsLinkCreateResponse204) & {
  headers: Headers;
};
export type basecampClinicListingsLinkCreateResponseError = (basecampClinicListingsLinkCreateResponse400) & {
  headers: Headers;
};

export type basecampClinicListingsLinkCreateResponse = (basecampClinicListingsLinkCreateResponseSuccess | basecampClinicListingsLinkCreateResponseError)

export const getBasecampClinicListingsLinkCreateUrl = () => {




  return `/api/basecamp/clinic-listings/link`
}

export const basecampClinicListingsLinkCreate = async (linkOrganizationClinicInput: LinkOrganizationClinicInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampClinicListingsLinkCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampClinicListingsLinkCreateResponse>(getBasecampClinicListingsLinkCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(linkOrganizationClinicInput)
  }
);}





export const getBasecampClinicListingsLinkCreateMutationKey = () => ['basecampClinicListingsLinkCreate'] as const;

export const getBasecampClinicListingsLinkCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsLinkCreate>>, TError,BasecampClinicListingsLinkCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsLinkCreate>>, TError,BasecampClinicListingsLinkCreateMutationVariables, TContext> => {

const mutationKey = getBasecampClinicListingsLinkCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampClinicListingsLinkCreate>>, BasecampClinicListingsLinkCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampClinicListingsLinkCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampClinicListingsLinkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampClinicListingsLinkCreate>>>
    export type BasecampClinicListingsLinkCreateMutationBody = LinkOrganizationClinicInput
    export type BasecampClinicListingsLinkCreateMutationError = Error
    export type BasecampClinicListingsLinkCreateMutationVariables = {data: LinkOrganizationClinicInput}

    export const useBasecampClinicListingsLinkCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsLinkCreate>>, TError,BasecampClinicListingsLinkCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampClinicListingsLinkCreate>>,
        TError,
        BasecampClinicListingsLinkCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampClinicListingsLinkCreateMutationOptions(options), queryClient);
    }

export type basecampClinicListingsUpdateCreateResponse200 = {
  data: UpdateOrganizationClinicOutput
  status: 200
}

export type basecampClinicListingsUpdateCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampClinicListingsUpdateCreateResponseSuccess = (basecampClinicListingsUpdateCreateResponse200) & {
  headers: Headers;
};
export type basecampClinicListingsUpdateCreateResponseError = (basecampClinicListingsUpdateCreateResponse400) & {
  headers: Headers;
};

export type basecampClinicListingsUpdateCreateResponse = (basecampClinicListingsUpdateCreateResponseSuccess | basecampClinicListingsUpdateCreateResponseError)

export const getBasecampClinicListingsUpdateCreateUrl = () => {




  return `/api/basecamp/clinic-listings/update`
}

export const basecampClinicListingsUpdateCreate = async (updateOrganizationClinicInput: UpdateOrganizationClinicInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampClinicListingsUpdateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampClinicListingsUpdateCreateResponse>(getBasecampClinicListingsUpdateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOrganizationClinicInput)
  }
);}





export const getBasecampClinicListingsUpdateCreateMutationKey = () => ['basecampClinicListingsUpdateCreate'] as const;

export const getBasecampClinicListingsUpdateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsUpdateCreate>>, TError,BasecampClinicListingsUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsUpdateCreate>>, TError,BasecampClinicListingsUpdateCreateMutationVariables, TContext> => {

const mutationKey = getBasecampClinicListingsUpdateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampClinicListingsUpdateCreate>>, BasecampClinicListingsUpdateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampClinicListingsUpdateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampClinicListingsUpdateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampClinicListingsUpdateCreate>>>
    export type BasecampClinicListingsUpdateCreateMutationBody = UpdateOrganizationClinicInput
    export type BasecampClinicListingsUpdateCreateMutationError = Error
    export type BasecampClinicListingsUpdateCreateMutationVariables = {data: UpdateOrganizationClinicInput}

    export const useBasecampClinicListingsUpdateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampClinicListingsUpdateCreate>>, TError,BasecampClinicListingsUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampClinicListingsUpdateCreate>>,
        TError,
        BasecampClinicListingsUpdateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampClinicListingsUpdateCreateMutationOptions(options), queryClient);
    }

export type basecampCommunityPostsListResponse200 = {
  data: GetCommunityPostsOutput[]
  status: 200
}

export type basecampCommunityPostsListResponse400 = {
  data: Error
  status: 400
}

export type basecampCommunityPostsListResponseSuccess = (basecampCommunityPostsListResponse200) & {
  headers: Headers;
};
export type basecampCommunityPostsListResponseError = (basecampCommunityPostsListResponse400) & {
  headers: Headers;
};

export type basecampCommunityPostsListResponse = (basecampCommunityPostsListResponseSuccess | basecampCommunityPostsListResponseError)

export const getBasecampCommunityPostsListUrl = (params: BasecampCommunityPostsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/community/posts?${stringifiedParams}` : `/api/basecamp/community/posts`
}

export const basecampCommunityPostsList = async (params: BasecampCommunityPostsListParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampCommunityPostsListResponse> => {

  return customFetch<basecampCommunityPostsListResponse>(getBasecampCommunityPostsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampCommunityPostsListQueryKey = (params?: BasecampCommunityPostsListParams,) => {
    return [
    `/api/basecamp/community/posts`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampCommunityPostsListQueryOptions = <TData = Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError = Error>(params: BasecampCommunityPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampCommunityPostsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampCommunityPostsList>>> = ({ signal }) => basecampCommunityPostsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampCommunityPostsListQueryResult = NonNullable<Awaited<ReturnType<typeof basecampCommunityPostsList>>>
export type BasecampCommunityPostsListQueryError = Error


export function useBasecampCommunityPostsList<TData = Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError = Error>(
 params: BasecampCommunityPostsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampCommunityPostsList>>,
          TError,
          Awaited<ReturnType<typeof basecampCommunityPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampCommunityPostsList<TData = Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError = Error>(
 params: BasecampCommunityPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampCommunityPostsList>>,
          TError,
          Awaited<ReturnType<typeof basecampCommunityPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampCommunityPostsList<TData = Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError = Error>(
 params: BasecampCommunityPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampCommunityPostsList<TData = Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError = Error>(
 params: BasecampCommunityPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampCommunityPostsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampCommunityPostsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampCommunityPreviewDigestCreateResponse200 = {
  data: PreviewCommunityDigestOutput
  status: 200
}

export type basecampCommunityPreviewDigestCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampCommunityPreviewDigestCreateResponseSuccess = (basecampCommunityPreviewDigestCreateResponse200) & {
  headers: Headers;
};
export type basecampCommunityPreviewDigestCreateResponseError = (basecampCommunityPreviewDigestCreateResponse400) & {
  headers: Headers;
};

export type basecampCommunityPreviewDigestCreateResponse = (basecampCommunityPreviewDigestCreateResponseSuccess | basecampCommunityPreviewDigestCreateResponseError)

export const getBasecampCommunityPreviewDigestCreateUrl = () => {




  return `/api/basecamp/community/preview-digest`
}

/**
 * Renders the community digest email template against a draft payload.
 *
 * Used by the Basecamp curator UI to display a live preview of what the
 * digest email will look like before publishing. Reuses the same input
 * contract and rendering path as the real send (``CommunityDigestEmailHandler``
 * + ``community_digest.html``) so the preview cannot drift from the sent email.
 */
export const basecampCommunityPreviewDigestCreate = async (publishCommunityDigestInput: PublishCommunityDigestInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampCommunityPreviewDigestCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampCommunityPreviewDigestCreateResponse>(getBasecampCommunityPreviewDigestCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(publishCommunityDigestInput)
  }
);}





export const getBasecampCommunityPreviewDigestCreateMutationKey = () => ['basecampCommunityPreviewDigestCreate'] as const;

export const getBasecampCommunityPreviewDigestCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampCommunityPreviewDigestCreate>>, TError,BasecampCommunityPreviewDigestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampCommunityPreviewDigestCreate>>, TError,BasecampCommunityPreviewDigestCreateMutationVariables, TContext> => {

const mutationKey = getBasecampCommunityPreviewDigestCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampCommunityPreviewDigestCreate>>, BasecampCommunityPreviewDigestCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampCommunityPreviewDigestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampCommunityPreviewDigestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampCommunityPreviewDigestCreate>>>
    export type BasecampCommunityPreviewDigestCreateMutationBody = PublishCommunityDigestInput
    export type BasecampCommunityPreviewDigestCreateMutationError = Error
    export type BasecampCommunityPreviewDigestCreateMutationVariables = {data: PublishCommunityDigestInput}

    export const useBasecampCommunityPreviewDigestCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampCommunityPreviewDigestCreate>>, TError,BasecampCommunityPreviewDigestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampCommunityPreviewDigestCreate>>,
        TError,
        BasecampCommunityPreviewDigestCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampCommunityPreviewDigestCreateMutationOptions(options), queryClient);
    }

export type basecampCommunityPublishDigestCreateResponse200 = {
  data: void
  status: 200
}

export type basecampCommunityPublishDigestCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampCommunityPublishDigestCreateResponse503 = {
  data: Error
  status: 503
}

export type basecampCommunityPublishDigestCreateResponseSuccess = (basecampCommunityPublishDigestCreateResponse200) & {
  headers: Headers;
};
export type basecampCommunityPublishDigestCreateResponseError = (basecampCommunityPublishDigestCreateResponse400 | basecampCommunityPublishDigestCreateResponse503) & {
  headers: Headers;
};

export type basecampCommunityPublishDigestCreateResponse = (basecampCommunityPublishDigestCreateResponseSuccess | basecampCommunityPublishDigestCreateResponseError)

export const getBasecampCommunityPublishDigestCreateUrl = () => {




  return `/api/basecamp/community/publish-digest`
}

export const basecampCommunityPublishDigestCreate = async (publishCommunityDigestInput: PublishCommunityDigestInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampCommunityPublishDigestCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampCommunityPublishDigestCreateResponse>(getBasecampCommunityPublishDigestCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(publishCommunityDigestInput)
  }
);}





export const getBasecampCommunityPublishDigestCreateMutationKey = () => ['basecampCommunityPublishDigestCreate'] as const;

export const getBasecampCommunityPublishDigestCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampCommunityPublishDigestCreate>>, TError,BasecampCommunityPublishDigestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampCommunityPublishDigestCreate>>, TError,BasecampCommunityPublishDigestCreateMutationVariables, TContext> => {

const mutationKey = getBasecampCommunityPublishDigestCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampCommunityPublishDigestCreate>>, BasecampCommunityPublishDigestCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampCommunityPublishDigestCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampCommunityPublishDigestCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampCommunityPublishDigestCreate>>>
    export type BasecampCommunityPublishDigestCreateMutationBody = PublishCommunityDigestInput
    export type BasecampCommunityPublishDigestCreateMutationError = Error
    export type BasecampCommunityPublishDigestCreateMutationVariables = {data: PublishCommunityDigestInput}

    export const useBasecampCommunityPublishDigestCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampCommunityPublishDigestCreate>>, TError,BasecampCommunityPublishDigestCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampCommunityPublishDigestCreate>>,
        TError,
        BasecampCommunityPublishDigestCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampCommunityPublishDigestCreateMutationOptions(options), queryClient);
    }

export type listBaseQaCriteriaResponse200 = {
  data: GetBaseQACriteriaOutput
  status: 200
}

export type listBaseQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type listBaseQaCriteriaResponseSuccess = (listBaseQaCriteriaResponse200) & {
  headers: Headers;
};
export type listBaseQaCriteriaResponseError = (listBaseQaCriteriaResponse400) & {
  headers: Headers;
};

export type listBaseQaCriteriaResponse = (listBaseQaCriteriaResponseSuccess | listBaseQaCriteriaResponseError)

export const getListBaseQaCriteriaUrl = () => {




  return `/api/basecamp/criteria/base`
}

export const listBaseQaCriteria = async ( options?: Parameters<typeof customFetch>[1]): Promise<listBaseQaCriteriaResponse> => {

  return customFetch<listBaseQaCriteriaResponse>(getListBaseQaCriteriaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListBaseQaCriteriaQueryKey = () => {
    return [
    `/api/basecamp/criteria/base`
    ] as const;
    }


export const getListBaseQaCriteriaQueryOptions = <TData = Awaited<ReturnType<typeof listBaseQaCriteria>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBaseQaCriteriaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBaseQaCriteria>>> = ({ signal }) => listBaseQaCriteria({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBaseQaCriteria>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBaseQaCriteriaQueryResult = NonNullable<Awaited<ReturnType<typeof listBaseQaCriteria>>>
export type ListBaseQaCriteriaQueryError = Error


export function useListBaseQaCriteria<TData = Awaited<ReturnType<typeof listBaseQaCriteria>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseQaCriteria>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBaseQaCriteria>>,
          TError,
          Awaited<ReturnType<typeof listBaseQaCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBaseQaCriteria<TData = Awaited<ReturnType<typeof listBaseQaCriteria>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseQaCriteria>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBaseQaCriteria>>,
          TError,
          Awaited<ReturnType<typeof listBaseQaCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBaseQaCriteria<TData = Awaited<ReturnType<typeof listBaseQaCriteria>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListBaseQaCriteria<TData = Awaited<ReturnType<typeof listBaseQaCriteria>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBaseQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBaseQaCriteriaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createBaseQaCriteriaResponse201 = {
  data: BaseQACriteriaItem
  status: 201
}

export type createBaseQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type createBaseQaCriteriaResponseSuccess = (createBaseQaCriteriaResponse201) & {
  headers: Headers;
};
export type createBaseQaCriteriaResponseError = (createBaseQaCriteriaResponse400) & {
  headers: Headers;
};

export type createBaseQaCriteriaResponse = (createBaseQaCriteriaResponseSuccess | createBaseQaCriteriaResponseError)

export const getCreateBaseQaCriteriaUrl = () => {




  return `/api/basecamp/criteria/base/create`
}

export const createBaseQaCriteria = async (createBaseQACriteriaInput: CreateBaseQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<createBaseQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createBaseQaCriteriaResponse>(getCreateBaseQaCriteriaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createBaseQACriteriaInput)
  }
);}





export const getCreateBaseQaCriteriaMutationKey = () => ['createBaseQaCriteria'] as const;

export const getCreateBaseQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBaseQaCriteria>>, TError,CreateBaseQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createBaseQaCriteria>>, TError,CreateBaseQaCriteriaMutationVariables, TContext> => {

const mutationKey = getCreateBaseQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBaseQaCriteria>>, CreateBaseQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createBaseQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateBaseQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof createBaseQaCriteria>>>
    export type CreateBaseQaCriteriaMutationBody = CreateBaseQACriteriaInput
    export type CreateBaseQaCriteriaMutationError = Error
    export type CreateBaseQaCriteriaMutationVariables = {data: CreateBaseQACriteriaInput}

    export const useCreateBaseQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBaseQaCriteria>>, TError,CreateBaseQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBaseQaCriteria>>,
        TError,
        CreateBaseQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getCreateBaseQaCriteriaMutationOptions(options), queryClient);
    }

export type updateBaseQaCriteriaResponse200 = {
  data: BaseQACriteriaItem
  status: 200
}

export type updateBaseQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type updateBaseQaCriteriaResponseSuccess = (updateBaseQaCriteriaResponse200) & {
  headers: Headers;
};
export type updateBaseQaCriteriaResponseError = (updateBaseQaCriteriaResponse400) & {
  headers: Headers;
};

export type updateBaseQaCriteriaResponse = (updateBaseQaCriteriaResponseSuccess | updateBaseQaCriteriaResponseError)

export const getUpdateBaseQaCriteriaUrl = () => {




  return `/api/basecamp/criteria/base/update`
}

export const updateBaseQaCriteria = async (patchedUpdateBaseQACriteriaInput?: PatchedUpdateBaseQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<updateBaseQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateBaseQaCriteriaResponse>(getUpdateBaseQaCriteriaUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedUpdateBaseQACriteriaInput)
  }
);}





export const getUpdateBaseQaCriteriaMutationKey = () => ['updateBaseQaCriteria'] as const;

export const getUpdateBaseQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBaseQaCriteria>>, TError,UpdateBaseQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBaseQaCriteria>>, TError,UpdateBaseQaCriteriaMutationVariables, TContext> => {

const mutationKey = getUpdateBaseQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBaseQaCriteria>>, UpdateBaseQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateBaseQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateBaseQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof updateBaseQaCriteria>>>
    export type UpdateBaseQaCriteriaMutationBody = PatchedUpdateBaseQACriteriaInput | undefined
    export type UpdateBaseQaCriteriaMutationError = Error
    export type UpdateBaseQaCriteriaMutationVariables = {data?: PatchedUpdateBaseQACriteriaInput}

    export const useUpdateBaseQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBaseQaCriteria>>, TError,UpdateBaseQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBaseQaCriteria>>,
        TError,
        UpdateBaseQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateBaseQaCriteriaMutationOptions(options), queryClient);
    }

export type listOrgQaCriteriaResponse200 = {
  data: GetOrgQACriteriaOutput
  status: 200
}

export type listOrgQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type listOrgQaCriteriaResponseSuccess = (listOrgQaCriteriaResponse200) & {
  headers: Headers;
};
export type listOrgQaCriteriaResponseError = (listOrgQaCriteriaResponse400) & {
  headers: Headers;
};

export type listOrgQaCriteriaResponse = (listOrgQaCriteriaResponseSuccess | listOrgQaCriteriaResponseError)

export const getListOrgQaCriteriaUrl = (params: ListOrgQaCriteriaParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/criteria/org?${stringifiedParams}` : `/api/basecamp/criteria/org`
}

export const listOrgQaCriteria = async (params: ListOrgQaCriteriaParams, options?: Parameters<typeof customFetch>[1]): Promise<listOrgQaCriteriaResponse> => {

  return customFetch<listOrgQaCriteriaResponse>(getListOrgQaCriteriaUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListOrgQaCriteriaQueryKey = (params?: ListOrgQaCriteriaParams,) => {
    return [
    `/api/basecamp/criteria/org`, ...(params ? [params] : [])
    ] as const;
    }


export const getListOrgQaCriteriaQueryOptions = <TData = Awaited<ReturnType<typeof listOrgQaCriteria>>, TError = Error>(params: ListOrgQaCriteriaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOrgQaCriteriaQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrgQaCriteria>>> = ({ signal }) => listOrgQaCriteria(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOrgQaCriteria>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOrgQaCriteriaQueryResult = NonNullable<Awaited<ReturnType<typeof listOrgQaCriteria>>>
export type ListOrgQaCriteriaQueryError = Error


export function useListOrgQaCriteria<TData = Awaited<ReturnType<typeof listOrgQaCriteria>>, TError = Error>(
 params: ListOrgQaCriteriaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgQaCriteria>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgQaCriteria>>,
          TError,
          Awaited<ReturnType<typeof listOrgQaCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgQaCriteria<TData = Awaited<ReturnType<typeof listOrgQaCriteria>>, TError = Error>(
 params: ListOrgQaCriteriaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgQaCriteria>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgQaCriteria>>,
          TError,
          Awaited<ReturnType<typeof listOrgQaCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOrgQaCriteria<TData = Awaited<ReturnType<typeof listOrgQaCriteria>>, TError = Error>(
 params: ListOrgQaCriteriaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListOrgQaCriteria<TData = Awaited<ReturnType<typeof listOrgQaCriteria>>, TError = Error>(
 params: ListOrgQaCriteriaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOrgQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOrgQaCriteriaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createOrgQaCriteriaResponse201 = {
  data: OrgQACriteriaItem
  status: 201
}

export type createOrgQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type createOrgQaCriteriaResponseSuccess = (createOrgQaCriteriaResponse201) & {
  headers: Headers;
};
export type createOrgQaCriteriaResponseError = (createOrgQaCriteriaResponse400) & {
  headers: Headers;
};

export type createOrgQaCriteriaResponse = (createOrgQaCriteriaResponseSuccess | createOrgQaCriteriaResponseError)

export const getCreateOrgQaCriteriaUrl = () => {




  return `/api/basecamp/criteria/org/create`
}

export const createOrgQaCriteria = async (createOrgQACriteriaInput: CreateOrgQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<createOrgQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createOrgQaCriteriaResponse>(getCreateOrgQaCriteriaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOrgQACriteriaInput)
  }
);}





export const getCreateOrgQaCriteriaMutationKey = () => ['createOrgQaCriteria'] as const;

export const getCreateOrgQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgQaCriteria>>, TError,CreateOrgQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrgQaCriteria>>, TError,CreateOrgQaCriteriaMutationVariables, TContext> => {

const mutationKey = getCreateOrgQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrgQaCriteria>>, CreateOrgQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createOrgQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrgQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof createOrgQaCriteria>>>
    export type CreateOrgQaCriteriaMutationBody = CreateOrgQACriteriaInput
    export type CreateOrgQaCriteriaMutationError = Error
    export type CreateOrgQaCriteriaMutationVariables = {data: CreateOrgQACriteriaInput}

    export const useCreateOrgQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrgQaCriteria>>, TError,CreateOrgQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrgQaCriteria>>,
        TError,
        CreateOrgQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getCreateOrgQaCriteriaMutationOptions(options), queryClient);
    }

export type updateOrgQaCriteriaResponse200 = {
  data: OrgQACriteriaItem
  status: 200
}

export type updateOrgQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type updateOrgQaCriteriaResponseSuccess = (updateOrgQaCriteriaResponse200) & {
  headers: Headers;
};
export type updateOrgQaCriteriaResponseError = (updateOrgQaCriteriaResponse400) & {
  headers: Headers;
};

export type updateOrgQaCriteriaResponse = (updateOrgQaCriteriaResponseSuccess | updateOrgQaCriteriaResponseError)

export const getUpdateOrgQaCriteriaUrl = () => {




  return `/api/basecamp/criteria/org/update`
}

export const updateOrgQaCriteria = async (patchedUpdateOrgQACriteriaInput?: PatchedUpdateOrgQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<updateOrgQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateOrgQaCriteriaResponse>(getUpdateOrgQaCriteriaUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedUpdateOrgQACriteriaInput)
  }
);}





export const getUpdateOrgQaCriteriaMutationKey = () => ['updateOrgQaCriteria'] as const;

export const getUpdateOrgQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgQaCriteria>>, TError,UpdateOrgQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrgQaCriteria>>, TError,UpdateOrgQaCriteriaMutationVariables, TContext> => {

const mutationKey = getUpdateOrgQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrgQaCriteria>>, UpdateOrgQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateOrgQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrgQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrgQaCriteria>>>
    export type UpdateOrgQaCriteriaMutationBody = PatchedUpdateOrgQACriteriaInput | undefined
    export type UpdateOrgQaCriteriaMutationError = Error
    export type UpdateOrgQaCriteriaMutationVariables = {data?: PatchedUpdateOrgQACriteriaInput}

    export const useUpdateOrgQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrgQaCriteria>>, TError,UpdateOrgQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrgQaCriteria>>,
        TError,
        UpdateOrgQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOrgQaCriteriaMutationOptions(options), queryClient);
    }

export type upsertOrgQaCriteriaResponse200 = {
  data: OrgQACriteriaItem
  status: 200
}

export type upsertOrgQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type upsertOrgQaCriteriaResponseSuccess = (upsertOrgQaCriteriaResponse200) & {
  headers: Headers;
};
export type upsertOrgQaCriteriaResponseError = (upsertOrgQaCriteriaResponse400) & {
  headers: Headers;
};

export type upsertOrgQaCriteriaResponse = (upsertOrgQaCriteriaResponseSuccess | upsertOrgQaCriteriaResponseError)

export const getUpsertOrgQaCriteriaUrl = () => {




  return `/api/basecamp/criteria/org/upsert`
}

export const upsertOrgQaCriteria = async (upsertOrgQACriteriaInput: UpsertOrgQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<upsertOrgQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<upsertOrgQaCriteriaResponse>(getUpsertOrgQaCriteriaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(upsertOrgQACriteriaInput)
  }
);}





export const getUpsertOrgQaCriteriaMutationKey = () => ['upsertOrgQaCriteria'] as const;

export const getUpsertOrgQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertOrgQaCriteria>>, TError,UpsertOrgQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertOrgQaCriteria>>, TError,UpsertOrgQaCriteriaMutationVariables, TContext> => {

const mutationKey = getUpsertOrgQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertOrgQaCriteria>>, UpsertOrgQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertOrgQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertOrgQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof upsertOrgQaCriteria>>>
    export type UpsertOrgQaCriteriaMutationBody = UpsertOrgQACriteriaInput
    export type UpsertOrgQaCriteriaMutationError = Error
    export type UpsertOrgQaCriteriaMutationVariables = {data: UpsertOrgQACriteriaInput}

    export const useUpsertOrgQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertOrgQaCriteria>>, TError,UpsertOrgQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertOrgQaCriteria>>,
        TError,
        UpsertOrgQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertOrgQaCriteriaMutationOptions(options), queryClient);
    }

export type listEvalModelComparisonsResponse200 = {
  data: ListEvalModelComparisonsOutput
  status: 200
}

export type listEvalModelComparisonsResponseSuccess = (listEvalModelComparisonsResponse200) & {
  headers: Headers;
};
;

export type listEvalModelComparisonsResponse = (listEvalModelComparisonsResponseSuccess)

export const getListEvalModelComparisonsUrl = (params?: ListEvalModelComparisonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-model-comparisons?${stringifiedParams}` : `/api/basecamp/eval-model-comparisons`
}

export const listEvalModelComparisons = async (params?: ListEvalModelComparisonsParams, options?: Parameters<typeof customFetch>[1]): Promise<listEvalModelComparisonsResponse> => {

  return customFetch<listEvalModelComparisonsResponse>(getListEvalModelComparisonsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEvalModelComparisonsQueryKey = (params?: ListEvalModelComparisonsParams,) => {
    return [
    `/api/basecamp/eval-model-comparisons`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEvalModelComparisonsQueryOptions = <TData = Awaited<ReturnType<typeof listEvalModelComparisons>>, TError = unknown>(params?: ListEvalModelComparisonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalModelComparisons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEvalModelComparisonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvalModelComparisons>>> = ({ signal }) => listEvalModelComparisons(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEvalModelComparisons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEvalModelComparisonsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvalModelComparisons>>>
export type ListEvalModelComparisonsQueryError = unknown


export function useListEvalModelComparisons<TData = Awaited<ReturnType<typeof listEvalModelComparisons>>, TError = unknown>(
 params: undefined |  ListEvalModelComparisonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalModelComparisons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvalModelComparisons>>,
          TError,
          Awaited<ReturnType<typeof listEvalModelComparisons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEvalModelComparisons<TData = Awaited<ReturnType<typeof listEvalModelComparisons>>, TError = unknown>(
 params?: ListEvalModelComparisonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalModelComparisons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvalModelComparisons>>,
          TError,
          Awaited<ReturnType<typeof listEvalModelComparisons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEvalModelComparisons<TData = Awaited<ReturnType<typeof listEvalModelComparisons>>, TError = unknown>(
 params?: ListEvalModelComparisonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalModelComparisons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEvalModelComparisons<TData = Awaited<ReturnType<typeof listEvalModelComparisons>>, TError = unknown>(
 params?: ListEvalModelComparisonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalModelComparisons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEvalModelComparisonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createEvalModelComparisonResponse200 = {
  data: CreateEvalModelComparisonOutput
  status: 200
}

export type createEvalModelComparisonResponse400 = {
  data: Error
  status: 400
}

export type createEvalModelComparisonResponseSuccess = (createEvalModelComparisonResponse200) & {
  headers: Headers;
};
export type createEvalModelComparisonResponseError = (createEvalModelComparisonResponse400) & {
  headers: Headers;
};

export type createEvalModelComparisonResponse = (createEvalModelComparisonResponseSuccess | createEvalModelComparisonResponseError)

export const getCreateEvalModelComparisonUrl = () => {




  return `/api/basecamp/eval-model-comparisons`
}

export const createEvalModelComparison = async (createEvalModelComparisonInput: CreateEvalModelComparisonInput, options?: Parameters<typeof customFetch>[1]): Promise<createEvalModelComparisonResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createEvalModelComparisonResponse>(getCreateEvalModelComparisonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createEvalModelComparisonInput)
  }
);}





export const getCreateEvalModelComparisonMutationKey = () => ['createEvalModelComparison'] as const;

export const getCreateEvalModelComparisonMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvalModelComparison>>, TError,CreateEvalModelComparisonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEvalModelComparison>>, TError,CreateEvalModelComparisonMutationVariables, TContext> => {

const mutationKey = getCreateEvalModelComparisonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEvalModelComparison>>, CreateEvalModelComparisonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createEvalModelComparison(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEvalModelComparisonMutationResult = NonNullable<Awaited<ReturnType<typeof createEvalModelComparison>>>
    export type CreateEvalModelComparisonMutationBody = CreateEvalModelComparisonInput
    export type CreateEvalModelComparisonMutationError = Error
    export type CreateEvalModelComparisonMutationVariables = {data: CreateEvalModelComparisonInput}

    export const useCreateEvalModelComparison = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvalModelComparison>>, TError,CreateEvalModelComparisonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEvalModelComparison>>,
        TError,
        CreateEvalModelComparisonMutationVariables,
        TContext
      > => {
      return useMutation(getCreateEvalModelComparisonMutationOptions(options), queryClient);
    }

export type getEvalModelComparisonResponse200 = {
  data: EvalModelComparisonDetail
  status: 200
}

export type getEvalModelComparisonResponseSuccess = (getEvalModelComparisonResponse200) & {
  headers: Headers;
};
;

export type getEvalModelComparisonResponse = (getEvalModelComparisonResponseSuccess)

export const getGetEvalModelComparisonUrl = (comparisonId: number,) => {




  return `/api/basecamp/eval-model-comparisons/${comparisonId}`
}

export const getEvalModelComparison = async (comparisonId: number, options?: Parameters<typeof customFetch>[1]): Promise<getEvalModelComparisonResponse> => {

  return customFetch<getEvalModelComparisonResponse>(getGetEvalModelComparisonUrl(comparisonId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalModelComparisonQueryKey = (comparisonId: number,) => {
    return [
    `/api/basecamp/eval-model-comparisons/${comparisonId}`
    ] as const;
    }


export const getGetEvalModelComparisonQueryOptions = <TData = Awaited<ReturnType<typeof getEvalModelComparison>>, TError = unknown>(comparisonId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalModelComparison>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalModelComparisonQueryKey(comparisonId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalModelComparison>>> = ({ signal }) => getEvalModelComparison(comparisonId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: comparisonId !== null && comparisonId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalModelComparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalModelComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalModelComparison>>>
export type GetEvalModelComparisonQueryError = unknown


export function useGetEvalModelComparison<TData = Awaited<ReturnType<typeof getEvalModelComparison>>, TError = unknown>(
 comparisonId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalModelComparison>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalModelComparison>>,
          TError,
          Awaited<ReturnType<typeof getEvalModelComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalModelComparison<TData = Awaited<ReturnType<typeof getEvalModelComparison>>, TError = unknown>(
 comparisonId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalModelComparison>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalModelComparison>>,
          TError,
          Awaited<ReturnType<typeof getEvalModelComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalModelComparison<TData = Awaited<ReturnType<typeof getEvalModelComparison>>, TError = unknown>(
 comparisonId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalModelComparison>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalModelComparison<TData = Awaited<ReturnType<typeof getEvalModelComparison>>, TError = unknown>(
 comparisonId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalModelComparison>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalModelComparisonQueryOptions(comparisonId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateEvalModelComparisonResponse200 = {
  data: EvalModelComparisonSummary
  status: 200
}

export type updateEvalModelComparisonResponse400 = {
  data: Error
  status: 400
}

export type updateEvalModelComparisonResponseSuccess = (updateEvalModelComparisonResponse200) & {
  headers: Headers;
};
export type updateEvalModelComparisonResponseError = (updateEvalModelComparisonResponse400) & {
  headers: Headers;
};

export type updateEvalModelComparisonResponse = (updateEvalModelComparisonResponseSuccess | updateEvalModelComparisonResponseError)

export const getUpdateEvalModelComparisonUrl = (comparisonId: number,) => {




  return `/api/basecamp/eval-model-comparisons/${comparisonId}`
}

export const updateEvalModelComparison = async (comparisonId: number,
    patchedPatchEvalModelComparisonInput?: PatchedPatchEvalModelComparisonInput, options?: Parameters<typeof customFetch>[1]): Promise<updateEvalModelComparisonResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateEvalModelComparisonResponse>(getUpdateEvalModelComparisonUrl(comparisonId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedPatchEvalModelComparisonInput)
  }
);}





export const getUpdateEvalModelComparisonMutationKey = () => ['updateEvalModelComparison'] as const;

export const getUpdateEvalModelComparisonMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvalModelComparison>>, TError,UpdateEvalModelComparisonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEvalModelComparison>>, TError,UpdateEvalModelComparisonMutationVariables, TContext> => {

const mutationKey = getUpdateEvalModelComparisonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEvalModelComparison>>, UpdateEvalModelComparisonMutationVariables> = (props) => {
          const {comparisonId,data} = props ?? {};

          return  updateEvalModelComparison(comparisonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEvalModelComparisonMutationResult = NonNullable<Awaited<ReturnType<typeof updateEvalModelComparison>>>
    export type UpdateEvalModelComparisonMutationBody = PatchedPatchEvalModelComparisonInput | undefined
    export type UpdateEvalModelComparisonMutationError = Error
    export type UpdateEvalModelComparisonMutationVariables = {comparisonId: number;data?: PatchedPatchEvalModelComparisonInput}

    export const useUpdateEvalModelComparison = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEvalModelComparison>>, TError,UpdateEvalModelComparisonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateEvalModelComparison>>,
        TError,
        UpdateEvalModelComparisonMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateEvalModelComparisonMutationOptions(options), queryClient);
    }

export type markComparisonPromptSeenResponse200 = {
  data: ComparisonPromptSeenOutput
  status: 200
}

export type markComparisonPromptSeenResponseSuccess = (markComparisonPromptSeenResponse200) & {
  headers: Headers;
};
;

export type markComparisonPromptSeenResponse = (markComparisonPromptSeenResponseSuccess)

export const getMarkComparisonPromptSeenUrl = (comparisonId: number,) => {




  return `/api/basecamp/eval-model-comparisons/${comparisonId}/seen`
}

/**
 * POST stamps a slot as seen: the reviewer opened its outputs.
 * Distinct from reviewed (a saved pick) — this is the trail marker.
 */
export const markComparisonPromptSeen = async (comparisonId: number,
    comparisonPromptSeenInput: ComparisonPromptSeenInput, options?: Parameters<typeof customFetch>[1]): Promise<markComparisonPromptSeenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<markComparisonPromptSeenResponse>(getMarkComparisonPromptSeenUrl(comparisonId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(comparisonPromptSeenInput)
  }
);}





export const getMarkComparisonPromptSeenMutationKey = () => ['markComparisonPromptSeen'] as const;

export const getMarkComparisonPromptSeenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markComparisonPromptSeen>>, TError,MarkComparisonPromptSeenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markComparisonPromptSeen>>, TError,MarkComparisonPromptSeenMutationVariables, TContext> => {

const mutationKey = getMarkComparisonPromptSeenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markComparisonPromptSeen>>, MarkComparisonPromptSeenMutationVariables> = (props) => {
          const {comparisonId,data} = props ?? {};

          return  markComparisonPromptSeen(comparisonId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkComparisonPromptSeenMutationResult = NonNullable<Awaited<ReturnType<typeof markComparisonPromptSeen>>>
    export type MarkComparisonPromptSeenMutationBody = ComparisonPromptSeenInput
    export type MarkComparisonPromptSeenMutationError = unknown
    export type MarkComparisonPromptSeenMutationVariables = {comparisonId: number;data: ComparisonPromptSeenInput}

    export const useMarkComparisonPromptSeen = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markComparisonPromptSeen>>, TError,MarkComparisonPromptSeenMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markComparisonPromptSeen>>,
        TError,
        MarkComparisonPromptSeenMutationVariables,
        TContext
      > => {
      return useMutation(getMarkComparisonPromptSeenMutationOptions(options), queryClient);
    }

export type listAvailableModelsResponse200 = {
  data: ListAvailableModelsOutput
  status: 200
}

export type listAvailableModelsResponseSuccess = (listAvailableModelsResponse200) & {
  headers: Headers;
};
;

export type listAvailableModelsResponse = (listAvailableModelsResponseSuccess)

export const getListAvailableModelsUrl = () => {




  return `/api/basecamp/eval-model-comparisons/models`
}

export const listAvailableModels = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAvailableModelsResponse> => {

  return customFetch<listAvailableModelsResponse>(getListAvailableModelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAvailableModelsQueryKey = () => {
    return [
    `/api/basecamp/eval-model-comparisons/models`
    ] as const;
    }


export const getListAvailableModelsQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableModels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableModels>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableModelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableModels>>> = ({ signal }) => listAvailableModels({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableModels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAvailableModelsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableModels>>>
export type ListAvailableModelsQueryError = unknown


export function useListAvailableModels<TData = Awaited<ReturnType<typeof listAvailableModels>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableModels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableModels>>,
          TError,
          Awaited<ReturnType<typeof listAvailableModels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableModels<TData = Awaited<ReturnType<typeof listAvailableModels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableModels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableModels>>,
          TError,
          Awaited<ReturnType<typeof listAvailableModels>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableModels<TData = Awaited<ReturnType<typeof listAvailableModels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableModels>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAvailableModels<TData = Awaited<ReturnType<typeof listAvailableModels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableModels>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableModelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type previewEvalModelComparisonResponse200 = {
  data: PreviewEvalModelComparisonOutput
  status: 200
}

export type previewEvalModelComparisonResponse400 = {
  data: Error
  status: 400
}

export type previewEvalModelComparisonResponseSuccess = (previewEvalModelComparisonResponse200) & {
  headers: Headers;
};
export type previewEvalModelComparisonResponseError = (previewEvalModelComparisonResponse400) & {
  headers: Headers;
};

export type previewEvalModelComparisonResponse = (previewEvalModelComparisonResponseSuccess | previewEvalModelComparisonResponseError)

export const getPreviewEvalModelComparisonUrl = (params: PreviewEvalModelComparisonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-model-comparisons/preview?${stringifiedParams}` : `/api/basecamp/eval-model-comparisons/preview`
}

/**
 * What a kickoff would run, before anything runs — same service math as
 * create, one source of truth.
 */
export const previewEvalModelComparison = async (params: PreviewEvalModelComparisonParams, options?: Parameters<typeof customFetch>[1]): Promise<previewEvalModelComparisonResponse> => {

  return customFetch<previewEvalModelComparisonResponse>(getPreviewEvalModelComparisonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPreviewEvalModelComparisonQueryKey = (params?: PreviewEvalModelComparisonParams,) => {
    return [
    `/api/basecamp/eval-model-comparisons/preview`, ...(params ? [params] : [])
    ] as const;
    }


export const getPreviewEvalModelComparisonQueryOptions = <TData = Awaited<ReturnType<typeof previewEvalModelComparison>>, TError = Error>(params: PreviewEvalModelComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewEvalModelComparison>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPreviewEvalModelComparisonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof previewEvalModelComparison>>> = ({ signal }) => previewEvalModelComparison(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof previewEvalModelComparison>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PreviewEvalModelComparisonQueryResult = NonNullable<Awaited<ReturnType<typeof previewEvalModelComparison>>>
export type PreviewEvalModelComparisonQueryError = Error


export function usePreviewEvalModelComparison<TData = Awaited<ReturnType<typeof previewEvalModelComparison>>, TError = Error>(
 params: PreviewEvalModelComparisonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewEvalModelComparison>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewEvalModelComparison>>,
          TError,
          Awaited<ReturnType<typeof previewEvalModelComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewEvalModelComparison<TData = Awaited<ReturnType<typeof previewEvalModelComparison>>, TError = Error>(
 params: PreviewEvalModelComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewEvalModelComparison>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof previewEvalModelComparison>>,
          TError,
          Awaited<ReturnType<typeof previewEvalModelComparison>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePreviewEvalModelComparison<TData = Awaited<ReturnType<typeof previewEvalModelComparison>>, TError = Error>(
 params: PreviewEvalModelComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewEvalModelComparison>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePreviewEvalModelComparison<TData = Awaited<ReturnType<typeof previewEvalModelComparison>>, TError = Error>(
 params: PreviewEvalModelComparisonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof previewEvalModelComparison>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPreviewEvalModelComparisonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listEvalMultiModelTestsResponse200 = {
  data: ListEvalMultiModelTestsOutput
  status: 200
}

export type listEvalMultiModelTestsResponseSuccess = (listEvalMultiModelTestsResponse200) & {
  headers: Headers;
};
;

export type listEvalMultiModelTestsResponse = (listEvalMultiModelTestsResponseSuccess)

export const getListEvalMultiModelTestsUrl = () => {




  return `/api/basecamp/eval-multi-model-tests`
}

/**
 * GET to list multi_model_tests, POST to create one (and start its
 * background progress workflow).
 */
export const listEvalMultiModelTests = async ( options?: Parameters<typeof customFetch>[1]): Promise<listEvalMultiModelTestsResponse> => {

  return customFetch<listEvalMultiModelTestsResponse>(getListEvalMultiModelTestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEvalMultiModelTestsQueryKey = () => {
    return [
    `/api/basecamp/eval-multi-model-tests`
    ] as const;
    }


export const getListEvalMultiModelTestsQueryOptions = <TData = Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEvalMultiModelTestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvalMultiModelTests>>> = ({ signal }) => listEvalMultiModelTests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEvalMultiModelTestsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvalMultiModelTests>>>
export type ListEvalMultiModelTestsQueryError = unknown


export function useListEvalMultiModelTests<TData = Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvalMultiModelTests>>,
          TError,
          Awaited<ReturnType<typeof listEvalMultiModelTests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEvalMultiModelTests<TData = Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvalMultiModelTests>>,
          TError,
          Awaited<ReturnType<typeof listEvalMultiModelTests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEvalMultiModelTests<TData = Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEvalMultiModelTests<TData = Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalMultiModelTests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEvalMultiModelTestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createEvalMultiModelTestResponse200 = {
  data: EvalMultiModelTestSummary
  status: 200
}

export type createEvalMultiModelTestResponse400 = {
  data: Error
  status: 400
}

export type createEvalMultiModelTestResponseSuccess = (createEvalMultiModelTestResponse200) & {
  headers: Headers;
};
export type createEvalMultiModelTestResponseError = (createEvalMultiModelTestResponse400) & {
  headers: Headers;
};

export type createEvalMultiModelTestResponse = (createEvalMultiModelTestResponseSuccess | createEvalMultiModelTestResponseError)

export const getCreateEvalMultiModelTestUrl = () => {




  return `/api/basecamp/eval-multi-model-tests`
}

/**
 * GET to list multi_model_tests, POST to create one (and start its
 * background progress workflow).
 */
export const createEvalMultiModelTest = async (multiModelTestCreateInput: MultiModelTestCreateInput, options?: Parameters<typeof customFetch>[1]): Promise<createEvalMultiModelTestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createEvalMultiModelTestResponse>(getCreateEvalMultiModelTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(multiModelTestCreateInput)
  }
);}





export const getCreateEvalMultiModelTestMutationKey = () => ['createEvalMultiModelTest'] as const;

export const getCreateEvalMultiModelTestMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvalMultiModelTest>>, TError,CreateEvalMultiModelTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEvalMultiModelTest>>, TError,CreateEvalMultiModelTestMutationVariables, TContext> => {

const mutationKey = getCreateEvalMultiModelTestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEvalMultiModelTest>>, CreateEvalMultiModelTestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createEvalMultiModelTest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEvalMultiModelTestMutationResult = NonNullable<Awaited<ReturnType<typeof createEvalMultiModelTest>>>
    export type CreateEvalMultiModelTestMutationBody = MultiModelTestCreateInput
    export type CreateEvalMultiModelTestMutationError = Error
    export type CreateEvalMultiModelTestMutationVariables = {data: MultiModelTestCreateInput}

    export const useCreateEvalMultiModelTest = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEvalMultiModelTest>>, TError,CreateEvalMultiModelTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createEvalMultiModelTest>>,
        TError,
        CreateEvalMultiModelTestMutationVariables,
        TContext
      > => {
      return useMutation(getCreateEvalMultiModelTestMutationOptions(options), queryClient);
    }

export type getEvalMultiModelTestResponse200 = {
  data: EvalMultiModelTestDetail
  status: 200
}

export type getEvalMultiModelTestResponseSuccess = (getEvalMultiModelTestResponse200) & {
  headers: Headers;
};
;

export type getEvalMultiModelTestResponse = (getEvalMultiModelTestResponseSuccess)

export const getGetEvalMultiModelTestUrl = (multiModelTestId: number,) => {




  return `/api/basecamp/eval-multi-model-tests/${multiModelTestId}`
}

/**
 * GET the multi_model_test grid. Progress runs in the background
 * (PROC-227); an open page also advances it, and restarts the background
 * workflow if the test hasn't settled and none is live.
 */
export const getEvalMultiModelTest = async (multiModelTestId: number, options?: Parameters<typeof customFetch>[1]): Promise<getEvalMultiModelTestResponse> => {

  return customFetch<getEvalMultiModelTestResponse>(getGetEvalMultiModelTestUrl(multiModelTestId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalMultiModelTestQueryKey = (multiModelTestId: number,) => {
    return [
    `/api/basecamp/eval-multi-model-tests/${multiModelTestId}`
    ] as const;
    }


export const getGetEvalMultiModelTestQueryOptions = <TData = Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError = unknown>(multiModelTestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalMultiModelTestQueryKey(multiModelTestId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalMultiModelTest>>> = ({ signal }) => getEvalMultiModelTest(multiModelTestId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: multiModelTestId !== null && multiModelTestId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalMultiModelTestQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalMultiModelTest>>>
export type GetEvalMultiModelTestQueryError = unknown


export function useGetEvalMultiModelTest<TData = Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError = unknown>(
 multiModelTestId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalMultiModelTest>>,
          TError,
          Awaited<ReturnType<typeof getEvalMultiModelTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalMultiModelTest<TData = Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError = unknown>(
 multiModelTestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalMultiModelTest>>,
          TError,
          Awaited<ReturnType<typeof getEvalMultiModelTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalMultiModelTest<TData = Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError = unknown>(
 multiModelTestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalMultiModelTest<TData = Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError = unknown>(
 multiModelTestId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalMultiModelTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalMultiModelTestQueryOptions(multiModelTestId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type advanceEvalMultiModelTestM2mResponse200 = {
  data: MultiModelTestAdvanceOutput
  status: 200
}

export type advanceEvalMultiModelTestM2mResponseSuccess = (advanceEvalMultiModelTestM2mResponse200) & {
  headers: Headers;
};
;

export type advanceEvalMultiModelTestM2mResponse = (advanceEvalMultiModelTestM2mResponseSuccess)

export const getAdvanceEvalMultiModelTestM2mUrl = (multiModelTestId: number,) => {




  return `/api/basecamp/eval-multi-model-tests/${multiModelTestId}/advance/m2m`
}

/**
 * M2M: one background advance step for MultiModelTestProgressWorkflow
 * (PROC-227), which calls this until ``settled``. Runs it starts are
 * attributed to the test's creator.
 */
export const advanceEvalMultiModelTestM2m = async (multiModelTestId: number, options?: Parameters<typeof customFetch>[1]): Promise<advanceEvalMultiModelTestM2mResponse> => {

  return customFetch<advanceEvalMultiModelTestM2mResponse>(getAdvanceEvalMultiModelTestM2mUrl(multiModelTestId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdvanceEvalMultiModelTestM2mMutationKey = () => ['advanceEvalMultiModelTestM2m'] as const;

export const getAdvanceEvalMultiModelTestM2mMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceEvalMultiModelTestM2m>>, TError,AdvanceEvalMultiModelTestM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof advanceEvalMultiModelTestM2m>>, TError,AdvanceEvalMultiModelTestM2mMutationVariables, TContext> => {

const mutationKey = getAdvanceEvalMultiModelTestM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof advanceEvalMultiModelTestM2m>>, AdvanceEvalMultiModelTestM2mMutationVariables> = (props) => {
          const {multiModelTestId} = props ?? {};

          return  advanceEvalMultiModelTestM2m(multiModelTestId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdvanceEvalMultiModelTestM2mMutationResult = NonNullable<Awaited<ReturnType<typeof advanceEvalMultiModelTestM2m>>>

    export type AdvanceEvalMultiModelTestM2mMutationError = unknown
    export type AdvanceEvalMultiModelTestM2mMutationVariables = {multiModelTestId: number}

    export const useAdvanceEvalMultiModelTestM2m = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceEvalMultiModelTestM2m>>, TError,AdvanceEvalMultiModelTestM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof advanceEvalMultiModelTestM2m>>,
        TError,
        AdvanceEvalMultiModelTestM2mMutationVariables,
        TContext
      > => {
      return useMutation(getAdvanceEvalMultiModelTestM2mMutationOptions(options), queryClient);
    }

export type suggestMultiModelTestProfilesResponse200 = {
  data: MultiModelTestSuggestionsOutput
  status: 200
}

export type suggestMultiModelTestProfilesResponse400 = {
  data: Error
  status: 400
}

export type suggestMultiModelTestProfilesResponseSuccess = (suggestMultiModelTestProfilesResponse200) & {
  headers: Headers;
};
export type suggestMultiModelTestProfilesResponseError = (suggestMultiModelTestProfilesResponse400) & {
  headers: Headers;
};

export type suggestMultiModelTestProfilesResponse = (suggestMultiModelTestProfilesResponseSuccess | suggestMultiModelTestProfilesResponseError)

export const getSuggestMultiModelTestProfilesUrl = (params?: SuggestMultiModelTestProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-multi-model-tests/suggest-profiles?${stringifiedParams}` : `/api/basecamp/eval-multi-model-tests/suggest-profiles`
}

/**
 * GET ?template_ids=1,2,3 — per template, the profiles ranked by
 * slot coverage, with the best one marked as the suggestion.
 */
export const suggestMultiModelTestProfiles = async (params?: SuggestMultiModelTestProfilesParams, options?: Parameters<typeof customFetch>[1]): Promise<suggestMultiModelTestProfilesResponse> => {

  return customFetch<suggestMultiModelTestProfilesResponse>(getSuggestMultiModelTestProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSuggestMultiModelTestProfilesQueryKey = (params?: SuggestMultiModelTestProfilesParams,) => {
    return [
    `/api/basecamp/eval-multi-model-tests/suggest-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getSuggestMultiModelTestProfilesQueryOptions = <TData = Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError = Error>(params?: SuggestMultiModelTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSuggestMultiModelTestProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>> = ({ signal }) => suggestMultiModelTestProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SuggestMultiModelTestProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>>
export type SuggestMultiModelTestProfilesQueryError = Error


export function useSuggestMultiModelTestProfiles<TData = Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError = Error>(
 params: undefined |  SuggestMultiModelTestProfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>,
          TError,
          Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSuggestMultiModelTestProfiles<TData = Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError = Error>(
 params?: SuggestMultiModelTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>,
          TError,
          Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSuggestMultiModelTestProfiles<TData = Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError = Error>(
 params?: SuggestMultiModelTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSuggestMultiModelTestProfiles<TData = Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError = Error>(
 params?: SuggestMultiModelTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestMultiModelTestProfiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSuggestMultiModelTestProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getEvalReviewForRunResponse200 = {
  data: GetEvalReviewForRunOutput
  status: 200
}

export type getEvalReviewForRunResponse404 = {
  data: Error
  status: 404
}

export type getEvalReviewForRunResponseSuccess = (getEvalReviewForRunResponse200) & {
  headers: Headers;
};
export type getEvalReviewForRunResponseError = (getEvalReviewForRunResponse404) & {
  headers: Headers;
};

export type getEvalReviewForRunResponse = (getEvalReviewForRunResponseSuccess | getEvalReviewForRunResponseError)

export const getGetEvalReviewForRunUrl = (runId: number,) => {




  return `/api/basecamp/eval-reviews/for-run/${runId}`
}

/**
 * Everything the scoring panel on a prompt test run needs, in one call.
 */
export const getEvalReviewForRun = async (runId: number, options?: Parameters<typeof customFetch>[1]): Promise<getEvalReviewForRunResponse> => {

  return customFetch<getEvalReviewForRunResponse>(getGetEvalReviewForRunUrl(runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalReviewForRunQueryKey = (runId: number,) => {
    return [
    `/api/basecamp/eval-reviews/for-run/${runId}`
    ] as const;
    }


export const getGetEvalReviewForRunQueryOptions = <TData = Awaited<ReturnType<typeof getEvalReviewForRun>>, TError = Error>(runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewForRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalReviewForRunQueryKey(runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalReviewForRun>>> = ({ signal }) => getEvalReviewForRun(runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewForRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalReviewForRunQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalReviewForRun>>>
export type GetEvalReviewForRunQueryError = Error


export function useGetEvalReviewForRun<TData = Awaited<ReturnType<typeof getEvalReviewForRun>>, TError = Error>(
 runId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewForRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalReviewForRun>>,
          TError,
          Awaited<ReturnType<typeof getEvalReviewForRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalReviewForRun<TData = Awaited<ReturnType<typeof getEvalReviewForRun>>, TError = Error>(
 runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewForRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalReviewForRun>>,
          TError,
          Awaited<ReturnType<typeof getEvalReviewForRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalReviewForRun<TData = Awaited<ReturnType<typeof getEvalReviewForRun>>, TError = Error>(
 runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewForRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalReviewForRun<TData = Awaited<ReturnType<typeof getEvalReviewForRun>>, TError = Error>(
 runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewForRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalReviewForRunQueryOptions(runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type scoreEvalReviewItemResponse200 = {
  data: EvalReviewScore
  status: 200
}

export type scoreEvalReviewItemResponse400 = {
  data: Error
  status: 400
}

export type scoreEvalReviewItemResponseSuccess = (scoreEvalReviewItemResponse200) & {
  headers: Headers;
};
export type scoreEvalReviewItemResponseError = (scoreEvalReviewItemResponse400) & {
  headers: Headers;
};

export type scoreEvalReviewItemResponse = (scoreEvalReviewItemResponseSuccess | scoreEvalReviewItemResponseError)

export const getScoreEvalReviewItemUrl = (itemId: number,) => {




  return `/api/basecamp/eval-reviews/items/${itemId}/score`
}

/**
 * Record this reviewer's scores. Re-submitting corrects the previous one.
 */
export const scoreEvalReviewItem = async (itemId: number,
    scoreEvalReviewItemInput: ScoreEvalReviewItemInput, options?: Parameters<typeof customFetch>[1]): Promise<scoreEvalReviewItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<scoreEvalReviewItemResponse>(getScoreEvalReviewItemUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scoreEvalReviewItemInput)
  }
);}





export const getScoreEvalReviewItemMutationKey = () => ['scoreEvalReviewItem'] as const;

export const getScoreEvalReviewItemMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scoreEvalReviewItem>>, TError,ScoreEvalReviewItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof scoreEvalReviewItem>>, TError,ScoreEvalReviewItemMutationVariables, TContext> => {

const mutationKey = getScoreEvalReviewItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scoreEvalReviewItem>>, ScoreEvalReviewItemMutationVariables> = (props) => {
          const {itemId,data} = props ?? {};

          return  scoreEvalReviewItem(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScoreEvalReviewItemMutationResult = NonNullable<Awaited<ReturnType<typeof scoreEvalReviewItem>>>
    export type ScoreEvalReviewItemMutationBody = ScoreEvalReviewItemInput
    export type ScoreEvalReviewItemMutationError = Error
    export type ScoreEvalReviewItemMutationVariables = {itemId: number;data: ScoreEvalReviewItemInput}

    export const useScoreEvalReviewItem = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scoreEvalReviewItem>>, TError,ScoreEvalReviewItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scoreEvalReviewItem>>,
        TError,
        ScoreEvalReviewItemMutationVariables,
        TContext
      > => {
      return useMutation(getScoreEvalReviewItemMutationOptions(options), queryClient);
    }

export type skipEvalReviewItemResponse200 = {
  data: EvalReviewScore
  status: 200
}

export type skipEvalReviewItemResponse400 = {
  data: Error
  status: 400
}

export type skipEvalReviewItemResponseSuccess = (skipEvalReviewItemResponse200) & {
  headers: Headers;
};
export type skipEvalReviewItemResponseError = (skipEvalReviewItemResponse400) & {
  headers: Headers;
};

export type skipEvalReviewItemResponse = (skipEvalReviewItemResponseSuccess | skipEvalReviewItemResponseError)

export const getSkipEvalReviewItemUrl = (itemId: number,) => {




  return `/api/basecamp/eval-reviews/items/${itemId}/skip`
}

export const skipEvalReviewItem = async (itemId: number,
    skipEvalReviewItemInput?: SkipEvalReviewItemInput, options?: Parameters<typeof customFetch>[1]): Promise<skipEvalReviewItemResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<skipEvalReviewItemResponse>(getSkipEvalReviewItemUrl(itemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(skipEvalReviewItemInput)
  }
);}





export const getSkipEvalReviewItemMutationKey = () => ['skipEvalReviewItem'] as const;

export const getSkipEvalReviewItemMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipEvalReviewItem>>, TError,SkipEvalReviewItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof skipEvalReviewItem>>, TError,SkipEvalReviewItemMutationVariables, TContext> => {

const mutationKey = getSkipEvalReviewItemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipEvalReviewItem>>, SkipEvalReviewItemMutationVariables> = (props) => {
          const {itemId,data} = props ?? {};

          return  skipEvalReviewItem(itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipEvalReviewItemMutationResult = NonNullable<Awaited<ReturnType<typeof skipEvalReviewItem>>>
    export type SkipEvalReviewItemMutationBody = SkipEvalReviewItemInput | undefined
    export type SkipEvalReviewItemMutationError = Error
    export type SkipEvalReviewItemMutationVariables = {itemId: number;data?: SkipEvalReviewItemInput}

    export const useSkipEvalReviewItem = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipEvalReviewItem>>, TError,SkipEvalReviewItemMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof skipEvalReviewItem>>,
        TError,
        SkipEvalReviewItemMutationVariables,
        TContext
      > => {
      return useMutation(getSkipEvalReviewItemMutationOptions(options), queryClient);
    }

export type getEvalReviewProgressResponse200 = {
  data: GetEvalReviewProgressOutput
  status: 200
}

export type getEvalReviewProgressResponseSuccess = (getEvalReviewProgressResponse200) & {
  headers: Headers;
};
;

export type getEvalReviewProgressResponse = (getEvalReviewProgressResponseSuccess)

export const getGetEvalReviewProgressUrl = (params?: GetEvalReviewProgressParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-reviews/progress?${stringifiedParams}` : `/api/basecamp/eval-reviews/progress`
}

export const getEvalReviewProgress = async (params?: GetEvalReviewProgressParams, options?: Parameters<typeof customFetch>[1]): Promise<getEvalReviewProgressResponse> => {

  return customFetch<getEvalReviewProgressResponse>(getGetEvalReviewProgressUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalReviewProgressQueryKey = (params?: GetEvalReviewProgressParams,) => {
    return [
    `/api/basecamp/eval-reviews/progress`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEvalReviewProgressQueryOptions = <TData = Awaited<ReturnType<typeof getEvalReviewProgress>>, TError = unknown>(params?: GetEvalReviewProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalReviewProgressQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalReviewProgress>>> = ({ signal }) => getEvalReviewProgress(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewProgress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalReviewProgressQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalReviewProgress>>>
export type GetEvalReviewProgressQueryError = unknown


export function useGetEvalReviewProgress<TData = Awaited<ReturnType<typeof getEvalReviewProgress>>, TError = unknown>(
 params: undefined |  GetEvalReviewProgressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewProgress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalReviewProgress>>,
          TError,
          Awaited<ReturnType<typeof getEvalReviewProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalReviewProgress<TData = Awaited<ReturnType<typeof getEvalReviewProgress>>, TError = unknown>(
 params?: GetEvalReviewProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewProgress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalReviewProgress>>,
          TError,
          Awaited<ReturnType<typeof getEvalReviewProgress>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalReviewProgress<TData = Awaited<ReturnType<typeof getEvalReviewProgress>>, TError = unknown>(
 params?: GetEvalReviewProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalReviewProgress<TData = Awaited<ReturnType<typeof getEvalReviewProgress>>, TError = unknown>(
 params?: GetEvalReviewProgressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalReviewProgress>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalReviewProgressQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getEvalResultsResponse200 = {
  data: GetEvalResultsOutput
  status: 200
}

export type getEvalResultsResponse400 = {
  data: Error
  status: 400
}

export type getEvalResultsResponseSuccess = (getEvalResultsResponse200) & {
  headers: Headers;
};
export type getEvalResultsResponseError = (getEvalResultsResponse400) & {
  headers: Headers;
};

export type getEvalResultsResponse = (getEvalResultsResponseSuccess | getEvalResultsResponseError)

export const getGetEvalResultsUrl = (params?: GetEvalResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-reviews/results?${stringifiedParams}` : `/api/basecamp/eval-reviews/results`
}

/**
 * Scores read back: per-dimension aggregates plus one row per submission.
 *
 * Both in one response because the table is short enough that paginating it
 * separately would cost a round trip for nothing, and because the summary is
 * meaningless without being able to see what produced it.
 */
export const getEvalResults = async (params?: GetEvalResultsParams, options?: Parameters<typeof customFetch>[1]): Promise<getEvalResultsResponse> => {

  return customFetch<getEvalResultsResponse>(getGetEvalResultsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalResultsQueryKey = (params?: GetEvalResultsParams,) => {
    return [
    `/api/basecamp/eval-reviews/results`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEvalResultsQueryOptions = <TData = Awaited<ReturnType<typeof getEvalResults>>, TError = Error>(params?: GetEvalResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalResults>>> = ({ signal }) => getEvalResults(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalResultsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalResults>>>
export type GetEvalResultsQueryError = Error


export function useGetEvalResults<TData = Awaited<ReturnType<typeof getEvalResults>>, TError = Error>(
 params: undefined |  GetEvalResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalResults>>,
          TError,
          Awaited<ReturnType<typeof getEvalResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalResults<TData = Awaited<ReturnType<typeof getEvalResults>>, TError = Error>(
 params?: GetEvalResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalResults>>,
          TError,
          Awaited<ReturnType<typeof getEvalResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalResults<TData = Awaited<ReturnType<typeof getEvalResults>>, TError = Error>(
 params?: GetEvalResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalResults<TData = Awaited<ReturnType<typeof getEvalResults>>, TError = Error>(
 params?: GetEvalResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResults>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalResultsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getEvalResultsScopeOptionsResponse200 = {
  data: EvalResultsScopeOptionsOutput
  status: 200
}

export type getEvalResultsScopeOptionsResponseSuccess = (getEvalResultsScopeOptionsResponse200) & {
  headers: Headers;
};
;

export type getEvalResultsScopeOptionsResponse = (getEvalResultsScopeOptionsResponseSuccess)

export const getGetEvalResultsScopeOptionsUrl = () => {




  return `/api/basecamp/eval-reviews/scope-options`
}

/**
 * GET Eval Results' org and template filter choices: only those with
 * production rows (or, for orgs, a suggestion to review or shipped).
 */
export const getEvalResultsScopeOptions = async ( options?: Parameters<typeof customFetch>[1]): Promise<getEvalResultsScopeOptionsResponse> => {

  return customFetch<getEvalResultsScopeOptionsResponse>(getGetEvalResultsScopeOptionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalResultsScopeOptionsQueryKey = () => {
    return [
    `/api/basecamp/eval-reviews/scope-options`
    ] as const;
    }


export const getGetEvalResultsScopeOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalResultsScopeOptionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>> = ({ signal }) => getEvalResultsScopeOptions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalResultsScopeOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>>
export type GetEvalResultsScopeOptionsQueryError = unknown


export function useGetEvalResultsScopeOptions<TData = Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalResultsScopeOptions>>,
          TError,
          Awaited<ReturnType<typeof getEvalResultsScopeOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalResultsScopeOptions<TData = Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalResultsScopeOptions>>,
          TError,
          Awaited<ReturnType<typeof getEvalResultsScopeOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalResultsScopeOptions<TData = Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalResultsScopeOptions<TData = Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalResultsScopeOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalResultsScopeOptionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getEvalScoringStandardResponse200 = {
  data: EvalScoringStandard
  status: 200
}

export type getEvalScoringStandardResponseSuccess = (getEvalScoringStandardResponse200) & {
  headers: Headers;
};
;

export type getEvalScoringStandardResponse = (getEvalScoringStandardResponseSuccess)

export const getGetEvalScoringStandardUrl = () => {




  return `/api/basecamp/eval-reviews/standard`
}

/**
 * The scoring standard on its own, for the rubric page.
 *
 * So the rubric editor can show the dimensions and anchors that are
 * actually in force, rather than an empty form that gives no hint of what
 * authoring a criterion will change.
 */
export const getEvalScoringStandard = async ( options?: Parameters<typeof customFetch>[1]): Promise<getEvalScoringStandardResponse> => {

  return customFetch<getEvalScoringStandardResponse>(getGetEvalScoringStandardUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEvalScoringStandardQueryKey = () => {
    return [
    `/api/basecamp/eval-reviews/standard`
    ] as const;
    }


export const getGetEvalScoringStandardQueryOptions = <TData = Awaited<ReturnType<typeof getEvalScoringStandard>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalScoringStandard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEvalScoringStandardQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvalScoringStandard>>> = ({ signal }) => getEvalScoringStandard({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvalScoringStandard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEvalScoringStandardQueryResult = NonNullable<Awaited<ReturnType<typeof getEvalScoringStandard>>>
export type GetEvalScoringStandardQueryError = unknown


export function useGetEvalScoringStandard<TData = Awaited<ReturnType<typeof getEvalScoringStandard>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalScoringStandard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalScoringStandard>>,
          TError,
          Awaited<ReturnType<typeof getEvalScoringStandard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalScoringStandard<TData = Awaited<ReturnType<typeof getEvalScoringStandard>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalScoringStandard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvalScoringStandard>>,
          TError,
          Awaited<ReturnType<typeof getEvalScoringStandard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvalScoringStandard<TData = Awaited<ReturnType<typeof getEvalScoringStandard>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalScoringStandard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetEvalScoringStandard<TData = Awaited<ReturnType<typeof getEvalScoringStandard>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvalScoringStandard>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEvalScoringStandardQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type upsertEvalCriterionResponse200 = {
  data: EvalScoringStandard
  status: 200
}

export type upsertEvalCriterionResponse400 = {
  data: Error
  status: 400
}

export type upsertEvalCriterionResponseSuccess = (upsertEvalCriterionResponse200) & {
  headers: Headers;
};
export type upsertEvalCriterionResponseError = (upsertEvalCriterionResponse400) & {
  headers: Headers;
};

export type upsertEvalCriterionResponse = (upsertEvalCriterionResponseSuccess | upsertEvalCriterionResponseError)

export const getUpsertEvalCriterionUrl = () => {




  return `/api/basecamp/eval-reviews/standard/criteria`
}

/**
 * Add a criterion as its own row, or reword one that exists.
 *
 * Versioning is the service's problem — see ``upsert_criterion``.
 */
export const upsertEvalCriterion = async (upsertEvalCriterionInput: UpsertEvalCriterionInput, options?: Parameters<typeof customFetch>[1]): Promise<upsertEvalCriterionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<upsertEvalCriterionResponse>(getUpsertEvalCriterionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(upsertEvalCriterionInput)
  }
);}





export const getUpsertEvalCriterionMutationKey = () => ['upsertEvalCriterion'] as const;

export const getUpsertEvalCriterionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertEvalCriterion>>, TError,UpsertEvalCriterionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upsertEvalCriterion>>, TError,UpsertEvalCriterionMutationVariables, TContext> => {

const mutationKey = getUpsertEvalCriterionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upsertEvalCriterion>>, UpsertEvalCriterionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  upsertEvalCriterion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpsertEvalCriterionMutationResult = NonNullable<Awaited<ReturnType<typeof upsertEvalCriterion>>>
    export type UpsertEvalCriterionMutationBody = UpsertEvalCriterionInput
    export type UpsertEvalCriterionMutationError = Error
    export type UpsertEvalCriterionMutationVariables = {data: UpsertEvalCriterionInput}

    export const useUpsertEvalCriterion = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upsertEvalCriterion>>, TError,UpsertEvalCriterionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upsertEvalCriterion>>,
        TError,
        UpsertEvalCriterionMutationVariables,
        TContext
      > => {
      return useMutation(getUpsertEvalCriterionMutationOptions(options), queryClient);
    }

export type deleteEvalCriterionResponse200 = {
  data: EvalScoringStandard
  status: 200
}

export type deleteEvalCriterionResponse400 = {
  data: Error
  status: 400
}

export type deleteEvalCriterionResponseSuccess = (deleteEvalCriterionResponse200) & {
  headers: Headers;
};
export type deleteEvalCriterionResponseError = (deleteEvalCriterionResponse400) & {
  headers: Headers;
};

export type deleteEvalCriterionResponse = (deleteEvalCriterionResponseSuccess | deleteEvalCriterionResponseError)

export const getDeleteEvalCriterionUrl = (criterionId: number,) => {




  return `/api/basecamp/eval-reviews/standard/criteria/${criterionId}/delete`
}

/**
 * Remove a criterion. The dimension falls back to the built-in wording
 * once nothing is left under it.
 */
export const deleteEvalCriterion = async (criterionId: number, options?: Parameters<typeof customFetch>[1]): Promise<deleteEvalCriterionResponse> => {

  return customFetch<deleteEvalCriterionResponse>(getDeleteEvalCriterionUrl(criterionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDeleteEvalCriterionMutationKey = () => ['deleteEvalCriterion'] as const;

export const getDeleteEvalCriterionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvalCriterion>>, TError,DeleteEvalCriterionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvalCriterion>>, TError,DeleteEvalCriterionMutationVariables, TContext> => {

const mutationKey = getDeleteEvalCriterionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvalCriterion>>, DeleteEvalCriterionMutationVariables> = (props) => {
          const {criterionId} = props ?? {};

          return  deleteEvalCriterion(criterionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEvalCriterionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvalCriterion>>>

    export type DeleteEvalCriterionMutationError = Error
    export type DeleteEvalCriterionMutationVariables = {criterionId: number}

    export const useDeleteEvalCriterion = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvalCriterion>>, TError,DeleteEvalCriterionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvalCriterion>>,
        TError,
        DeleteEvalCriterionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteEvalCriterionMutationOptions(options), queryClient);
    }

export type listPromptSuggestionsResponse200 = {
  data: ListPromptSuggestionsOutput
  status: 200
}

export type listPromptSuggestionsResponse400 = {
  data: Error
  status: 400
}

export type listPromptSuggestionsResponseSuccess = (listPromptSuggestionsResponse200) & {
  headers: Headers;
};
export type listPromptSuggestionsResponseError = (listPromptSuggestionsResponse400) & {
  headers: Headers;
};

export type listPromptSuggestionsResponse = (listPromptSuggestionsResponseSuccess | listPromptSuggestionsResponseError)

export const getListPromptSuggestionsUrl = (params: ListPromptSuggestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-reviews/suggestions?${stringifiedParams}` : `/api/basecamp/eval-reviews/suggestions`
}

/**
 * An org's suggestions still to review, new then testing, strongest
 * theme first. Shipped ones are under ``ListAcceptedPromptSuggestions``.
 */
export const listPromptSuggestions = async (params: ListPromptSuggestionsParams, options?: Parameters<typeof customFetch>[1]): Promise<listPromptSuggestionsResponse> => {

  return customFetch<listPromptSuggestionsResponse>(getListPromptSuggestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptSuggestionsQueryKey = (params?: ListPromptSuggestionsParams,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPromptSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof listPromptSuggestions>>, TError = Error>(params: ListPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptSuggestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptSuggestions>>> = ({ signal }) => listPromptSuggestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptSuggestions>>>
export type ListPromptSuggestionsQueryError = Error


export function useListPromptSuggestions<TData = Awaited<ReturnType<typeof listPromptSuggestions>>, TError = Error>(
 params: ListPromptSuggestionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptSuggestions>>,
          TError,
          Awaited<ReturnType<typeof listPromptSuggestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptSuggestions<TData = Awaited<ReturnType<typeof listPromptSuggestions>>, TError = Error>(
 params: ListPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptSuggestions>>,
          TError,
          Awaited<ReturnType<typeof listPromptSuggestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptSuggestions<TData = Awaited<ReturnType<typeof listPromptSuggestions>>, TError = Error>(
 params: ListPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromptSuggestions<TData = Awaited<ReturnType<typeof listPromptSuggestions>>, TError = Error>(
 params: ListPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getPromptSuggestionResponse200 = {
  data: PromptSuggestion
  status: 200
}

export type getPromptSuggestionResponse404 = {
  data: Error
  status: 404
}

export type getPromptSuggestionResponseSuccess = (getPromptSuggestionResponse200) & {
  headers: Headers;
};
export type getPromptSuggestionResponseError = (getPromptSuggestionResponse404) & {
  headers: Headers;
};

export type getPromptSuggestionResponse = (getPromptSuggestionResponseSuccess | getPromptSuggestionResponseError)

export const getGetPromptSuggestionUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}`
}

/**
 * One suggestion, for its Review & test on the prompt's Evaluations page.
 */
export const getPromptSuggestion = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<getPromptSuggestionResponse> => {

  return customFetch<getPromptSuggestionResponse>(getGetPromptSuggestionUrl(suggestionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptSuggestionQueryKey = (suggestionId: number,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/${suggestionId}`
    ] as const;
    }


export const getGetPromptSuggestionQueryOptions = <TData = Awaited<ReturnType<typeof getPromptSuggestion>>, TError = Error>(suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptSuggestionQueryKey(suggestionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptSuggestion>>> = ({ signal }) => getPromptSuggestion(suggestionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: suggestionId !== null && suggestionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptSuggestionQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptSuggestion>>>
export type GetPromptSuggestionQueryError = Error


export function useGetPromptSuggestion<TData = Awaited<ReturnType<typeof getPromptSuggestion>>, TError = Error>(
 suggestionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getPromptSuggestion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptSuggestion<TData = Awaited<ReturnType<typeof getPromptSuggestion>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptSuggestion>>,
          TError,
          Awaited<ReturnType<typeof getPromptSuggestion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptSuggestion<TData = Awaited<ReturnType<typeof getPromptSuggestion>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptSuggestion<TData = Awaited<ReturnType<typeof getPromptSuggestion>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestion>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptSuggestionQueryOptions(suggestionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type dismissPromptSuggestionResponse200 = {
  data: PromptSuggestion
  status: 200
}

export type dismissPromptSuggestionResponse400 = {
  data: Error
  status: 400
}

export type dismissPromptSuggestionResponse404 = {
  data: Error
  status: 404
}

export type dismissPromptSuggestionResponse409 = {
  data: Error
  status: 409
}

export type dismissPromptSuggestionResponseSuccess = (dismissPromptSuggestionResponse200) & {
  headers: Headers;
};
export type dismissPromptSuggestionResponseError = (dismissPromptSuggestionResponse400 | dismissPromptSuggestionResponse404 | dismissPromptSuggestionResponse409) & {
  headers: Headers;
};

export type dismissPromptSuggestionResponse = (dismissPromptSuggestionResponseSuccess | dismissPromptSuggestionResponseError)

export const getDismissPromptSuggestionUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/dismiss`
}

/**
 * Dismiss a suggestion that isn't shipped. Its theme won't be suggested
 * again.
 */
export const dismissPromptSuggestion = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<dismissPromptSuggestionResponse> => {

  return customFetch<dismissPromptSuggestionResponse>(getDismissPromptSuggestionUrl(suggestionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDismissPromptSuggestionMutationKey = () => ['dismissPromptSuggestion'] as const;

export const getDismissPromptSuggestionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissPromptSuggestion>>, TError,DismissPromptSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof dismissPromptSuggestion>>, TError,DismissPromptSuggestionMutationVariables, TContext> => {

const mutationKey = getDismissPromptSuggestionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissPromptSuggestion>>, DismissPromptSuggestionMutationVariables> = (props) => {
          const {suggestionId} = props ?? {};

          return  dismissPromptSuggestion(suggestionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DismissPromptSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof dismissPromptSuggestion>>>

    export type DismissPromptSuggestionMutationError = Error
    export type DismissPromptSuggestionMutationVariables = {suggestionId: number}

    export const useDismissPromptSuggestion = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissPromptSuggestion>>, TError,DismissPromptSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissPromptSuggestion>>,
        TError,
        DismissPromptSuggestionMutationVariables,
        TContext
      > => {
      return useMutation(getDismissPromptSuggestionMutationOptions(options), queryClient);
    }

export type updatePromptSuggestionDraftResponse200 = {
  data: PromptSuggestion
  status: 200
}

export type updatePromptSuggestionDraftResponse400 = {
  data: Error
  status: 400
}

export type updatePromptSuggestionDraftResponse404 = {
  data: Error
  status: 404
}

export type updatePromptSuggestionDraftResponseSuccess = (updatePromptSuggestionDraftResponse200) & {
  headers: Headers;
};
export type updatePromptSuggestionDraftResponseError = (updatePromptSuggestionDraftResponse400 | updatePromptSuggestionDraftResponse404) & {
  headers: Headers;
};

export type updatePromptSuggestionDraftResponse = (updatePromptSuggestionDraftResponseSuccess | updatePromptSuggestionDraftResponseError)

export const getUpdatePromptSuggestionDraftUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/draft`
}

/**
 * Edit a new or testing suggestion's draft. Fields not sent are left as
 * they are.
 */
export const updatePromptSuggestionDraft = async (suggestionId: number,
    updatePromptSuggestionDraftInput: UpdatePromptSuggestionDraftInput, options?: Parameters<typeof customFetch>[1]): Promise<updatePromptSuggestionDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updatePromptSuggestionDraftResponse>(getUpdatePromptSuggestionDraftUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePromptSuggestionDraftInput)
  }
);}





export const getUpdatePromptSuggestionDraftMutationKey = () => ['updatePromptSuggestionDraft'] as const;

export const getUpdatePromptSuggestionDraftMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePromptSuggestionDraft>>, TError,UpdatePromptSuggestionDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePromptSuggestionDraft>>, TError,UpdatePromptSuggestionDraftMutationVariables, TContext> => {

const mutationKey = getUpdatePromptSuggestionDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePromptSuggestionDraft>>, UpdatePromptSuggestionDraftMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  updatePromptSuggestionDraft(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePromptSuggestionDraftMutationResult = NonNullable<Awaited<ReturnType<typeof updatePromptSuggestionDraft>>>
    export type UpdatePromptSuggestionDraftMutationBody = UpdatePromptSuggestionDraftInput
    export type UpdatePromptSuggestionDraftMutationError = Error
    export type UpdatePromptSuggestionDraftMutationVariables = {suggestionId: number;data: UpdatePromptSuggestionDraftInput}

    export const useUpdatePromptSuggestionDraft = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePromptSuggestionDraft>>, TError,UpdatePromptSuggestionDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePromptSuggestionDraft>>,
        TError,
        UpdatePromptSuggestionDraftMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePromptSuggestionDraftMutationOptions(options), queryClient);
    }

export type getPromptSuggestionDraftM2mResponse200 = {
  data: PromptSuggestionDraftM2MOutput
  status: 200
}

export type getPromptSuggestionDraftM2mResponse404 = {
  data: Error
  status: 404
}

export type getPromptSuggestionDraftM2mResponseSuccess = (getPromptSuggestionDraftM2mResponse200) & {
  headers: Headers;
};
export type getPromptSuggestionDraftM2mResponseError = (getPromptSuggestionDraftM2mResponse404) & {
  headers: Headers;
};

export type getPromptSuggestionDraftM2mResponse = (getPromptSuggestionDraftM2mResponseSuccess | getPromptSuggestionDraftM2mResponseError)

export const getGetPromptSuggestionDraftM2mUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/draft/m2m`
}

/**
 * GET a suggestion's draft changes; POST ``{field, value}`` to set one
 * (``value`` null drops the change). Rio's draft tools in a suggestion's
 * session; never the prompt or its ``draft_overrides``.
 */
export const getPromptSuggestionDraftM2m = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<getPromptSuggestionDraftM2mResponse> => {

  return customFetch<getPromptSuggestionDraftM2mResponse>(getGetPromptSuggestionDraftM2mUrl(suggestionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptSuggestionDraftM2mQueryKey = (suggestionId: number,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/${suggestionId}/draft/m2m`
    ] as const;
    }


export const getGetPromptSuggestionDraftM2mQueryOptions = <TData = Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError = Error>(suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptSuggestionDraftM2mQueryKey(suggestionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>> = ({ signal }) => getPromptSuggestionDraftM2m(suggestionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: suggestionId !== null && suggestionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptSuggestionDraftM2mQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>>
export type GetPromptSuggestionDraftM2mQueryError = Error


export function useGetPromptSuggestionDraftM2m<TData = Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError = Error>(
 suggestionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptSuggestionDraftM2m<TData = Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptSuggestionDraftM2m<TData = Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptSuggestionDraftM2m<TData = Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptSuggestionDraftM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptSuggestionDraftM2mQueryOptions(suggestionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type putPromptSuggestionDraftM2mResponse200 = {
  data: PromptSuggestionDraftM2MOutput
  status: 200
}

export type putPromptSuggestionDraftM2mResponse400 = {
  data: Error
  status: 400
}

export type putPromptSuggestionDraftM2mResponse404 = {
  data: Error
  status: 404
}

export type putPromptSuggestionDraftM2mResponseSuccess = (putPromptSuggestionDraftM2mResponse200) & {
  headers: Headers;
};
export type putPromptSuggestionDraftM2mResponseError = (putPromptSuggestionDraftM2mResponse400 | putPromptSuggestionDraftM2mResponse404) & {
  headers: Headers;
};

export type putPromptSuggestionDraftM2mResponse = (putPromptSuggestionDraftM2mResponseSuccess | putPromptSuggestionDraftM2mResponseError)

export const getPutPromptSuggestionDraftM2mUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/draft/m2m`
}

/**
 * GET a suggestion's draft changes; POST ``{field, value}`` to set one
 * (``value`` null drops the change). Rio's draft tools in a suggestion's
 * session; never the prompt or its ``draft_overrides``.
 */
export const putPromptSuggestionDraftM2m = async (suggestionId: number,
    putPromptSuggestionDraftM2MInput: PutPromptSuggestionDraftM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<putPromptSuggestionDraftM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<putPromptSuggestionDraftM2mResponse>(getPutPromptSuggestionDraftM2mUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPromptSuggestionDraftM2MInput)
  }
);}





export const getPutPromptSuggestionDraftM2mMutationKey = () => ['putPromptSuggestionDraftM2m'] as const;

export const getPutPromptSuggestionDraftM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPromptSuggestionDraftM2m>>, TError,PutPromptSuggestionDraftM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putPromptSuggestionDraftM2m>>, TError,PutPromptSuggestionDraftM2mMutationVariables, TContext> => {

const mutationKey = getPutPromptSuggestionDraftM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPromptSuggestionDraftM2m>>, PutPromptSuggestionDraftM2mMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  putPromptSuggestionDraftM2m(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPromptSuggestionDraftM2mMutationResult = NonNullable<Awaited<ReturnType<typeof putPromptSuggestionDraftM2m>>>
    export type PutPromptSuggestionDraftM2mMutationBody = PutPromptSuggestionDraftM2MInput
    export type PutPromptSuggestionDraftM2mMutationError = Error
    export type PutPromptSuggestionDraftM2mMutationVariables = {suggestionId: number;data: PutPromptSuggestionDraftM2MInput}

    export const usePutPromptSuggestionDraftM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPromptSuggestionDraftM2m>>, TError,PutPromptSuggestionDraftM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPromptSuggestionDraftM2m>>,
        TError,
        PutPromptSuggestionDraftM2mMutationVariables,
        TContext
      > => {
      return useMutation(getPutPromptSuggestionDraftM2mMutationOptions(options), queryClient);
    }

export type incorporatePromptSuggestionsResponse200 = {
  data: PromptSuggestion
  status: 200
}

export type incorporatePromptSuggestionsResponse202 = {
  data: PromptSuggestion
  status: 202
}

export type incorporatePromptSuggestionsResponse400 = {
  data: Error
  status: 400
}

export type incorporatePromptSuggestionsResponse404 = {
  data: Error
  status: 404
}

export type incorporatePromptSuggestionsResponse409 = {
  data: Error
  status: 409
}

export type incorporatePromptSuggestionsResponse502 = {
  data: Error
  status: 502
}

export type incorporatePromptSuggestionsResponseSuccess = (incorporatePromptSuggestionsResponse200 | incorporatePromptSuggestionsResponse202) & {
  headers: Headers;
};
export type incorporatePromptSuggestionsResponseError = (incorporatePromptSuggestionsResponse400 | incorporatePromptSuggestionsResponse404 | incorporatePromptSuggestionsResponse409 | incorporatePromptSuggestionsResponse502) & {
  headers: Headers;
};

export type incorporatePromptSuggestionsResponse = (incorporatePromptSuggestionsResponseSuccess | incorporatePromptSuggestionsResponseError)

export const getIncorporatePromptSuggestionsUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/incorporate`
}

/**
 * POST Review draft's pop-up: the prompt's other open suggestions, each
 * incorporated into this one or dismissed. Current drafts that change
 * different fields merge at once (200). Otherwise Rio re-drafts this one
 * with every theme (202; the page polls), and the incorporated ones leave
 * Eval Results when it writes back.
 */
export const incorporatePromptSuggestions = async (suggestionId: number,
    incorporatePromptSuggestionsInput?: IncorporatePromptSuggestionsInput, options?: Parameters<typeof customFetch>[1]): Promise<incorporatePromptSuggestionsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<incorporatePromptSuggestionsResponse>(getIncorporatePromptSuggestionsUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(incorporatePromptSuggestionsInput)
  }
);}





export const getIncorporatePromptSuggestionsMutationKey = () => ['incorporatePromptSuggestions'] as const;

export const getIncorporatePromptSuggestionsMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof incorporatePromptSuggestions>>, TError,IncorporatePromptSuggestionsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof incorporatePromptSuggestions>>, TError,IncorporatePromptSuggestionsMutationVariables, TContext> => {

const mutationKey = getIncorporatePromptSuggestionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof incorporatePromptSuggestions>>, IncorporatePromptSuggestionsMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  incorporatePromptSuggestions(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IncorporatePromptSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof incorporatePromptSuggestions>>>
    export type IncorporatePromptSuggestionsMutationBody = IncorporatePromptSuggestionsInput | undefined
    export type IncorporatePromptSuggestionsMutationError = Error
    export type IncorporatePromptSuggestionsMutationVariables = {suggestionId: number;data?: IncorporatePromptSuggestionsInput}

    export const useIncorporatePromptSuggestions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof incorporatePromptSuggestions>>, TError,IncorporatePromptSuggestionsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof incorporatePromptSuggestions>>,
        TError,
        IncorporatePromptSuggestionsMutationVariables,
        TContext
      > => {
      return useMutation(getIncorporatePromptSuggestionsMutationOptions(options), queryClient);
    }

export type openPromptSuggestionPrResponse201 = {
  data: OpenPROutput
  status: 201
}

export type openPromptSuggestionPrResponse400 = {
  data: Error
  status: 400
}

export type openPromptSuggestionPrResponse404 = {
  data: Error
  status: 404
}

export type openPromptSuggestionPrResponse409 = {
  data: Error
  status: 409
}

export type openPromptSuggestionPrResponse502 = {
  data: Error
  status: 502
}

export type openPromptSuggestionPrResponseSuccess = (openPromptSuggestionPrResponse201) & {
  headers: Headers;
};
export type openPromptSuggestionPrResponseError = (openPromptSuggestionPrResponse400 | openPromptSuggestionPrResponse404 | openPromptSuggestionPrResponse409 | openPromptSuggestionPrResponse502) & {
  headers: Headers;
};

export type openPromptSuggestionPrResponse = (openPromptSuggestionPrResponseSuccess | openPromptSuggestionPrResponseError)

export const getOpenPromptSuggestionPrUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/open-pr`
}

/**
 * POST: approve the suggestion by opening its PRs. Never touches the
 * prompt's own ``draft_overrides``.
 */
export const openPromptSuggestionPr = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<openPromptSuggestionPrResponse> => {

  return customFetch<openPromptSuggestionPrResponse>(getOpenPromptSuggestionPrUrl(suggestionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getOpenPromptSuggestionPrMutationKey = () => ['openPromptSuggestionPr'] as const;

export const getOpenPromptSuggestionPrMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPromptSuggestionPr>>, TError,OpenPromptSuggestionPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof openPromptSuggestionPr>>, TError,OpenPromptSuggestionPrMutationVariables, TContext> => {

const mutationKey = getOpenPromptSuggestionPrMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openPromptSuggestionPr>>, OpenPromptSuggestionPrMutationVariables> = (props) => {
          const {suggestionId} = props ?? {};

          return  openPromptSuggestionPr(suggestionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenPromptSuggestionPrMutationResult = NonNullable<Awaited<ReturnType<typeof openPromptSuggestionPr>>>

    export type OpenPromptSuggestionPrMutationError = Error
    export type OpenPromptSuggestionPrMutationVariables = {suggestionId: number}

    export const useOpenPromptSuggestionPr = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPromptSuggestionPr>>, TError,OpenPromptSuggestionPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openPromptSuggestionPr>>,
        TError,
        OpenPromptSuggestionPrMutationVariables,
        TContext
      > => {
      return useMutation(getOpenPromptSuggestionPrMutationOptions(options), queryClient);
    }

export type redraftPromptSuggestionResponse202 = {
  data: PromptSuggestion
  status: 202
}

export type redraftPromptSuggestionResponse400 = {
  data: Error
  status: 400
}

export type redraftPromptSuggestionResponse404 = {
  data: Error
  status: 404
}

export type redraftPromptSuggestionResponse409 = {
  data: Error
  status: 409
}

export type redraftPromptSuggestionResponse502 = {
  data: Error
  status: 502
}

export type redraftPromptSuggestionResponseSuccess = (redraftPromptSuggestionResponse202) & {
  headers: Headers;
};
export type redraftPromptSuggestionResponseError = (redraftPromptSuggestionResponse400 | redraftPromptSuggestionResponse404 | redraftPromptSuggestionResponse409 | redraftPromptSuggestionResponse502) & {
  headers: Headers;
};

export type redraftPromptSuggestionResponse = (redraftPromptSuggestionResponseSuccess | redraftPromptSuggestionResponseError)

export const getRedraftPromptSuggestionUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/redraft`
}

/**
 * POST: have Rio re-draft a suggestion whose prompt changed since it was
 * drafted, on the prompt as it is now. Returns 202; the card polls.
 */
export const redraftPromptSuggestion = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<redraftPromptSuggestionResponse> => {

  return customFetch<redraftPromptSuggestionResponse>(getRedraftPromptSuggestionUrl(suggestionId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRedraftPromptSuggestionMutationKey = () => ['redraftPromptSuggestion'] as const;

export const getRedraftPromptSuggestionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redraftPromptSuggestion>>, TError,RedraftPromptSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof redraftPromptSuggestion>>, TError,RedraftPromptSuggestionMutationVariables, TContext> => {

const mutationKey = getRedraftPromptSuggestionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redraftPromptSuggestion>>, RedraftPromptSuggestionMutationVariables> = (props) => {
          const {suggestionId} = props ?? {};

          return  redraftPromptSuggestion(suggestionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedraftPromptSuggestionMutationResult = NonNullable<Awaited<ReturnType<typeof redraftPromptSuggestion>>>

    export type RedraftPromptSuggestionMutationError = Error
    export type RedraftPromptSuggestionMutationVariables = {suggestionId: number}

    export const useRedraftPromptSuggestion = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redraftPromptSuggestion>>, TError,RedraftPromptSuggestionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redraftPromptSuggestion>>,
        TError,
        RedraftPromptSuggestionMutationVariables,
        TContext
      > => {
      return useMutation(getRedraftPromptSuggestionMutationOptions(options), queryClient);
    }

export type getRioSuggestionMessagesResponse200 = {
  data: RioMessageList
  status: 200
}

export type getRioSuggestionMessagesResponse404 = {
  data: Error
  status: 404
}

export type getRioSuggestionMessagesResponseSuccess = (getRioSuggestionMessagesResponse200) & {
  headers: Headers;
};
export type getRioSuggestionMessagesResponseError = (getRioSuggestionMessagesResponse404) & {
  headers: Headers;
};

export type getRioSuggestionMessagesResponse = (getRioSuggestionMessagesResponseSuccess | getRioSuggestionMessagesResponseError)

export const getGetRioSuggestionMessagesUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/messages`
}

/**
 * GET /api/basecamp/eval-reviews/suggestions/<id>/rio/messages — SPA.
 * ``?include_edit_log=true`` as on ``GetRioPromptMessages``.
 */
export const getRioSuggestionMessages = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<getRioSuggestionMessagesResponse> => {

  return customFetch<getRioSuggestionMessagesResponse>(getGetRioSuggestionMessagesUrl(suggestionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRioSuggestionMessagesQueryKey = (suggestionId: number,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/messages`
    ] as const;
    }


export const getGetRioSuggestionMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError = Error>(suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRioSuggestionMessagesQueryKey(suggestionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRioSuggestionMessages>>> = ({ signal }) => getRioSuggestionMessages(suggestionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: suggestionId !== null && suggestionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRioSuggestionMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getRioSuggestionMessages>>>
export type GetRioSuggestionMessagesQueryError = Error


export function useGetRioSuggestionMessages<TData = Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError = Error>(
 suggestionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRioSuggestionMessages>>,
          TError,
          Awaited<ReturnType<typeof getRioSuggestionMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRioSuggestionMessages<TData = Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRioSuggestionMessages>>,
          TError,
          Awaited<ReturnType<typeof getRioSuggestionMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRioSuggestionMessages<TData = Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRioSuggestionMessages<TData = Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioSuggestionMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRioSuggestionMessagesQueryOptions(suggestionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listRioSuggestionMessagesM2mResponse200 = {
  data: RioMessageList
  status: 200
}

export type listRioSuggestionMessagesM2mResponse400 = {
  data: Error
  status: 400
}

export type listRioSuggestionMessagesM2mResponseSuccess = (listRioSuggestionMessagesM2mResponse200) & {
  headers: Headers;
};
export type listRioSuggestionMessagesM2mResponseError = (listRioSuggestionMessagesM2mResponse400) & {
  headers: Headers;
};

export type listRioSuggestionMessagesM2mResponse = (listRioSuggestionMessagesM2mResponseSuccess | listRioSuggestionMessagesM2mResponseError)

export const getListRioSuggestionMessagesM2mUrl = (suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/messages/list?${stringifiedParams}` : `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/messages/list`
}

/**
 * GET /api/basecamp/eval-reviews/suggestions/<id>/rio/messages/list —
 * M2M, for the Rio worker's rehydration on start.
 */
export const listRioSuggestionMessagesM2m = async (suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams, options?: Parameters<typeof customFetch>[1]): Promise<listRioSuggestionMessagesM2mResponse> => {

  return customFetch<listRioSuggestionMessagesM2mResponse>(getListRioSuggestionMessagesM2mUrl(suggestionId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRioSuggestionMessagesM2mQueryKey = (suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/messages/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRioSuggestionMessagesM2mQueryOptions = <TData = Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError = Error>(suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRioSuggestionMessagesM2mQueryKey(suggestionId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>> = ({ signal }) => listRioSuggestionMessagesM2m(suggestionId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: suggestionId !== null && suggestionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRioSuggestionMessagesM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>>
export type ListRioSuggestionMessagesM2mQueryError = Error


export function useListRioSuggestionMessagesM2m<TData = Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError = Error>(
 suggestionId: number,
    params: undefined |  ListRioSuggestionMessagesM2mParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>,
          TError,
          Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRioSuggestionMessagesM2m<TData = Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError = Error>(
 suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>,
          TError,
          Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRioSuggestionMessagesM2m<TData = Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError = Error>(
 suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRioSuggestionMessagesM2m<TData = Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError = Error>(
 suggestionId: number,
    params?: ListRioSuggestionMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioSuggestionMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRioSuggestionMessagesM2mQueryOptions(suggestionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type saveRioSuggestionMessageResponse200 = {
  data: SaveRioPromptMessageOutput
  status: 200
}

export type saveRioSuggestionMessageResponse400 = {
  data: Error
  status: 400
}

export type saveRioSuggestionMessageResponse404 = {
  data: Error
  status: 404
}

export type saveRioSuggestionMessageResponse409 = {
  data: Error
  status: 409
}

export type saveRioSuggestionMessageResponseSuccess = (saveRioSuggestionMessageResponse200) & {
  headers: Headers;
};
export type saveRioSuggestionMessageResponseError = (saveRioSuggestionMessageResponse400 | saveRioSuggestionMessageResponse404 | saveRioSuggestionMessageResponse409) & {
  headers: Headers;
};

export type saveRioSuggestionMessageResponse = (saveRioSuggestionMessageResponseSuccess | saveRioSuggestionMessageResponseError)

export const getSaveRioSuggestionMessageUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/messages/save`
}

/**
 * POST /api/basecamp/eval-reviews/suggestions/<id>/rio/messages/save —
 * M2M, the Rio worker's per-turn persistence. Idempotent on
 * ``message_id``.
 */
export const saveRioSuggestionMessage = async (suggestionId: number,
    saveRioPromptMessageInput: SaveRioPromptMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<saveRioSuggestionMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<saveRioSuggestionMessageResponse>(getSaveRioSuggestionMessageUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveRioPromptMessageInput)
  }
);}





export const getSaveRioSuggestionMessageMutationKey = () => ['saveRioSuggestionMessage'] as const;

export const getSaveRioSuggestionMessageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRioSuggestionMessage>>, TError,SaveRioSuggestionMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveRioSuggestionMessage>>, TError,SaveRioSuggestionMessageMutationVariables, TContext> => {

const mutationKey = getSaveRioSuggestionMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRioSuggestionMessage>>, SaveRioSuggestionMessageMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  saveRioSuggestionMessage(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveRioSuggestionMessageMutationResult = NonNullable<Awaited<ReturnType<typeof saveRioSuggestionMessage>>>
    export type SaveRioSuggestionMessageMutationBody = SaveRioPromptMessageInput
    export type SaveRioSuggestionMessageMutationError = Error
    export type SaveRioSuggestionMessageMutationVariables = {suggestionId: number;data: SaveRioPromptMessageInput}

    export const useSaveRioSuggestionMessage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRioSuggestionMessage>>, TError,SaveRioSuggestionMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveRioSuggestionMessage>>,
        TError,
        SaveRioSuggestionMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSaveRioSuggestionMessageMutationOptions(options), queryClient);
    }

export type sendRioSuggestionMessageResponse202 = {
  data: SendRioPromptMessageOutput
  status: 202
}

export type sendRioSuggestionMessageResponse400 = {
  data: Error
  status: 400
}

export type sendRioSuggestionMessageResponse404 = {
  data: Error
  status: 404
}

export type sendRioSuggestionMessageResponse409 = {
  data: Error
  status: 409
}

export type sendRioSuggestionMessageResponseSuccess = (sendRioSuggestionMessageResponse202) & {
  headers: Headers;
};
export type sendRioSuggestionMessageResponseError = (sendRioSuggestionMessageResponse400 | sendRioSuggestionMessageResponse404 | sendRioSuggestionMessageResponse409) & {
  headers: Headers;
};

export type sendRioSuggestionMessageResponse = (sendRioSuggestionMessageResponseSuccess | sendRioSuggestionMessageResponseError)

export const getSendRioSuggestionMessageUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/rio/send`
}

/**
 * POST /api/basecamp/eval-reviews/suggestions/<id>/rio/send — SPA.
 *
 * Signal-with-start of the suggestion's own Rio session, under the
 * suggestion's org. Returns 202; the SPA polls ``/rio/messages``.
 */
export const sendRioSuggestionMessage = async (suggestionId: number,
    sendRioPromptMessageInput: SendRioPromptMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<sendRioSuggestionMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<sendRioSuggestionMessageResponse>(getSendRioSuggestionMessageUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendRioPromptMessageInput)
  }
);}





export const getSendRioSuggestionMessageMutationKey = () => ['sendRioSuggestionMessage'] as const;

export const getSendRioSuggestionMessageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRioSuggestionMessage>>, TError,SendRioSuggestionMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRioSuggestionMessage>>, TError,SendRioSuggestionMessageMutationVariables, TContext> => {

const mutationKey = getSendRioSuggestionMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRioSuggestionMessage>>, SendRioSuggestionMessageMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  sendRioSuggestionMessage(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendRioSuggestionMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendRioSuggestionMessage>>>
    export type SendRioSuggestionMessageMutationBody = SendRioPromptMessageInput
    export type SendRioSuggestionMessageMutationError = Error
    export type SendRioSuggestionMessageMutationVariables = {suggestionId: number;data: SendRioPromptMessageInput}

    export const useSendRioSuggestionMessage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRioSuggestionMessage>>, TError,SendRioSuggestionMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendRioSuggestionMessage>>,
        TError,
        SendRioSuggestionMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSendRioSuggestionMessageMutationOptions(options), queryClient);
    }

export type listPromptSuggestionTestsResponse200 = {
  data: ListPromptSuggestionTestsOutput
  status: 200
}

export type listPromptSuggestionTestsResponse404 = {
  data: Error
  status: 404
}

export type listPromptSuggestionTestsResponseSuccess = (listPromptSuggestionTestsResponse200) & {
  headers: Headers;
};
export type listPromptSuggestionTestsResponseError = (listPromptSuggestionTestsResponse404) & {
  headers: Headers;
};

export type listPromptSuggestionTestsResponse = (listPromptSuggestionTestsResponseSuccess | listPromptSuggestionTestsResponseError)

export const getListPromptSuggestionTestsUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/tests`
}

/**
 * GET a suggestion's tests, newest first; POST to start one.
 */
export const listPromptSuggestionTests = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<listPromptSuggestionTestsResponse> => {

  return customFetch<listPromptSuggestionTestsResponse>(getListPromptSuggestionTestsUrl(suggestionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptSuggestionTestsQueryKey = (suggestionId: number,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/${suggestionId}/tests`
    ] as const;
    }


export const getListPromptSuggestionTestsQueryOptions = <TData = Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError = Error>(suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptSuggestionTestsQueryKey(suggestionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptSuggestionTests>>> = ({ signal }) => listPromptSuggestionTests(suggestionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: suggestionId !== null && suggestionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptSuggestionTestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptSuggestionTests>>>
export type ListPromptSuggestionTestsQueryError = Error


export function useListPromptSuggestionTests<TData = Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError = Error>(
 suggestionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptSuggestionTests>>,
          TError,
          Awaited<ReturnType<typeof listPromptSuggestionTests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptSuggestionTests<TData = Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptSuggestionTests>>,
          TError,
          Awaited<ReturnType<typeof listPromptSuggestionTests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptSuggestionTests<TData = Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromptSuggestionTests<TData = Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptSuggestionTestsQueryOptions(suggestionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startPromptSuggestionTestResponse201 = {
  data: PromptSuggestionTest
  status: 201
}

export type startPromptSuggestionTestResponse400 = {
  data: Error
  status: 400
}

export type startPromptSuggestionTestResponse404 = {
  data: Error
  status: 404
}

export type startPromptSuggestionTestResponseSuccess = (startPromptSuggestionTestResponse201) & {
  headers: Headers;
};
export type startPromptSuggestionTestResponseError = (startPromptSuggestionTestResponse400 | startPromptSuggestionTestResponse404) & {
  headers: Headers;
};

export type startPromptSuggestionTestResponse = (startPromptSuggestionTestResponseSuccess | startPromptSuggestionTestResponseError)

export const getStartPromptSuggestionTestUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/tests`
}

/**
 * GET a suggestion's tests, newest first; POST to start one.
 */
export const startPromptSuggestionTest = async (suggestionId: number,
    startPromptSuggestionTestInput?: StartPromptSuggestionTestInput, options?: Parameters<typeof customFetch>[1]): Promise<startPromptSuggestionTestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startPromptSuggestionTestResponse>(getStartPromptSuggestionTestUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startPromptSuggestionTestInput)
  }
);}





export const getStartPromptSuggestionTestMutationKey = () => ['startPromptSuggestionTest'] as const;

export const getStartPromptSuggestionTestMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptSuggestionTest>>, TError,StartPromptSuggestionTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPromptSuggestionTest>>, TError,StartPromptSuggestionTestMutationVariables, TContext> => {

const mutationKey = getStartPromptSuggestionTestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPromptSuggestionTest>>, StartPromptSuggestionTestMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  startPromptSuggestionTest(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPromptSuggestionTestMutationResult = NonNullable<Awaited<ReturnType<typeof startPromptSuggestionTest>>>
    export type StartPromptSuggestionTestMutationBody = StartPromptSuggestionTestInput | undefined
    export type StartPromptSuggestionTestMutationError = Error
    export type StartPromptSuggestionTestMutationVariables = {suggestionId: number;data?: StartPromptSuggestionTestInput}

    export const useStartPromptSuggestionTest = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptSuggestionTest>>, TError,StartPromptSuggestionTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPromptSuggestionTest>>,
        TError,
        StartPromptSuggestionTestMutationVariables,
        TContext
      > => {
      return useMutation(getStartPromptSuggestionTestMutationOptions(options), queryClient);
    }

export type listPromptSuggestionTestsM2mResponse200 = {
  data: ListPromptSuggestionTestsOutput
  status: 200
}

export type listPromptSuggestionTestsM2mResponse404 = {
  data: Error
  status: 404
}

export type listPromptSuggestionTestsM2mResponseSuccess = (listPromptSuggestionTestsM2mResponse200) & {
  headers: Headers;
};
export type listPromptSuggestionTestsM2mResponseError = (listPromptSuggestionTestsM2mResponse404) & {
  headers: Headers;
};

export type listPromptSuggestionTestsM2mResponse = (listPromptSuggestionTestsM2mResponseSuccess | listPromptSuggestionTestsM2mResponseError)

export const getListPromptSuggestionTestsM2mUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/tests/m2m`
}

/**
 * M2M sibling of ``PromptSuggestionTests`` for Rio: GET the tests, POST
 * ``{profile_id}`` to start one.
 */
export const listPromptSuggestionTestsM2m = async (suggestionId: number, options?: Parameters<typeof customFetch>[1]): Promise<listPromptSuggestionTestsM2mResponse> => {

  return customFetch<listPromptSuggestionTestsM2mResponse>(getListPromptSuggestionTestsM2mUrl(suggestionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptSuggestionTestsM2mQueryKey = (suggestionId: number,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/${suggestionId}/tests/m2m`
    ] as const;
    }


export const getListPromptSuggestionTestsM2mQueryOptions = <TData = Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError = Error>(suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptSuggestionTestsM2mQueryKey(suggestionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>> = ({ signal }) => listPromptSuggestionTestsM2m(suggestionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: suggestionId !== null && suggestionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptSuggestionTestsM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>>
export type ListPromptSuggestionTestsM2mQueryError = Error


export function useListPromptSuggestionTestsM2m<TData = Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError = Error>(
 suggestionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>,
          TError,
          Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptSuggestionTestsM2m<TData = Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>,
          TError,
          Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptSuggestionTestsM2m<TData = Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromptSuggestionTestsM2m<TData = Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError = Error>(
 suggestionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptSuggestionTestsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptSuggestionTestsM2mQueryOptions(suggestionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startPromptSuggestionTestM2mResponse201 = {
  data: PromptSuggestionTest
  status: 201
}

export type startPromptSuggestionTestM2mResponse400 = {
  data: Error
  status: 400
}

export type startPromptSuggestionTestM2mResponse404 = {
  data: Error
  status: 404
}

export type startPromptSuggestionTestM2mResponseSuccess = (startPromptSuggestionTestM2mResponse201) & {
  headers: Headers;
};
export type startPromptSuggestionTestM2mResponseError = (startPromptSuggestionTestM2mResponse400 | startPromptSuggestionTestM2mResponse404) & {
  headers: Headers;
};

export type startPromptSuggestionTestM2mResponse = (startPromptSuggestionTestM2mResponseSuccess | startPromptSuggestionTestM2mResponseError)

export const getStartPromptSuggestionTestM2mUrl = (suggestionId: number,) => {




  return `/api/basecamp/eval-reviews/suggestions/${suggestionId}/tests/m2m`
}

/**
 * M2M sibling of ``PromptSuggestionTests`` for Rio: GET the tests, POST
 * ``{profile_id}`` to start one.
 */
export const startPromptSuggestionTestM2m = async (suggestionId: number,
    startPromptSuggestionTestM2MInput: StartPromptSuggestionTestM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<startPromptSuggestionTestM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startPromptSuggestionTestM2mResponse>(getStartPromptSuggestionTestM2mUrl(suggestionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startPromptSuggestionTestM2MInput)
  }
);}





export const getStartPromptSuggestionTestM2mMutationKey = () => ['startPromptSuggestionTestM2m'] as const;

export const getStartPromptSuggestionTestM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptSuggestionTestM2m>>, TError,StartPromptSuggestionTestM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPromptSuggestionTestM2m>>, TError,StartPromptSuggestionTestM2mMutationVariables, TContext> => {

const mutationKey = getStartPromptSuggestionTestM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPromptSuggestionTestM2m>>, StartPromptSuggestionTestM2mMutationVariables> = (props) => {
          const {suggestionId,data} = props ?? {};

          return  startPromptSuggestionTestM2m(suggestionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPromptSuggestionTestM2mMutationResult = NonNullable<Awaited<ReturnType<typeof startPromptSuggestionTestM2m>>>
    export type StartPromptSuggestionTestM2mMutationBody = StartPromptSuggestionTestM2MInput
    export type StartPromptSuggestionTestM2mMutationError = Error
    export type StartPromptSuggestionTestM2mMutationVariables = {suggestionId: number;data: StartPromptSuggestionTestM2MInput}

    export const useStartPromptSuggestionTestM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptSuggestionTestM2m>>, TError,StartPromptSuggestionTestM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPromptSuggestionTestM2m>>,
        TError,
        StartPromptSuggestionTestM2mMutationVariables,
        TContext
      > => {
      return useMutation(getStartPromptSuggestionTestM2mMutationOptions(options), queryClient);
    }

export type listAcceptedPromptSuggestionsResponse200 = {
  data: ListAcceptedPromptSuggestionsOutput
  status: 200
}

export type listAcceptedPromptSuggestionsResponse400 = {
  data: Error
  status: 400
}

export type listAcceptedPromptSuggestionsResponseSuccess = (listAcceptedPromptSuggestionsResponse200) & {
  headers: Headers;
};
export type listAcceptedPromptSuggestionsResponseError = (listAcceptedPromptSuggestionsResponse400) & {
  headers: Headers;
};

export type listAcceptedPromptSuggestionsResponse = (listAcceptedPromptSuggestionsResponseSuccess | listAcceptedPromptSuggestionsResponseError)

export const getListAcceptedPromptSuggestionsUrl = (params?: ListAcceptedPromptSuggestionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/eval-reviews/suggestions/accepted?${stringifiedParams}` : `/api/basecamp/eval-reviews/suggestions/accepted`
}

/**
 * Shipped suggestions and how their prompts are faring: one org's, or
 * every org's without ``organization``.
 */
export const listAcceptedPromptSuggestions = async (params?: ListAcceptedPromptSuggestionsParams, options?: Parameters<typeof customFetch>[1]): Promise<listAcceptedPromptSuggestionsResponse> => {

  return customFetch<listAcceptedPromptSuggestionsResponse>(getListAcceptedPromptSuggestionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAcceptedPromptSuggestionsQueryKey = (params?: ListAcceptedPromptSuggestionsParams,) => {
    return [
    `/api/basecamp/eval-reviews/suggestions/accepted`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAcceptedPromptSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError = Error>(params?: ListAcceptedPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAcceptedPromptSuggestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>> = ({ signal }) => listAcceptedPromptSuggestions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAcceptedPromptSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>>
export type ListAcceptedPromptSuggestionsQueryError = Error


export function useListAcceptedPromptSuggestions<TData = Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError = Error>(
 params: undefined |  ListAcceptedPromptSuggestionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>,
          TError,
          Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAcceptedPromptSuggestions<TData = Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError = Error>(
 params?: ListAcceptedPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>,
          TError,
          Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAcceptedPromptSuggestions<TData = Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError = Error>(
 params?: ListAcceptedPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAcceptedPromptSuggestions<TData = Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError = Error>(
 params?: ListAcceptedPromptSuggestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAcceptedPromptSuggestions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAcceptedPromptSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listEvalRubricsResponse200 = {
  data: ListEvalRubricsOutput
  status: 200
}

export type listEvalRubricsResponseSuccess = (listEvalRubricsResponse200) & {
  headers: Headers;
};
;

export type listEvalRubricsResponse = (listEvalRubricsResponseSuccess)

export const getListEvalRubricsUrl = () => {




  return `/api/basecamp/eval-rubrics`
}

export const listEvalRubrics = async ( options?: Parameters<typeof customFetch>[1]): Promise<listEvalRubricsResponse> => {

  return customFetch<listEvalRubricsResponse>(getListEvalRubricsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEvalRubricsQueryKey = () => {
    return [
    `/api/basecamp/eval-rubrics`
    ] as const;
    }


export const getListEvalRubricsQueryOptions = <TData = Awaited<ReturnType<typeof listEvalRubrics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalRubrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEvalRubricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEvalRubrics>>> = ({ signal }) => listEvalRubrics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEvalRubrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEvalRubricsQueryResult = NonNullable<Awaited<ReturnType<typeof listEvalRubrics>>>
export type ListEvalRubricsQueryError = unknown


export function useListEvalRubrics<TData = Awaited<ReturnType<typeof listEvalRubrics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalRubrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvalRubrics>>,
          TError,
          Awaited<ReturnType<typeof listEvalRubrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEvalRubrics<TData = Awaited<ReturnType<typeof listEvalRubrics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalRubrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEvalRubrics>>,
          TError,
          Awaited<ReturnType<typeof listEvalRubrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEvalRubrics<TData = Awaited<ReturnType<typeof listEvalRubrics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalRubrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListEvalRubrics<TData = Awaited<ReturnType<typeof listEvalRubrics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEvalRubrics>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEvalRubricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listExpertChatsResponse200 = {
  data: ListExpertChatsPaginatedOutput
  status: 200
}

export type listExpertChatsResponse400 = {
  data: Error
  status: 400
}

export type listExpertChatsResponseSuccess = (listExpertChatsResponse200) & {
  headers: Headers;
};
export type listExpertChatsResponseError = (listExpertChatsResponse400) & {
  headers: Headers;
};

export type listExpertChatsResponse = (listExpertChatsResponseSuccess | listExpertChatsResponseError)

export const getListExpertChatsUrl = (params?: ListExpertChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["provider_ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/expert-chats?${stringifiedParams}` : `/api/basecamp/expert-chats`
}

/**
 * GET expert-chats — every expert chat, across every organization.
 */
export const listExpertChats = async (params?: ListExpertChatsParams, options?: Parameters<typeof customFetch>[1]): Promise<listExpertChatsResponse> => {

  return customFetch<listExpertChatsResponse>(getListExpertChatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpertChatsQueryKey = (params?: ListExpertChatsParams,) => {
    return [
    `/api/basecamp/expert-chats`, ...(params ? [params] : [])
    ] as const;
    }


export const getListExpertChatsQueryOptions = <TData = Awaited<ReturnType<typeof listExpertChats>>, TError = Error>(params?: ListExpertChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpertChatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpertChats>>> = ({ signal }) => listExpertChats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpertChats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExpertChatsQueryResult = NonNullable<Awaited<ReturnType<typeof listExpertChats>>>
export type ListExpertChatsQueryError = Error


export function useListExpertChats<TData = Awaited<ReturnType<typeof listExpertChats>>, TError = Error>(
 params: undefined |  ListExpertChatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertChats>>,
          TError,
          Awaited<ReturnType<typeof listExpertChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExpertChats<TData = Awaited<ReturnType<typeof listExpertChats>>, TError = Error>(
 params?: ListExpertChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertChats>>,
          TError,
          Awaited<ReturnType<typeof listExpertChats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExpertChats<TData = Awaited<ReturnType<typeof listExpertChats>>, TError = Error>(
 params?: ListExpertChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListExpertChats<TData = Awaited<ReturnType<typeof listExpertChats>>, TError = Error>(
 params?: ListExpertChatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChats>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExpertChatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getExpertChatMessagesResponse200 = {
  data: GetExpertChatMessagesOutput
  status: 200
}

export type getExpertChatMessagesResponse400 = {
  data: Error
  status: 400
}

export type getExpertChatMessagesResponseSuccess = (getExpertChatMessagesResponse200) & {
  headers: Headers;
};
export type getExpertChatMessagesResponseError = (getExpertChatMessagesResponse400) & {
  headers: Headers;
};

export type getExpertChatMessagesResponse = (getExpertChatMessagesResponseSuccess | getExpertChatMessagesResponseError)

export const getGetExpertChatMessagesUrl = (chatId: number,
    params?: GetExpertChatMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/expert-chats/${chatId}/messages?${stringifiedParams}` : `/api/basecamp/expert-chats/${chatId}/messages`
}

/**
 * GET expert-chats/<chat_id>/messages — read-only transcript.
 *
 * Returns the chat row alongside the messages: the SPA reaches this on a
 * deep link with nothing but the chat id, so it needs the header data in
 * the same response.
 */
export const getExpertChatMessages = async (chatId: number,
    params?: GetExpertChatMessagesParams, options?: Parameters<typeof customFetch>[1]): Promise<getExpertChatMessagesResponse> => {

  return customFetch<getExpertChatMessagesResponse>(getGetExpertChatMessagesUrl(chatId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExpertChatMessagesQueryKey = (chatId: number,
    params?: GetExpertChatMessagesParams,) => {
    return [
    `/api/basecamp/expert-chats/${chatId}/messages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExpertChatMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getExpertChatMessages>>, TError = Error>(chatId: number,
    params?: GetExpertChatMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertChatMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExpertChatMessagesQueryKey(chatId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpertChatMessages>>> = ({ signal }) => getExpertChatMessages(chatId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: chatId !== null && chatId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExpertChatMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExpertChatMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getExpertChatMessages>>>
export type GetExpertChatMessagesQueryError = Error


export function useGetExpertChatMessages<TData = Awaited<ReturnType<typeof getExpertChatMessages>>, TError = Error>(
 chatId: number,
    params: undefined |  GetExpertChatMessagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertChatMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertChatMessages>>,
          TError,
          Awaited<ReturnType<typeof getExpertChatMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExpertChatMessages<TData = Awaited<ReturnType<typeof getExpertChatMessages>>, TError = Error>(
 chatId: number,
    params?: GetExpertChatMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertChatMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertChatMessages>>,
          TError,
          Awaited<ReturnType<typeof getExpertChatMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExpertChatMessages<TData = Awaited<ReturnType<typeof getExpertChatMessages>>, TError = Error>(
 chatId: number,
    params?: GetExpertChatMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertChatMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExpertChatMessages<TData = Awaited<ReturnType<typeof getExpertChatMessages>>, TError = Error>(
 chatId: number,
    params?: GetExpertChatMessagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertChatMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExpertChatMessagesQueryOptions(chatId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listExpertChatProvidersResponse200 = {
  data: ExpertChatProvider[]
  status: 200
}

export type listExpertChatProvidersResponse400 = {
  data: Error
  status: 400
}

export type listExpertChatProvidersResponseSuccess = (listExpertChatProvidersResponse200) & {
  headers: Headers;
};
export type listExpertChatProvidersResponseError = (listExpertChatProvidersResponse400) & {
  headers: Headers;
};

export type listExpertChatProvidersResponse = (listExpertChatProvidersResponseSuccess | listExpertChatProvidersResponseError)

export const getListExpertChatProvidersUrl = () => {




  return `/api/basecamp/expert-chats/providers`
}

/**
 * GET expert-chats/providers — Clarity experts for filter and picker.
 */
export const listExpertChatProviders = async ( options?: Parameters<typeof customFetch>[1]): Promise<listExpertChatProvidersResponse> => {

  return customFetch<listExpertChatProvidersResponse>(getListExpertChatProvidersUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListExpertChatProvidersQueryKey = () => {
    return [
    `/api/basecamp/expert-chats/providers`
    ] as const;
    }


export const getListExpertChatProvidersQueryOptions = <TData = Awaited<ReturnType<typeof listExpertChatProviders>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChatProviders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListExpertChatProvidersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listExpertChatProviders>>> = ({ signal }) => listExpertChatProviders({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listExpertChatProviders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListExpertChatProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof listExpertChatProviders>>>
export type ListExpertChatProvidersQueryError = Error


export function useListExpertChatProviders<TData = Awaited<ReturnType<typeof listExpertChatProviders>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChatProviders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertChatProviders>>,
          TError,
          Awaited<ReturnType<typeof listExpertChatProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExpertChatProviders<TData = Awaited<ReturnType<typeof listExpertChatProviders>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChatProviders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listExpertChatProviders>>,
          TError,
          Awaited<ReturnType<typeof listExpertChatProviders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListExpertChatProviders<TData = Awaited<ReturnType<typeof listExpertChatProviders>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChatProviders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListExpertChatProviders<TData = Awaited<ReturnType<typeof listExpertChatProviders>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listExpertChatProviders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListExpertChatProvidersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listRecentExportsResponse200 = {
  data: RecentExportOutput[]
  status: 200
}

export type listRecentExportsResponse400 = {
  data: Error
  status: 400
}

export type listRecentExportsResponseSuccess = (listRecentExportsResponse200) & {
  headers: Headers;
};
export type listRecentExportsResponseError = (listRecentExportsResponse400) & {
  headers: Headers;
};

export type listRecentExportsResponse = (listRecentExportsResponseSuccess | listRecentExportsResponseError)

export const getListRecentExportsUrl = () => {




  return `/api/basecamp/exports/recent`
}

/**
 * List recent ephemeral export workflow executions (last 15 minutes).
 */
export const listRecentExports = async ( options?: Parameters<typeof customFetch>[1]): Promise<listRecentExportsResponse> => {

  return customFetch<listRecentExportsResponse>(getListRecentExportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecentExportsQueryKey = () => {
    return [
    `/api/basecamp/exports/recent`
    ] as const;
    }


export const getListRecentExportsQueryOptions = <TData = Awaited<ReturnType<typeof listRecentExports>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentExports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecentExportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentExports>>> = ({ signal }) => listRecentExports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecentExports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecentExportsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentExports>>>
export type ListRecentExportsQueryError = Error


export function useListRecentExports<TData = Awaited<ReturnType<typeof listRecentExports>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentExports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentExports>>,
          TError,
          Awaited<ReturnType<typeof listRecentExports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentExports<TData = Awaited<ReturnType<typeof listRecentExports>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentExports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentExports>>,
          TError,
          Awaited<ReturnType<typeof listRecentExports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentExports<TData = Awaited<ReturnType<typeof listRecentExports>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentExports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRecentExports<TData = Awaited<ReturnType<typeof listRecentExports>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentExports>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecentExportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startExportTestResponse200 = {
  data: StartExportTestOutput
  status: 200
}

export type startExportTestResponse400 = {
  data: Error
  status: 400
}

export type startExportTestResponseSuccess = (startExportTestResponse200) & {
  headers: Headers;
};
export type startExportTestResponseError = (startExportTestResponse400) & {
  headers: Headers;
};

export type startExportTestResponse = (startExportTestResponseSuccess | startExportTestResponseError)

export const getStartExportTestUrl = () => {




  return `/api/basecamp/exports/test`
}

/**
 * Kick off an ephemeral report export workflow.
 */
export const startExportTest = async (startExportTestInput: StartExportTestInput, options?: Parameters<typeof customFetch>[1]): Promise<startExportTestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startExportTestResponse>(getStartExportTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startExportTestInput)
  }
);}





export const getStartExportTestMutationKey = () => ['startExportTest'] as const;

export const getStartExportTestMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startExportTest>>, TError,StartExportTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startExportTest>>, TError,StartExportTestMutationVariables, TContext> => {

const mutationKey = getStartExportTestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startExportTest>>, StartExportTestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startExportTest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartExportTestMutationResult = NonNullable<Awaited<ReturnType<typeof startExportTest>>>
    export type StartExportTestMutationBody = StartExportTestInput
    export type StartExportTestMutationError = Error
    export type StartExportTestMutationVariables = {data: StartExportTestInput}

    export const useStartExportTest = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startExportTest>>, TError,StartExportTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startExportTest>>,
        TError,
        StartExportTestMutationVariables,
        TContext
      > => {
      return useMutation(getStartExportTestMutationOptions(options), queryClient);
    }

export type getExportTestStatusResponse200 = {
  data: ExportTestStatusOutput
  status: 200
}

export type getExportTestStatusResponse400 = {
  data: Error
  status: 400
}

export type getExportTestStatusResponseSuccess = (getExportTestStatusResponse200) & {
  headers: Headers;
};
export type getExportTestStatusResponseError = (getExportTestStatusResponse400) & {
  headers: Headers;
};

export type getExportTestStatusResponse = (getExportTestStatusResponseSuccess | getExportTestStatusResponseError)

export const getGetExportTestStatusUrl = (workflowId: string,) => {




  return `/api/basecamp/exports/test-status/${workflowId}`
}

/**
 * Poll an export workflow's status. For completed runs, returns a
 * presigned download URL valid for ~10 minutes.
 */
export const getExportTestStatus = async (workflowId: string, options?: Parameters<typeof customFetch>[1]): Promise<getExportTestStatusResponse> => {

  return customFetch<getExportTestStatusResponse>(getGetExportTestStatusUrl(workflowId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetExportTestStatusQueryKey = (workflowId: string,) => {
    return [
    `/api/basecamp/exports/test-status/${workflowId}`
    ] as const;
    }


export const getGetExportTestStatusQueryOptions = <TData = Awaited<ReturnType<typeof getExportTestStatus>>, TError = Error>(workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportTestStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExportTestStatusQueryKey(workflowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExportTestStatus>>> = ({ signal }) => getExportTestStatus(workflowId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExportTestStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExportTestStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getExportTestStatus>>>
export type GetExportTestStatusQueryError = Error


export function useGetExportTestStatus<TData = Awaited<ReturnType<typeof getExportTestStatus>>, TError = Error>(
 workflowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportTestStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportTestStatus>>,
          TError,
          Awaited<ReturnType<typeof getExportTestStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExportTestStatus<TData = Awaited<ReturnType<typeof getExportTestStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportTestStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExportTestStatus>>,
          TError,
          Awaited<ReturnType<typeof getExportTestStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExportTestStatus<TData = Awaited<ReturnType<typeof getExportTestStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportTestStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExportTestStatus<TData = Awaited<ReturnType<typeof getExportTestStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExportTestStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExportTestStatusQueryOptions(workflowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampGoogleAutocompleteRetrieveResponse200 = {
  data: BasecampGetGoogleMapsAutocompleteResultsOutput
  status: 200
}

export type basecampGoogleAutocompleteRetrieveResponse400 = {
  data: Error
  status: 400
}

export type basecampGoogleAutocompleteRetrieveResponseSuccess = (basecampGoogleAutocompleteRetrieveResponse200) & {
  headers: Headers;
};
export type basecampGoogleAutocompleteRetrieveResponseError = (basecampGoogleAutocompleteRetrieveResponse400) & {
  headers: Headers;
};

export type basecampGoogleAutocompleteRetrieveResponse = (basecampGoogleAutocompleteRetrieveResponseSuccess | basecampGoogleAutocompleteRetrieveResponseError)

export const getBasecampGoogleAutocompleteRetrieveUrl = (params: BasecampGoogleAutocompleteRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/google/autocomplete?${stringifiedParams}` : `/api/basecamp/google/autocomplete`
}

export const basecampGoogleAutocompleteRetrieve = async (params: BasecampGoogleAutocompleteRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampGoogleAutocompleteRetrieveResponse> => {

  return customFetch<basecampGoogleAutocompleteRetrieveResponse>(getBasecampGoogleAutocompleteRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampGoogleAutocompleteRetrieveQueryKey = (params?: BasecampGoogleAutocompleteRetrieveParams,) => {
    return [
    `/api/basecamp/google/autocomplete`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampGoogleAutocompleteRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError = Error>(params: BasecampGoogleAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampGoogleAutocompleteRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>> = ({ signal }) => basecampGoogleAutocompleteRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampGoogleAutocompleteRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>>
export type BasecampGoogleAutocompleteRetrieveQueryError = Error


export function useBasecampGoogleAutocompleteRetrieve<TData = Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError = Error>(
 params: BasecampGoogleAutocompleteRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampGoogleAutocompleteRetrieve<TData = Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError = Error>(
 params: BasecampGoogleAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampGoogleAutocompleteRetrieve<TData = Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError = Error>(
 params: BasecampGoogleAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampGoogleAutocompleteRetrieve<TData = Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError = Error>(
 params: BasecampGoogleAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGoogleAutocompleteRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampGoogleAutocompleteRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampGooglePlaceMetadataRetrieveResponse200 = {
  data: BasecampGetPlaceMetadataOutput
  status: 200
}

export type basecampGooglePlaceMetadataRetrieveResponse400 = {
  data: Error
  status: 400
}

export type basecampGooglePlaceMetadataRetrieveResponseSuccess = (basecampGooglePlaceMetadataRetrieveResponse200) & {
  headers: Headers;
};
export type basecampGooglePlaceMetadataRetrieveResponseError = (basecampGooglePlaceMetadataRetrieveResponse400) & {
  headers: Headers;
};

export type basecampGooglePlaceMetadataRetrieveResponse = (basecampGooglePlaceMetadataRetrieveResponseSuccess | basecampGooglePlaceMetadataRetrieveResponseError)

export const getBasecampGooglePlaceMetadataRetrieveUrl = (params: BasecampGooglePlaceMetadataRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/google/place-metadata?${stringifiedParams}` : `/api/basecamp/google/place-metadata`
}

export const basecampGooglePlaceMetadataRetrieve = async (params: BasecampGooglePlaceMetadataRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampGooglePlaceMetadataRetrieveResponse> => {

  return customFetch<basecampGooglePlaceMetadataRetrieveResponse>(getBasecampGooglePlaceMetadataRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampGooglePlaceMetadataRetrieveQueryKey = (params?: BasecampGooglePlaceMetadataRetrieveParams,) => {
    return [
    `/api/basecamp/google/place-metadata`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampGooglePlaceMetadataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError = Error>(params: BasecampGooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampGooglePlaceMetadataRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>> = ({ signal }) => basecampGooglePlaceMetadataRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampGooglePlaceMetadataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>>
export type BasecampGooglePlaceMetadataRetrieveQueryError = Error


export function useBasecampGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError = Error>(
 params: BasecampGooglePlaceMetadataRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError = Error>(
 params: BasecampGooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError = Error>(
 params: BasecampGooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError = Error>(
 params: BasecampGooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampGooglePlaceMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampGooglePlaceMetadataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createAssessmentInputWithPrResponse201 = {
  data: OpenAssessmentInputPROutput
  status: 201
}

export type createAssessmentInputWithPrResponse400 = {
  data: Error
  status: 400
}

export type createAssessmentInputWithPrResponse409 = {
  data: Error
  status: 409
}

export type createAssessmentInputWithPrResponse502 = {
  data: Error
  status: 502
}

export type createAssessmentInputWithPrResponseSuccess = (createAssessmentInputWithPrResponse201) & {
  headers: Headers;
};
export type createAssessmentInputWithPrResponseError = (createAssessmentInputWithPrResponse400 | createAssessmentInputWithPrResponse409 | createAssessmentInputWithPrResponse502) & {
  headers: Headers;
};

export type createAssessmentInputWithPrResponse = (createAssessmentInputWithPrResponseSuccess | createAssessmentInputWithPrResponseError)

export const getCreateAssessmentInputWithPrUrl = () => {




  return `/api/basecamp/inputs/create-assessment-with-pr`
}

/**
 * POST /api/basecamp/inputs/create-assessment-with-pr
 *
 * Register a new assessment key in ``inputs.yaml``. That's the only file
 * the endpoint touches.
 *
 * Rationale: the runtime prompt renderer resolves ``assessments.<key>``
 * via a dict lookup on ``base_inputs`` (``get_value_with_list_of_keys`` in
 * ``prompts/utils.py``) — ``INPUT_REGISTRY`` in ``catalog.py`` is only
 * consulted for typed metadata (SPA input catalog display, prompt-detail
 * page). So adding the key to ``inputs.yaml`` is enough to wire content
 * end-to-end through the ephemeral prompt-test workflow; the SPA registry
 * catches up when someone extends ``catalog.py`` in a normal PR later.
 *
 * Single pipelines PR (no api-django companion) — the registry mirror
 * doesn't need updating because catalog.py stays as-is.
 */
export const createAssessmentInputWithPr = async (createAssessmentInputWithPRInput: CreateAssessmentInputWithPRInput, options?: Parameters<typeof customFetch>[1]): Promise<createAssessmentInputWithPrResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createAssessmentInputWithPrResponse>(getCreateAssessmentInputWithPrUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAssessmentInputWithPRInput)
  }
);}





export const getCreateAssessmentInputWithPrMutationKey = () => ['createAssessmentInputWithPr'] as const;

export const getCreateAssessmentInputWithPrMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssessmentInputWithPr>>, TError,CreateAssessmentInputWithPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAssessmentInputWithPr>>, TError,CreateAssessmentInputWithPrMutationVariables, TContext> => {

const mutationKey = getCreateAssessmentInputWithPrMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssessmentInputWithPr>>, CreateAssessmentInputWithPrMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAssessmentInputWithPr(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssessmentInputWithPrMutationResult = NonNullable<Awaited<ReturnType<typeof createAssessmentInputWithPr>>>
    export type CreateAssessmentInputWithPrMutationBody = CreateAssessmentInputWithPRInput
    export type CreateAssessmentInputWithPrMutationError = Error
    export type CreateAssessmentInputWithPrMutationVariables = {data: CreateAssessmentInputWithPRInput}

    export const useCreateAssessmentInputWithPr = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssessmentInputWithPr>>, TError,CreateAssessmentInputWithPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAssessmentInputWithPr>>,
        TError,
        CreateAssessmentInputWithPrMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAssessmentInputWithPrMutationOptions(options), queryClient);
    }

export type listAssessmentFileKindsResponse200 = {
  data: KeyedLookupsOutput
  status: 200
}

export type listAssessmentFileKindsResponse502 = {
  data: Error
  status: 502
}

export type listAssessmentFileKindsResponseSuccess = (listAssessmentFileKindsResponse200) & {
  headers: Headers;
};
export type listAssessmentFileKindsResponseError = (listAssessmentFileKindsResponse502) & {
  headers: Headers;
};

export type listAssessmentFileKindsResponse = (listAssessmentFileKindsResponseSuccess | listAssessmentFileKindsResponseError)

export const getListAssessmentFileKindsUrl = () => {




  return `/api/basecamp/inputs/file-kinds`
}

/**
 * GET /api/basecamp/inputs/file-kinds
 *
 * Return the sorted list of ``ApiLearnerFileFileKindChoices`` enum
 * values, parsed from the ``schema.graphql`` codegen snapshot.
 *
 * Feeds the dropdown in basecamp's ``NewAssessmentInputDialog`` so
 * the user picks from the actual FDM enum instead of the previous
 * "type it and hope pipelines CI accepts it" flow.
 */
export const listAssessmentFileKinds = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAssessmentFileKindsResponse> => {

  return customFetch<listAssessmentFileKindsResponse>(getListAssessmentFileKindsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssessmentFileKindsQueryKey = () => {
    return [
    `/api/basecamp/inputs/file-kinds`
    ] as const;
    }


export const getListAssessmentFileKindsQueryOptions = <TData = Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssessmentFileKindsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssessmentFileKinds>>> = ({ signal }) => listAssessmentFileKinds({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssessmentFileKindsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssessmentFileKinds>>>
export type ListAssessmentFileKindsQueryError = Error


export function useListAssessmentFileKinds<TData = Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentFileKinds>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentFileKinds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentFileKinds<TData = Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentFileKinds>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentFileKinds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentFileKinds<TData = Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAssessmentFileKinds<TData = Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKinds>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssessmentFileKindsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAssessmentFileKindsM2mResponse200 = {
  data: KeyedLookupsOutput
  status: 200
}

export type listAssessmentFileKindsM2mResponse502 = {
  data: Error
  status: 502
}

export type listAssessmentFileKindsM2mResponseSuccess = (listAssessmentFileKindsM2mResponse200) & {
  headers: Headers;
};
export type listAssessmentFileKindsM2mResponseError = (listAssessmentFileKindsM2mResponse502) & {
  headers: Headers;
};

export type listAssessmentFileKindsM2mResponse = (listAssessmentFileKindsM2mResponseSuccess | listAssessmentFileKindsM2mResponseError)

export const getListAssessmentFileKindsM2mUrl = () => {




  return `/api/basecamp/inputs/file-kinds/m2m`
}

/**
 * Temporal M2M sibling of ``ListAssessmentFileKinds``.
 *
 * Same payload as the SPA endpoint. Rio's
 * ``list_available_file_kinds`` tool calls this so the constructor
 * can propose valid file_kind values without hallucinating.
 */
export const listAssessmentFileKindsM2m = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAssessmentFileKindsM2mResponse> => {

  return customFetch<listAssessmentFileKindsM2mResponse>(getListAssessmentFileKindsM2mUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAssessmentFileKindsM2mQueryKey = () => {
    return [
    `/api/basecamp/inputs/file-kinds/m2m`
    ] as const;
    }


export const getListAssessmentFileKindsM2mQueryOptions = <TData = Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssessmentFileKindsM2mQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>> = ({ signal }) => listAssessmentFileKindsM2m({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssessmentFileKindsM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>>
export type ListAssessmentFileKindsM2mQueryError = Error


export function useListAssessmentFileKindsM2m<TData = Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentFileKindsM2m<TData = Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>,
          TError,
          Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssessmentFileKindsM2m<TData = Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAssessmentFileKindsM2m<TData = Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssessmentFileKindsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssessmentFileKindsM2mQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listLearnerTestProfilesResponse200 = {
  data: LearnerTestProfile[]
  status: 200
}

export type listLearnerTestProfilesResponseSuccess = (listLearnerTestProfilesResponse200) & {
  headers: Headers;
};
;

export type listLearnerTestProfilesResponse = (listLearnerTestProfilesResponseSuccess)

export const getListLearnerTestProfilesUrl = (params?: ListLearnerTestProfilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/learner-test-profiles?${stringifiedParams}` : `/api/basecamp/learner-test-profiles`
}

/**
 * List + create at ``/learner-test-profiles``.
 */
export const listLearnerTestProfiles = async (params?: ListLearnerTestProfilesParams, options?: Parameters<typeof customFetch>[1]): Promise<listLearnerTestProfilesResponse> => {

  return customFetch<listLearnerTestProfilesResponse>(getListLearnerTestProfilesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLearnerTestProfilesQueryKey = (params?: ListLearnerTestProfilesParams,) => {
    return [
    `/api/basecamp/learner-test-profiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLearnerTestProfilesQueryOptions = <TData = Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError = unknown>(params?: ListLearnerTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLearnerTestProfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLearnerTestProfiles>>> = ({ signal }) => listLearnerTestProfiles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLearnerTestProfilesQueryResult = NonNullable<Awaited<ReturnType<typeof listLearnerTestProfiles>>>
export type ListLearnerTestProfilesQueryError = unknown


export function useListLearnerTestProfiles<TData = Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError = unknown>(
 params: undefined |  ListLearnerTestProfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLearnerTestProfiles>>,
          TError,
          Awaited<ReturnType<typeof listLearnerTestProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLearnerTestProfiles<TData = Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError = unknown>(
 params?: ListLearnerTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLearnerTestProfiles>>,
          TError,
          Awaited<ReturnType<typeof listLearnerTestProfiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLearnerTestProfiles<TData = Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError = unknown>(
 params?: ListLearnerTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLearnerTestProfiles<TData = Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError = unknown>(
 params?: ListLearnerTestProfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLearnerTestProfilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createLearnerTestProfileResponse201 = {
  data: LearnerTestProfile
  status: 201
}

export type createLearnerTestProfileResponse400 = {
  data: Error
  status: 400
}

export type createLearnerTestProfileResponseSuccess = (createLearnerTestProfileResponse201) & {
  headers: Headers;
};
export type createLearnerTestProfileResponseError = (createLearnerTestProfileResponse400) & {
  headers: Headers;
};

export type createLearnerTestProfileResponse = (createLearnerTestProfileResponseSuccess | createLearnerTestProfileResponseError)

export const getCreateLearnerTestProfileUrl = () => {




  return `/api/basecamp/learner-test-profiles`
}

/**
 * List + create at ``/learner-test-profiles``.
 */
export const createLearnerTestProfile = async (learnerTestProfile: NonReadonly<LearnerTestProfile>, options?: Parameters<typeof customFetch>[1]): Promise<createLearnerTestProfileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createLearnerTestProfileResponse>(getCreateLearnerTestProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(learnerTestProfile)
  }
);}





export const getCreateLearnerTestProfileMutationKey = () => ['createLearnerTestProfile'] as const;

export const getCreateLearnerTestProfileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLearnerTestProfile>>, TError,CreateLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLearnerTestProfile>>, TError,CreateLearnerTestProfileMutationVariables, TContext> => {

const mutationKey = getCreateLearnerTestProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLearnerTestProfile>>, CreateLearnerTestProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createLearnerTestProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLearnerTestProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createLearnerTestProfile>>>
    export type CreateLearnerTestProfileMutationBody = NonReadonly<LearnerTestProfile>
    export type CreateLearnerTestProfileMutationError = Error
    export type CreateLearnerTestProfileMutationVariables = {data: NonReadonly<LearnerTestProfile>}

    export const useCreateLearnerTestProfile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLearnerTestProfile>>, TError,CreateLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLearnerTestProfile>>,
        TError,
        CreateLearnerTestProfileMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLearnerTestProfileMutationOptions(options), queryClient);
    }

export type getLearnerTestProfileResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type getLearnerTestProfileResponse400 = {
  data: Error
  status: 400
}

export type getLearnerTestProfileResponseSuccess = (getLearnerTestProfileResponse200) & {
  headers: Headers;
};
export type getLearnerTestProfileResponseError = (getLearnerTestProfileResponse400) & {
  headers: Headers;
};

export type getLearnerTestProfileResponse = (getLearnerTestProfileResponseSuccess | getLearnerTestProfileResponseError)

export const getGetLearnerTestProfileUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}`
}

/**
 * Read / update / delete at ``/learner-test-profiles/<id>``.
 */
export const getLearnerTestProfile = async (profileId: number, options?: Parameters<typeof customFetch>[1]): Promise<getLearnerTestProfileResponse> => {

  return customFetch<getLearnerTestProfileResponse>(getGetLearnerTestProfileUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLearnerTestProfileQueryKey = (profileId: number,) => {
    return [
    `/api/basecamp/learner-test-profiles/${profileId}`
    ] as const;
    }


export const getGetLearnerTestProfileQueryOptions = <TData = Awaited<ReturnType<typeof getLearnerTestProfile>>, TError = Error>(profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLearnerTestProfileQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLearnerTestProfile>>> = ({ signal }) => getLearnerTestProfile(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLearnerTestProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getLearnerTestProfile>>>
export type GetLearnerTestProfileQueryError = Error


export function useGetLearnerTestProfile<TData = Awaited<ReturnType<typeof getLearnerTestProfile>>, TError = Error>(
 profileId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearnerTestProfile>>,
          TError,
          Awaited<ReturnType<typeof getLearnerTestProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLearnerTestProfile<TData = Awaited<ReturnType<typeof getLearnerTestProfile>>, TError = Error>(
 profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearnerTestProfile>>,
          TError,
          Awaited<ReturnType<typeof getLearnerTestProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLearnerTestProfile<TData = Awaited<ReturnType<typeof getLearnerTestProfile>>, TError = Error>(
 profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLearnerTestProfile<TData = Awaited<ReturnType<typeof getLearnerTestProfile>>, TError = Error>(
 profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLearnerTestProfileQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateLearnerTestProfileResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type updateLearnerTestProfileResponse400 = {
  data: Error
  status: 400
}

export type updateLearnerTestProfileResponseSuccess = (updateLearnerTestProfileResponse200) & {
  headers: Headers;
};
export type updateLearnerTestProfileResponseError = (updateLearnerTestProfileResponse400) & {
  headers: Headers;
};

export type updateLearnerTestProfileResponse = (updateLearnerTestProfileResponseSuccess | updateLearnerTestProfileResponseError)

export const getUpdateLearnerTestProfileUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}`
}

/**
 * Read / update / delete at ``/learner-test-profiles/<id>``.
 */
export const updateLearnerTestProfile = async (profileId: number,
    learnerTestProfilePatch?: LearnerTestProfilePatch, options?: Parameters<typeof customFetch>[1]): Promise<updateLearnerTestProfileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateLearnerTestProfileResponse>(getUpdateLearnerTestProfileUrl(profileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(learnerTestProfilePatch)
  }
);}





export const getUpdateLearnerTestProfileMutationKey = () => ['updateLearnerTestProfile'] as const;

export const getUpdateLearnerTestProfileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfile>>, TError,UpdateLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfile>>, TError,UpdateLearnerTestProfileMutationVariables, TContext> => {

const mutationKey = getUpdateLearnerTestProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLearnerTestProfile>>, UpdateLearnerTestProfileMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  updateLearnerTestProfile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLearnerTestProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateLearnerTestProfile>>>
    export type UpdateLearnerTestProfileMutationBody = LearnerTestProfilePatch | undefined
    export type UpdateLearnerTestProfileMutationError = Error
    export type UpdateLearnerTestProfileMutationVariables = {profileId: number;data?: LearnerTestProfilePatch}

    export const useUpdateLearnerTestProfile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfile>>, TError,UpdateLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLearnerTestProfile>>,
        TError,
        UpdateLearnerTestProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLearnerTestProfileMutationOptions(options), queryClient);
    }

export type deleteLearnerTestProfileResponse204 = {
  data: void
  status: 204
}

export type deleteLearnerTestProfileResponse400 = {
  data: Error
  status: 400
}

export type deleteLearnerTestProfileResponseSuccess = (deleteLearnerTestProfileResponse204) & {
  headers: Headers;
};
export type deleteLearnerTestProfileResponseError = (deleteLearnerTestProfileResponse400) & {
  headers: Headers;
};

export type deleteLearnerTestProfileResponse = (deleteLearnerTestProfileResponseSuccess | deleteLearnerTestProfileResponseError)

export const getDeleteLearnerTestProfileUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}`
}

/**
 * Read / update / delete at ``/learner-test-profiles/<id>``.
 */
export const deleteLearnerTestProfile = async (profileId: number, options?: Parameters<typeof customFetch>[1]): Promise<deleteLearnerTestProfileResponse> => {

  return customFetch<deleteLearnerTestProfileResponse>(getDeleteLearnerTestProfileUrl(profileId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLearnerTestProfileMutationKey = () => ['deleteLearnerTestProfile'] as const;

export const getDeleteLearnerTestProfileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLearnerTestProfile>>, TError,DeleteLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLearnerTestProfile>>, TError,DeleteLearnerTestProfileMutationVariables, TContext> => {

const mutationKey = getDeleteLearnerTestProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLearnerTestProfile>>, DeleteLearnerTestProfileMutationVariables> = (props) => {
          const {profileId} = props ?? {};

          return  deleteLearnerTestProfile(profileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLearnerTestProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLearnerTestProfile>>>

    export type DeleteLearnerTestProfileMutationError = Error
    export type DeleteLearnerTestProfileMutationVariables = {profileId: number}

    export const useDeleteLearnerTestProfile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLearnerTestProfile>>, TError,DeleteLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLearnerTestProfile>>,
        TError,
        DeleteLearnerTestProfileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLearnerTestProfileMutationOptions(options), queryClient);
    }

export type cloneLearnerTestProfileResponse201 = {
  data: LearnerTestProfile
  status: 201
}

export type cloneLearnerTestProfileResponse400 = {
  data: Error
  status: 400
}

export type cloneLearnerTestProfileResponseSuccess = (cloneLearnerTestProfileResponse201) & {
  headers: Headers;
};
export type cloneLearnerTestProfileResponseError = (cloneLearnerTestProfileResponse400) & {
  headers: Headers;
};

export type cloneLearnerTestProfileResponse = (cloneLearnerTestProfileResponseSuccess | cloneLearnerTestProfileResponseError)

export const getCloneLearnerTestProfileUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/clone`
}

/**
 * Clone an existing profile — ``POST /learner-test-profiles/<id>/clone``.
 *
 * User-facing scenario: they've built a base profile ("Ethan intake")
 * and want to test a prompt against 5-7 variants where one input
 * differs (diagnostic_impressions='ABC diagnostic scenario 1',
 * 'scenario 2', ...). Instead of hand-copying the profile in the UI
 * each time, this endpoint deep-copies ``mock_learner_data`` +
 * ``test_files`` in one call so the caller just tweaks the field
 * they care about.
 *
 * Deep copy semantics:
 *   - ``mock_learner_data`` (JSON dict): full copy via json round-trip
 *     so mutating the clone doesn't leak into the source.
 *   - ``test_files`` (JSON list of dicts): same treatment. Files are
 *     referenced by uuid/s3_prefix, so both profiles point at the
 *     same S3 blobs (no re-upload; test files are immutable pool
 *     entries).
 *   - ``report_types``, ``notes``: copied as-is.
 *   - ``organization``: defaults to the source's org; caller may
 *     override in the request body (e.g. cloning a global profile
 *     into a specific org for org-scoped testing).
 *   - ``name``: defaults to ``"<source name> (copy)"``; caller may
 *     override.
 *   - ``created_by``: the CLONER, not the source's creator.
 */
export const cloneLearnerTestProfile = async (profileId: number,
    cloneInput?: CloneInput, options?: Parameters<typeof customFetch>[1]): Promise<cloneLearnerTestProfileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<cloneLearnerTestProfileResponse>(getCloneLearnerTestProfileUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cloneInput)
  }
);}





export const getCloneLearnerTestProfileMutationKey = () => ['cloneLearnerTestProfile'] as const;

export const getCloneLearnerTestProfileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneLearnerTestProfile>>, TError,CloneLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneLearnerTestProfile>>, TError,CloneLearnerTestProfileMutationVariables, TContext> => {

const mutationKey = getCloneLearnerTestProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneLearnerTestProfile>>, CloneLearnerTestProfileMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  cloneLearnerTestProfile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneLearnerTestProfileMutationResult = NonNullable<Awaited<ReturnType<typeof cloneLearnerTestProfile>>>
    export type CloneLearnerTestProfileMutationBody = CloneInput | undefined
    export type CloneLearnerTestProfileMutationError = Error
    export type CloneLearnerTestProfileMutationVariables = {profileId: number;data?: CloneInput}

    export const useCloneLearnerTestProfile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneLearnerTestProfile>>, TError,CloneLearnerTestProfileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneLearnerTestProfile>>,
        TError,
        CloneLearnerTestProfileMutationVariables,
        TContext
      > => {
      return useMutation(getCloneLearnerTestProfileMutationOptions(options), queryClient);
    }

export type cloneLearnerTestProfileM2mResponse201 = {
  data: LearnerTestProfile
  status: 201
}

export type cloneLearnerTestProfileM2mResponse400 = {
  data: Error
  status: 400
}

export type cloneLearnerTestProfileM2mResponseSuccess = (cloneLearnerTestProfileM2mResponse201) & {
  headers: Headers;
};
export type cloneLearnerTestProfileM2mResponseError = (cloneLearnerTestProfileM2mResponse400) & {
  headers: Headers;
};

export type cloneLearnerTestProfileM2mResponse = (cloneLearnerTestProfileM2mResponseSuccess | cloneLearnerTestProfileM2mResponseError)

export const getCloneLearnerTestProfileM2mUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/clone/m2m`
}

/**
 * M2M sibling of ``LearnerTestProfileCloneView``. Body identical;
 * only the auth + role gate change. Rio calls this on
 * ``apply_clone_profile_as_variant``.
 */
export const cloneLearnerTestProfileM2m = async (profileId: number,
    cloneInput?: CloneInput, options?: Parameters<typeof customFetch>[1]): Promise<cloneLearnerTestProfileM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<cloneLearnerTestProfileM2mResponse>(getCloneLearnerTestProfileM2mUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cloneInput)
  }
);}





export const getCloneLearnerTestProfileM2mMutationKey = () => ['cloneLearnerTestProfileM2m'] as const;

export const getCloneLearnerTestProfileM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneLearnerTestProfileM2m>>, TError,CloneLearnerTestProfileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneLearnerTestProfileM2m>>, TError,CloneLearnerTestProfileM2mMutationVariables, TContext> => {

const mutationKey = getCloneLearnerTestProfileM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneLearnerTestProfileM2m>>, CloneLearnerTestProfileM2mMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  cloneLearnerTestProfileM2m(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloneLearnerTestProfileM2mMutationResult = NonNullable<Awaited<ReturnType<typeof cloneLearnerTestProfileM2m>>>
    export type CloneLearnerTestProfileM2mMutationBody = CloneInput | undefined
    export type CloneLearnerTestProfileM2mMutationError = Error
    export type CloneLearnerTestProfileM2mMutationVariables = {profileId: number;data?: CloneInput}

    export const useCloneLearnerTestProfileM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneLearnerTestProfileM2m>>, TError,CloneLearnerTestProfileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneLearnerTestProfileM2m>>,
        TError,
        CloneLearnerTestProfileM2mMutationVariables,
        TContext
      > => {
      return useMutation(getCloneLearnerTestProfileM2mMutationOptions(options), queryClient);
    }

export type getLearnerTestProfileM2mResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type getLearnerTestProfileM2mResponse400 = {
  data: Error
  status: 400
}

export type getLearnerTestProfileM2mResponseSuccess = (getLearnerTestProfileM2mResponse200) & {
  headers: Headers;
};
export type getLearnerTestProfileM2mResponseError = (getLearnerTestProfileM2mResponse400) & {
  headers: Headers;
};

export type getLearnerTestProfileM2mResponse = (getLearnerTestProfileM2mResponseSuccess | getLearnerTestProfileM2mResponseError)

export const getGetLearnerTestProfileM2mUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/m2m`
}

/**
 * Temporal M2M sibling of ``LearnerTestProfileDetailView.get``
 * (read only). Rio doesn't update the profile row directly via this
 * endpoint — mock changes go through ``UpdateMockDataM2MView``, file
 * toggles through ``ToggleTestFileM2MView``. Deletes stay SPA-only.
 */
export const getLearnerTestProfileM2m = async (profileId: number, options?: Parameters<typeof customFetch>[1]): Promise<getLearnerTestProfileM2mResponse> => {

  return customFetch<getLearnerTestProfileM2mResponse>(getGetLearnerTestProfileM2mUrl(profileId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLearnerTestProfileM2mQueryKey = (profileId: number,) => {
    return [
    `/api/basecamp/learner-test-profiles/${profileId}/m2m`
    ] as const;
    }


export const getGetLearnerTestProfileM2mQueryOptions = <TData = Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError = Error>(profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLearnerTestProfileM2mQueryKey(profileId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>> = ({ signal }) => getLearnerTestProfileM2m(profileId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: profileId !== null && profileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLearnerTestProfileM2mQueryResult = NonNullable<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>>
export type GetLearnerTestProfileM2mQueryError = Error


export function useGetLearnerTestProfileM2m<TData = Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError = Error>(
 profileId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearnerTestProfileM2m>>,
          TError,
          Awaited<ReturnType<typeof getLearnerTestProfileM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLearnerTestProfileM2m<TData = Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError = Error>(
 profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLearnerTestProfileM2m>>,
          TError,
          Awaited<ReturnType<typeof getLearnerTestProfileM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLearnerTestProfileM2m<TData = Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError = Error>(
 profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLearnerTestProfileM2m<TData = Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError = Error>(
 profileId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLearnerTestProfileM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLearnerTestProfileM2mQueryOptions(profileId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updateLearnerTestProfileMockM2mResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type updateLearnerTestProfileMockM2mResponse400 = {
  data: Error
  status: 400
}

export type updateLearnerTestProfileMockM2mResponseSuccess = (updateLearnerTestProfileMockM2mResponse200) & {
  headers: Headers;
};
export type updateLearnerTestProfileMockM2mResponseError = (updateLearnerTestProfileMockM2mResponse400) & {
  headers: Headers;
};

export type updateLearnerTestProfileMockM2mResponse = (updateLearnerTestProfileMockM2mResponseSuccess | updateLearnerTestProfileMockM2mResponseError)

export const getUpdateLearnerTestProfileMockM2mUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/mock/m2m`
}

/**
 * PUT /api/basecamp/learner-test-profiles/<id>/mock/m2m
 *
 * Deep-merge ``updates`` (with dotted-key expansion) into the
 * profile's ``mock_learner_data``. Rio uses this on
 * ``apply_edit_learner_profile_mock``.
 */
export const updateLearnerTestProfileMockM2m = async (profileId: number,
    updateMockDataM2MInput: UpdateMockDataM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<updateLearnerTestProfileMockM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateLearnerTestProfileMockM2mResponse>(getUpdateLearnerTestProfileMockM2mUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMockDataM2MInput)
  }
);}





export const getUpdateLearnerTestProfileMockM2mMutationKey = () => ['updateLearnerTestProfileMockM2m'] as const;

export const getUpdateLearnerTestProfileMockM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfileMockM2m>>, TError,UpdateLearnerTestProfileMockM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfileMockM2m>>, TError,UpdateLearnerTestProfileMockM2mMutationVariables, TContext> => {

const mutationKey = getUpdateLearnerTestProfileMockM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLearnerTestProfileMockM2m>>, UpdateLearnerTestProfileMockM2mMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  updateLearnerTestProfileMockM2m(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLearnerTestProfileMockM2mMutationResult = NonNullable<Awaited<ReturnType<typeof updateLearnerTestProfileMockM2m>>>
    export type UpdateLearnerTestProfileMockM2mMutationBody = UpdateMockDataM2MInput
    export type UpdateLearnerTestProfileMockM2mMutationError = Error
    export type UpdateLearnerTestProfileMockM2mMutationVariables = {profileId: number;data: UpdateMockDataM2MInput}

    export const useUpdateLearnerTestProfileMockM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfileMockM2m>>, TError,UpdateLearnerTestProfileMockM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLearnerTestProfileMockM2m>>,
        TError,
        UpdateLearnerTestProfileMockM2mMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLearnerTestProfileMockM2mMutationOptions(options), queryClient);
    }

export type toggleLearnerTestFileResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type toggleLearnerTestFileResponse400 = {
  data: Error
  status: 400
}

export type toggleLearnerTestFileResponseSuccess = (toggleLearnerTestFileResponse200) & {
  headers: Headers;
};
export type toggleLearnerTestFileResponseError = (toggleLearnerTestFileResponse400) & {
  headers: Headers;
};

export type toggleLearnerTestFileResponse = (toggleLearnerTestFileResponseSuccess | toggleLearnerTestFileResponseError)

export const getToggleLearnerTestFileUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/toggle-file`
}

/**
 * POST /api/basecamp/learner-test-profiles/<id>/toggle-file
 *
 * SPA twin of the M2M toggle, with a scope guard the M2M view lacks:
 * GLOBAL profiles are shared by every org and prompt, so their files
 * can't be persistently disabled here — clone a variant first. Org
 * profiles and prompt-scoped variants toggle freely (reversible).
 */
export const toggleLearnerTestFile = async (profileId: number,
    toggleTestFileM2MInput: ToggleTestFileM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<toggleLearnerTestFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<toggleLearnerTestFileResponse>(getToggleLearnerTestFileUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(toggleTestFileM2MInput)
  }
);}





export const getToggleLearnerTestFileMutationKey = () => ['toggleLearnerTestFile'] as const;

export const getToggleLearnerTestFileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleLearnerTestFile>>, TError,ToggleLearnerTestFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleLearnerTestFile>>, TError,ToggleLearnerTestFileMutationVariables, TContext> => {

const mutationKey = getToggleLearnerTestFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleLearnerTestFile>>, ToggleLearnerTestFileMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  toggleLearnerTestFile(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleLearnerTestFileMutationResult = NonNullable<Awaited<ReturnType<typeof toggleLearnerTestFile>>>
    export type ToggleLearnerTestFileMutationBody = ToggleTestFileM2MInput
    export type ToggleLearnerTestFileMutationError = Error
    export type ToggleLearnerTestFileMutationVariables = {profileId: number;data: ToggleTestFileM2MInput}

    export const useToggleLearnerTestFile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleLearnerTestFile>>, TError,ToggleLearnerTestFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleLearnerTestFile>>,
        TError,
        ToggleLearnerTestFileMutationVariables,
        TContext
      > => {
      return useMutation(getToggleLearnerTestFileMutationOptions(options), queryClient);
    }

export type toggleLearnerTestFileM2mResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type toggleLearnerTestFileM2mResponse400 = {
  data: Error
  status: 400
}

export type toggleLearnerTestFileM2mResponseSuccess = (toggleLearnerTestFileM2mResponse200) & {
  headers: Headers;
};
export type toggleLearnerTestFileM2mResponseError = (toggleLearnerTestFileM2mResponse400) & {
  headers: Headers;
};

export type toggleLearnerTestFileM2mResponse = (toggleLearnerTestFileM2mResponseSuccess | toggleLearnerTestFileM2mResponseError)

export const getToggleLearnerTestFileM2mUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/toggle-file/m2m`
}

/**
 * POST /api/basecamp/learner-test-profiles/<id>/toggle-file/m2m
 *
 * Flip an ``enabled`` flag on a single entry in the profile's
 * ``test_files`` list. If the flag key doesn't exist yet on the row,
 * it's added. Disabled files are still stored so the SPA can render
 * them; the run-scoping logic skips ``enabled=False`` entries.
 */
export const toggleLearnerTestFileM2m = async (profileId: number,
    toggleTestFileM2MInput: ToggleTestFileM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<toggleLearnerTestFileM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<toggleLearnerTestFileM2mResponse>(getToggleLearnerTestFileM2mUrl(profileId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(toggleTestFileM2MInput)
  }
);}





export const getToggleLearnerTestFileM2mMutationKey = () => ['toggleLearnerTestFileM2m'] as const;

export const getToggleLearnerTestFileM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleLearnerTestFileM2m>>, TError,ToggleLearnerTestFileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleLearnerTestFileM2m>>, TError,ToggleLearnerTestFileM2mMutationVariables, TContext> => {

const mutationKey = getToggleLearnerTestFileM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleLearnerTestFileM2m>>, ToggleLearnerTestFileM2mMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  toggleLearnerTestFileM2m(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleLearnerTestFileM2mMutationResult = NonNullable<Awaited<ReturnType<typeof toggleLearnerTestFileM2m>>>
    export type ToggleLearnerTestFileM2mMutationBody = ToggleTestFileM2MInput
    export type ToggleLearnerTestFileM2mMutationError = Error
    export type ToggleLearnerTestFileM2mMutationVariables = {profileId: number;data: ToggleTestFileM2MInput}

    export const useToggleLearnerTestFileM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleLearnerTestFileM2m>>, TError,ToggleLearnerTestFileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleLearnerTestFileM2m>>,
        TError,
        ToggleLearnerTestFileM2mMutationVariables,
        TContext
      > => {
      return useMutation(getToggleLearnerTestFileM2mMutationOptions(options), queryClient);
    }

export type updateLearnerTestProfileM2mResponse200 = {
  data: LearnerTestProfile
  status: 200
}

export type updateLearnerTestProfileM2mResponse400 = {
  data: Error
  status: 400
}

export type updateLearnerTestProfileM2mResponseSuccess = (updateLearnerTestProfileM2mResponse200) & {
  headers: Headers;
};
export type updateLearnerTestProfileM2mResponseError = (updateLearnerTestProfileM2mResponse400) & {
  headers: Headers;
};

export type updateLearnerTestProfileM2mResponse = (updateLearnerTestProfileM2mResponseSuccess | updateLearnerTestProfileM2mResponseError)

export const getUpdateLearnerTestProfileM2mUrl = (profileId: number,) => {




  return `/api/basecamp/learner-test-profiles/${profileId}/update/m2m`
}

/**
 * M2M sibling of ``LearnerTestProfileDetailView.put``. Used by Rio
 * to rename profiles or promote variants (``scoped_prompt_key=null``).
 *
 * Only PUT is exposed. The parent view also defines ``get`` and
 * ``delete`` (that's the whole detail surface); leaving them
 * inherited would advertise a destructive delete route at
 * ``/update/m2m`` even though this endpoint is meant to be
 * update-only. ``http_method_names`` narrows accepted verbs at the
 * Django level — anything else returns 405 without dispatching.
 */
export const updateLearnerTestProfileM2m = async (profileId: number,
    learnerTestProfilePatch?: LearnerTestProfilePatch, options?: Parameters<typeof customFetch>[1]): Promise<updateLearnerTestProfileM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateLearnerTestProfileM2mResponse>(getUpdateLearnerTestProfileM2mUrl(profileId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(learnerTestProfilePatch)
  }
);}





export const getUpdateLearnerTestProfileM2mMutationKey = () => ['updateLearnerTestProfileM2m'] as const;

export const getUpdateLearnerTestProfileM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfileM2m>>, TError,UpdateLearnerTestProfileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfileM2m>>, TError,UpdateLearnerTestProfileM2mMutationVariables, TContext> => {

const mutationKey = getUpdateLearnerTestProfileM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLearnerTestProfileM2m>>, UpdateLearnerTestProfileM2mMutationVariables> = (props) => {
          const {profileId,data} = props ?? {};

          return  updateLearnerTestProfileM2m(profileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLearnerTestProfileM2mMutationResult = NonNullable<Awaited<ReturnType<typeof updateLearnerTestProfileM2m>>>
    export type UpdateLearnerTestProfileM2mMutationBody = LearnerTestProfilePatch | undefined
    export type UpdateLearnerTestProfileM2mMutationError = Error
    export type UpdateLearnerTestProfileM2mMutationVariables = {profileId: number;data?: LearnerTestProfilePatch}

    export const useUpdateLearnerTestProfileM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLearnerTestProfileM2m>>, TError,UpdateLearnerTestProfileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLearnerTestProfileM2m>>,
        TError,
        UpdateLearnerTestProfileM2mMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLearnerTestProfileM2mMutationOptions(options), queryClient);
    }

export type listLearnerTestProfilesM2mResponse200 = {
  data: LearnerTestProfile[]
  status: 200
}

export type listLearnerTestProfilesM2mResponseSuccess = (listLearnerTestProfilesM2mResponse200) & {
  headers: Headers;
};
;

export type listLearnerTestProfilesM2mResponse = (listLearnerTestProfilesM2mResponseSuccess)

export const getListLearnerTestProfilesM2mUrl = (params?: ListLearnerTestProfilesM2mParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/learner-test-profiles/m2m?${stringifiedParams}` : `/api/basecamp/learner-test-profiles/m2m`
}

/**
 * Temporal M2M sibling of ``LearnerTestProfilesView.get`` (list only).
 *
 * Response wraps the list under ``results`` to match the pattern
 * Rio's basecamp client already consumes for other list endpoints.
 * Rio doesn't create profiles from chat — profile creation stays on
 * the SPA-only endpoint.
 */
export const listLearnerTestProfilesM2m = async (params?: ListLearnerTestProfilesM2mParams, options?: Parameters<typeof customFetch>[1]): Promise<listLearnerTestProfilesM2mResponse> => {

  return customFetch<listLearnerTestProfilesM2mResponse>(getListLearnerTestProfilesM2mUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLearnerTestProfilesM2mQueryKey = (params?: ListLearnerTestProfilesM2mParams,) => {
    return [
    `/api/basecamp/learner-test-profiles/m2m`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLearnerTestProfilesM2mQueryOptions = <TData = Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError = unknown>(params?: ListLearnerTestProfilesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLearnerTestProfilesM2mQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>> = ({ signal }) => listLearnerTestProfilesM2m(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLearnerTestProfilesM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>>
export type ListLearnerTestProfilesM2mQueryError = unknown


export function useListLearnerTestProfilesM2m<TData = Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError = unknown>(
 params: undefined |  ListLearnerTestProfilesM2mParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>,
          TError,
          Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLearnerTestProfilesM2m<TData = Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError = unknown>(
 params?: ListLearnerTestProfilesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>,
          TError,
          Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLearnerTestProfilesM2m<TData = Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError = unknown>(
 params?: ListLearnerTestProfilesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLearnerTestProfilesM2m<TData = Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError = unknown>(
 params?: ListLearnerTestProfilesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLearnerTestProfilesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLearnerTestProfilesM2mQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampOrganizationUsersRetrieveResponse200 = {
  data: GetOrganizationUsersOutput
  status: 200
}

export type basecampOrganizationUsersRetrieveResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationUsersRetrieveResponseSuccess = (basecampOrganizationUsersRetrieveResponse200) & {
  headers: Headers;
};
export type basecampOrganizationUsersRetrieveResponseError = (basecampOrganizationUsersRetrieveResponse400) & {
  headers: Headers;
};

export type basecampOrganizationUsersRetrieveResponse = (basecampOrganizationUsersRetrieveResponseSuccess | basecampOrganizationUsersRetrieveResponseError)

export const getBasecampOrganizationUsersRetrieveUrl = (params: BasecampOrganizationUsersRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/organization-users?${stringifiedParams}` : `/api/basecamp/organization-users`
}

export const basecampOrganizationUsersRetrieve = async (params: BasecampOrganizationUsersRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationUsersRetrieveResponse> => {

  return customFetch<basecampOrganizationUsersRetrieveResponse>(getBasecampOrganizationUsersRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampOrganizationUsersRetrieveQueryKey = (params?: BasecampOrganizationUsersRetrieveParams,) => {
    return [
    `/api/basecamp/organization-users`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampOrganizationUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError = Error>(params: BasecampOrganizationUsersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampOrganizationUsersRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>> = ({ signal }) => basecampOrganizationUsersRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampOrganizationUsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>>
export type BasecampOrganizationUsersRetrieveQueryError = Error


export function useBasecampOrganizationUsersRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampOrganizationUsersRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampOrganizationUsersRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampOrganizationUsersRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampOrganizationUsersRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampOrganizationUsersCreateCreateResponse200 = {
  data: void
  status: 200
}

export type basecampOrganizationUsersCreateCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationUsersCreateCreateResponseSuccess = (basecampOrganizationUsersCreateCreateResponse200) & {
  headers: Headers;
};
export type basecampOrganizationUsersCreateCreateResponseError = (basecampOrganizationUsersCreateCreateResponse400) & {
  headers: Headers;
};

export type basecampOrganizationUsersCreateCreateResponse = (basecampOrganizationUsersCreateCreateResponseSuccess | basecampOrganizationUsersCreateCreateResponseError)

export const getBasecampOrganizationUsersCreateCreateUrl = () => {




  return `/api/basecamp/organization-users/create`
}

export const basecampOrganizationUsersCreateCreate = async (createOrganizationUserInput: CreateOrganizationUserInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationUsersCreateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampOrganizationUsersCreateCreateResponse>(getBasecampOrganizationUsersCreateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOrganizationUserInput)
  }
);}





export const getBasecampOrganizationUsersCreateCreateMutationKey = () => ['basecampOrganizationUsersCreateCreate'] as const;

export const getBasecampOrganizationUsersCreateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersCreateCreate>>, TError,BasecampOrganizationUsersCreateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersCreateCreate>>, TError,BasecampOrganizationUsersCreateCreateMutationVariables, TContext> => {

const mutationKey = getBasecampOrganizationUsersCreateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampOrganizationUsersCreateCreate>>, BasecampOrganizationUsersCreateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampOrganizationUsersCreateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampOrganizationUsersCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationUsersCreateCreate>>>
    export type BasecampOrganizationUsersCreateCreateMutationBody = CreateOrganizationUserInput
    export type BasecampOrganizationUsersCreateCreateMutationError = Error
    export type BasecampOrganizationUsersCreateCreateMutationVariables = {data: CreateOrganizationUserInput}

    export const useBasecampOrganizationUsersCreateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersCreateCreate>>, TError,BasecampOrganizationUsersCreateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampOrganizationUsersCreateCreate>>,
        TError,
        BasecampOrganizationUsersCreateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampOrganizationUsersCreateCreateMutationOptions(options), queryClient);
    }

export type basecampOrganizationUsersOrphanedRetrieveResponse200 = {
  data: GetOrphanedOrganizationUsersOutput
  status: 200
}

export type basecampOrganizationUsersOrphanedRetrieveResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationUsersOrphanedRetrieveResponseSuccess = (basecampOrganizationUsersOrphanedRetrieveResponse200) & {
  headers: Headers;
};
export type basecampOrganizationUsersOrphanedRetrieveResponseError = (basecampOrganizationUsersOrphanedRetrieveResponse400) & {
  headers: Headers;
};

export type basecampOrganizationUsersOrphanedRetrieveResponse = (basecampOrganizationUsersOrphanedRetrieveResponseSuccess | basecampOrganizationUsersOrphanedRetrieveResponseError)

export const getBasecampOrganizationUsersOrphanedRetrieveUrl = (params: BasecampOrganizationUsersOrphanedRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/organization-users/orphaned?${stringifiedParams}` : `/api/basecamp/organization-users/orphaned`
}

export const basecampOrganizationUsersOrphanedRetrieve = async (params: BasecampOrganizationUsersOrphanedRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationUsersOrphanedRetrieveResponse> => {

  return customFetch<basecampOrganizationUsersOrphanedRetrieveResponse>(getBasecampOrganizationUsersOrphanedRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampOrganizationUsersOrphanedRetrieveQueryKey = (params?: BasecampOrganizationUsersOrphanedRetrieveParams,) => {
    return [
    `/api/basecamp/organization-users/orphaned`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampOrganizationUsersOrphanedRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError = Error>(params: BasecampOrganizationUsersOrphanedRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampOrganizationUsersOrphanedRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>> = ({ signal }) => basecampOrganizationUsersOrphanedRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampOrganizationUsersOrphanedRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>>
export type BasecampOrganizationUsersOrphanedRetrieveQueryError = Error


export function useBasecampOrganizationUsersOrphanedRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersOrphanedRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampOrganizationUsersOrphanedRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersOrphanedRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampOrganizationUsersOrphanedRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersOrphanedRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampOrganizationUsersOrphanedRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError = Error>(
 params: BasecampOrganizationUsersOrphanedRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationUsersOrphanedRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampOrganizationUsersOrphanedRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type basecampOrganizationUsersRemoveCreateResponse200 = {
  data: void
  status: 200
}

export type basecampOrganizationUsersRemoveCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationUsersRemoveCreateResponseSuccess = (basecampOrganizationUsersRemoveCreateResponse200) & {
  headers: Headers;
};
export type basecampOrganizationUsersRemoveCreateResponseError = (basecampOrganizationUsersRemoveCreateResponse400) & {
  headers: Headers;
};

export type basecampOrganizationUsersRemoveCreateResponse = (basecampOrganizationUsersRemoveCreateResponseSuccess | basecampOrganizationUsersRemoveCreateResponseError)

export const getBasecampOrganizationUsersRemoveCreateUrl = () => {




  return `/api/basecamp/organization-users/remove`
}

export const basecampOrganizationUsersRemoveCreate = async (removeOrganizationUserInput: RemoveOrganizationUserInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationUsersRemoveCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampOrganizationUsersRemoveCreateResponse>(getBasecampOrganizationUsersRemoveCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeOrganizationUserInput)
  }
);}





export const getBasecampOrganizationUsersRemoveCreateMutationKey = () => ['basecampOrganizationUsersRemoveCreate'] as const;

export const getBasecampOrganizationUsersRemoveCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRemoveCreate>>, TError,BasecampOrganizationUsersRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRemoveCreate>>, TError,BasecampOrganizationUsersRemoveCreateMutationVariables, TContext> => {

const mutationKey = getBasecampOrganizationUsersRemoveCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampOrganizationUsersRemoveCreate>>, BasecampOrganizationUsersRemoveCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampOrganizationUsersRemoveCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampOrganizationUsersRemoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationUsersRemoveCreate>>>
    export type BasecampOrganizationUsersRemoveCreateMutationBody = RemoveOrganizationUserInput
    export type BasecampOrganizationUsersRemoveCreateMutationError = Error
    export type BasecampOrganizationUsersRemoveCreateMutationVariables = {data: RemoveOrganizationUserInput}

    export const useBasecampOrganizationUsersRemoveCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRemoveCreate>>, TError,BasecampOrganizationUsersRemoveCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampOrganizationUsersRemoveCreate>>,
        TError,
        BasecampOrganizationUsersRemoveCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampOrganizationUsersRemoveCreateMutationOptions(options), queryClient);
    }

export type basecampOrganizationUsersRestoreCreateResponse200 = {
  data: void
  status: 200
}

export type basecampOrganizationUsersRestoreCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationUsersRestoreCreateResponseSuccess = (basecampOrganizationUsersRestoreCreateResponse200) & {
  headers: Headers;
};
export type basecampOrganizationUsersRestoreCreateResponseError = (basecampOrganizationUsersRestoreCreateResponse400) & {
  headers: Headers;
};

export type basecampOrganizationUsersRestoreCreateResponse = (basecampOrganizationUsersRestoreCreateResponseSuccess | basecampOrganizationUsersRestoreCreateResponseError)

export const getBasecampOrganizationUsersRestoreCreateUrl = () => {




  return `/api/basecamp/organization-users/restore`
}

export const basecampOrganizationUsersRestoreCreate = async (restoreOrphanedOrganizationUserInput: RestoreOrphanedOrganizationUserInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationUsersRestoreCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampOrganizationUsersRestoreCreateResponse>(getBasecampOrganizationUsersRestoreCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(restoreOrphanedOrganizationUserInput)
  }
);}





export const getBasecampOrganizationUsersRestoreCreateMutationKey = () => ['basecampOrganizationUsersRestoreCreate'] as const;

export const getBasecampOrganizationUsersRestoreCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRestoreCreate>>, TError,BasecampOrganizationUsersRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRestoreCreate>>, TError,BasecampOrganizationUsersRestoreCreateMutationVariables, TContext> => {

const mutationKey = getBasecampOrganizationUsersRestoreCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampOrganizationUsersRestoreCreate>>, BasecampOrganizationUsersRestoreCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampOrganizationUsersRestoreCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampOrganizationUsersRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationUsersRestoreCreate>>>
    export type BasecampOrganizationUsersRestoreCreateMutationBody = RestoreOrphanedOrganizationUserInput
    export type BasecampOrganizationUsersRestoreCreateMutationError = Error
    export type BasecampOrganizationUsersRestoreCreateMutationVariables = {data: RestoreOrphanedOrganizationUserInput}

    export const useBasecampOrganizationUsersRestoreCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersRestoreCreate>>, TError,BasecampOrganizationUsersRestoreCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampOrganizationUsersRestoreCreate>>,
        TError,
        BasecampOrganizationUsersRestoreCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampOrganizationUsersRestoreCreateMutationOptions(options), queryClient);
    }

export type basecampOrganizationUsersUpdateCreateResponse200 = {
  data: void
  status: 200
}

export type basecampOrganizationUsersUpdateCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationUsersUpdateCreateResponseSuccess = (basecampOrganizationUsersUpdateCreateResponse200) & {
  headers: Headers;
};
export type basecampOrganizationUsersUpdateCreateResponseError = (basecampOrganizationUsersUpdateCreateResponse400) & {
  headers: Headers;
};

export type basecampOrganizationUsersUpdateCreateResponse = (basecampOrganizationUsersUpdateCreateResponseSuccess | basecampOrganizationUsersUpdateCreateResponseError)

export const getBasecampOrganizationUsersUpdateCreateUrl = () => {




  return `/api/basecamp/organization-users/update`
}

export const basecampOrganizationUsersUpdateCreate = async (updateOrganizationUserInput: UpdateOrganizationUserInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationUsersUpdateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampOrganizationUsersUpdateCreateResponse>(getBasecampOrganizationUsersUpdateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOrganizationUserInput)
  }
);}





export const getBasecampOrganizationUsersUpdateCreateMutationKey = () => ['basecampOrganizationUsersUpdateCreate'] as const;

export const getBasecampOrganizationUsersUpdateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersUpdateCreate>>, TError,BasecampOrganizationUsersUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersUpdateCreate>>, TError,BasecampOrganizationUsersUpdateCreateMutationVariables, TContext> => {

const mutationKey = getBasecampOrganizationUsersUpdateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampOrganizationUsersUpdateCreate>>, BasecampOrganizationUsersUpdateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampOrganizationUsersUpdateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampOrganizationUsersUpdateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationUsersUpdateCreate>>>
    export type BasecampOrganizationUsersUpdateCreateMutationBody = UpdateOrganizationUserInput
    export type BasecampOrganizationUsersUpdateCreateMutationError = Error
    export type BasecampOrganizationUsersUpdateCreateMutationVariables = {data: UpdateOrganizationUserInput}

    export const useBasecampOrganizationUsersUpdateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationUsersUpdateCreate>>, TError,BasecampOrganizationUsersUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampOrganizationUsersUpdateCreate>>,
        TError,
        BasecampOrganizationUsersUpdateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampOrganizationUsersUpdateCreateMutationOptions(options), queryClient);
    }

export type basecampOrganizationsRetrieveResponse200 = {
  data: GetOrganizationsOutput
  status: 200
}

export type basecampOrganizationsRetrieveResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationsRetrieveResponseSuccess = (basecampOrganizationsRetrieveResponse200) & {
  headers: Headers;
};
export type basecampOrganizationsRetrieveResponseError = (basecampOrganizationsRetrieveResponse400) & {
  headers: Headers;
};

export type basecampOrganizationsRetrieveResponse = (basecampOrganizationsRetrieveResponseSuccess | basecampOrganizationsRetrieveResponseError)

export const getBasecampOrganizationsRetrieveUrl = (params?: BasecampOrganizationsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/organizations?${stringifiedParams}` : `/api/basecamp/organizations`
}

export const basecampOrganizationsRetrieve = async (params?: BasecampOrganizationsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationsRetrieveResponse> => {

  return customFetch<basecampOrganizationsRetrieveResponse>(getBasecampOrganizationsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBasecampOrganizationsRetrieveQueryKey = (params?: BasecampOrganizationsRetrieveParams,) => {
    return [
    `/api/basecamp/organizations`, ...(params ? [params] : [])
    ] as const;
    }


export const getBasecampOrganizationsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError = Error>(params?: BasecampOrganizationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBasecampOrganizationsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>> = ({ signal }) => basecampOrganizationsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BasecampOrganizationsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>>
export type BasecampOrganizationsRetrieveQueryError = Error


export function useBasecampOrganizationsRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError = Error>(
 params: undefined |  BasecampOrganizationsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampOrganizationsRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError = Error>(
 params?: BasecampOrganizationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBasecampOrganizationsRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError = Error>(
 params?: BasecampOrganizationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useBasecampOrganizationsRetrieve<TData = Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError = Error>(
 params?: BasecampOrganizationsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof basecampOrganizationsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBasecampOrganizationsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getGoalGenerationRulesResponse200 = {
  data: GetGoalGenerationRulesOutput
  status: 200
}

export type getGoalGenerationRulesResponse400 = {
  data: Error
  status: 400
}

export type getGoalGenerationRulesResponseSuccess = (getGoalGenerationRulesResponse200) & {
  headers: Headers;
};
export type getGoalGenerationRulesResponseError = (getGoalGenerationRulesResponse400) & {
  headers: Headers;
};

export type getGoalGenerationRulesResponse = (getGoalGenerationRulesResponseSuccess | getGoalGenerationRulesResponseError)

export const getGetGoalGenerationRulesUrl = (orgId: string,) => {




  return `/api/basecamp/organizations/${orgId}/goal-generation-rules`
}

export const getGoalGenerationRules = async (orgId: string, options?: Parameters<typeof customFetch>[1]): Promise<getGoalGenerationRulesResponse> => {

  return customFetch<getGoalGenerationRulesResponse>(getGetGoalGenerationRulesUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGoalGenerationRulesQueryKey = (orgId: string,) => {
    return [
    `/api/basecamp/organizations/${orgId}/goal-generation-rules`
    ] as const;
    }


export const getGetGoalGenerationRulesQueryOptions = <TData = Awaited<ReturnType<typeof getGoalGenerationRules>>, TError = Error>(orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalGenerationRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoalGenerationRulesQueryKey(orgId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoalGenerationRules>>> = ({ signal }) => getGoalGenerationRules(orgId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orgId !== null && orgId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoalGenerationRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGoalGenerationRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getGoalGenerationRules>>>
export type GetGoalGenerationRulesQueryError = Error


export function useGetGoalGenerationRules<TData = Awaited<ReturnType<typeof getGoalGenerationRules>>, TError = Error>(
 orgId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalGenerationRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalGenerationRules>>,
          TError,
          Awaited<ReturnType<typeof getGoalGenerationRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoalGenerationRules<TData = Awaited<ReturnType<typeof getGoalGenerationRules>>, TError = Error>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalGenerationRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalGenerationRules>>,
          TError,
          Awaited<ReturnType<typeof getGoalGenerationRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoalGenerationRules<TData = Awaited<ReturnType<typeof getGoalGenerationRules>>, TError = Error>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalGenerationRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGoalGenerationRules<TData = Awaited<ReturnType<typeof getGoalGenerationRules>>, TError = Error>(
 orgId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalGenerationRules>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGoalGenerationRulesQueryOptions(orgId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type putGoalGenerationRulesResponse200 = {
  data: GetGoalGenerationRulesOutput
  status: 200
}

export type putGoalGenerationRulesResponse400 = {
  data: Error
  status: 400
}

export type putGoalGenerationRulesResponseSuccess = (putGoalGenerationRulesResponse200) & {
  headers: Headers;
};
export type putGoalGenerationRulesResponseError = (putGoalGenerationRulesResponse400) & {
  headers: Headers;
};

export type putGoalGenerationRulesResponse = (putGoalGenerationRulesResponseSuccess | putGoalGenerationRulesResponseError)

export const getPutGoalGenerationRulesUrl = (orgId: string,) => {




  return `/api/basecamp/organizations/${orgId}/goal-generation-rules`
}

export const putGoalGenerationRules = async (orgId: string,
    putGoalGenerationRulesInput?: PutGoalGenerationRulesInput, options?: Parameters<typeof customFetch>[1]): Promise<putGoalGenerationRulesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<putGoalGenerationRulesResponse>(getPutGoalGenerationRulesUrl(orgId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putGoalGenerationRulesInput)
  }
);}





export const getPutGoalGenerationRulesMutationKey = () => ['putGoalGenerationRules'] as const;

export const getPutGoalGenerationRulesMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGoalGenerationRules>>, TError,PutGoalGenerationRulesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putGoalGenerationRules>>, TError,PutGoalGenerationRulesMutationVariables, TContext> => {

const mutationKey = getPutGoalGenerationRulesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putGoalGenerationRules>>, PutGoalGenerationRulesMutationVariables> = (props) => {
          const {orgId,data} = props ?? {};

          return  putGoalGenerationRules(orgId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutGoalGenerationRulesMutationResult = NonNullable<Awaited<ReturnType<typeof putGoalGenerationRules>>>
    export type PutGoalGenerationRulesMutationBody = PutGoalGenerationRulesInput | undefined
    export type PutGoalGenerationRulesMutationError = Error
    export type PutGoalGenerationRulesMutationVariables = {orgId: string;data?: PutGoalGenerationRulesInput}

    export const usePutGoalGenerationRules = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGoalGenerationRules>>, TError,PutGoalGenerationRulesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putGoalGenerationRules>>,
        TError,
        PutGoalGenerationRulesMutationVariables,
        TContext
      > => {
      return useMutation(getPutGoalGenerationRulesMutationOptions(options), queryClient);
    }

export type basecampOrganizationsCreateCreateResponse200 = {
  data: CreateOrganizationOutput
  status: 200
}

export type basecampOrganizationsCreateCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationsCreateCreateResponseSuccess = (basecampOrganizationsCreateCreateResponse200) & {
  headers: Headers;
};
export type basecampOrganizationsCreateCreateResponseError = (basecampOrganizationsCreateCreateResponse400) & {
  headers: Headers;
};

export type basecampOrganizationsCreateCreateResponse = (basecampOrganizationsCreateCreateResponseSuccess | basecampOrganizationsCreateCreateResponseError)

export const getBasecampOrganizationsCreateCreateUrl = () => {




  return `/api/basecamp/organizations/create`
}

export const basecampOrganizationsCreateCreate = async (createOrganizationInput: CreateOrganizationInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationsCreateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampOrganizationsCreateCreateResponse>(getBasecampOrganizationsCreateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createOrganizationInput)
  }
);}





export const getBasecampOrganizationsCreateCreateMutationKey = () => ['basecampOrganizationsCreateCreate'] as const;

export const getBasecampOrganizationsCreateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationsCreateCreate>>, TError,BasecampOrganizationsCreateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationsCreateCreate>>, TError,BasecampOrganizationsCreateCreateMutationVariables, TContext> => {

const mutationKey = getBasecampOrganizationsCreateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampOrganizationsCreateCreate>>, BasecampOrganizationsCreateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampOrganizationsCreateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampOrganizationsCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationsCreateCreate>>>
    export type BasecampOrganizationsCreateCreateMutationBody = CreateOrganizationInput
    export type BasecampOrganizationsCreateCreateMutationError = Error
    export type BasecampOrganizationsCreateCreateMutationVariables = {data: CreateOrganizationInput}

    export const useBasecampOrganizationsCreateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationsCreateCreate>>, TError,BasecampOrganizationsCreateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampOrganizationsCreateCreate>>,
        TError,
        BasecampOrganizationsCreateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampOrganizationsCreateCreateMutationOptions(options), queryClient);
    }

export type basecampOrganizationsUpdateCreateResponse200 = {
  data: UpdateOrganizationOutput
  status: 200
}

export type basecampOrganizationsUpdateCreateResponse400 = {
  data: Error
  status: 400
}

export type basecampOrganizationsUpdateCreateResponseSuccess = (basecampOrganizationsUpdateCreateResponse200) & {
  headers: Headers;
};
export type basecampOrganizationsUpdateCreateResponseError = (basecampOrganizationsUpdateCreateResponse400) & {
  headers: Headers;
};

export type basecampOrganizationsUpdateCreateResponse = (basecampOrganizationsUpdateCreateResponseSuccess | basecampOrganizationsUpdateCreateResponseError)

export const getBasecampOrganizationsUpdateCreateUrl = () => {




  return `/api/basecamp/organizations/update`
}

/**
 * POST /organizations/update — update org-level settings (basecamp admin).
 */
export const basecampOrganizationsUpdateCreate = async (updateOrganizationInput: UpdateOrganizationInput, options?: Parameters<typeof customFetch>[1]): Promise<basecampOrganizationsUpdateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<basecampOrganizationsUpdateCreateResponse>(getBasecampOrganizationsUpdateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateOrganizationInput)
  }
);}





export const getBasecampOrganizationsUpdateCreateMutationKey = () => ['basecampOrganizationsUpdateCreate'] as const;

export const getBasecampOrganizationsUpdateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationsUpdateCreate>>, TError,BasecampOrganizationsUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationsUpdateCreate>>, TError,BasecampOrganizationsUpdateCreateMutationVariables, TContext> => {

const mutationKey = getBasecampOrganizationsUpdateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof basecampOrganizationsUpdateCreate>>, BasecampOrganizationsUpdateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  basecampOrganizationsUpdateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BasecampOrganizationsUpdateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof basecampOrganizationsUpdateCreate>>>
    export type BasecampOrganizationsUpdateCreateMutationBody = UpdateOrganizationInput
    export type BasecampOrganizationsUpdateCreateMutationError = Error
    export type BasecampOrganizationsUpdateCreateMutationVariables = {data: UpdateOrganizationInput}

    export const useBasecampOrganizationsUpdateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof basecampOrganizationsUpdateCreate>>, TError,BasecampOrganizationsUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof basecampOrganizationsUpdateCreate>>,
        TError,
        BasecampOrganizationsUpdateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getBasecampOrganizationsUpdateCreateMutationOptions(options), queryClient);
    }

export type listPayorTypesResponse200 = {
  data: ListPayorTypesOutput
  status: 200
}

export type listPayorTypesResponseSuccess = (listPayorTypesResponse200) & {
  headers: Headers;
};
;

export type listPayorTypesResponse = (listPayorTypesResponseSuccess)

export const getListPayorTypesUrl = () => {




  return `/api/basecamp/payor-types`
}

/**
 * Returns the PayorType enum values for the QA package pickers.
 */
export const listPayorTypes = async ( options?: Parameters<typeof customFetch>[1]): Promise<listPayorTypesResponse> => {

  return customFetch<listPayorTypesResponse>(getListPayorTypesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPayorTypesQueryKey = () => {
    return [
    `/api/basecamp/payor-types`
    ] as const;
    }


export const getListPayorTypesQueryOptions = <TData = Awaited<ReturnType<typeof listPayorTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayorTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPayorTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPayorTypes>>> = ({ signal }) => listPayorTypes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPayorTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPayorTypesQueryResult = NonNullable<Awaited<ReturnType<typeof listPayorTypes>>>
export type ListPayorTypesQueryError = unknown


export function useListPayorTypes<TData = Awaited<ReturnType<typeof listPayorTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayorTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayorTypes>>,
          TError,
          Awaited<ReturnType<typeof listPayorTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayorTypes<TData = Awaited<ReturnType<typeof listPayorTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayorTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPayorTypes>>,
          TError,
          Awaited<ReturnType<typeof listPayorTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPayorTypes<TData = Awaited<ReturnType<typeof listPayorTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayorTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPayorTypes<TData = Awaited<ReturnType<typeof listPayorTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPayorTypes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPayorTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listPromptsResponse200 = {
  data: GetPromptsPaginatedOutput
  status: 200
}

export type listPromptsResponse400 = {
  data: Error
  status: 400
}

export type listPromptsResponseSuccess = (listPromptsResponse200) & {
  headers: Headers;
};
export type listPromptsResponseError = (listPromptsResponse400) & {
  headers: Headers;
};

export type listPromptsResponse = (listPromptsResponseSuccess | listPromptsResponseError)

export const getListPromptsUrl = (params?: ListPromptsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/prompts?${stringifiedParams}` : `/api/basecamp/prompts`
}

export const listPrompts = async (params?: ListPromptsParams, options?: Parameters<typeof customFetch>[1]): Promise<listPromptsResponse> => {

  return customFetch<listPromptsResponse>(getListPromptsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptsQueryKey = (params?: ListPromptsParams,) => {
    return [
    `/api/basecamp/prompts`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPromptsQueryOptions = <TData = Awaited<ReturnType<typeof listPrompts>>, TError = Error>(params?: ListPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrompts>>> = ({ signal }) => listPrompts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptsQueryResult = NonNullable<Awaited<ReturnType<typeof listPrompts>>>
export type ListPromptsQueryError = Error


export function useListPrompts<TData = Awaited<ReturnType<typeof listPrompts>>, TError = Error>(
 params: undefined |  ListPromptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrompts>>,
          TError,
          Awaited<ReturnType<typeof listPrompts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrompts<TData = Awaited<ReturnType<typeof listPrompts>>, TError = Error>(
 params?: ListPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrompts>>,
          TError,
          Awaited<ReturnType<typeof listPrompts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPrompts<TData = Awaited<ReturnType<typeof listPrompts>>, TError = Error>(
 params?: ListPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPrompts<TData = Awaited<ReturnType<typeof listPrompts>>, TError = Error>(
 params?: ListPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type deleteDraftPromptResponse200 = {
  data: DeleteDraftPromptOutput
  status: 200
}

export type deleteDraftPromptResponse400 = {
  data: Error
  status: 400
}

export type deleteDraftPromptResponseSuccess = (deleteDraftPromptResponse200) & {
  headers: Headers;
};
export type deleteDraftPromptResponseError = (deleteDraftPromptResponse400) & {
  headers: Headers;
};

export type deleteDraftPromptResponse = (deleteDraftPromptResponseSuccess | deleteDraftPromptResponseError)

export const getDeleteDraftPromptUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/delete-draft`
}

/**
 * SPA-facing delete for draft-only Prompt rows. Powers the "Delete
 * prompt" button on the prompt-detail page.
 */
export const deleteDraftPrompt = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<deleteDraftPromptResponse> => {

  return customFetch<deleteDraftPromptResponse>(getDeleteDraftPromptUrl(key),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDeleteDraftPromptMutationKey = () => ['deleteDraftPrompt'] as const;

export const getDeleteDraftPromptMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftPrompt>>, TError,DeleteDraftPromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftPrompt>>, TError,DeleteDraftPromptMutationVariables, TContext> => {

const mutationKey = getDeleteDraftPromptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftPrompt>>, DeleteDraftPromptMutationVariables> = (props) => {
          const {key} = props ?? {};

          return  deleteDraftPrompt(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftPromptMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftPrompt>>>

    export type DeleteDraftPromptMutationError = Error
    export type DeleteDraftPromptMutationVariables = {key: string}

    export const useDeleteDraftPrompt = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftPrompt>>, TError,DeleteDraftPromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftPrompt>>,
        TError,
        DeleteDraftPromptMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftPromptMutationOptions(options), queryClient);
    }

export type deleteDraftPromptM2mResponse200 = {
  data: DeleteDraftPromptOutput
  status: 200
}

export type deleteDraftPromptM2mResponse400 = {
  data: Error
  status: 400
}

export type deleteDraftPromptM2mResponseSuccess = (deleteDraftPromptM2mResponse200) & {
  headers: Headers;
};
export type deleteDraftPromptM2mResponseError = (deleteDraftPromptM2mResponse400) & {
  headers: Headers;
};

export type deleteDraftPromptM2mResponse = (deleteDraftPromptM2mResponseSuccess | deleteDraftPromptM2mResponseError)

export const getDeleteDraftPromptM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/delete-draft/m2m`
}

/**
 * M2M sibling of ``DeleteDraftPromptView`` — Rio's
 * ``apply_delete_prompt_draft`` tool calls this.
 */
export const deleteDraftPromptM2m = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<deleteDraftPromptM2mResponse> => {

  return customFetch<deleteDraftPromptM2mResponse>(getDeleteDraftPromptM2mUrl(key),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDeleteDraftPromptM2mMutationKey = () => ['deleteDraftPromptM2m'] as const;

export const getDeleteDraftPromptM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftPromptM2m>>, TError,DeleteDraftPromptM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftPromptM2m>>, TError,DeleteDraftPromptM2mMutationVariables, TContext> => {

const mutationKey = getDeleteDraftPromptM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftPromptM2m>>, DeleteDraftPromptM2mMutationVariables> = (props) => {
          const {key} = props ?? {};

          return  deleteDraftPromptM2m(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftPromptM2mMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftPromptM2m>>>

    export type DeleteDraftPromptM2mMutationError = Error
    export type DeleteDraftPromptM2mMutationVariables = {key: string}

    export const useDeleteDraftPromptM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftPromptM2m>>, TError,DeleteDraftPromptM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftPromptM2m>>,
        TError,
        DeleteDraftPromptM2mMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDraftPromptM2mMutationOptions(options), queryClient);
    }

export type getPromptDetailsResponse200 = {
  data: GetPromptDetailsOutput
  status: 200
}

export type getPromptDetailsResponse400 = {
  data: Error
  status: 400
}

export type getPromptDetailsResponseSuccess = (getPromptDetailsResponse200) & {
  headers: Headers;
};
export type getPromptDetailsResponseError = (getPromptDetailsResponse400) & {
  headers: Headers;
};

export type getPromptDetailsResponse = (getPromptDetailsResponseSuccess | getPromptDetailsResponseError)

export const getGetPromptDetailsUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/details`
}

export const getPromptDetails = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<getPromptDetailsResponse> => {

  return customFetch<getPromptDetailsResponse>(getGetPromptDetailsUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptDetailsQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/details`
    ] as const;
    }


export const getGetPromptDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getPromptDetails>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptDetailsQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptDetails>>> = ({ signal }) => getPromptDetails(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptDetails>>>
export type GetPromptDetailsQueryError = Error


export function useGetPromptDetails<TData = Awaited<ReturnType<typeof getPromptDetails>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDetails>>,
          TError,
          Awaited<ReturnType<typeof getPromptDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDetails<TData = Awaited<ReturnType<typeof getPromptDetails>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDetails>>,
          TError,
          Awaited<ReturnType<typeof getPromptDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDetails<TData = Awaited<ReturnType<typeof getPromptDetails>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptDetails<TData = Awaited<ReturnType<typeof getPromptDetails>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptDetailsQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getPromptDetailsM2mResponse200 = {
  data: GetPromptDetailsOutput
  status: 200
}

export type getPromptDetailsM2mResponse400 = {
  data: Error
  status: 400
}

export type getPromptDetailsM2mResponseSuccess = (getPromptDetailsM2mResponse200) & {
  headers: Headers;
};
export type getPromptDetailsM2mResponseError = (getPromptDetailsM2mResponse400) & {
  headers: Headers;
};

export type getPromptDetailsM2mResponse = (getPromptDetailsM2mResponseSuccess | getPromptDetailsM2mResponseError)

export const getGetPromptDetailsM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/details/m2m`
}

/**
 * Temporal M2M sibling of ``GetPromptDetails``.
 *
 * Same JSON shape, same registry lookup, same Prompt row resolution.
 * Split from the SPA endpoint because dual-auth doesn't cleanly
 * interoperate with ``role_required_for_rest_apis``' M2M client_name
 * check (mirrors the SPA/M2M split in ``rio_chat_views`` /
 * ``prompt_sandbox_views``). Called by Rio's ``get_prompt_snapshot``
 * every turn.
 */
export const getPromptDetailsM2m = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<getPromptDetailsM2mResponse> => {

  return customFetch<getPromptDetailsM2mResponse>(getGetPromptDetailsM2mUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptDetailsM2mQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/details/m2m`
    ] as const;
    }


export const getGetPromptDetailsM2mQueryOptions = <TData = Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptDetailsM2mQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptDetailsM2m>>> = ({ signal }) => getPromptDetailsM2m(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptDetailsM2mQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptDetailsM2m>>>
export type GetPromptDetailsM2mQueryError = Error


export function useGetPromptDetailsM2m<TData = Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDetailsM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptDetailsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDetailsM2m<TData = Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDetailsM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptDetailsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDetailsM2m<TData = Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptDetailsM2m<TData = Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDetailsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptDetailsM2mQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getPromptDraftResponse200 = {
  data: GetPromptDraftOutput
  status: 200
}

export type getPromptDraftResponse400 = {
  data: Error
  status: 400
}

export type getPromptDraftResponseSuccess = (getPromptDraftResponse200) & {
  headers: Headers;
};
export type getPromptDraftResponseError = (getPromptDraftResponse400) & {
  headers: Headers;
};

export type getPromptDraftResponse = (getPromptDraftResponseSuccess | getPromptDraftResponseError)

export const getGetPromptDraftUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/draft`
}

export const getPromptDraft = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<getPromptDraftResponse> => {

  return customFetch<getPromptDraftResponse>(getGetPromptDraftUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptDraftQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/draft`
    ] as const;
    }


export const getGetPromptDraftQueryOptions = <TData = Awaited<ReturnType<typeof getPromptDraft>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptDraftQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptDraft>>> = ({ signal }) => getPromptDraft(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptDraft>>>
export type GetPromptDraftQueryError = Error


export function useGetPromptDraft<TData = Awaited<ReturnType<typeof getPromptDraft>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDraft>>,
          TError,
          Awaited<ReturnType<typeof getPromptDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDraft<TData = Awaited<ReturnType<typeof getPromptDraft>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDraft>>,
          TError,
          Awaited<ReturnType<typeof getPromptDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDraft<TData = Awaited<ReturnType<typeof getPromptDraft>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptDraft<TData = Awaited<ReturnType<typeof getPromptDraft>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraft>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptDraftQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type putPromptDraftResponse200 = {
  data: GetPromptDraftOutput
  status: 200
}

export type putPromptDraftResponse400 = {
  data: Error
  status: 400
}

export type putPromptDraftResponseSuccess = (putPromptDraftResponse200) & {
  headers: Headers;
};
export type putPromptDraftResponseError = (putPromptDraftResponse400) & {
  headers: Headers;
};

export type putPromptDraftResponse = (putPromptDraftResponseSuccess | putPromptDraftResponseError)

export const getPutPromptDraftUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/draft`
}

export const putPromptDraft = async (key: string,
    putPromptDraftInput?: PutPromptDraftInput, options?: Parameters<typeof customFetch>[1]): Promise<putPromptDraftResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<putPromptDraftResponse>(getPutPromptDraftUrl(key),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPromptDraftInput)
  }
);}





export const getPutPromptDraftMutationKey = () => ['putPromptDraft'] as const;

export const getPutPromptDraftMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPromptDraft>>, TError,PutPromptDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putPromptDraft>>, TError,PutPromptDraftMutationVariables, TContext> => {

const mutationKey = getPutPromptDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPromptDraft>>, PutPromptDraftMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  putPromptDraft(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPromptDraftMutationResult = NonNullable<Awaited<ReturnType<typeof putPromptDraft>>>
    export type PutPromptDraftMutationBody = PutPromptDraftInput | undefined
    export type PutPromptDraftMutationError = Error
    export type PutPromptDraftMutationVariables = {key: string;data?: PutPromptDraftInput}

    export const usePutPromptDraft = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPromptDraft>>, TError,PutPromptDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPromptDraft>>,
        TError,
        PutPromptDraftMutationVariables,
        TContext
      > => {
      return useMutation(getPutPromptDraftMutationOptions(options), queryClient);
    }

export type deletePromptDraftResponse200 = {
  data: GetPromptDraftOutput
  status: 200
}

export type deletePromptDraftResponse400 = {
  data: Error
  status: 400
}

export type deletePromptDraftResponseSuccess = (deletePromptDraftResponse200) & {
  headers: Headers;
};
export type deletePromptDraftResponseError = (deletePromptDraftResponse400) & {
  headers: Headers;
};

export type deletePromptDraftResponse = (deletePromptDraftResponseSuccess | deletePromptDraftResponseError)

export const getDeletePromptDraftUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/draft`
}

export const deletePromptDraft = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<deletePromptDraftResponse> => {

  return customFetch<deletePromptDraftResponse>(getDeletePromptDraftUrl(key),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePromptDraftMutationKey = () => ['deletePromptDraft'] as const;

export const getDeletePromptDraftMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePromptDraft>>, TError,DeletePromptDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePromptDraft>>, TError,DeletePromptDraftMutationVariables, TContext> => {

const mutationKey = getDeletePromptDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePromptDraft>>, DeletePromptDraftMutationVariables> = (props) => {
          const {key} = props ?? {};

          return  deletePromptDraft(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePromptDraftMutationResult = NonNullable<Awaited<ReturnType<typeof deletePromptDraft>>>

    export type DeletePromptDraftMutationError = Error
    export type DeletePromptDraftMutationVariables = {key: string}

    export const useDeletePromptDraft = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePromptDraft>>, TError,DeletePromptDraftMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePromptDraft>>,
        TError,
        DeletePromptDraftMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePromptDraftMutationOptions(options), queryClient);
    }

export type getPromptDraftM2mResponse200 = {
  data: GetPromptDraftOutput
  status: 200
}

export type getPromptDraftM2mResponse400 = {
  data: Error
  status: 400
}

export type getPromptDraftM2mResponseSuccess = (getPromptDraftM2mResponse200) & {
  headers: Headers;
};
export type getPromptDraftM2mResponseError = (getPromptDraftM2mResponse400) & {
  headers: Headers;
};

export type getPromptDraftM2mResponse = (getPromptDraftM2mResponseSuccess | getPromptDraftM2mResponseError)

export const getGetPromptDraftM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/draft/m2m`
}

/**
 * Temporal M2M sibling of ``PromptDraftView``.
 *
 * Split from the SPA endpoint because dual-auth doesn't cleanly
 * interoperate with ``role_required_for_rest_apis``' M2M client_name
 * check (see the note in ``prompt_sandbox_views.py`` on this pattern).
 *
 * Two verbs:
 * - ``GET`` — read the current draft. Same payload as the SPA GET.
 * - ``POST`` — merge ``{field, value}`` into ``draft_overrides``.
 *   Rio's per-tool-call single-field write pattern; the endpoint
 *   does the read-modify-write internally so Rio doesn't have to
 *   manage the full dict per call.
 *
 * ``draft_by`` / ``draft_updated_at`` metadata is intentionally NOT
 * updated on M2M writes so the "who last touched this draft" audit
 * reflects the last HUMAN edit — Rio's writes are frequent and would
 * drown out human edits otherwise.
 */
export const getPromptDraftM2m = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<getPromptDraftM2mResponse> => {

  return customFetch<getPromptDraftM2mResponse>(getGetPromptDraftM2mUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptDraftM2mQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/draft/m2m`
    ] as const;
    }


export const getGetPromptDraftM2mQueryOptions = <TData = Awaited<ReturnType<typeof getPromptDraftM2m>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraftM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptDraftM2mQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptDraftM2m>>> = ({ signal }) => getPromptDraftM2m(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptDraftM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptDraftM2mQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptDraftM2m>>>
export type GetPromptDraftM2mQueryError = Error


export function useGetPromptDraftM2m<TData = Awaited<ReturnType<typeof getPromptDraftM2m>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraftM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDraftM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptDraftM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDraftM2m<TData = Awaited<ReturnType<typeof getPromptDraftM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraftM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptDraftM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptDraftM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptDraftM2m<TData = Awaited<ReturnType<typeof getPromptDraftM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraftM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptDraftM2m<TData = Awaited<ReturnType<typeof getPromptDraftM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptDraftM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptDraftM2mQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type putPromptDraftM2mResponse200 = {
  data: GetPromptDraftOutput
  status: 200
}

export type putPromptDraftM2mResponse400 = {
  data: Error
  status: 400
}

export type putPromptDraftM2mResponseSuccess = (putPromptDraftM2mResponse200) & {
  headers: Headers;
};
export type putPromptDraftM2mResponseError = (putPromptDraftM2mResponse400) & {
  headers: Headers;
};

export type putPromptDraftM2mResponse = (putPromptDraftM2mResponseSuccess | putPromptDraftM2mResponseError)

export const getPutPromptDraftM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/draft/m2m`
}

/**
 * Temporal M2M sibling of ``PromptDraftView``.
 *
 * Split from the SPA endpoint because dual-auth doesn't cleanly
 * interoperate with ``role_required_for_rest_apis``' M2M client_name
 * check (see the note in ``prompt_sandbox_views.py`` on this pattern).
 *
 * Two verbs:
 * - ``GET`` — read the current draft. Same payload as the SPA GET.
 * - ``POST`` — merge ``{field, value}`` into ``draft_overrides``.
 *   Rio's per-tool-call single-field write pattern; the endpoint
 *   does the read-modify-write internally so Rio doesn't have to
 *   manage the full dict per call.
 *
 * ``draft_by`` / ``draft_updated_at`` metadata is intentionally NOT
 * updated on M2M writes so the "who last touched this draft" audit
 * reflects the last HUMAN edit — Rio's writes are frequent and would
 * drown out human edits otherwise.
 */
export const putPromptDraftM2m = async (key: string,
    putPromptDraftM2MInput: PutPromptDraftM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<putPromptDraftM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<putPromptDraftM2mResponse>(getPutPromptDraftM2mUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putPromptDraftM2MInput)
  }
);}





export const getPutPromptDraftM2mMutationKey = () => ['putPromptDraftM2m'] as const;

export const getPutPromptDraftM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPromptDraftM2m>>, TError,PutPromptDraftM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putPromptDraftM2m>>, TError,PutPromptDraftM2mMutationVariables, TContext> => {

const mutationKey = getPutPromptDraftM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPromptDraftM2m>>, PutPromptDraftM2mMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  putPromptDraftM2m(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutPromptDraftM2mMutationResult = NonNullable<Awaited<ReturnType<typeof putPromptDraftM2m>>>
    export type PutPromptDraftM2mMutationBody = PutPromptDraftM2MInput
    export type PutPromptDraftM2mMutationError = Error
    export type PutPromptDraftM2mMutationVariables = {key: string;data: PutPromptDraftM2MInput}

    export const usePutPromptDraftM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPromptDraftM2m>>, TError,PutPromptDraftM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPromptDraftM2m>>,
        TError,
        PutPromptDraftM2mMutationVariables,
        TContext
      > => {
      return useMutation(getPutPromptDraftM2mMutationOptions(options), queryClient);
    }

export type duplicatePromptResponse201 = {
  data: PromptOutput
  status: 201
}

export type duplicatePromptResponse400 = {
  data: Error
  status: 400
}

export type duplicatePromptResponseSuccess = (duplicatePromptResponse201) & {
  headers: Headers;
};
export type duplicatePromptResponseError = (duplicatePromptResponse400) & {
  headers: Headers;
};

export type duplicatePromptResponse = (duplicatePromptResponseSuccess | duplicatePromptResponseError)

export const getDuplicatePromptUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/duplicate`
}

/**
 * Create a new draft ``Prompt`` row seeded with an existing prompt's
 * yaml content, so duplicating a prompt from the basecamp UI drops the
 * caller straight into the same evaluations/review-draft/PR flow as any
 * other draft, instead of asking Rio to copy it over in chat.
 *
 * Mirrors Rio's ``apply_duplicate_prompts`` tool (PROC-119), but that
 * tool is scoped to cross-org reuse and refuses same-org/global
 * sources. This endpoint has no such restriction — it's a plain "copy
 * this prompt under a new key" operation available to any admin from
 * the prompt-detail page.
 */
export const duplicatePrompt = async (key: string,
    duplicatePromptInput: DuplicatePromptInput, options?: Parameters<typeof customFetch>[1]): Promise<duplicatePromptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<duplicatePromptResponse>(getDuplicatePromptUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(duplicatePromptInput)
  }
);}





export const getDuplicatePromptMutationKey = () => ['duplicatePrompt'] as const;

export const getDuplicatePromptMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicatePrompt>>, TError,DuplicatePromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicatePrompt>>, TError,DuplicatePromptMutationVariables, TContext> => {

const mutationKey = getDuplicatePromptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicatePrompt>>, DuplicatePromptMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  duplicatePrompt(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicatePromptMutationResult = NonNullable<Awaited<ReturnType<typeof duplicatePrompt>>>
    export type DuplicatePromptMutationBody = DuplicatePromptInput
    export type DuplicatePromptMutationError = Error
    export type DuplicatePromptMutationVariables = {key: string;data: DuplicatePromptInput}

    export const useDuplicatePrompt = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicatePrompt>>, TError,DuplicatePromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicatePrompt>>,
        TError,
        DuplicatePromptMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicatePromptMutationOptions(options), queryClient);
    }

export type editPromptYamlAndOpenPrResponse201 = {
  data: OpenPROutput
  status: 201
}

export type editPromptYamlAndOpenPrResponse400 = {
  data: Error
  status: 400
}

export type editPromptYamlAndOpenPrResponse404 = {
  data: Error
  status: 404
}

export type editPromptYamlAndOpenPrResponse409 = {
  data: Error
  status: 409
}

export type editPromptYamlAndOpenPrResponse502 = {
  data: Error
  status: 502
}

export type editPromptYamlAndOpenPrResponseSuccess = (editPromptYamlAndOpenPrResponse201) & {
  headers: Headers;
};
export type editPromptYamlAndOpenPrResponseError = (editPromptYamlAndOpenPrResponse400 | editPromptYamlAndOpenPrResponse404 | editPromptYamlAndOpenPrResponse409 | editPromptYamlAndOpenPrResponse502) & {
  headers: Headers;
};

export type editPromptYamlAndOpenPrResponse = (editPromptYamlAndOpenPrResponseSuccess | editPromptYamlAndOpenPrResponseError)

export const getEditPromptYamlAndOpenPrUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/open-pr`
}

/**
 * POST /api/basecamp/prompts/<key>/open-pr
 *
 * Edit an existing prompt's yaml entry, regenerate the registry, and open
 * paired pipelines + api-django PRs. Returns both PR URLs.
 */
export const editPromptYamlAndOpenPr = async (key: string,
    editPromptYamlInput?: EditPromptYamlInput, options?: Parameters<typeof customFetch>[1]): Promise<editPromptYamlAndOpenPrResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<editPromptYamlAndOpenPrResponse>(getEditPromptYamlAndOpenPrUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editPromptYamlInput)
  }
);}





export const getEditPromptYamlAndOpenPrMutationKey = () => ['editPromptYamlAndOpenPr'] as const;

export const getEditPromptYamlAndOpenPrMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPr>>, TError,EditPromptYamlAndOpenPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPr>>, TError,EditPromptYamlAndOpenPrMutationVariables, TContext> => {

const mutationKey = getEditPromptYamlAndOpenPrMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPromptYamlAndOpenPr>>, EditPromptYamlAndOpenPrMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  editPromptYamlAndOpenPr(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPromptYamlAndOpenPrMutationResult = NonNullable<Awaited<ReturnType<typeof editPromptYamlAndOpenPr>>>
    export type EditPromptYamlAndOpenPrMutationBody = EditPromptYamlInput | undefined
    export type EditPromptYamlAndOpenPrMutationError = Error
    export type EditPromptYamlAndOpenPrMutationVariables = {key: string;data?: EditPromptYamlInput}

    export const useEditPromptYamlAndOpenPr = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPr>>, TError,EditPromptYamlAndOpenPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPromptYamlAndOpenPr>>,
        TError,
        EditPromptYamlAndOpenPrMutationVariables,
        TContext
      > => {
      return useMutation(getEditPromptYamlAndOpenPrMutationOptions(options), queryClient);
    }

export type editPromptYamlAndOpenPrM2mResponse201 = {
  data: OpenPROutput
  status: 201
}

export type editPromptYamlAndOpenPrM2mResponse400 = {
  data: Error
  status: 400
}

export type editPromptYamlAndOpenPrM2mResponse404 = {
  data: Error
  status: 404
}

export type editPromptYamlAndOpenPrM2mResponse409 = {
  data: Error
  status: 409
}

export type editPromptYamlAndOpenPrM2mResponse502 = {
  data: Error
  status: 502
}

export type editPromptYamlAndOpenPrM2mResponseSuccess = (editPromptYamlAndOpenPrM2mResponse201) & {
  headers: Headers;
};
export type editPromptYamlAndOpenPrM2mResponseError = (editPromptYamlAndOpenPrM2mResponse400 | editPromptYamlAndOpenPrM2mResponse404 | editPromptYamlAndOpenPrM2mResponse409 | editPromptYamlAndOpenPrM2mResponse502) & {
  headers: Headers;
};

export type editPromptYamlAndOpenPrM2mResponse = (editPromptYamlAndOpenPrM2mResponseSuccess | editPromptYamlAndOpenPrM2mResponseError)

export const getEditPromptYamlAndOpenPrM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/open-pr/m2m`
}

/**
 * Temporal M2M sibling of ``EditPromptYamlAndOpenPR``.
 *
 * Rio's ``apply_open_edit_prompt_pr`` tool sends an empty body — the
 * edits already live on the Prompt row's ``draft_overrides``. This
 * view sources those edits, rewrites ``request.data``, and calls the
 * parent's post BODY (bypassing its own role-required decorator).
 */
export const editPromptYamlAndOpenPrM2m = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<editPromptYamlAndOpenPrM2mResponse> => {

  return customFetch<editPromptYamlAndOpenPrM2mResponse>(getEditPromptYamlAndOpenPrM2mUrl(key),
  {
    ...options,
    method: 'POST'


  }
);}





export const getEditPromptYamlAndOpenPrM2mMutationKey = () => ['editPromptYamlAndOpenPrM2m'] as const;

export const getEditPromptYamlAndOpenPrM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrM2m>>, TError,EditPromptYamlAndOpenPrM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrM2m>>, TError,EditPromptYamlAndOpenPrM2mMutationVariables, TContext> => {

const mutationKey = getEditPromptYamlAndOpenPrM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPromptYamlAndOpenPrM2m>>, EditPromptYamlAndOpenPrM2mMutationVariables> = (props) => {
          const {key} = props ?? {};

          return  editPromptYamlAndOpenPrM2m(key,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPromptYamlAndOpenPrM2mMutationResult = NonNullable<Awaited<ReturnType<typeof editPromptYamlAndOpenPrM2m>>>

    export type EditPromptYamlAndOpenPrM2mMutationError = Error
    export type EditPromptYamlAndOpenPrM2mMutationVariables = {key: string}

    export const useEditPromptYamlAndOpenPrM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrM2m>>, TError,EditPromptYamlAndOpenPrM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPromptYamlAndOpenPrM2m>>,
        TError,
        EditPromptYamlAndOpenPrM2mMutationVariables,
        TContext
      > => {
      return useMutation(getEditPromptYamlAndOpenPrM2mMutationOptions(options), queryClient);
    }

export type getRioPromptMessagesResponse200 = {
  data: RioMessageList
  status: 200
}

export type getRioPromptMessagesResponse400 = {
  data: Error
  status: 400
}

export type getRioPromptMessagesResponseSuccess = (getRioPromptMessagesResponse200) & {
  headers: Headers;
};
export type getRioPromptMessagesResponseError = (getRioPromptMessagesResponse400) & {
  headers: Headers;
};

export type getRioPromptMessagesResponse = (getRioPromptMessagesResponseSuccess | getRioPromptMessagesResponseError)

export const getGetRioPromptMessagesUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/rio/messages`
}

/**
 * GET /api/basecamp/prompts/<key>/rio/messages — SPA-facing.
 *
 * Reads the persisted Rio-Prompt chat log for the given prompt key.
 * ``?include_edit_log=true`` opts in to SYSTEM tool-log rows with a
 * structured ``edit`` field the SPA can render as a "what Rio did"
 * strip below each reply.
 */
export const getRioPromptMessages = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<getRioPromptMessagesResponse> => {

  return customFetch<getRioPromptMessagesResponse>(getGetRioPromptMessagesUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRioPromptMessagesQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/rio/messages`
    ] as const;
    }


export const getGetRioPromptMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getRioPromptMessages>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioPromptMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRioPromptMessagesQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRioPromptMessages>>> = ({ signal }) => getRioPromptMessages(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRioPromptMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRioPromptMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getRioPromptMessages>>>
export type GetRioPromptMessagesQueryError = Error


export function useGetRioPromptMessages<TData = Awaited<ReturnType<typeof getRioPromptMessages>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioPromptMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRioPromptMessages>>,
          TError,
          Awaited<ReturnType<typeof getRioPromptMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRioPromptMessages<TData = Awaited<ReturnType<typeof getRioPromptMessages>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioPromptMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRioPromptMessages>>,
          TError,
          Awaited<ReturnType<typeof getRioPromptMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRioPromptMessages<TData = Awaited<ReturnType<typeof getRioPromptMessages>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioPromptMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRioPromptMessages<TData = Awaited<ReturnType<typeof getRioPromptMessages>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioPromptMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRioPromptMessagesQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listRioPromptMessagesM2mResponse200 = {
  data: RioMessageList
  status: 200
}

export type listRioPromptMessagesM2mResponse400 = {
  data: Error
  status: 400
}

export type listRioPromptMessagesM2mResponseSuccess = (listRioPromptMessagesM2mResponse200) & {
  headers: Headers;
};
export type listRioPromptMessagesM2mResponseError = (listRioPromptMessagesM2mResponse400) & {
  headers: Headers;
};

export type listRioPromptMessagesM2mResponse = (listRioPromptMessagesM2mResponseSuccess | listRioPromptMessagesM2mResponseError)

export const getListRioPromptMessagesM2mUrl = (key: string,
    params?: ListRioPromptMessagesM2mParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/prompts/${key}/rio/messages/list?${stringifiedParams}` : `/api/basecamp/prompts/${key}/rio/messages/list`
}

/**
 * GET /api/basecamp/prompts/<key>/rio/messages/list — M2M-only.
 *
 * Same payload as ``GetRioPromptMessages`` but for the Rio worker's
 * rehydration-on-start path. Split from the SPA endpoint for the
 * same reason ``rio_chat_views`` did: mixed SPA + M2M auth doesn't
 * interact cleanly with ``role_required_for_rest_apis``.
 */
export const listRioPromptMessagesM2m = async (key: string,
    params?: ListRioPromptMessagesM2mParams, options?: Parameters<typeof customFetch>[1]): Promise<listRioPromptMessagesM2mResponse> => {

  return customFetch<listRioPromptMessagesM2mResponse>(getListRioPromptMessagesM2mUrl(key,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRioPromptMessagesM2mQueryKey = (key: string,
    params?: ListRioPromptMessagesM2mParams,) => {
    return [
    `/api/basecamp/prompts/${key}/rio/messages/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRioPromptMessagesM2mQueryOptions = <TData = Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError = Error>(key: string,
    params?: ListRioPromptMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRioPromptMessagesM2mQueryKey(key,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>> = ({ signal }) => listRioPromptMessagesM2m(key,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRioPromptMessagesM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>>
export type ListRioPromptMessagesM2mQueryError = Error


export function useListRioPromptMessagesM2m<TData = Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError = Error>(
 key: string,
    params: undefined |  ListRioPromptMessagesM2mParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRioPromptMessagesM2m>>,
          TError,
          Awaited<ReturnType<typeof listRioPromptMessagesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRioPromptMessagesM2m<TData = Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError = Error>(
 key: string,
    params?: ListRioPromptMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRioPromptMessagesM2m>>,
          TError,
          Awaited<ReturnType<typeof listRioPromptMessagesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRioPromptMessagesM2m<TData = Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError = Error>(
 key: string,
    params?: ListRioPromptMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRioPromptMessagesM2m<TData = Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError = Error>(
 key: string,
    params?: ListRioPromptMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioPromptMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRioPromptMessagesM2mQueryOptions(key,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type saveRioPromptMessageResponse200 = {
  data: SaveRioPromptMessageOutput
  status: 200
}

export type saveRioPromptMessageResponse400 = {
  data: Error
  status: 400
}

export type saveRioPromptMessageResponse409 = {
  data: Error
  status: 409
}

export type saveRioPromptMessageResponseSuccess = (saveRioPromptMessageResponse200) & {
  headers: Headers;
};
export type saveRioPromptMessageResponseError = (saveRioPromptMessageResponse400 | saveRioPromptMessageResponse409) & {
  headers: Headers;
};

export type saveRioPromptMessageResponse = (saveRioPromptMessageResponseSuccess | saveRioPromptMessageResponseError)

export const getSaveRioPromptMessageUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/rio/messages/save`
}

/**
 * POST /api/basecamp/prompts/<key>/rio/messages/save — M2M-only.
 *
 * The Rio worker calls this from its per-turn persistence path so the
 * DB stays authoritative for the chat log. Idempotent on
 * ``message_id`` (unique constraint on the shared table).
 */
export const saveRioPromptMessage = async (key: string,
    saveRioPromptMessageInput: SaveRioPromptMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<saveRioPromptMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<saveRioPromptMessageResponse>(getSaveRioPromptMessageUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveRioPromptMessageInput)
  }
);}





export const getSaveRioPromptMessageMutationKey = () => ['saveRioPromptMessage'] as const;

export const getSaveRioPromptMessageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRioPromptMessage>>, TError,SaveRioPromptMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveRioPromptMessage>>, TError,SaveRioPromptMessageMutationVariables, TContext> => {

const mutationKey = getSaveRioPromptMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRioPromptMessage>>, SaveRioPromptMessageMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  saveRioPromptMessage(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveRioPromptMessageMutationResult = NonNullable<Awaited<ReturnType<typeof saveRioPromptMessage>>>
    export type SaveRioPromptMessageMutationBody = SaveRioPromptMessageInput
    export type SaveRioPromptMessageMutationError = Error
    export type SaveRioPromptMessageMutationVariables = {key: string;data: SaveRioPromptMessageInput}

    export const useSaveRioPromptMessage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRioPromptMessage>>, TError,SaveRioPromptMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveRioPromptMessage>>,
        TError,
        SaveRioPromptMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSaveRioPromptMessageMutationOptions(options), queryClient);
    }

export type sendRioPromptMessageResponse200 = {
  data: SendRioPromptMessageOutput
  status: 200
}

export type sendRioPromptMessageResponse400 = {
  data: Error
  status: 400
}

export type sendRioPromptMessageResponse409 = {
  data: Error
  status: 409
}

export type sendRioPromptMessageResponseSuccess = (sendRioPromptMessageResponse200) & {
  headers: Headers;
};
export type sendRioPromptMessageResponseError = (sendRioPromptMessageResponse400 | sendRioPromptMessageResponse409) & {
  headers: Headers;
};

export type sendRioPromptMessageResponse = (sendRioPromptMessageResponseSuccess | sendRioPromptMessageResponseError)

export const getSendRioPromptMessageUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/rio/send`
}

/**
 * POST /api/basecamp/prompts/<key>/rio/send — SPA-facing.
 *
 * Signal-with-start: boots (or attaches to) the
 * ``RioPromptConversationWorkflow`` for this prompt and delivers the
 * user message as a ``user_message`` signal. Returns 202 immediately;
 * the SPA polls ``/rio/messages`` for the assistant reply.
 */
export const sendRioPromptMessage = async (key: string,
    sendRioPromptMessageInput: SendRioPromptMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<sendRioPromptMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<sendRioPromptMessageResponse>(getSendRioPromptMessageUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendRioPromptMessageInput)
  }
);}





export const getSendRioPromptMessageMutationKey = () => ['sendRioPromptMessage'] as const;

export const getSendRioPromptMessageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRioPromptMessage>>, TError,SendRioPromptMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRioPromptMessage>>, TError,SendRioPromptMessageMutationVariables, TContext> => {

const mutationKey = getSendRioPromptMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRioPromptMessage>>, SendRioPromptMessageMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  sendRioPromptMessage(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendRioPromptMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendRioPromptMessage>>>
    export type SendRioPromptMessageMutationBody = SendRioPromptMessageInput
    export type SendRioPromptMessageMutationError = Error
    export type SendRioPromptMessageMutationVariables = {key: string;data: SendRioPromptMessageInput}

    export const useSendRioPromptMessage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRioPromptMessage>>, TError,SendRioPromptMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendRioPromptMessage>>,
        TError,
        SendRioPromptMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSendRioPromptMessageMutationOptions(options), queryClient);
    }

export type listPromptTestRunsResponse200 = {
  data: PromptTestRun[]
  status: 200
}

export type listPromptTestRunsResponse400 = {
  data: Error
  status: 400
}

export type listPromptTestRunsResponseSuccess = (listPromptTestRunsResponse200) & {
  headers: Headers;
};
export type listPromptTestRunsResponseError = (listPromptTestRunsResponse400) & {
  headers: Headers;
};

export type listPromptTestRunsResponse = (listPromptTestRunsResponseSuccess | listPromptTestRunsResponseError)

export const getListPromptTestRunsUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/test-runs`
}

/**
 * POST to start a run, GET to list runs for this prompt.
 */
export const listPromptTestRuns = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<listPromptTestRunsResponse> => {

  return customFetch<listPromptTestRunsResponse>(getListPromptTestRunsUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptTestRunsQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/test-runs`
    ] as const;
    }


export const getListPromptTestRunsQueryOptions = <TData = Awaited<ReturnType<typeof listPromptTestRuns>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptTestRunsQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptTestRuns>>> = ({ signal }) => listPromptTestRuns(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptTestRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptTestRuns>>>
export type ListPromptTestRunsQueryError = Error


export function useListPromptTestRuns<TData = Awaited<ReturnType<typeof listPromptTestRuns>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptTestRuns>>,
          TError,
          Awaited<ReturnType<typeof listPromptTestRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptTestRuns<TData = Awaited<ReturnType<typeof listPromptTestRuns>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptTestRuns>>,
          TError,
          Awaited<ReturnType<typeof listPromptTestRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptTestRuns<TData = Awaited<ReturnType<typeof listPromptTestRuns>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromptTestRuns<TData = Awaited<ReturnType<typeof listPromptTestRuns>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRuns>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptTestRunsQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startPromptTestRunResponse200 = {
  data: PromptTestRun
  status: 200
}

export type startPromptTestRunResponse400 = {
  data: Error
  status: 400
}

export type startPromptTestRunResponseSuccess = (startPromptTestRunResponse200) & {
  headers: Headers;
};
export type startPromptTestRunResponseError = (startPromptTestRunResponse400) & {
  headers: Headers;
};

export type startPromptTestRunResponse = (startPromptTestRunResponseSuccess | startPromptTestRunResponseError)

export const getStartPromptTestRunUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/test-runs`
}

/**
 * POST to start a run, GET to list runs for this prompt.
 */
export const startPromptTestRun = async (key: string,
    startPromptTestRunInput?: StartPromptTestRunInput, options?: Parameters<typeof customFetch>[1]): Promise<startPromptTestRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startPromptTestRunResponse>(getStartPromptTestRunUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startPromptTestRunInput)
  }
);}





export const getStartPromptTestRunMutationKey = () => ['startPromptTestRun'] as const;

export const getStartPromptTestRunMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptTestRun>>, TError,StartPromptTestRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPromptTestRun>>, TError,StartPromptTestRunMutationVariables, TContext> => {

const mutationKey = getStartPromptTestRunMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPromptTestRun>>, StartPromptTestRunMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  startPromptTestRun(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPromptTestRunMutationResult = NonNullable<Awaited<ReturnType<typeof startPromptTestRun>>>
    export type StartPromptTestRunMutationBody = StartPromptTestRunInput | undefined
    export type StartPromptTestRunMutationError = Error
    export type StartPromptTestRunMutationVariables = {key: string;data?: StartPromptTestRunInput}

    export const useStartPromptTestRun = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptTestRun>>, TError,StartPromptTestRunMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPromptTestRun>>,
        TError,
        StartPromptTestRunMutationVariables,
        TContext
      > => {
      return useMutation(getStartPromptTestRunMutationOptions(options), queryClient);
    }

export type getPromptTestRunResponse200 = {
  data: PromptTestRun
  status: 200
}

export type getPromptTestRunResponse400 = {
  data: Error
  status: 400
}

export type getPromptTestRunResponseSuccess = (getPromptTestRunResponse200) & {
  headers: Headers;
};
export type getPromptTestRunResponseError = (getPromptTestRunResponse400) & {
  headers: Headers;
};

export type getPromptTestRunResponse = (getPromptTestRunResponseSuccess | getPromptTestRunResponseError)

export const getGetPromptTestRunUrl = (key: string,
    runId: number,) => {




  return `/api/basecamp/prompts/${key}/test-runs/${runId}`
}

/**
 * Read one run. Poll Temporal on read; persist state transitions.
 */
export const getPromptTestRun = async (key: string,
    runId: number, options?: Parameters<typeof customFetch>[1]): Promise<getPromptTestRunResponse> => {

  return customFetch<getPromptTestRunResponse>(getGetPromptTestRunUrl(key,runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptTestRunQueryKey = (key: string,
    runId: number,) => {
    return [
    `/api/basecamp/prompts/${key}/test-runs/${runId}`
    ] as const;
    }


export const getGetPromptTestRunQueryOptions = <TData = Awaited<ReturnType<typeof getPromptTestRun>>, TError = Error>(key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptTestRunQueryKey(key,runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptTestRun>>> = ({ signal }) => getPromptTestRun(key,runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined && runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRun>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptTestRunQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptTestRun>>>
export type GetPromptTestRunQueryError = Error


export function useGetPromptTestRun<TData = Awaited<ReturnType<typeof getPromptTestRun>>, TError = Error>(
 key: string,
    runId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRun>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptTestRun>>,
          TError,
          Awaited<ReturnType<typeof getPromptTestRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptTestRun<TData = Awaited<ReturnType<typeof getPromptTestRun>>, TError = Error>(
 key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRun>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptTestRun>>,
          TError,
          Awaited<ReturnType<typeof getPromptTestRun>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptTestRun<TData = Awaited<ReturnType<typeof getPromptTestRun>>, TError = Error>(
 key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptTestRun<TData = Awaited<ReturnType<typeof getPromptTestRun>>, TError = Error>(
 key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRun>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptTestRunQueryOptions(key,runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getPromptTestRunM2mResponse200 = {
  data: PromptTestRun
  status: 200
}

export type getPromptTestRunM2mResponse400 = {
  data: Error
  status: 400
}

export type getPromptTestRunM2mResponseSuccess = (getPromptTestRunM2mResponse200) & {
  headers: Headers;
};
export type getPromptTestRunM2mResponseError = (getPromptTestRunM2mResponse400) & {
  headers: Headers;
};

export type getPromptTestRunM2mResponse = (getPromptTestRunM2mResponseSuccess | getPromptTestRunM2mResponseError)

export const getGetPromptTestRunM2mUrl = (key: string,
    runId: number,) => {




  return `/api/basecamp/prompts/${key}/test-runs/${runId}/m2m`
}

/**
 * Temporal M2M sibling of ``PromptTestRunDetailView``. Same
 * Temporal-refresh-on-read semantics; only the auth differs.
 */
export const getPromptTestRunM2m = async (key: string,
    runId: number, options?: Parameters<typeof customFetch>[1]): Promise<getPromptTestRunM2mResponse> => {

  return customFetch<getPromptTestRunM2mResponse>(getGetPromptTestRunM2mUrl(key,runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptTestRunM2mQueryKey = (key: string,
    runId: number,) => {
    return [
    `/api/basecamp/prompts/${key}/test-runs/${runId}/m2m`
    ] as const;
    }


export const getGetPromptTestRunM2mQueryOptions = <TData = Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError = Error>(key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptTestRunM2mQueryKey(key,runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptTestRunM2m>>> = ({ signal }) => getPromptTestRunM2m(key,runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined && runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptTestRunM2mQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptTestRunM2m>>>
export type GetPromptTestRunM2mQueryError = Error


export function useGetPromptTestRunM2m<TData = Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError = Error>(
 key: string,
    runId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptTestRunM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptTestRunM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptTestRunM2m<TData = Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError = Error>(
 key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptTestRunM2m>>,
          TError,
          Awaited<ReturnType<typeof getPromptTestRunM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptTestRunM2m<TData = Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError = Error>(
 key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptTestRunM2m<TData = Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError = Error>(
 key: string,
    runId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestRunM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptTestRunM2mQueryOptions(key,runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listPromptTestRunsM2mResponse200 = {
  data: PromptTestRun[]
  status: 200
}

export type listPromptTestRunsM2mResponse400 = {
  data: Error
  status: 400
}

export type listPromptTestRunsM2mResponseSuccess = (listPromptTestRunsM2mResponse200) & {
  headers: Headers;
};
export type listPromptTestRunsM2mResponseError = (listPromptTestRunsM2mResponse400) & {
  headers: Headers;
};

export type listPromptTestRunsM2mResponse = (listPromptTestRunsM2mResponseSuccess | listPromptTestRunsM2mResponseError)

export const getListPromptTestRunsM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/test-runs/m2m`
}

/**
 * Temporal M2M sibling of ``PromptTestRunsView``.
 *
 * - ``GET`` — list this prompt's most recent runs (``?limit=`` supported).
 *   Rio's ``list_recent_test_runs`` tool uses this.
 * - ``POST`` — start a run. Slimmer payload than the SPA (see
 *   ``StartPromptTestRunM2MInputSerializer``); the workflow launch
 *   itself is identical to the SPA path.
 *
 * Response shape wraps the list under ``results`` (mirrors the pattern
 * Rio's basecamp client already expects for the search + profile
 * listing endpoints).
 */
export const listPromptTestRunsM2m = async (key: string, options?: Parameters<typeof customFetch>[1]): Promise<listPromptTestRunsM2mResponse> => {

  return customFetch<listPromptTestRunsM2mResponse>(getListPromptTestRunsM2mUrl(key),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptTestRunsM2mQueryKey = (key: string,) => {
    return [
    `/api/basecamp/prompts/${key}/test-runs/m2m`
    ] as const;
    }


export const getListPromptTestRunsM2mQueryOptions = <TData = Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError = Error>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptTestRunsM2mQueryKey(key);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptTestRunsM2m>>> = ({ signal }) => listPromptTestRunsM2m(key, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: key !== null && key !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptTestRunsM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptTestRunsM2m>>>
export type ListPromptTestRunsM2mQueryError = Error


export function useListPromptTestRunsM2m<TData = Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError = Error>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptTestRunsM2m>>,
          TError,
          Awaited<ReturnType<typeof listPromptTestRunsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptTestRunsM2m<TData = Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptTestRunsM2m>>,
          TError,
          Awaited<ReturnType<typeof listPromptTestRunsM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptTestRunsM2m<TData = Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromptTestRunsM2m<TData = Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError = Error>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTestRunsM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptTestRunsM2mQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startPromptTestRunM2mResponse200 = {
  data: PromptTestRun
  status: 200
}

export type startPromptTestRunM2mResponse400 = {
  data: Error
  status: 400
}

export type startPromptTestRunM2mResponseSuccess = (startPromptTestRunM2mResponse200) & {
  headers: Headers;
};
export type startPromptTestRunM2mResponseError = (startPromptTestRunM2mResponse400) & {
  headers: Headers;
};

export type startPromptTestRunM2mResponse = (startPromptTestRunM2mResponseSuccess | startPromptTestRunM2mResponseError)

export const getStartPromptTestRunM2mUrl = (key: string,) => {




  return `/api/basecamp/prompts/${key}/test-runs/m2m`
}

/**
 * Temporal M2M sibling of ``PromptTestRunsView``.
 *
 * - ``GET`` — list this prompt's most recent runs (``?limit=`` supported).
 *   Rio's ``list_recent_test_runs`` tool uses this.
 * - ``POST`` — start a run. Slimmer payload than the SPA (see
 *   ``StartPromptTestRunM2MInputSerializer``); the workflow launch
 *   itself is identical to the SPA path.
 *
 * Response shape wraps the list under ``results`` (mirrors the pattern
 * Rio's basecamp client already expects for the search + profile
 * listing endpoints).
 */
export const startPromptTestRunM2m = async (key: string,
    startPromptTestRunM2MInput: StartPromptTestRunM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<startPromptTestRunM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startPromptTestRunM2mResponse>(getStartPromptTestRunM2mUrl(key),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startPromptTestRunM2MInput)
  }
);}





export const getStartPromptTestRunM2mMutationKey = () => ['startPromptTestRunM2m'] as const;

export const getStartPromptTestRunM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptTestRunM2m>>, TError,StartPromptTestRunM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPromptTestRunM2m>>, TError,StartPromptTestRunM2mMutationVariables, TContext> => {

const mutationKey = getStartPromptTestRunM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPromptTestRunM2m>>, StartPromptTestRunM2mMutationVariables> = (props) => {
          const {key,data} = props ?? {};

          return  startPromptTestRunM2m(key,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPromptTestRunM2mMutationResult = NonNullable<Awaited<ReturnType<typeof startPromptTestRunM2m>>>
    export type StartPromptTestRunM2mMutationBody = StartPromptTestRunM2MInput
    export type StartPromptTestRunM2mMutationError = Error
    export type StartPromptTestRunM2mMutationVariables = {key: string;data: StartPromptTestRunM2MInput}

    export const useStartPromptTestRunM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptTestRunM2m>>, TError,StartPromptTestRunM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPromptTestRunM2m>>,
        TError,
        StartPromptTestRunM2mMutationVariables,
        TContext
      > => {
      return useMutation(getStartPromptTestRunM2mMutationOptions(options), queryClient);
    }

export type listAvailableInputsResponse200 = {
  data: AvailableInputsOutput
  status: 200
}

export type listAvailableInputsResponseSuccess = (listAvailableInputsResponse200) & {
  headers: Headers;
};
;

export type listAvailableInputsResponse = (listAvailableInputsResponseSuccess)

export const getListAvailableInputsUrl = () => {




  return `/api/basecamp/prompts/available-inputs`
}

/**
 * GET /api/basecamp/prompts/available-inputs
 *
 * Returns the full set of input keys from the api-django registry mirror
 * (same source basecamp's prompt-detail page already loads from). No
 * GitHub round-trip needed — reads from disk cache.
 */
export const listAvailableInputs = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAvailableInputsResponse> => {

  return customFetch<listAvailableInputsResponse>(getListAvailableInputsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAvailableInputsQueryKey = () => {
    return [
    `/api/basecamp/prompts/available-inputs`
    ] as const;
    }


export const getListAvailableInputsQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableInputs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableInputs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableInputsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableInputs>>> = ({ signal }) => listAvailableInputs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableInputs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAvailableInputsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableInputs>>>
export type ListAvailableInputsQueryError = unknown


export function useListAvailableInputs<TData = Awaited<ReturnType<typeof listAvailableInputs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableInputs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableInputs>>,
          TError,
          Awaited<ReturnType<typeof listAvailableInputs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableInputs<TData = Awaited<ReturnType<typeof listAvailableInputs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableInputs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableInputs>>,
          TError,
          Awaited<ReturnType<typeof listAvailableInputs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableInputs<TData = Awaited<ReturnType<typeof listAvailableInputs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableInputs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAvailableInputs<TData = Awaited<ReturnType<typeof listAvailableInputs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableInputs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableInputsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAvailableRolesResponse200 = {
  data: KeyedLookupsOutput
  status: 200
}

export type listAvailableRolesResponse502 = {
  data: Error
  status: 502
}

export type listAvailableRolesResponseSuccess = (listAvailableRolesResponse200) & {
  headers: Headers;
};
export type listAvailableRolesResponseError = (listAvailableRolesResponse502) & {
  headers: Headers;
};

export type listAvailableRolesResponse = (listAvailableRolesResponseSuccess | listAvailableRolesResponseError)

export const getListAvailableRolesUrl = () => {




  return `/api/basecamp/prompts/available-roles`
}

/**
 * GET /api/basecamp/prompts/available-roles
 *
 * Returns the current set of role keys + resolved text from pipelines'
 * ``prompts/roles/*.yaml``. Live fetch per dialog-open — the set is small
 * (~5 entries) and rarely changes. Add caching if that changes.
 */
export const listAvailableRoles = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAvailableRolesResponse> => {

  return customFetch<listAvailableRolesResponse>(getListAvailableRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAvailableRolesQueryKey = () => {
    return [
    `/api/basecamp/prompts/available-roles`
    ] as const;
    }


export const getListAvailableRolesQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableRoles>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableRoles>>> = ({ signal }) => listAvailableRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAvailableRolesQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableRoles>>>
export type ListAvailableRolesQueryError = Error


export function useListAvailableRoles<TData = Awaited<ReturnType<typeof listAvailableRoles>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableRoles>>,
          TError,
          Awaited<ReturnType<typeof listAvailableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableRoles<TData = Awaited<ReturnType<typeof listAvailableRoles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableRoles>>,
          TError,
          Awaited<ReturnType<typeof listAvailableRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableRoles<TData = Awaited<ReturnType<typeof listAvailableRoles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAvailableRoles<TData = Awaited<ReturnType<typeof listAvailableRoles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableRoles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAvailableTechnicalInstructionsResponse200 = {
  data: KeyedLookupsOutput
  status: 200
}

export type listAvailableTechnicalInstructionsResponse502 = {
  data: Error
  status: 502
}

export type listAvailableTechnicalInstructionsResponseSuccess = (listAvailableTechnicalInstructionsResponse200) & {
  headers: Headers;
};
export type listAvailableTechnicalInstructionsResponseError = (listAvailableTechnicalInstructionsResponse502) & {
  headers: Headers;
};

export type listAvailableTechnicalInstructionsResponse = (listAvailableTechnicalInstructionsResponseSuccess | listAvailableTechnicalInstructionsResponseError)

export const getListAvailableTechnicalInstructionsUrl = () => {




  return `/api/basecamp/prompts/available-technical-instructions`
}

/**
 * GET /api/basecamp/prompts/available-technical-instructions
 *
 * Keyed-lookup catalog for the ``technical_instructions`` field. Note
 * that unlike ``templated_instructions``, this field also accepts a
 * literal fallback (pipelines' ``_resolved_technical_instructions`` uses
 * the raw yaml value if it doesn't match a key). The SPA's picker still
 * surfaces "custom" for that case.
 */
export const listAvailableTechnicalInstructions = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAvailableTechnicalInstructionsResponse> => {

  return customFetch<listAvailableTechnicalInstructionsResponse>(getListAvailableTechnicalInstructionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAvailableTechnicalInstructionsQueryKey = () => {
    return [
    `/api/basecamp/prompts/available-technical-instructions`
    ] as const;
    }


export const getListAvailableTechnicalInstructionsQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableTechnicalInstructionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>> = ({ signal }) => listAvailableTechnicalInstructions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAvailableTechnicalInstructionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>>
export type ListAvailableTechnicalInstructionsQueryError = Error


export function useListAvailableTechnicalInstructions<TData = Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>,
          TError,
          Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableTechnicalInstructions<TData = Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>,
          TError,
          Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableTechnicalInstructions<TData = Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAvailableTechnicalInstructions<TData = Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTechnicalInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableTechnicalInstructionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listAvailableTemplatedInstructionsResponse200 = {
  data: KeyedLookupsOutput
  status: 200
}

export type listAvailableTemplatedInstructionsResponse502 = {
  data: Error
  status: 502
}

export type listAvailableTemplatedInstructionsResponseSuccess = (listAvailableTemplatedInstructionsResponse200) & {
  headers: Headers;
};
export type listAvailableTemplatedInstructionsResponseError = (listAvailableTemplatedInstructionsResponse502) & {
  headers: Headers;
};

export type listAvailableTemplatedInstructionsResponse = (listAvailableTemplatedInstructionsResponseSuccess | listAvailableTemplatedInstructionsResponseError)

export const getListAvailableTemplatedInstructionsUrl = () => {




  return `/api/basecamp/prompts/available-templated-instructions`
}

/**
 * GET /api/basecamp/prompts/available-templated-instructions
 *
 * Keyed-lookup catalog for the ``templated_instructions`` field. Same
 * shape as roles — a small dict of short-name → full-text.
 */
export const listAvailableTemplatedInstructions = async ( options?: Parameters<typeof customFetch>[1]): Promise<listAvailableTemplatedInstructionsResponse> => {

  return customFetch<listAvailableTemplatedInstructionsResponse>(getListAvailableTemplatedInstructionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAvailableTemplatedInstructionsQueryKey = () => {
    return [
    `/api/basecamp/prompts/available-templated-instructions`
    ] as const;
    }


export const getListAvailableTemplatedInstructionsQueryOptions = <TData = Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAvailableTemplatedInstructionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>> = ({ signal }) => listAvailableTemplatedInstructions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAvailableTemplatedInstructionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>>
export type ListAvailableTemplatedInstructionsQueryError = Error


export function useListAvailableTemplatedInstructions<TData = Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>,
          TError,
          Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableTemplatedInstructions<TData = Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>,
          TError,
          Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAvailableTemplatedInstructions<TData = Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAvailableTemplatedInstructions<TData = Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAvailableTemplatedInstructions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAvailableTemplatedInstructionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createPromptResponse201 = {
  data: PromptOutput
  status: 201
}

export type createPromptResponse400 = {
  data: Error
  status: 400
}

export type createPromptResponseSuccess = (createPromptResponse201) & {
  headers: Headers;
};
export type createPromptResponseError = (createPromptResponse400) & {
  headers: Headers;
};

export type createPromptResponse = (createPromptResponseSuccess | createPromptResponseError)

export const getCreatePromptUrl = () => {




  return `/api/basecamp/prompts/create`
}

export const createPrompt = async (createPromptInput: CreatePromptInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptResponse>(getCreatePromptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptInput)
  }
);}





export const getCreatePromptMutationKey = () => ['createPrompt'] as const;

export const getCreatePromptMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPrompt>>, TError,CreatePromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPrompt>>, TError,CreatePromptMutationVariables, TContext> => {

const mutationKey = getCreatePromptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPrompt>>, CreatePromptMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPrompt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptMutationResult = NonNullable<Awaited<ReturnType<typeof createPrompt>>>
    export type CreatePromptMutationBody = CreatePromptInput
    export type CreatePromptMutationError = Error
    export type CreatePromptMutationVariables = {data: CreatePromptInput}

    export const useCreatePrompt = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPrompt>>, TError,CreatePromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPrompt>>,
        TError,
        CreatePromptMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptMutationOptions(options), queryClient);
    }

export type createPromptWithPrResponse201 = {
  data: OpenPROutput
  status: 201
}

export type createPromptWithPrResponse400 = {
  data: Error
  status: 400
}

export type createPromptWithPrResponse409 = {
  data: Error
  status: 409
}

export type createPromptWithPrResponse502 = {
  data: Error
  status: 502
}

export type createPromptWithPrResponseSuccess = (createPromptWithPrResponse201) & {
  headers: Headers;
};
export type createPromptWithPrResponseError = (createPromptWithPrResponse400 | createPromptWithPrResponse409 | createPromptWithPrResponse502) & {
  headers: Headers;
};

export type createPromptWithPrResponse = (createPromptWithPrResponseSuccess | createPromptWithPrResponseError)

export const getCreatePromptWithPrUrl = () => {




  return `/api/basecamp/prompts/create-with-pr`
}

/**
 * POST /api/basecamp/prompts/create-with-pr
 *
 * Add a new prompt to the chosen yaml file, regen the registry, and open
 * paired pipelines + api-django PRs. The api-django PR includes an
 * auto-generated data migration that creates the ``Prompt`` DB row
 * attributed to the requesting user's ``Auth0User``.
 */
export const createPromptWithPr = async (createPromptWithPRInput: CreatePromptWithPRInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptWithPrResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptWithPrResponse>(getCreatePromptWithPrUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptWithPRInput)
  }
);}





export const getCreatePromptWithPrMutationKey = () => ['createPromptWithPr'] as const;

export const getCreatePromptWithPrMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPr>>, TError,CreatePromptWithPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPr>>, TError,CreatePromptWithPrMutationVariables, TContext> => {

const mutationKey = getCreatePromptWithPrMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromptWithPr>>, CreatePromptWithPrMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPromptWithPr(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptWithPrMutationResult = NonNullable<Awaited<ReturnType<typeof createPromptWithPr>>>
    export type CreatePromptWithPrMutationBody = CreatePromptWithPRInput
    export type CreatePromptWithPrMutationError = Error
    export type CreatePromptWithPrMutationVariables = {data: CreatePromptWithPRInput}

    export const useCreatePromptWithPr = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPr>>, TError,CreatePromptWithPrMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromptWithPr>>,
        TError,
        CreatePromptWithPrMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptWithPrMutationOptions(options), queryClient);
    }

export type createPromptWithPrBulkResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type createPromptWithPrBulkResponse400 = {
  data: Error
  status: 400
}

export type createPromptWithPrBulkResponse409 = {
  data: Error
  status: 409
}

export type createPromptWithPrBulkResponse502 = {
  data: Error
  status: 502
}

export type createPromptWithPrBulkResponseSuccess = (createPromptWithPrBulkResponse201) & {
  headers: Headers;
};
export type createPromptWithPrBulkResponseError = (createPromptWithPrBulkResponse400 | createPromptWithPrBulkResponse409 | createPromptWithPrBulkResponse502) & {
  headers: Headers;
};

export type createPromptWithPrBulkResponse = (createPromptWithPrBulkResponseSuccess | createPromptWithPrBulkResponseError)

export const getCreatePromptWithPrBulkUrl = () => {




  return `/api/basecamp/prompts/create-with-pr/bulk`
}

/**
 * POST /api/basecamp/prompts/create-with-pr/bulk
 *
 * Bulk sibling of ``CreatePromptWithPR`` (PROC-93). Add N new prompts
 * across their target yaml files in a SINGLE paired pipelines +
 * api-django PR. Groups entries by ``target_yaml_filename`` so a
 * single copy operation can split duplicates across multiple yamls
 * (e.g., a global one lands in ``global.yaml`` while the org-scoped
 * ones go to ``report_builder.yaml``).
 *
 * The api-django PR includes ONE auto-generated data migration file
 * with N ``Prompt.objects.get_or_create(...)`` blocks — cleaner than
 * N migration files fighting for numbering slots. Attribution goes
 * to the requester's ``Auth0User``.
 *
 * Same guardrails as the single-prompt path: unique keys, target
 * yaml files must exist, open PR conflict detection.
 */
export const createPromptWithPrBulk = async (createPromptWithPRBulkInput: CreatePromptWithPRBulkInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptWithPrBulkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptWithPrBulkResponse>(getCreatePromptWithPrBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptWithPRBulkInput)
  }
);}





export const getCreatePromptWithPrBulkMutationKey = () => ['createPromptWithPrBulk'] as const;

export const getCreatePromptWithPrBulkMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrBulk>>, TError,CreatePromptWithPrBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrBulk>>, TError,CreatePromptWithPrBulkMutationVariables, TContext> => {

const mutationKey = getCreatePromptWithPrBulkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromptWithPrBulk>>, CreatePromptWithPrBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPromptWithPrBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptWithPrBulkMutationResult = NonNullable<Awaited<ReturnType<typeof createPromptWithPrBulk>>>
    export type CreatePromptWithPrBulkMutationBody = CreatePromptWithPRBulkInput
    export type CreatePromptWithPrBulkMutationError = Error
    export type CreatePromptWithPrBulkMutationVariables = {data: CreatePromptWithPRBulkInput}

    export const useCreatePromptWithPrBulk = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrBulk>>, TError,CreatePromptWithPrBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromptWithPrBulk>>,
        TError,
        CreatePromptWithPrBulkMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptWithPrBulkMutationOptions(options), queryClient);
    }

export type createPromptsWithPrFromDraftsBulkResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type createPromptsWithPrFromDraftsBulkResponse400 = {
  data: Error
  status: 400
}

export type createPromptsWithPrFromDraftsBulkResponse409 = {
  data: Error
  status: 409
}

export type createPromptsWithPrFromDraftsBulkResponse502 = {
  data: Error
  status: 502
}

export type createPromptsWithPrFromDraftsBulkResponseSuccess = (createPromptsWithPrFromDraftsBulkResponse201) & {
  headers: Headers;
};
export type createPromptsWithPrFromDraftsBulkResponseError = (createPromptsWithPrFromDraftsBulkResponse400 | createPromptsWithPrFromDraftsBulkResponse409 | createPromptsWithPrFromDraftsBulkResponse502) & {
  headers: Headers;
};

export type createPromptsWithPrFromDraftsBulkResponse = (createPromptsWithPrFromDraftsBulkResponseSuccess | createPromptsWithPrFromDraftsBulkResponseError)

export const getCreatePromptsWithPrFromDraftsBulkUrl = () => {




  return `/api/basecamp/prompts/create-with-pr/bulk/from-drafts`
}

/**
 * SPA endpoint: bulk-open PR for N existing prompt drafts.
 *
 * Users draft prompts on basecamp (via the existing
 * ``CreatePrompt`` + ``PromptDraftView`` flow) which populates the
 * Prompt row's ``draft_overrides``. When the user is ready to ship
 * N of them together, this endpoint bundles all N into a single
 * paired pipelines + api-django PR (PROC-93).
 *
 * Distinct from ``CreatePromptWithPRBulk`` (the "author from
 * scratch" variant which takes full yaml bodies in the request)
 * and ``CreatePromptWithPRBulkM2M`` (the Temporal M2M variant used
 * by Rio). This SPA-auth variant reads bodies from ``draft_overrides``
 * so the checkbox UI on the Prompts list only has to send
 * ``{prompt_key, target_yaml_filename}`` per selected prompt.
 */
export const createPromptsWithPrFromDraftsBulk = async (createPromptsWithPRFromDraftsBulkInput: CreatePromptsWithPRFromDraftsBulkInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptsWithPrFromDraftsBulkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptsWithPrFromDraftsBulkResponse>(getCreatePromptsWithPrFromDraftsBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptsWithPRFromDraftsBulkInput)
  }
);}





export const getCreatePromptsWithPrFromDraftsBulkMutationKey = () => ['createPromptsWithPrFromDraftsBulk'] as const;

export const getCreatePromptsWithPrFromDraftsBulkMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptsWithPrFromDraftsBulk>>, TError,CreatePromptsWithPrFromDraftsBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromptsWithPrFromDraftsBulk>>, TError,CreatePromptsWithPrFromDraftsBulkMutationVariables, TContext> => {

const mutationKey = getCreatePromptsWithPrFromDraftsBulkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromptsWithPrFromDraftsBulk>>, CreatePromptsWithPrFromDraftsBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPromptsWithPrFromDraftsBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptsWithPrFromDraftsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof createPromptsWithPrFromDraftsBulk>>>
    export type CreatePromptsWithPrFromDraftsBulkMutationBody = CreatePromptsWithPRFromDraftsBulkInput
    export type CreatePromptsWithPrFromDraftsBulkMutationError = Error
    export type CreatePromptsWithPrFromDraftsBulkMutationVariables = {data: CreatePromptsWithPRFromDraftsBulkInput}

    export const useCreatePromptsWithPrFromDraftsBulk = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptsWithPrFromDraftsBulk>>, TError,CreatePromptsWithPrFromDraftsBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromptsWithPrFromDraftsBulk>>,
        TError,
        CreatePromptsWithPrFromDraftsBulkMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptsWithPrFromDraftsBulkMutationOptions(options), queryClient);
    }

export type createPromptWithPrBulkM2mResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type createPromptWithPrBulkM2mResponse400 = {
  data: Error
  status: 400
}

export type createPromptWithPrBulkM2mResponse409 = {
  data: Error
  status: 409
}

export type createPromptWithPrBulkM2mResponse502 = {
  data: Error
  status: 502
}

export type createPromptWithPrBulkM2mResponseSuccess = (createPromptWithPrBulkM2mResponse201) & {
  headers: Headers;
};
export type createPromptWithPrBulkM2mResponseError = (createPromptWithPrBulkM2mResponse400 | createPromptWithPrBulkM2mResponse409 | createPromptWithPrBulkM2mResponse502) & {
  headers: Headers;
};

export type createPromptWithPrBulkM2mResponse = (createPromptWithPrBulkM2mResponseSuccess | createPromptWithPrBulkM2mResponseError)

export const getCreatePromptWithPrBulkM2mUrl = () => {




  return `/api/basecamp/prompts/create-with-pr/bulk/m2m`
}

/**
 * Temporal M2M sibling of ``CreatePromptWithPRBulk`` (PROC-93).
 *
 * Rio's ``apply_bulk_duplicate_prompts`` tool sends
 * ``{prompts: [{prompt_key, target_yaml_filename}, ...]}`` — the yaml
 * fields for each new entry come from each prompt row's
 * ``draft_overrides``. Same delegation pattern as
 * ``CreatePromptWithPRM2M`` above but iterated across N rows.
 */
export const createPromptWithPrBulkM2m = async (createPromptWithPRBulkM2MInput: CreatePromptWithPRBulkM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptWithPrBulkM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptWithPrBulkM2mResponse>(getCreatePromptWithPrBulkM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptWithPRBulkM2MInput)
  }
);}





export const getCreatePromptWithPrBulkM2mMutationKey = () => ['createPromptWithPrBulkM2m'] as const;

export const getCreatePromptWithPrBulkM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrBulkM2m>>, TError,CreatePromptWithPrBulkM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrBulkM2m>>, TError,CreatePromptWithPrBulkM2mMutationVariables, TContext> => {

const mutationKey = getCreatePromptWithPrBulkM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromptWithPrBulkM2m>>, CreatePromptWithPrBulkM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPromptWithPrBulkM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptWithPrBulkM2mMutationResult = NonNullable<Awaited<ReturnType<typeof createPromptWithPrBulkM2m>>>
    export type CreatePromptWithPrBulkM2mMutationBody = CreatePromptWithPRBulkM2MInput
    export type CreatePromptWithPrBulkM2mMutationError = Error
    export type CreatePromptWithPrBulkM2mMutationVariables = {data: CreatePromptWithPRBulkM2MInput}

    export const useCreatePromptWithPrBulkM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrBulkM2m>>, TError,CreatePromptWithPrBulkM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromptWithPrBulkM2m>>,
        TError,
        CreatePromptWithPrBulkM2mMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptWithPrBulkM2mMutationOptions(options), queryClient);
    }

export type createPromptWithPrM2mResponse201 = {
  data: OpenPROutput
  status: 201
}

export type createPromptWithPrM2mResponse400 = {
  data: Error
  status: 400
}

export type createPromptWithPrM2mResponse409 = {
  data: Error
  status: 409
}

export type createPromptWithPrM2mResponse502 = {
  data: Error
  status: 502
}

export type createPromptWithPrM2mResponseSuccess = (createPromptWithPrM2mResponse201) & {
  headers: Headers;
};
export type createPromptWithPrM2mResponseError = (createPromptWithPrM2mResponse400 | createPromptWithPrM2mResponse409 | createPromptWithPrM2mResponse502) & {
  headers: Headers;
};

export type createPromptWithPrM2mResponse = (createPromptWithPrM2mResponseSuccess | createPromptWithPrM2mResponseError)

export const getCreatePromptWithPrM2mUrl = () => {




  return `/api/basecamp/prompts/create-with-pr/m2m`
}

/**
 * Temporal M2M sibling of ``CreatePromptWithPR``.
 *
 * Rio's ``apply_open_new_prompt_pr`` tool sends
 * ``{prompt_key, target_yaml_filename}`` — the yaml fields for the
 * new entry come from the row's ``draft_overrides``. Same delegation
 * pattern as ``EditPromptYamlAndOpenPRM2M`` above.
 */
export const createPromptWithPrM2m = async (createPromptWithPRM2MInput: CreatePromptWithPRM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptWithPrM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptWithPrM2mResponse>(getCreatePromptWithPrM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptWithPRM2MInput)
  }
);}





export const getCreatePromptWithPrM2mMutationKey = () => ['createPromptWithPrM2m'] as const;

export const getCreatePromptWithPrM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrM2m>>, TError,CreatePromptWithPrM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrM2m>>, TError,CreatePromptWithPrM2mMutationVariables, TContext> => {

const mutationKey = getCreatePromptWithPrM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromptWithPrM2m>>, CreatePromptWithPrM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPromptWithPrM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptWithPrM2mMutationResult = NonNullable<Awaited<ReturnType<typeof createPromptWithPrM2m>>>
    export type CreatePromptWithPrM2mMutationBody = CreatePromptWithPRM2MInput
    export type CreatePromptWithPrM2mMutationError = Error
    export type CreatePromptWithPrM2mMutationVariables = {data: CreatePromptWithPRM2MInput}

    export const useCreatePromptWithPrM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptWithPrM2m>>, TError,CreatePromptWithPrM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromptWithPrM2m>>,
        TError,
        CreatePromptWithPrM2mMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptWithPrM2mMutationOptions(options), queryClient);
    }

export type editPromptYamlAndOpenPrBulkResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type editPromptYamlAndOpenPrBulkResponse400 = {
  data: Error
  status: 400
}

export type editPromptYamlAndOpenPrBulkResponse404 = {
  data: Error
  status: 404
}

export type editPromptYamlAndOpenPrBulkResponse409 = {
  data: Error
  status: 409
}

export type editPromptYamlAndOpenPrBulkResponse502 = {
  data: Error
  status: 502
}

export type editPromptYamlAndOpenPrBulkResponseSuccess = (editPromptYamlAndOpenPrBulkResponse201) & {
  headers: Headers;
};
export type editPromptYamlAndOpenPrBulkResponseError = (editPromptYamlAndOpenPrBulkResponse400 | editPromptYamlAndOpenPrBulkResponse404 | editPromptYamlAndOpenPrBulkResponse409 | editPromptYamlAndOpenPrBulkResponse502) & {
  headers: Headers;
};

export type editPromptYamlAndOpenPrBulkResponse = (editPromptYamlAndOpenPrBulkResponseSuccess | editPromptYamlAndOpenPrBulkResponseError)

export const getEditPromptYamlAndOpenPrBulkUrl = () => {




  return `/api/basecamp/prompts/edit-with-pr/bulk`
}

/**
 * POST /api/basecamp/prompts/edit-with-pr/bulk
 *
 * Bulk sibling of ``EditPromptYamlAndOpenPR`` (PROC-102). Edit N
 * existing prompts across their owning yaml files in a SINGLE paired
 * pipelines + api-django PR. Groups entries by the yaml file that
 * owns each ``prompt_key`` so one load+edit+serialize pass runs per
 * file rather than N.
 *
 * Unlike the create-bulk sibling: no migration file, no ``instructions``
 * requirement (edits can be sparse — e.g., an ``inputs``-only tweak
 * on N prompts), and the target yaml is discovered from the current
 * yaml content rather than supplied per entry.
 */
export const editPromptYamlAndOpenPrBulk = async (editPromptYamlBulkInput: EditPromptYamlBulkInput, options?: Parameters<typeof customFetch>[1]): Promise<editPromptYamlAndOpenPrBulkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<editPromptYamlAndOpenPrBulkResponse>(getEditPromptYamlAndOpenPrBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editPromptYamlBulkInput)
  }
);}





export const getEditPromptYamlAndOpenPrBulkMutationKey = () => ['editPromptYamlAndOpenPrBulk'] as const;

export const getEditPromptYamlAndOpenPrBulkMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulk>>, TError,EditPromptYamlAndOpenPrBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulk>>, TError,EditPromptYamlAndOpenPrBulkMutationVariables, TContext> => {

const mutationKey = getEditPromptYamlAndOpenPrBulkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulk>>, EditPromptYamlAndOpenPrBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  editPromptYamlAndOpenPrBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPromptYamlAndOpenPrBulkMutationResult = NonNullable<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulk>>>
    export type EditPromptYamlAndOpenPrBulkMutationBody = EditPromptYamlBulkInput
    export type EditPromptYamlAndOpenPrBulkMutationError = Error
    export type EditPromptYamlAndOpenPrBulkMutationVariables = {data: EditPromptYamlBulkInput}

    export const useEditPromptYamlAndOpenPrBulk = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulk>>, TError,EditPromptYamlAndOpenPrBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulk>>,
        TError,
        EditPromptYamlAndOpenPrBulkMutationVariables,
        TContext
      > => {
      return useMutation(getEditPromptYamlAndOpenPrBulkMutationOptions(options), queryClient);
    }

export type editPromptsWithPrFromDraftsBulkResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type editPromptsWithPrFromDraftsBulkResponse400 = {
  data: Error
  status: 400
}

export type editPromptsWithPrFromDraftsBulkResponse404 = {
  data: Error
  status: 404
}

export type editPromptsWithPrFromDraftsBulkResponse409 = {
  data: Error
  status: 409
}

export type editPromptsWithPrFromDraftsBulkResponse502 = {
  data: Error
  status: 502
}

export type editPromptsWithPrFromDraftsBulkResponseSuccess = (editPromptsWithPrFromDraftsBulkResponse201) & {
  headers: Headers;
};
export type editPromptsWithPrFromDraftsBulkResponseError = (editPromptsWithPrFromDraftsBulkResponse400 | editPromptsWithPrFromDraftsBulkResponse404 | editPromptsWithPrFromDraftsBulkResponse409 | editPromptsWithPrFromDraftsBulkResponse502) & {
  headers: Headers;
};

export type editPromptsWithPrFromDraftsBulkResponse = (editPromptsWithPrFromDraftsBulkResponseSuccess | editPromptsWithPrFromDraftsBulkResponseError)

export const getEditPromptsWithPrFromDraftsBulkUrl = () => {




  return `/api/basecamp/prompts/edit-with-pr/bulk/from-drafts`
}

/**
 * SPA endpoint: bulk-open EDIT PR for N existing prompts' drafts
 * (PROC-102).
 *
 * Symmetrical to ``CreatePromptsWithPRFromDraftsBulk`` but for the
 * edit flow. Accepts ``{prompts: [{prompt_key}, ...]}`` and sources
 * each entry's edits from that Prompt row's ``draft_overrides``.
 *
 * Reserved for a future basecamp UI that lets users select multiple
 * prompts-with-drafts to bundle into one edit PR. Rio hits the M2M
 * variant below.
 */
export const editPromptsWithPrFromDraftsBulk = async (editPromptsWithPRFromDraftsBulkInput: EditPromptsWithPRFromDraftsBulkInput, options?: Parameters<typeof customFetch>[1]): Promise<editPromptsWithPrFromDraftsBulkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<editPromptsWithPrFromDraftsBulkResponse>(getEditPromptsWithPrFromDraftsBulkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editPromptsWithPRFromDraftsBulkInput)
  }
);}





export const getEditPromptsWithPrFromDraftsBulkMutationKey = () => ['editPromptsWithPrFromDraftsBulk'] as const;

export const getEditPromptsWithPrFromDraftsBulkMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptsWithPrFromDraftsBulk>>, TError,EditPromptsWithPrFromDraftsBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPromptsWithPrFromDraftsBulk>>, TError,EditPromptsWithPrFromDraftsBulkMutationVariables, TContext> => {

const mutationKey = getEditPromptsWithPrFromDraftsBulkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPromptsWithPrFromDraftsBulk>>, EditPromptsWithPrFromDraftsBulkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  editPromptsWithPrFromDraftsBulk(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPromptsWithPrFromDraftsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof editPromptsWithPrFromDraftsBulk>>>
    export type EditPromptsWithPrFromDraftsBulkMutationBody = EditPromptsWithPRFromDraftsBulkInput
    export type EditPromptsWithPrFromDraftsBulkMutationError = Error
    export type EditPromptsWithPrFromDraftsBulkMutationVariables = {data: EditPromptsWithPRFromDraftsBulkInput}

    export const useEditPromptsWithPrFromDraftsBulk = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptsWithPrFromDraftsBulk>>, TError,EditPromptsWithPrFromDraftsBulkMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPromptsWithPrFromDraftsBulk>>,
        TError,
        EditPromptsWithPrFromDraftsBulkMutationVariables,
        TContext
      > => {
      return useMutation(getEditPromptsWithPrFromDraftsBulkMutationOptions(options), queryClient);
    }

export type editPromptYamlAndOpenPrBulkM2mResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type editPromptYamlAndOpenPrBulkM2mResponse400 = {
  data: Error
  status: 400
}

export type editPromptYamlAndOpenPrBulkM2mResponse404 = {
  data: Error
  status: 404
}

export type editPromptYamlAndOpenPrBulkM2mResponse409 = {
  data: Error
  status: 409
}

export type editPromptYamlAndOpenPrBulkM2mResponse502 = {
  data: Error
  status: 502
}

export type editPromptYamlAndOpenPrBulkM2mResponseSuccess = (editPromptYamlAndOpenPrBulkM2mResponse201) & {
  headers: Headers;
};
export type editPromptYamlAndOpenPrBulkM2mResponseError = (editPromptYamlAndOpenPrBulkM2mResponse400 | editPromptYamlAndOpenPrBulkM2mResponse404 | editPromptYamlAndOpenPrBulkM2mResponse409 | editPromptYamlAndOpenPrBulkM2mResponse502) & {
  headers: Headers;
};

export type editPromptYamlAndOpenPrBulkM2mResponse = (editPromptYamlAndOpenPrBulkM2mResponseSuccess | editPromptYamlAndOpenPrBulkM2mResponseError)

export const getEditPromptYamlAndOpenPrBulkM2mUrl = () => {




  return `/api/basecamp/prompts/edit-with-pr/bulk/m2m`
}

/**
 * Temporal M2M sibling of ``EditPromptYamlAndOpenPRBulk`` (PROC-102).
 *
 * Rio's ``apply_open_edit_prompts_pr`` tool sends
 * ``{prompts: [{prompt_key}, ...]}`` — every entry's edits come from
 * that prompt row's ``draft_overrides``. Same delegation pattern as
 * ``EditPromptYamlAndOpenPRM2M`` but iterated across N rows and
 * without the ``instructions``-required guard (edits are sparse by
 * design).
 */
export const editPromptYamlAndOpenPrBulkM2m = async (editPromptYamlAndOpenPRBulkM2MInput: EditPromptYamlAndOpenPRBulkM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<editPromptYamlAndOpenPrBulkM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<editPromptYamlAndOpenPrBulkM2mResponse>(getEditPromptYamlAndOpenPrBulkM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editPromptYamlAndOpenPRBulkM2MInput)
  }
);}





export const getEditPromptYamlAndOpenPrBulkM2mMutationKey = () => ['editPromptYamlAndOpenPrBulkM2m'] as const;

export const getEditPromptYamlAndOpenPrBulkM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulkM2m>>, TError,EditPromptYamlAndOpenPrBulkM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulkM2m>>, TError,EditPromptYamlAndOpenPrBulkM2mMutationVariables, TContext> => {

const mutationKey = getEditPromptYamlAndOpenPrBulkM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulkM2m>>, EditPromptYamlAndOpenPrBulkM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  editPromptYamlAndOpenPrBulkM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EditPromptYamlAndOpenPrBulkM2mMutationResult = NonNullable<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulkM2m>>>
    export type EditPromptYamlAndOpenPrBulkM2mMutationBody = EditPromptYamlAndOpenPRBulkM2MInput
    export type EditPromptYamlAndOpenPrBulkM2mMutationError = Error
    export type EditPromptYamlAndOpenPrBulkM2mMutationVariables = {data: EditPromptYamlAndOpenPRBulkM2MInput}

    export const useEditPromptYamlAndOpenPrBulkM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulkM2m>>, TError,EditPromptYamlAndOpenPrBulkM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editPromptYamlAndOpenPrBulkM2m>>,
        TError,
        EditPromptYamlAndOpenPrBulkM2mMutationVariables,
        TContext
      > => {
      return useMutation(getEditPromptYamlAndOpenPrBulkM2mMutationOptions(options), queryClient);
    }

export type createPromptM2mResponse201 = {
  data: PromptOutput
  status: 201
}

export type createPromptM2mResponse400 = {
  data: Error
  status: 400
}

export type createPromptM2mResponseSuccess = (createPromptM2mResponse201) & {
  headers: Headers;
};
export type createPromptM2mResponseError = (createPromptM2mResponse400) & {
  headers: Headers;
};

export type createPromptM2mResponse = (createPromptM2mResponseSuccess | createPromptM2mResponseError)

export const getCreatePromptM2mUrl = () => {




  return `/api/basecamp/prompts/m2m`
}

/**
 * Temporal M2M sibling of ``CreatePrompt``.
 *
 * Same DB write as the SPA endpoint; different auth. Used by Rio's
 * ``apply_create_prompt`` tool.
 *
 * Attribution: ``created_by`` defaults to ``request.user`` (whatever
 * Auth0User the M2M token resolves to). Optionally accepts
 * ``requesting_user_auth0id`` in the payload — when Rio can plumb
 * the acting user's auth0id through the workflow, that field will
 * override the default so the row shows the real human as creator.
 */
export const createPromptM2m = async (createPromptM2MInput: CreatePromptM2MInput, options?: Parameters<typeof customFetch>[1]): Promise<createPromptM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createPromptM2mResponse>(getCreatePromptM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPromptM2MInput)
  }
);}





export const getCreatePromptM2mMutationKey = () => ['createPromptM2m'] as const;

export const getCreatePromptM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptM2m>>, TError,CreatePromptM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPromptM2m>>, TError,CreatePromptM2mMutationVariables, TContext> => {

const mutationKey = getCreatePromptM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPromptM2m>>, CreatePromptM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPromptM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePromptM2mMutationResult = NonNullable<Awaited<ReturnType<typeof createPromptM2m>>>
    export type CreatePromptM2mMutationBody = CreatePromptM2MInput
    export type CreatePromptM2mMutationError = Error
    export type CreatePromptM2mMutationVariables = {data: CreatePromptM2MInput}

    export const useCreatePromptM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPromptM2m>>, TError,CreatePromptM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPromptM2m>>,
        TError,
        CreatePromptM2mMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePromptM2mMutationOptions(options), queryClient);
    }

export type openPromptsPrBulkFromDraftsResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type openPromptsPrBulkFromDraftsResponse400 = {
  data: Error
  status: 400
}

export type openPromptsPrBulkFromDraftsResponse404 = {
  data: Error
  status: 404
}

export type openPromptsPrBulkFromDraftsResponse409 = {
  data: Error
  status: 409
}

export type openPromptsPrBulkFromDraftsResponse502 = {
  data: Error
  status: 502
}

export type openPromptsPrBulkFromDraftsResponseSuccess = (openPromptsPrBulkFromDraftsResponse201) & {
  headers: Headers;
};
export type openPromptsPrBulkFromDraftsResponseError = (openPromptsPrBulkFromDraftsResponse400 | openPromptsPrBulkFromDraftsResponse404 | openPromptsPrBulkFromDraftsResponse409 | openPromptsPrBulkFromDraftsResponse502) & {
  headers: Headers;
};

export type openPromptsPrBulkFromDraftsResponse = (openPromptsPrBulkFromDraftsResponseSuccess | openPromptsPrBulkFromDraftsResponseError)

export const getOpenPromptsPrBulkFromDraftsUrl = () => {




  return `/api/basecamp/prompts/open-pr/bulk/from-drafts`
}

/**
 * POST /api/basecamp/prompts/open-pr/bulk/from-drafts (PROC-102)
 *
 * THE bulk-PR endpoint for the SPA — handles any mix of already-in-yaml
 * prompts (surgical-edit) and brand-new prompts (yaml-append + data
 * migration) in a SINGLE paired pipelines + api-django PR.
 *
 * Input: ``{prompts: [{prompt_key, target_yaml_filename?}]}``.
 * ``target_yaml_filename`` is REQUIRED for entries whose key isn't
 * in the shipped registry (new), IGNORED for entries whose key is
 * already there (existing).
 *
 * Distinct from ``CreatePromptsWithPRFromDraftsBulk`` (create-only,
 * PROC-93) and ``EditPromptsWithPRFromDraftsBulk`` (edit-only,
 * earlier in PROC-102) — this endpoint composes both flows so
 * mixed selections don't have to be split into two PRs. Those two
 * are kept in place as focused entry points for callers that
 * already know the shape (Rio's tools, and the create-with-pr
 * dialog on the "New Prompt" button flow).
 */
export const openPromptsPrBulkFromDrafts = async (openPromptsPRBulkFromDraftsInput: OpenPromptsPRBulkFromDraftsInput, options?: Parameters<typeof customFetch>[1]): Promise<openPromptsPrBulkFromDraftsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<openPromptsPrBulkFromDraftsResponse>(getOpenPromptsPrBulkFromDraftsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(openPromptsPRBulkFromDraftsInput)
  }
);}





export const getOpenPromptsPrBulkFromDraftsMutationKey = () => ['openPromptsPrBulkFromDrafts'] as const;

export const getOpenPromptsPrBulkFromDraftsMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPromptsPrBulkFromDrafts>>, TError,OpenPromptsPrBulkFromDraftsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof openPromptsPrBulkFromDrafts>>, TError,OpenPromptsPrBulkFromDraftsMutationVariables, TContext> => {

const mutationKey = getOpenPromptsPrBulkFromDraftsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openPromptsPrBulkFromDrafts>>, OpenPromptsPrBulkFromDraftsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  openPromptsPrBulkFromDrafts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenPromptsPrBulkFromDraftsMutationResult = NonNullable<Awaited<ReturnType<typeof openPromptsPrBulkFromDrafts>>>
    export type OpenPromptsPrBulkFromDraftsMutationBody = OpenPromptsPRBulkFromDraftsInput
    export type OpenPromptsPrBulkFromDraftsMutationError = Error
    export type OpenPromptsPrBulkFromDraftsMutationVariables = {data: OpenPromptsPRBulkFromDraftsInput}

    export const useOpenPromptsPrBulkFromDrafts = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPromptsPrBulkFromDrafts>>, TError,OpenPromptsPrBulkFromDraftsMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openPromptsPrBulkFromDrafts>>,
        TError,
        OpenPromptsPrBulkFromDraftsMutationVariables,
        TContext
      > => {
      return useMutation(getOpenPromptsPrBulkFromDraftsMutationOptions(options), queryClient);
    }

export type openPromptsPrBulkFromDraftsM2mResponse201 = {
  data: OpenPRBulkOutput
  status: 201
}

export type openPromptsPrBulkFromDraftsM2mResponse400 = {
  data: Error
  status: 400
}

export type openPromptsPrBulkFromDraftsM2mResponse404 = {
  data: Error
  status: 404
}

export type openPromptsPrBulkFromDraftsM2mResponse409 = {
  data: Error
  status: 409
}

export type openPromptsPrBulkFromDraftsM2mResponse502 = {
  data: Error
  status: 502
}

export type openPromptsPrBulkFromDraftsM2mResponseSuccess = (openPromptsPrBulkFromDraftsM2mResponse201) & {
  headers: Headers;
};
export type openPromptsPrBulkFromDraftsM2mResponseError = (openPromptsPrBulkFromDraftsM2mResponse400 | openPromptsPrBulkFromDraftsM2mResponse404 | openPromptsPrBulkFromDraftsM2mResponse409 | openPromptsPrBulkFromDraftsM2mResponse502) & {
  headers: Headers;
};

export type openPromptsPrBulkFromDraftsM2mResponse = (openPromptsPrBulkFromDraftsM2mResponseSuccess | openPromptsPrBulkFromDraftsM2mResponseError)

export const getOpenPromptsPrBulkFromDraftsM2mUrl = () => {




  return `/api/basecamp/prompts/open-pr/bulk/from-drafts/m2m`
}

/**
 * Temporal M2M sibling of ``OpenPromptsPRBulkFromDrafts``.
 *
 * Rio's ``apply_open_edit_prompts_pr`` tool sends
 * ``{prompts: [{prompt_key, target_yaml_filename?}]}`` — same shape
 * as the SPA endpoint. This subclass swaps in M2M auth
 * (``Auth0TokenAuthentication`` + ``TEMPORAL_PERMISSION_CFG``) and
 * delegates to the parent's post body.
 *
 * Distinct from ``EditPromptYamlAndOpenPRBulkM2M`` (edit-only) —
 * this variant lets Rio bundle new + existing prompts in one PR.
 */
export const openPromptsPrBulkFromDraftsM2m = async (openPromptsPRBulkFromDraftsInput: OpenPromptsPRBulkFromDraftsInput, options?: Parameters<typeof customFetch>[1]): Promise<openPromptsPrBulkFromDraftsM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<openPromptsPrBulkFromDraftsM2mResponse>(getOpenPromptsPrBulkFromDraftsM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(openPromptsPRBulkFromDraftsInput)
  }
);}





export const getOpenPromptsPrBulkFromDraftsM2mMutationKey = () => ['openPromptsPrBulkFromDraftsM2m'] as const;

export const getOpenPromptsPrBulkFromDraftsM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPromptsPrBulkFromDraftsM2m>>, TError,OpenPromptsPrBulkFromDraftsM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof openPromptsPrBulkFromDraftsM2m>>, TError,OpenPromptsPrBulkFromDraftsM2mMutationVariables, TContext> => {

const mutationKey = getOpenPromptsPrBulkFromDraftsM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openPromptsPrBulkFromDraftsM2m>>, OpenPromptsPrBulkFromDraftsM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  openPromptsPrBulkFromDraftsM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type OpenPromptsPrBulkFromDraftsM2mMutationResult = NonNullable<Awaited<ReturnType<typeof openPromptsPrBulkFromDraftsM2m>>>
    export type OpenPromptsPrBulkFromDraftsM2mMutationBody = OpenPromptsPRBulkFromDraftsInput
    export type OpenPromptsPrBulkFromDraftsM2mMutationError = Error
    export type OpenPromptsPrBulkFromDraftsM2mMutationVariables = {data: OpenPromptsPRBulkFromDraftsInput}

    export const useOpenPromptsPrBulkFromDraftsM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openPromptsPrBulkFromDraftsM2m>>, TError,OpenPromptsPrBulkFromDraftsM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof openPromptsPrBulkFromDraftsM2m>>,
        TError,
        OpenPromptsPrBulkFromDraftsM2mMutationVariables,
        TContext
      > => {
      return useMutation(getOpenPromptsPrBulkFromDraftsM2mMutationOptions(options), queryClient);
    }

export type startPromptTestResponse200 = {
  data: Output
  status: 200
}

export type startPromptTestResponse400 = {
  data: Error
  status: 400
}

export type startPromptTestResponseSuccess = (startPromptTestResponse200) & {
  headers: Headers;
};
export type startPromptTestResponseError = (startPromptTestResponse400) & {
  headers: Headers;
};

export type startPromptTestResponse = (startPromptTestResponseSuccess | startPromptTestResponseError)

export const getStartPromptTestUrl = () => {




  return `/api/basecamp/prompts/test`
}

/**
 * Start EphemeralPromptTestWorkflow and return workflow_id for polling.
 */
export const startPromptTest = async (input: Input, options?: Parameters<typeof customFetch>[1]): Promise<startPromptTestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startPromptTestResponse>(getStartPromptTestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(input)
  }
);}





export const getStartPromptTestMutationKey = () => ['startPromptTest'] as const;

export const getStartPromptTestMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptTest>>, TError,StartPromptTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startPromptTest>>, TError,StartPromptTestMutationVariables, TContext> => {

const mutationKey = getStartPromptTestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startPromptTest>>, StartPromptTestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startPromptTest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartPromptTestMutationResult = NonNullable<Awaited<ReturnType<typeof startPromptTest>>>
    export type StartPromptTestMutationBody = Input
    export type StartPromptTestMutationError = Error
    export type StartPromptTestMutationVariables = {data: Input}

    export const useStartPromptTest = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startPromptTest>>, TError,StartPromptTestMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startPromptTest>>,
        TError,
        StartPromptTestMutationVariables,
        TContext
      > => {
      return useMutation(getStartPromptTestMutationOptions(options), queryClient);
    }

export type getPromptTestStatusResponse200 = {
  data: Output
  status: 200
}

export type getPromptTestStatusResponse400 = {
  data: Error
  status: 400
}

export type getPromptTestStatusResponseSuccess = (getPromptTestStatusResponse200) & {
  headers: Headers;
};
export type getPromptTestStatusResponseError = (getPromptTestStatusResponse400) & {
  headers: Headers;
};

export type getPromptTestStatusResponse = (getPromptTestStatusResponseSuccess | getPromptTestStatusResponseError)

export const getGetPromptTestStatusUrl = (workflowId: string,) => {




  return `/api/basecamp/prompts/test-status/${workflowId}`
}

/**
 * Poll EphemeralPromptTestWorkflow result.
 */
export const getPromptTestStatus = async (workflowId: string, options?: Parameters<typeof customFetch>[1]): Promise<getPromptTestStatusResponse> => {

  return customFetch<getPromptTestStatusResponse>(getGetPromptTestStatusUrl(workflowId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPromptTestStatusQueryKey = (workflowId: string,) => {
    return [
    `/api/basecamp/prompts/test-status/${workflowId}`
    ] as const;
    }


export const getGetPromptTestStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPromptTestStatus>>, TError = Error>(workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromptTestStatusQueryKey(workflowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromptTestStatus>>> = ({ signal }) => getPromptTestStatus(workflowId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromptTestStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromptTestStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPromptTestStatus>>>
export type GetPromptTestStatusQueryError = Error


export function useGetPromptTestStatus<TData = Awaited<ReturnType<typeof getPromptTestStatus>>, TError = Error>(
 workflowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptTestStatus>>,
          TError,
          Awaited<ReturnType<typeof getPromptTestStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptTestStatus<TData = Awaited<ReturnType<typeof getPromptTestStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromptTestStatus>>,
          TError,
          Awaited<ReturnType<typeof getPromptTestStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromptTestStatus<TData = Awaited<ReturnType<typeof getPromptTestStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromptTestStatus<TData = Awaited<ReturnType<typeof getPromptTestStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromptTestStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromptTestStatusQueryOptions(workflowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type updatePromptResponse200 = {
  data: PromptOutput
  status: 200
}

export type updatePromptResponse400 = {
  data: Error
  status: 400
}

export type updatePromptResponseSuccess = (updatePromptResponse200) & {
  headers: Headers;
};
export type updatePromptResponseError = (updatePromptResponse400) & {
  headers: Headers;
};

export type updatePromptResponse = (updatePromptResponseSuccess | updatePromptResponseError)

export const getUpdatePromptUrl = () => {




  return `/api/basecamp/prompts/update`
}

export const updatePrompt = async (updatePromptInput: UpdatePromptInput, options?: Parameters<typeof customFetch>[1]): Promise<updatePromptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updatePromptResponse>(getUpdatePromptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePromptInput)
  }
);}





export const getUpdatePromptMutationKey = () => ['updatePrompt'] as const;

export const getUpdatePromptMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePrompt>>, TError,UpdatePromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePrompt>>, TError,UpdatePromptMutationVariables, TContext> => {

const mutationKey = getUpdatePromptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePrompt>>, UpdatePromptMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePrompt(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePromptMutationResult = NonNullable<Awaited<ReturnType<typeof updatePrompt>>>
    export type UpdatePromptMutationBody = UpdatePromptInput
    export type UpdatePromptMutationError = Error
    export type UpdatePromptMutationVariables = {data: UpdatePromptInput}

    export const useUpdatePrompt = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePrompt>>, TError,UpdatePromptMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePrompt>>,
        TError,
        UpdatePromptMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePromptMutationOptions(options), queryClient);
    }

export type updatePromptM2mResponse200 = {
  data: PromptOutput
  status: 200
}

export type updatePromptM2mResponse400 = {
  data: Error
  status: 400
}

export type updatePromptM2mResponseSuccess = (updatePromptM2mResponse200) & {
  headers: Headers;
};
export type updatePromptM2mResponseError = (updatePromptM2mResponse400) & {
  headers: Headers;
};

export type updatePromptM2mResponse = (updatePromptM2mResponseSuccess | updatePromptM2mResponseError)

export const getUpdatePromptM2mUrl = () => {




  return `/api/basecamp/prompts/update/m2m`
}

/**
 * Temporal M2M sibling of ``UpdatePrompt`` (PROC-103).
 *
 * Rio's ``apply_update_prompt_row`` tool writes the LIVE
 * ``Prompt.response_schema`` / ``sample_output`` / ``name`` /
 * ``fallback_text`` columns via this endpoint. Those DB fields are
 * the runtime source of truth (yaml is a fallback), so Rio needs a
 * write path independent of the yaml PR flow.
 *
 * Shares the parent's body via ``_do_update_prompt``. The two views
 * intentionally keep separate decorators — SPA uses BASECAMP_ADMIN,
 * M2M uses TEMPORAL_PERMISSION_CFG.
 */
export const updatePromptM2m = async (updatePromptInput: UpdatePromptInput, options?: Parameters<typeof customFetch>[1]): Promise<updatePromptM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updatePromptM2mResponse>(getUpdatePromptM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePromptInput)
  }
);}





export const getUpdatePromptM2mMutationKey = () => ['updatePromptM2m'] as const;

export const getUpdatePromptM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePromptM2m>>, TError,UpdatePromptM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePromptM2m>>, TError,UpdatePromptM2mMutationVariables, TContext> => {

const mutationKey = getUpdatePromptM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePromptM2m>>, UpdatePromptM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePromptM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePromptM2mMutationResult = NonNullable<Awaited<ReturnType<typeof updatePromptM2m>>>
    export type UpdatePromptM2mMutationBody = UpdatePromptInput
    export type UpdatePromptM2mMutationError = Error
    export type UpdatePromptM2mMutationVariables = {data: UpdatePromptInput}

    export const useUpdatePromptM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePromptM2m>>, TError,UpdatePromptM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePromptM2m>>,
        TError,
        UpdatePromptM2mMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePromptM2mMutationOptions(options), queryClient);
    }

export type listPromptYamlFilesResponse200 = {
  data: ListYamlFilesOutput
  status: 200
}

export type listPromptYamlFilesResponse502 = {
  data: Error
  status: 502
}

export type listPromptYamlFilesResponseSuccess = (listPromptYamlFilesResponse200) & {
  headers: Headers;
};
export type listPromptYamlFilesResponseError = (listPromptYamlFilesResponse502) & {
  headers: Headers;
};

export type listPromptYamlFilesResponse = (listPromptYamlFilesResponseSuccess | listPromptYamlFilesResponseError)

export const getListPromptYamlFilesUrl = () => {




  return `/api/basecamp/prompts/yaml-files`
}

/**
 * GET /api/basecamp/prompts/yaml-files — populates the "target yaml"
 * dropdown on the new-prompt dialog.
 */
export const listPromptYamlFiles = async ( options?: Parameters<typeof customFetch>[1]): Promise<listPromptYamlFilesResponse> => {

  return customFetch<listPromptYamlFilesResponse>(getListPromptYamlFilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptYamlFilesQueryKey = () => {
    return [
    `/api/basecamp/prompts/yaml-files`
    ] as const;
    }


export const getListPromptYamlFilesQueryOptions = <TData = Awaited<ReturnType<typeof listPromptYamlFiles>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptYamlFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptYamlFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptYamlFiles>>> = ({ signal }) => listPromptYamlFiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptYamlFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptYamlFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptYamlFiles>>>
export type ListPromptYamlFilesQueryError = Error


export function useListPromptYamlFiles<TData = Awaited<ReturnType<typeof listPromptYamlFiles>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptYamlFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptYamlFiles>>,
          TError,
          Awaited<ReturnType<typeof listPromptYamlFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptYamlFiles<TData = Awaited<ReturnType<typeof listPromptYamlFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptYamlFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptYamlFiles>>,
          TError,
          Awaited<ReturnType<typeof listPromptYamlFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptYamlFiles<TData = Awaited<ReturnType<typeof listPromptYamlFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptYamlFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPromptYamlFiles<TData = Awaited<ReturnType<typeof listPromptYamlFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptYamlFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptYamlFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type setOrgRulePackageResponse200 = {
  data: QAToggleOutput
  status: 200
}

export type setOrgRulePackageResponse400 = {
  data: Error
  status: 400
}

export type setOrgRulePackageResponseSuccess = (setOrgRulePackageResponse200) & {
  headers: Headers;
};
export type setOrgRulePackageResponseError = (setOrgRulePackageResponse400) & {
  headers: Headers;
};

export type setOrgRulePackageResponse = (setOrgRulePackageResponseSuccess | setOrgRulePackageResponseError)

export const getSetOrgRulePackageUrl = () => {




  return `/api/basecamp/qa/org-packages/set`
}

/**
 * Attach (true) / turn off (false) / reset (null) a package for an org.
 */
export const setOrgRulePackage = async (setOrgRuleSetInput: SetOrgRuleSetInput, options?: Parameters<typeof customFetch>[1]): Promise<setOrgRulePackageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setOrgRulePackageResponse>(getSetOrgRulePackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setOrgRuleSetInput)
  }
);}





export const getSetOrgRulePackageMutationKey = () => ['setOrgRulePackage'] as const;

export const getSetOrgRulePackageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgRulePackage>>, TError,SetOrgRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrgRulePackage>>, TError,SetOrgRulePackageMutationVariables, TContext> => {

const mutationKey = getSetOrgRulePackageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrgRulePackage>>, SetOrgRulePackageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setOrgRulePackage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrgRulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof setOrgRulePackage>>>
    export type SetOrgRulePackageMutationBody = SetOrgRuleSetInput
    export type SetOrgRulePackageMutationError = Error
    export type SetOrgRulePackageMutationVariables = {data: SetOrgRuleSetInput}

    export const useSetOrgRulePackage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgRulePackage>>, TError,SetOrgRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOrgRulePackage>>,
        TError,
        SetOrgRulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getSetOrgRulePackageMutationOptions(options), queryClient);
    }

export type setOrgRuleResponse200 = {
  data: QAToggleOutput
  status: 200
}

export type setOrgRuleResponse400 = {
  data: Error
  status: 400
}

export type setOrgRuleResponseSuccess = (setOrgRuleResponse200) & {
  headers: Headers;
};
export type setOrgRuleResponseError = (setOrgRuleResponse400) & {
  headers: Headers;
};

export type setOrgRuleResponse = (setOrgRuleResponseSuccess | setOrgRuleResponseError)

export const getSetOrgRuleUrl = () => {




  return `/api/basecamp/qa/org-rules/set`
}

/**
 * Turn off (false) / reset (null) a single rule for an org.
 */
export const setOrgRule = async (setOrgRuleInput: SetOrgRuleInput, options?: Parameters<typeof customFetch>[1]): Promise<setOrgRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setOrgRuleResponse>(getSetOrgRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setOrgRuleInput)
  }
);}





export const getSetOrgRuleMutationKey = () => ['setOrgRule'] as const;

export const getSetOrgRuleMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgRule>>, TError,SetOrgRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrgRule>>, TError,SetOrgRuleMutationVariables, TContext> => {

const mutationKey = getSetOrgRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrgRule>>, SetOrgRuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setOrgRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrgRuleMutationResult = NonNullable<Awaited<ReturnType<typeof setOrgRule>>>
    export type SetOrgRuleMutationBody = SetOrgRuleInput
    export type SetOrgRuleMutationError = Error
    export type SetOrgRuleMutationVariables = {data: SetOrgRuleInput}

    export const useSetOrgRule = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgRule>>, TError,SetOrgRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setOrgRule>>,
        TError,
        SetOrgRuleMutationVariables,
        TContext
      > => {
      return useMutation(getSetOrgRuleMutationOptions(options), queryClient);
    }

export type listRulePackagesResponse200 = {
  data: ListRulePackagesOutput
  status: 200
}

export type listRulePackagesResponse400 = {
  data: Error
  status: 400
}

export type listRulePackagesResponseSuccess = (listRulePackagesResponse200) & {
  headers: Headers;
};
export type listRulePackagesResponseError = (listRulePackagesResponse400) & {
  headers: Headers;
};

export type listRulePackagesResponse = (listRulePackagesResponseSuccess | listRulePackagesResponseError)

export const getListRulePackagesUrl = (params?: ListRulePackagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/qa/packages?${stringifiedParams}` : `/api/basecamp/qa/packages`
}

export const listRulePackages = async (params?: ListRulePackagesParams, options?: Parameters<typeof customFetch>[1]): Promise<listRulePackagesResponse> => {

  return customFetch<listRulePackagesResponse>(getListRulePackagesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRulePackagesQueryKey = (params?: ListRulePackagesParams,) => {
    return [
    `/api/basecamp/qa/packages`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRulePackagesQueryOptions = <TData = Awaited<ReturnType<typeof listRulePackages>>, TError = Error>(params?: ListRulePackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRulePackages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRulePackagesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRulePackages>>> = ({ signal }) => listRulePackages(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRulePackages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRulePackagesQueryResult = NonNullable<Awaited<ReturnType<typeof listRulePackages>>>
export type ListRulePackagesQueryError = Error


export function useListRulePackages<TData = Awaited<ReturnType<typeof listRulePackages>>, TError = Error>(
 params: undefined |  ListRulePackagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRulePackages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRulePackages>>,
          TError,
          Awaited<ReturnType<typeof listRulePackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRulePackages<TData = Awaited<ReturnType<typeof listRulePackages>>, TError = Error>(
 params?: ListRulePackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRulePackages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRulePackages>>,
          TError,
          Awaited<ReturnType<typeof listRulePackages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRulePackages<TData = Awaited<ReturnType<typeof listRulePackages>>, TError = Error>(
 params?: ListRulePackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRulePackages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRulePackages<TData = Awaited<ReturnType<typeof listRulePackages>>, TError = Error>(
 params?: ListRulePackagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRulePackages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRulePackagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getRulePackageResponse200 = {
  data: RulePackageDetail
  status: 200
}

export type getRulePackageResponse404 = {
  data: Error
  status: 404
}

export type getRulePackageResponseSuccess = (getRulePackageResponse200) & {
  headers: Headers;
};
export type getRulePackageResponseError = (getRulePackageResponse404) & {
  headers: Headers;
};

export type getRulePackageResponse = (getRulePackageResponseSuccess | getRulePackageResponseError)

export const getGetRulePackageUrl = (packageId: number,) => {




  return `/api/basecamp/qa/packages/${packageId}`
}

/**
 * One package with everywhere it's attached or turned off ("used by").
 */
export const getRulePackage = async (packageId: number, options?: Parameters<typeof customFetch>[1]): Promise<getRulePackageResponse> => {

  return customFetch<getRulePackageResponse>(getGetRulePackageUrl(packageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRulePackageQueryKey = (packageId: number,) => {
    return [
    `/api/basecamp/qa/packages/${packageId}`
    ] as const;
    }


export const getGetRulePackageQueryOptions = <TData = Awaited<ReturnType<typeof getRulePackage>>, TError = Error>(packageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRulePackage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRulePackageQueryKey(packageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRulePackage>>> = ({ signal }) => getRulePackage(packageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: packageId !== null && packageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRulePackage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRulePackageQueryResult = NonNullable<Awaited<ReturnType<typeof getRulePackage>>>
export type GetRulePackageQueryError = Error


export function useGetRulePackage<TData = Awaited<ReturnType<typeof getRulePackage>>, TError = Error>(
 packageId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRulePackage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRulePackage>>,
          TError,
          Awaited<ReturnType<typeof getRulePackage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRulePackage<TData = Awaited<ReturnType<typeof getRulePackage>>, TError = Error>(
 packageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRulePackage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRulePackage>>,
          TError,
          Awaited<ReturnType<typeof getRulePackage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRulePackage<TData = Awaited<ReturnType<typeof getRulePackage>>, TError = Error>(
 packageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRulePackage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRulePackage<TData = Awaited<ReturnType<typeof getRulePackage>>, TError = Error>(
 packageId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRulePackage>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRulePackageQueryOptions(packageId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type createRulePackageResponse201 = {
  data: RulePackage
  status: 201
}

export type createRulePackageResponse400 = {
  data: Error
  status: 400
}

export type createRulePackageResponseSuccess = (createRulePackageResponse201) & {
  headers: Headers;
};
export type createRulePackageResponseError = (createRulePackageResponse400) & {
  headers: Headers;
};

export type createRulePackageResponse = (createRulePackageResponseSuccess | createRulePackageResponseError)

export const getCreateRulePackageUrl = () => {




  return `/api/basecamp/qa/packages/create`
}

export const createRulePackage = async (rulePackageFields: RulePackageFields, options?: Parameters<typeof customFetch>[1]): Promise<createRulePackageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createRulePackageResponse>(getCreateRulePackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(rulePackageFields)
  }
);}





export const getCreateRulePackageMutationKey = () => ['createRulePackage'] as const;

export const getCreateRulePackageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRulePackage>>, TError,CreateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRulePackage>>, TError,CreateRulePackageMutationVariables, TContext> => {

const mutationKey = getCreateRulePackageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRulePackage>>, CreateRulePackageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRulePackage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof createRulePackage>>>
    export type CreateRulePackageMutationBody = RulePackageFields
    export type CreateRulePackageMutationError = Error
    export type CreateRulePackageMutationVariables = {data: RulePackageFields}

    export const useCreateRulePackage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRulePackage>>, TError,CreateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRulePackage>>,
        TError,
        CreateRulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRulePackageMutationOptions(options), queryClient);
    }

export type duplicateRulePackageResponse201 = {
  data: RulePackage
  status: 201
}

export type duplicateRulePackageResponse400 = {
  data: Error
  status: 400
}

export type duplicateRulePackageResponseSuccess = (duplicateRulePackageResponse201) & {
  headers: Headers;
};
export type duplicateRulePackageResponseError = (duplicateRulePackageResponse400) & {
  headers: Headers;
};

export type duplicateRulePackageResponse = (duplicateRulePackageResponseSuccess | duplicateRulePackageResponseError)

export const getDuplicateRulePackageUrl = () => {




  return `/api/basecamp/qa/packages/duplicate`
}

/**
 * Copies a package and its live rules. Org/template attachments are not copied,
 * and the copy is always custom: a base or insurance copy would apply to reports
 * the moment it was created.
 */
export const duplicateRulePackage = async (duplicateRulePackageInput: DuplicateRulePackageInput, options?: Parameters<typeof customFetch>[1]): Promise<duplicateRulePackageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<duplicateRulePackageResponse>(getDuplicateRulePackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(duplicateRulePackageInput)
  }
);}





export const getDuplicateRulePackageMutationKey = () => ['duplicateRulePackage'] as const;

export const getDuplicateRulePackageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateRulePackage>>, TError,DuplicateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateRulePackage>>, TError,DuplicateRulePackageMutationVariables, TContext> => {

const mutationKey = getDuplicateRulePackageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateRulePackage>>, DuplicateRulePackageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  duplicateRulePackage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateRulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateRulePackage>>>
    export type DuplicateRulePackageMutationBody = DuplicateRulePackageInput
    export type DuplicateRulePackageMutationError = Error
    export type DuplicateRulePackageMutationVariables = {data: DuplicateRulePackageInput}

    export const useDuplicateRulePackage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateRulePackage>>, TError,DuplicateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateRulePackage>>,
        TError,
        DuplicateRulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateRulePackageMutationOptions(options), queryClient);
    }

export type updateRulePackageResponse200 = {
  data: RulePackage
  status: 200
}

export type updateRulePackageResponse400 = {
  data: Error
  status: 400
}

export type updateRulePackageResponseSuccess = (updateRulePackageResponse200) & {
  headers: Headers;
};
export type updateRulePackageResponseError = (updateRulePackageResponse400) & {
  headers: Headers;
};

export type updateRulePackageResponse = (updateRulePackageResponseSuccess | updateRulePackageResponseError)

export const getUpdateRulePackageUrl = () => {




  return `/api/basecamp/qa/packages/update`
}

export const updateRulePackage = async (updateRulePackageInput: UpdateRulePackageInput, options?: Parameters<typeof customFetch>[1]): Promise<updateRulePackageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateRulePackageResponse>(getUpdateRulePackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRulePackageInput)
  }
);}





export const getUpdateRulePackageMutationKey = () => ['updateRulePackage'] as const;

export const getUpdateRulePackageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRulePackage>>, TError,UpdateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRulePackage>>, TError,UpdateRulePackageMutationVariables, TContext> => {

const mutationKey = getUpdateRulePackageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRulePackage>>, UpdateRulePackageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateRulePackage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof updateRulePackage>>>
    export type UpdateRulePackageMutationBody = UpdateRulePackageInput
    export type UpdateRulePackageMutationError = Error
    export type UpdateRulePackageMutationVariables = {data: UpdateRulePackageInput}

    export const useUpdateRulePackage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRulePackage>>, TError,UpdateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRulePackage>>,
        TError,
        UpdateRulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRulePackageMutationOptions(options), queryClient);
    }

export type previewQaRulesResponse200 = {
  data: PreviewQARulesOutput
  status: 200
}

export type previewQaRulesResponse400 = {
  data: Error
  status: 400
}

export type previewQaRulesResponseSuccess = (previewQaRulesResponse200) & {
  headers: Headers;
};
export type previewQaRulesResponseError = (previewQaRulesResponse400) & {
  headers: Headers;
};

export type previewQaRulesResponse = (previewQaRulesResponseSuccess | previewQaRulesResponseError)

export const getPreviewQaRulesUrl = () => {




  return `/api/basecamp/qa/preview`
}

/**
 * Answers "I'm doing this report — which QA rules get pulled in, and why?".
 */
export const previewQaRules = async (previewQARulesInput?: PreviewQARulesInput, options?: Parameters<typeof customFetch>[1]): Promise<previewQaRulesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<previewQaRulesResponse>(getPreviewQaRulesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(previewQARulesInput)
  }
);}





export const getPreviewQaRulesMutationKey = () => ['previewQaRules'] as const;

export const getPreviewQaRulesMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewQaRules>>, TError,PreviewQaRulesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewQaRules>>, TError,PreviewQaRulesMutationVariables, TContext> => {

const mutationKey = getPreviewQaRulesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewQaRules>>, PreviewQaRulesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  previewQaRules(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PreviewQaRulesMutationResult = NonNullable<Awaited<ReturnType<typeof previewQaRules>>>
    export type PreviewQaRulesMutationBody = PreviewQARulesInput | undefined
    export type PreviewQaRulesMutationError = Error
    export type PreviewQaRulesMutationVariables = {data?: PreviewQARulesInput}

    export const usePreviewQaRules = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewQaRules>>, TError,PreviewQaRulesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewQaRules>>,
        TError,
        PreviewQaRulesMutationVariables,
        TContext
      > => {
      return useMutation(getPreviewQaRulesMutationOptions(options), queryClient);
    }

export type createRuleResponse201 = {
  data: RulePackageRule
  status: 201
}

export type createRuleResponse400 = {
  data: Error
  status: 400
}

export type createRuleResponseSuccess = (createRuleResponse201) & {
  headers: Headers;
};
export type createRuleResponseError = (createRuleResponse400) & {
  headers: Headers;
};

export type createRuleResponse = (createRuleResponseSuccess | createRuleResponseError)

export const getCreateRuleUrl = () => {




  return `/api/basecamp/qa/rules/create`
}

export const createRule = async (createRuleInput: CreateRuleInput, options?: Parameters<typeof customFetch>[1]): Promise<createRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createRuleResponse>(getCreateRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createRuleInput)
  }
);}





export const getCreateRuleMutationKey = () => ['createRule'] as const;

export const getCreateRuleMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRule>>, TError,CreateRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRule>>, TError,CreateRuleMutationVariables, TContext> => {

const mutationKey = getCreateRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRule>>, CreateRuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createRule>>>
    export type CreateRuleMutationBody = CreateRuleInput
    export type CreateRuleMutationError = Error
    export type CreateRuleMutationVariables = {data: CreateRuleInput}

    export const useCreateRule = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRule>>, TError,CreateRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRule>>,
        TError,
        CreateRuleMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRuleMutationOptions(options), queryClient);
    }

export type reorderRulesResponse200 = {
  data: RulePackage
  status: 200
}

export type reorderRulesResponse400 = {
  data: Error
  status: 400
}

export type reorderRulesResponseSuccess = (reorderRulesResponse200) & {
  headers: Headers;
};
export type reorderRulesResponseError = (reorderRulesResponse400) & {
  headers: Headers;
};

export type reorderRulesResponse = (reorderRulesResponseSuccess | reorderRulesResponseError)

export const getReorderRulesUrl = () => {




  return `/api/basecamp/qa/rules/reorder`
}

export const reorderRules = async (reorderRulesInput: ReorderRulesInput, options?: Parameters<typeof customFetch>[1]): Promise<reorderRulesResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<reorderRulesResponse>(getReorderRulesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reorderRulesInput)
  }
);}





export const getReorderRulesMutationKey = () => ['reorderRules'] as const;

export const getReorderRulesMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderRules>>, TError,ReorderRulesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderRules>>, TError,ReorderRulesMutationVariables, TContext> => {

const mutationKey = getReorderRulesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderRules>>, ReorderRulesMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  reorderRules(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderRulesMutationResult = NonNullable<Awaited<ReturnType<typeof reorderRules>>>
    export type ReorderRulesMutationBody = ReorderRulesInput
    export type ReorderRulesMutationError = Error
    export type ReorderRulesMutationVariables = {data: ReorderRulesInput}

    export const useReorderRules = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderRules>>, TError,ReorderRulesMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reorderRules>>,
        TError,
        ReorderRulesMutationVariables,
        TContext
      > => {
      return useMutation(getReorderRulesMutationOptions(options), queryClient);
    }

export type updateRuleResponse200 = {
  data: RulePackageRule
  status: 200
}

export type updateRuleResponse400 = {
  data: Error
  status: 400
}

export type updateRuleResponseSuccess = (updateRuleResponse200) & {
  headers: Headers;
};
export type updateRuleResponseError = (updateRuleResponse400) & {
  headers: Headers;
};

export type updateRuleResponse = (updateRuleResponseSuccess | updateRuleResponseError)

export const getUpdateRuleUrl = () => {




  return `/api/basecamp/qa/rules/update`
}

export const updateRule = async (updateRuleInput: UpdateRuleInput, options?: Parameters<typeof customFetch>[1]): Promise<updateRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateRuleResponse>(getUpdateRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateRuleInput)
  }
);}





export const getUpdateRuleMutationKey = () => ['updateRule'] as const;

export const getUpdateRuleMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRule>>, TError,UpdateRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRule>>, TError,UpdateRuleMutationVariables, TContext> => {

const mutationKey = getUpdateRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRule>>, UpdateRuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRule>>>
    export type UpdateRuleMutationBody = UpdateRuleInput
    export type UpdateRuleMutationError = Error
    export type UpdateRuleMutationVariables = {data: UpdateRuleInput}

    export const useUpdateRule = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRule>>, TError,UpdateRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRule>>,
        TError,
        UpdateRuleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateRuleMutationOptions(options), queryClient);
    }

export type setTemplateRulePackageResponse200 = {
  data: QAToggleOutput
  status: 200
}

export type setTemplateRulePackageResponse400 = {
  data: Error
  status: 400
}

export type setTemplateRulePackageResponseSuccess = (setTemplateRulePackageResponse200) & {
  headers: Headers;
};
export type setTemplateRulePackageResponseError = (setTemplateRulePackageResponse400) & {
  headers: Headers;
};

export type setTemplateRulePackageResponse = (setTemplateRulePackageResponseSuccess | setTemplateRulePackageResponseError)

export const getSetTemplateRulePackageUrl = () => {




  return `/api/basecamp/qa/template-packages/set`
}

/**
 * Attach (true) / turn off (false) / reset (null) a package for a template, in every org.
 */
export const setTemplateRulePackage = async (setTemplateRuleSetInput: SetTemplateRuleSetInput, options?: Parameters<typeof customFetch>[1]): Promise<setTemplateRulePackageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setTemplateRulePackageResponse>(getSetTemplateRulePackageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setTemplateRuleSetInput)
  }
);}





export const getSetTemplateRulePackageMutationKey = () => ['setTemplateRulePackage'] as const;

export const getSetTemplateRulePackageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTemplateRulePackage>>, TError,SetTemplateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setTemplateRulePackage>>, TError,SetTemplateRulePackageMutationVariables, TContext> => {

const mutationKey = getSetTemplateRulePackageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTemplateRulePackage>>, SetTemplateRulePackageMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setTemplateRulePackage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTemplateRulePackageMutationResult = NonNullable<Awaited<ReturnType<typeof setTemplateRulePackage>>>
    export type SetTemplateRulePackageMutationBody = SetTemplateRuleSetInput
    export type SetTemplateRulePackageMutationError = Error
    export type SetTemplateRulePackageMutationVariables = {data: SetTemplateRuleSetInput}

    export const useSetTemplateRulePackage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTemplateRulePackage>>, TError,SetTemplateRulePackageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTemplateRulePackage>>,
        TError,
        SetTemplateRulePackageMutationVariables,
        TContext
      > => {
      return useMutation(getSetTemplateRulePackageMutationOptions(options), queryClient);
    }

export type setTemplateRuleResponse200 = {
  data: QAToggleOutput
  status: 200
}

export type setTemplateRuleResponse400 = {
  data: Error
  status: 400
}

export type setTemplateRuleResponseSuccess = (setTemplateRuleResponse200) & {
  headers: Headers;
};
export type setTemplateRuleResponseError = (setTemplateRuleResponse400) & {
  headers: Headers;
};

export type setTemplateRuleResponse = (setTemplateRuleResponseSuccess | setTemplateRuleResponseError)

export const getSetTemplateRuleUrl = () => {




  return `/api/basecamp/qa/template-rules/set`
}

/**
 * Turn off (false) / reset (null) a single rule for a template, in every org.
 */
export const setTemplateRule = async (setTemplateRuleInput: SetTemplateRuleInput, options?: Parameters<typeof customFetch>[1]): Promise<setTemplateRuleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setTemplateRuleResponse>(getSetTemplateRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setTemplateRuleInput)
  }
);}





export const getSetTemplateRuleMutationKey = () => ['setTemplateRule'] as const;

export const getSetTemplateRuleMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTemplateRule>>, TError,SetTemplateRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setTemplateRule>>, TError,SetTemplateRuleMutationVariables, TContext> => {

const mutationKey = getSetTemplateRuleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTemplateRule>>, SetTemplateRuleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setTemplateRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTemplateRuleMutationResult = NonNullable<Awaited<ReturnType<typeof setTemplateRule>>>
    export type SetTemplateRuleMutationBody = SetTemplateRuleInput
    export type SetTemplateRuleMutationError = Error
    export type SetTemplateRuleMutationVariables = {data: SetTemplateRuleInput}

    export const useSetTemplateRule = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTemplateRule>>, TError,SetTemplateRuleMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setTemplateRule>>,
        TError,
        SetTemplateRuleMutationVariables,
        TContext
      > => {
      return useMutation(getSetTemplateRuleMutationOptions(options), queryClient);
    }

export type listTemplatesResponse200 = {
  data: GetTemplatesPaginatedOutput
  status: 200
}

export type listTemplatesResponse400 = {
  data: Error
  status: 400
}

export type listTemplatesResponseSuccess = (listTemplatesResponse200) & {
  headers: Headers;
};
export type listTemplatesResponseError = (listTemplatesResponse400) & {
  headers: Headers;
};

export type listTemplatesResponse = (listTemplatesResponseSuccess | listTemplatesResponseError)

export const getListTemplatesUrl = (params?: ListTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/templates?${stringifiedParams}` : `/api/basecamp/templates`
}

export const listTemplates = async (params?: ListTemplatesParams, options?: Parameters<typeof customFetch>[1]): Promise<listTemplatesResponse> => {

  return customFetch<listTemplatesResponse>(getListTemplatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplatesQueryKey = (params?: ListTemplatesParams,) => {
    return [
    `/api/basecamp/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplates>>, TError = Error>(params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesQueryError = Error


export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = Error>(
 params: undefined |  ListTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = Error>(
 params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = Error>(
 params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = Error>(
 params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getTemplateDetailResponse200 = {
  data: TemplateDetail
  status: 200
}

export type getTemplateDetailResponse400 = {
  data: Error
  status: 400
}

export type getTemplateDetailResponseSuccess = (getTemplateDetailResponse200) & {
  headers: Headers;
};
export type getTemplateDetailResponseError = (getTemplateDetailResponse400) & {
  headers: Headers;
};

export type getTemplateDetailResponse = (getTemplateDetailResponseSuccess | getTemplateDetailResponseError)

export const getGetTemplateDetailUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}`
}

export const getTemplateDetail = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<getTemplateDetailResponse> => {

  return customFetch<getTemplateDetailResponse>(getGetTemplateDetailUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTemplateDetailQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/${templateId}`
    ] as const;
    }


export const getGetTemplateDetailQueryOptions = <TData = Awaited<ReturnType<typeof getTemplateDetail>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateDetailQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateDetail>>> = ({ signal }) => getTemplateDetail(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplateDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplateDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplateDetail>>>
export type GetTemplateDetailQueryError = Error


export function useGetTemplateDetail<TData = Awaited<ReturnType<typeof getTemplateDetail>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateDetail>>,
          TError,
          Awaited<ReturnType<typeof getTemplateDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateDetail<TData = Awaited<ReturnType<typeof getTemplateDetail>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateDetail>>,
          TError,
          Awaited<ReturnType<typeof getTemplateDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateDetail<TData = Awaited<ReturnType<typeof getTemplateDetail>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTemplateDetail<TData = Awaited<ReturnType<typeof getTemplateDetail>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplateDetailQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listTemplateCurriculaResponse200 = {
  data: Curriculum[]
  status: 200
}

export type listTemplateCurriculaResponse400 = {
  data: Error
  status: 400
}

export type listTemplateCurriculaResponseSuccess = (listTemplateCurriculaResponse200) & {
  headers: Headers;
};
export type listTemplateCurriculaResponseError = (listTemplateCurriculaResponse400) & {
  headers: Headers;
};

export type listTemplateCurriculaResponse = (listTemplateCurriculaResponseSuccess | listTemplateCurriculaResponseError)

export const getListTemplateCurriculaUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}/curricula`
}

/**
 * List curricula available to a template, scoped to that template's organizations.
 *
 * Used by the basecamp Treatment Plan Settings dialog to populate the
 * "Filter Goal Bank to Folder Category" dropdown.
 */
export const listTemplateCurricula = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<listTemplateCurriculaResponse> => {

  return customFetch<listTemplateCurriculaResponse>(getListTemplateCurriculaUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateCurriculaQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/${templateId}/curricula`
    ] as const;
    }


export const getListTemplateCurriculaQueryOptions = <TData = Awaited<ReturnType<typeof listTemplateCurricula>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCurricula>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateCurriculaQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplateCurricula>>> = ({ signal }) => listTemplateCurricula(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplateCurricula>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateCurriculaQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplateCurricula>>>
export type ListTemplateCurriculaQueryError = Error


export function useListTemplateCurricula<TData = Awaited<ReturnType<typeof listTemplateCurricula>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCurricula>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateCurricula>>,
          TError,
          Awaited<ReturnType<typeof listTemplateCurricula>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateCurricula<TData = Awaited<ReturnType<typeof listTemplateCurricula>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCurricula>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateCurricula>>,
          TError,
          Awaited<ReturnType<typeof listTemplateCurricula>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateCurricula<TData = Awaited<ReturnType<typeof listTemplateCurricula>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCurricula>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTemplateCurricula<TData = Awaited<ReturnType<typeof listTemplateCurricula>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCurricula>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateCurriculaQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type exportTemplateJsonResponse200 = {
  data: void
  status: 200
}

export type exportTemplateJsonResponse400 = {
  data: Error
  status: 400
}

export type exportTemplateJsonResponseSuccess = (exportTemplateJsonResponse200) & {
  headers: Headers;
};
export type exportTemplateJsonResponseError = (exportTemplateJsonResponse400) & {
  headers: Headers;
};

export type exportTemplateJsonResponse = (exportTemplateJsonResponseSuccess | exportTemplateJsonResponseError)

export const getExportTemplateJsonUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}/export-json`
}

export const exportTemplateJson = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<exportTemplateJsonResponse> => {

  return customFetch<exportTemplateJsonResponse>(getExportTemplateJsonUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportTemplateJsonQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/${templateId}/export-json`
    ] as const;
    }


export const getExportTemplateJsonQueryOptions = <TData = Awaited<ReturnType<typeof exportTemplateJson>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplateJson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportTemplateJsonQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportTemplateJson>>> = ({ signal }) => exportTemplateJson(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportTemplateJson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportTemplateJsonQueryResult = NonNullable<Awaited<ReturnType<typeof exportTemplateJson>>>
export type ExportTemplateJsonQueryError = Error


export function useExportTemplateJson<TData = Awaited<ReturnType<typeof exportTemplateJson>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplateJson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTemplateJson>>,
          TError,
          Awaited<ReturnType<typeof exportTemplateJson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportTemplateJson<TData = Awaited<ReturnType<typeof exportTemplateJson>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplateJson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportTemplateJson>>,
          TError,
          Awaited<ReturnType<typeof exportTemplateJson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportTemplateJson<TData = Awaited<ReturnType<typeof exportTemplateJson>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplateJson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExportTemplateJson<TData = Awaited<ReturnType<typeof exportTemplateJson>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportTemplateJson>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportTemplateJsonQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listTemplateQaCriteriaResponse200 = {
  data: GetTemplateQACriteriaOutput
  status: 200
}

export type listTemplateQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type listTemplateQaCriteriaResponseSuccess = (listTemplateQaCriteriaResponse200) & {
  headers: Headers;
};
export type listTemplateQaCriteriaResponseError = (listTemplateQaCriteriaResponse400) & {
  headers: Headers;
};

export type listTemplateQaCriteriaResponse = (listTemplateQaCriteriaResponseSuccess | listTemplateQaCriteriaResponseError)

export const getListTemplateQaCriteriaUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}/qa-criteria`
}

export const listTemplateQaCriteria = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<listTemplateQaCriteriaResponse> => {

  return customFetch<listTemplateQaCriteriaResponse>(getListTemplateQaCriteriaUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateQaCriteriaQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/${templateId}/qa-criteria`
    ] as const;
    }


export const getListTemplateQaCriteriaQueryOptions = <TData = Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateQaCriteriaQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplateQaCriteria>>> = ({ signal }) => listTemplateQaCriteria(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateQaCriteriaQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplateQaCriteria>>>
export type ListTemplateQaCriteriaQueryError = Error


export function useListTemplateQaCriteria<TData = Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateQaCriteria>>,
          TError,
          Awaited<ReturnType<typeof listTemplateQaCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateQaCriteria<TData = Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateQaCriteria>>,
          TError,
          Awaited<ReturnType<typeof listTemplateQaCriteria>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateQaCriteria<TData = Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTemplateQaCriteria<TData = Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateQaCriteria>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateQaCriteriaQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type getRioMessagesResponse200 = {
  data: RioMessageList
  status: 200
}

export type getRioMessagesResponse400 = {
  data: Error
  status: 400
}

export type getRioMessagesResponseSuccess = (getRioMessagesResponse200) & {
  headers: Headers;
};
export type getRioMessagesResponseError = (getRioMessagesResponse400) & {
  headers: Headers;
};

export type getRioMessagesResponse = (getRioMessagesResponseSuccess | getRioMessagesResponseError)

export const getGetRioMessagesUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}/rio/messages`
}

/**
 * GET templates/<int:template_id>/rio/messages — SPA-facing.
 *
 * Reads Rio's chat log from the `RioChatMessage` table (DB-backed).
 * Chat history survives workflow lifecycle events (idle timeout,
 * code-change wedges, restarts, rate-limit blips).
 *
 * Basecamp SPA auth only — the worker uses `ListRioMessagesM2M`
 * (separate endpoint) for rehydration on start.
 */
export const getRioMessages = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<getRioMessagesResponse> => {

  return customFetch<getRioMessagesResponse>(getGetRioMessagesUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRioMessagesQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/${templateId}/rio/messages`
    ] as const;
    }


export const getGetRioMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getRioMessages>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRioMessagesQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRioMessages>>> = ({ signal }) => getRioMessages(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRioMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRioMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getRioMessages>>>
export type GetRioMessagesQueryError = Error


export function useGetRioMessages<TData = Awaited<ReturnType<typeof getRioMessages>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRioMessages>>,
          TError,
          Awaited<ReturnType<typeof getRioMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRioMessages<TData = Awaited<ReturnType<typeof getRioMessages>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRioMessages>>,
          TError,
          Awaited<ReturnType<typeof getRioMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRioMessages<TData = Awaited<ReturnType<typeof getRioMessages>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRioMessages<TData = Awaited<ReturnType<typeof getRioMessages>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRioMessages>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRioMessagesQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type listRioMessagesM2mResponse200 = {
  data: RioMessageList
  status: 200
}

export type listRioMessagesM2mResponse400 = {
  data: Error
  status: 400
}

export type listRioMessagesM2mResponseSuccess = (listRioMessagesM2mResponse200) & {
  headers: Headers;
};
export type listRioMessagesM2mResponseError = (listRioMessagesM2mResponse400) & {
  headers: Headers;
};

export type listRioMessagesM2mResponse = (listRioMessagesM2mResponseSuccess | listRioMessagesM2mResponseError)

export const getListRioMessagesM2mUrl = (templateId: number,
    params?: ListRioMessagesM2mParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/templates/${templateId}/rio/messages/list?${stringifiedParams}` : `/api/basecamp/templates/${templateId}/rio/messages/list`
}

/**
 * GET templates/<int:template_id>/rio/messages/list — M2M-only.
 *
 * Same payload as `GetRioMessages` but for the Rio worker's
 * rehydration-on-start path. Separate endpoint so basecamp SPA
 * auth and Temporal M2M auth live on cleanly distinct endpoints
 * (mixed `allowed_roles=[basecamp, m2m]` doesn't work cleanly with
 * `role_required_for_rest_apis`'s m2m client_name check).
 *
 * Optional `?limit=N` returns only the most recent N messages in
 * chronological order — keeps the rehydration payload bounded.
 */
export const listRioMessagesM2m = async (templateId: number,
    params?: ListRioMessagesM2mParams, options?: Parameters<typeof customFetch>[1]): Promise<listRioMessagesM2mResponse> => {

  return customFetch<listRioMessagesM2mResponse>(getListRioMessagesM2mUrl(templateId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRioMessagesM2mQueryKey = (templateId: number,
    params?: ListRioMessagesM2mParams,) => {
    return [
    `/api/basecamp/templates/${templateId}/rio/messages/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRioMessagesM2mQueryOptions = <TData = Awaited<ReturnType<typeof listRioMessagesM2m>>, TError = Error>(templateId: number,
    params?: ListRioMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRioMessagesM2mQueryKey(templateId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRioMessagesM2m>>> = ({ signal }) => listRioMessagesM2m(templateId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRioMessagesM2m>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRioMessagesM2mQueryResult = NonNullable<Awaited<ReturnType<typeof listRioMessagesM2m>>>
export type ListRioMessagesM2mQueryError = Error


export function useListRioMessagesM2m<TData = Awaited<ReturnType<typeof listRioMessagesM2m>>, TError = Error>(
 templateId: number,
    params: undefined |  ListRioMessagesM2mParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioMessagesM2m>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRioMessagesM2m>>,
          TError,
          Awaited<ReturnType<typeof listRioMessagesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRioMessagesM2m<TData = Awaited<ReturnType<typeof listRioMessagesM2m>>, TError = Error>(
 templateId: number,
    params?: ListRioMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioMessagesM2m>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRioMessagesM2m>>,
          TError,
          Awaited<ReturnType<typeof listRioMessagesM2m>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRioMessagesM2m<TData = Awaited<ReturnType<typeof listRioMessagesM2m>>, TError = Error>(
 templateId: number,
    params?: ListRioMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRioMessagesM2m<TData = Awaited<ReturnType<typeof listRioMessagesM2m>>, TError = Error>(
 templateId: number,
    params?: ListRioMessagesM2mParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRioMessagesM2m>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRioMessagesM2mQueryOptions(templateId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type saveRioMessageResponse200 = {
  data: SaveRioMessageOutput
  status: 200
}

export type saveRioMessageResponse400 = {
  data: Error
  status: 400
}

export type saveRioMessageResponse409 = {
  data: Error
  status: 409
}

export type saveRioMessageResponseSuccess = (saveRioMessageResponse200) & {
  headers: Headers;
};
export type saveRioMessageResponseError = (saveRioMessageResponse400 | saveRioMessageResponse409) & {
  headers: Headers;
};

export type saveRioMessageResponse = (saveRioMessageResponseSuccess | saveRioMessageResponseError)

export const getSaveRioMessageUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}/rio/messages/save`
}

/**
 * POST templates/<int:template_id>/rio/messages/save — persist one
 * message to the RioChatMessage table.
 *
 * M2M-only. The Rio worker calls this from `_process_turn` after
 * appending each USER + ASSISTANT message to its in-memory list, so
 * the DB stays authoritative for the chat log.
 *
 * Idempotent on `message_id`: the unique constraint means a retried
 * save activity won't double-insert.
 */
export const saveRioMessage = async (templateId: number,
    saveRioMessageInput: SaveRioMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<saveRioMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<saveRioMessageResponse>(getSaveRioMessageUrl(templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(saveRioMessageInput)
  }
);}





export const getSaveRioMessageMutationKey = () => ['saveRioMessage'] as const;

export const getSaveRioMessageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRioMessage>>, TError,SaveRioMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveRioMessage>>, TError,SaveRioMessageMutationVariables, TContext> => {

const mutationKey = getSaveRioMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveRioMessage>>, SaveRioMessageMutationVariables> = (props) => {
          const {templateId,data} = props ?? {};

          return  saveRioMessage(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveRioMessageMutationResult = NonNullable<Awaited<ReturnType<typeof saveRioMessage>>>
    export type SaveRioMessageMutationBody = SaveRioMessageInput
    export type SaveRioMessageMutationError = Error
    export type SaveRioMessageMutationVariables = {templateId: number;data: SaveRioMessageInput}

    export const useSaveRioMessage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveRioMessage>>, TError,SaveRioMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveRioMessage>>,
        TError,
        SaveRioMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSaveRioMessageMutationOptions(options), queryClient);
    }

export type sendRioMessageResponse200 = {
  data: SendRioMessageOutput
  status: 200
}

export type sendRioMessageResponse400 = {
  data: Error
  status: 400
}

export type sendRioMessageResponse409 = {
  data: Error
  status: 409
}

export type sendRioMessageResponseSuccess = (sendRioMessageResponse200) & {
  headers: Headers;
};
export type sendRioMessageResponseError = (sendRioMessageResponse400 | sendRioMessageResponse409) & {
  headers: Headers;
};

export type sendRioMessageResponse = (sendRioMessageResponseSuccess | sendRioMessageResponseError)

export const getSendRioMessageUrl = (templateId: number,) => {




  return `/api/basecamp/templates/${templateId}/rio/send`
}

/**
 * POST templates/<int:template_id>/rio/send — append a user message
 * to the Rio conversation. Uses Temporal's signal-with-start to either
 * boot the workflow (first message for this template) or signal the
 * running one. Returns 202 with the assigned `message_id` immediately;
 * the SPA polls `/rio/messages` for the assistant reply.
 */
export const sendRioMessage = async (templateId: number,
    sendRioMessageInput: SendRioMessageInput, options?: Parameters<typeof customFetch>[1]): Promise<sendRioMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<sendRioMessageResponse>(getSendRioMessageUrl(templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendRioMessageInput)
  }
);}





export const getSendRioMessageMutationKey = () => ['sendRioMessage'] as const;

export const getSendRioMessageMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRioMessage>>, TError,SendRioMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendRioMessage>>, TError,SendRioMessageMutationVariables, TContext> => {

const mutationKey = getSendRioMessageMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendRioMessage>>, SendRioMessageMutationVariables> = (props) => {
          const {templateId,data} = props ?? {};

          return  sendRioMessage(templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendRioMessageMutationResult = NonNullable<Awaited<ReturnType<typeof sendRioMessage>>>
    export type SendRioMessageMutationBody = SendRioMessageInput
    export type SendRioMessageMutationError = Error
    export type SendRioMessageMutationVariables = {templateId: number;data: SendRioMessageInput}

    export const useSendRioMessage = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendRioMessage>>, TError,SendRioMessageMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendRioMessage>>,
        TError,
        SendRioMessageMutationVariables,
        TContext
      > => {
      return useMutation(getSendRioMessageMutationOptions(options), queryClient);
    }

export type copyFieldResponse201 = {
  data: Section
  status: 201
}

export type copyFieldResponse400 = {
  data: Error
  status: 400
}

export type copyFieldResponseSuccess = (copyFieldResponse201) & {
  headers: Headers;
};
export type copyFieldResponseError = (copyFieldResponse400) & {
  headers: Headers;
};

export type copyFieldResponse = (copyFieldResponseSuccess | copyFieldResponseError)

export const getCopyFieldUrl = () => {




  return `/api/basecamp/templates/copy-field`
}

/**
 * POST /templates/copy-field — copy a single field into a section in another template.
 */
export const copyField = async (copyFieldInput: CopyFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<copyFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<copyFieldResponse>(getCopyFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(copyFieldInput)
  }
);}





export const getCopyFieldMutationKey = () => ['copyField'] as const;

export const getCopyFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyField>>, TError,CopyFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof copyField>>, TError,CopyFieldMutationVariables, TContext> => {

const mutationKey = getCopyFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyField>>, CopyFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  copyField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyFieldMutationResult = NonNullable<Awaited<ReturnType<typeof copyField>>>
    export type CopyFieldMutationBody = CopyFieldInput
    export type CopyFieldMutationError = Error
    export type CopyFieldMutationVariables = {data: CopyFieldInput}

    export const useCopyField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyField>>, TError,CopyFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copyField>>,
        TError,
        CopyFieldMutationVariables,
        TContext
      > => {
      return useMutation(getCopyFieldMutationOptions(options), queryClient);
    }

export type copySectionResponse201 = {
  data: Section
  status: 201
}

export type copySectionResponse400 = {
  data: Error
  status: 400
}

export type copySectionResponseSuccess = (copySectionResponse201) & {
  headers: Headers;
};
export type copySectionResponseError = (copySectionResponse400) & {
  headers: Headers;
};

export type copySectionResponse = (copySectionResponseSuccess | copySectionResponseError)

export const getCopySectionUrl = () => {




  return `/api/basecamp/templates/copy-section`
}

/**
 * POST /templates/copy-section — copy a section (+ its fields) into another template.
 */
export const copySection = async (copySectionInput: CopySectionInput, options?: Parameters<typeof customFetch>[1]): Promise<copySectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<copySectionResponse>(getCopySectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(copySectionInput)
  }
);}





export const getCopySectionMutationKey = () => ['copySection'] as const;

export const getCopySectionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copySection>>, TError,CopySectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof copySection>>, TError,CopySectionMutationVariables, TContext> => {

const mutationKey = getCopySectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copySection>>, CopySectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  copySection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopySectionMutationResult = NonNullable<Awaited<ReturnType<typeof copySection>>>
    export type CopySectionMutationBody = CopySectionInput
    export type CopySectionMutationError = Error
    export type CopySectionMutationVariables = {data: CopySectionInput}

    export const useCopySection = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copySection>>, TError,CopySectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof copySection>>,
        TError,
        CopySectionMutationVariables,
        TContext
      > => {
      return useMutation(getCopySectionMutationOptions(options), queryClient);
    }

export type deleteTemplateResponse200 = {
  data: void
  status: 200
}

export type deleteTemplateResponse400 = {
  data: Error
  status: 400
}

export type deleteTemplateResponseSuccess = (deleteTemplateResponse200) & {
  headers: Headers;
};
export type deleteTemplateResponseError = (deleteTemplateResponse400) & {
  headers: Headers;
};

export type deleteTemplateResponse = (deleteTemplateResponseSuccess | deleteTemplateResponseError)

export const getDeleteTemplateUrl = () => {




  return `/api/basecamp/templates/delete`
}

export const deleteTemplate = async (deleteTemplateInput: DeleteTemplateInput, options?: Parameters<typeof customFetch>[1]): Promise<deleteTemplateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<deleteTemplateResponse>(getDeleteTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteTemplateInput)
  }
);}





export const getDeleteTemplateMutationKey = () => ['deleteTemplate'] as const;

export const getDeleteTemplateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,DeleteTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,DeleteTemplateMutationVariables, TContext> => {

const mutationKey = getDeleteTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplate>>, DeleteTemplateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplate>>>
    export type DeleteTemplateMutationBody = DeleteTemplateInput
    export type DeleteTemplateMutationError = Error
    export type DeleteTemplateMutationVariables = {data: DeleteTemplateInput}

    export const useDeleteTemplate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplate>>, TError,DeleteTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplate>>,
        TError,
        DeleteTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
    }

export type duplicateTemplateResponse201 = {
  data: TemplateListItem
  status: 201
}

export type duplicateTemplateResponse400 = {
  data: Error
  status: 400
}

export type duplicateTemplateResponseSuccess = (duplicateTemplateResponse201) & {
  headers: Headers;
};
export type duplicateTemplateResponseError = (duplicateTemplateResponse400) & {
  headers: Headers;
};

export type duplicateTemplateResponse = (duplicateTemplateResponseSuccess | duplicateTemplateResponseError)

export const getDuplicateTemplateUrl = () => {




  return `/api/basecamp/templates/duplicate`
}

export const duplicateTemplate = async (duplicateTemplateInput: DuplicateTemplateInput, options?: Parameters<typeof customFetch>[1]): Promise<duplicateTemplateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<duplicateTemplateResponse>(getDuplicateTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(duplicateTemplateInput)
  }
);}





export const getDuplicateTemplateMutationKey = () => ['duplicateTemplate'] as const;

export const getDuplicateTemplateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateTemplate>>, TError,DuplicateTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateTemplate>>, TError,DuplicateTemplateMutationVariables, TContext> => {

const mutationKey = getDuplicateTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateTemplate>>, DuplicateTemplateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  duplicateTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateTemplate>>>
    export type DuplicateTemplateMutationBody = DuplicateTemplateInput
    export type DuplicateTemplateMutationError = Error
    export type DuplicateTemplateMutationVariables = {data: DuplicateTemplateInput}

    export const useDuplicateTemplate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateTemplate>>, TError,DuplicateTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateTemplate>>,
        TError,
        DuplicateTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateTemplateMutationOptions(options), queryClient);
    }

export type createTemplateExportFileResponse200 = {
  data: CreateTemplateExportFileOutput
  status: 200
}

export type createTemplateExportFileResponse400 = {
  data: Error
  status: 400
}

export type createTemplateExportFileResponseSuccess = (createTemplateExportFileResponse200) & {
  headers: Headers;
};
export type createTemplateExportFileResponseError = (createTemplateExportFileResponse400) & {
  headers: Headers;
};

export type createTemplateExportFileResponse = (createTemplateExportFileResponseSuccess | createTemplateExportFileResponseError)

export const getCreateTemplateExportFileUrl = () => {




  return `/api/basecamp/templates/export-file/create`
}

/**
 * Returns a presigned S3 upload URL for a Docxtemplater export template file.
 */
export const createTemplateExportFile = async (createTemplateExportFileInput: CreateTemplateExportFileInput, options?: Parameters<typeof customFetch>[1]): Promise<createTemplateExportFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createTemplateExportFileResponse>(getCreateTemplateExportFileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTemplateExportFileInput)
  }
);}





export const getCreateTemplateExportFileMutationKey = () => ['createTemplateExportFile'] as const;

export const getCreateTemplateExportFileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplateExportFile>>, TError,CreateTemplateExportFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplateExportFile>>, TError,CreateTemplateExportFileMutationVariables, TContext> => {

const mutationKey = getCreateTemplateExportFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplateExportFile>>, CreateTemplateExportFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTemplateExportFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateExportFileMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplateExportFile>>>
    export type CreateTemplateExportFileMutationBody = CreateTemplateExportFileInput
    export type CreateTemplateExportFileMutationError = Error
    export type CreateTemplateExportFileMutationVariables = {data: CreateTemplateExportFileInput}

    export const useCreateTemplateExportFile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplateExportFile>>, TError,CreateTemplateExportFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTemplateExportFile>>,
        TError,
        CreateTemplateExportFileMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTemplateExportFileMutationOptions(options), queryClient);
    }

export type updateTemplateExportFileResponse200 = {
  data: TemplateDetail
  status: 200
}

export type updateTemplateExportFileResponse400 = {
  data: Error
  status: 400
}

export type updateTemplateExportFileResponseSuccess = (updateTemplateExportFileResponse200) & {
  headers: Headers;
};
export type updateTemplateExportFileResponseError = (updateTemplateExportFileResponse400) & {
  headers: Headers;
};

export type updateTemplateExportFileResponse = (updateTemplateExportFileResponseSuccess | updateTemplateExportFileResponseError)

export const getUpdateTemplateExportFileUrl = () => {




  return `/api/basecamp/templates/export-file/update`
}

/**
 * Saves the export template S3 path on the template (or clears it when original_file_name is empty).
 */
export const updateTemplateExportFile = async (updateTemplateExportFileInput: UpdateTemplateExportFileInput, options?: Parameters<typeof customFetch>[1]): Promise<updateTemplateExportFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateTemplateExportFileResponse>(getUpdateTemplateExportFileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTemplateExportFileInput)
  }
);}





export const getUpdateTemplateExportFileMutationKey = () => ['updateTemplateExportFile'] as const;

export const getUpdateTemplateExportFileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplateExportFile>>, TError,UpdateTemplateExportFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplateExportFile>>, TError,UpdateTemplateExportFileMutationVariables, TContext> => {

const mutationKey = getUpdateTemplateExportFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplateExportFile>>, UpdateTemplateExportFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTemplateExportFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateExportFileMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplateExportFile>>>
    export type UpdateTemplateExportFileMutationBody = UpdateTemplateExportFileInput
    export type UpdateTemplateExportFileMutationError = Error
    export type UpdateTemplateExportFileMutationVariables = {data: UpdateTemplateExportFileInput}

    export const useUpdateTemplateExportFile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplateExportFile>>, TError,UpdateTemplateExportFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplateExportFile>>,
        TError,
        UpdateTemplateExportFileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTemplateExportFileMutationOptions(options), queryClient);
    }

export type m2mAddFieldResponse201 = {
  data: SectionField
  status: 201
}

export type m2mAddFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mAddFieldResponseSuccess = (m2mAddFieldResponse201) & {
  headers: Headers;
};
export type m2mAddFieldResponseError = (m2mAddFieldResponse400) & {
  headers: Headers;
};

export type m2mAddFieldResponse = (m2mAddFieldResponseSuccess | m2mAddFieldResponseError)

export const getM2mAddFieldUrl = () => {




  return `/api/basecamp/templates/fields/add`
}

/**
 * POST templates/fields/add — create a field inside a section.
 */
export const m2mAddField = async (addFieldInput: AddFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mAddFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mAddFieldResponse>(getM2mAddFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addFieldInput)
  }
);}





export const getM2mAddFieldMutationKey = () => ['m2mAddField'] as const;

export const getM2mAddFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddField>>, TError,M2mAddFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mAddField>>, TError,M2mAddFieldMutationVariables, TContext> => {

const mutationKey = getM2mAddFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mAddField>>, M2mAddFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mAddField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mAddFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mAddField>>>
    export type M2mAddFieldMutationBody = AddFieldInput
    export type M2mAddFieldMutationError = Error
    export type M2mAddFieldMutationVariables = {data: AddFieldInput}

    export const useM2mAddField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddField>>, TError,M2mAddFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mAddField>>,
        TError,
        M2mAddFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mAddFieldMutationOptions(options), queryClient);
    }

export type m2mMoveFieldResponse200 = {
  data: SectionField
  status: 200
}

export type m2mMoveFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mMoveFieldResponseSuccess = (m2mMoveFieldResponse200) & {
  headers: Headers;
};
export type m2mMoveFieldResponseError = (m2mMoveFieldResponse400) & {
  headers: Headers;
};

export type m2mMoveFieldResponse = (m2mMoveFieldResponseSuccess | m2mMoveFieldResponseError)

export const getM2mMoveFieldUrl = () => {




  return `/api/basecamp/templates/fields/move`
}

/**
 * POST templates/fields/move — change a field's rank_order, optionally moving sections.
 *
 * Set `new_section_id` to move the field to a different section in the
 * same template (validated). Without it, just updates rank_order.
 */
export const m2mMoveField = async (moveFieldInput: MoveFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mMoveFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mMoveFieldResponse>(getM2mMoveFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveFieldInput)
  }
);}





export const getM2mMoveFieldMutationKey = () => ['m2mMoveField'] as const;

export const getM2mMoveFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mMoveField>>, TError,M2mMoveFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mMoveField>>, TError,M2mMoveFieldMutationVariables, TContext> => {

const mutationKey = getM2mMoveFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mMoveField>>, M2mMoveFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mMoveField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mMoveFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mMoveField>>>
    export type M2mMoveFieldMutationBody = MoveFieldInput
    export type M2mMoveFieldMutationError = Error
    export type M2mMoveFieldMutationVariables = {data: MoveFieldInput}

    export const useM2mMoveField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mMoveField>>, TError,M2mMoveFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mMoveField>>,
        TError,
        M2mMoveFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mMoveFieldMutationOptions(options), queryClient);
    }

export type m2mRemoveFieldResponse200 = {
  data: RemoveFieldOutput
  status: 200
}

export type m2mRemoveFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mRemoveFieldResponseSuccess = (m2mRemoveFieldResponse200) & {
  headers: Headers;
};
export type m2mRemoveFieldResponseError = (m2mRemoveFieldResponse400) & {
  headers: Headers;
};

export type m2mRemoveFieldResponse = (m2mRemoveFieldResponseSuccess | m2mRemoveFieldResponseError)

export const getM2mRemoveFieldUrl = () => {




  return `/api/basecamp/templates/fields/remove`
}

/**
 * POST templates/fields/remove — delete a field.
 */
export const m2mRemoveField = async (removeFieldInput: RemoveFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mRemoveFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mRemoveFieldResponse>(getM2mRemoveFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeFieldInput)
  }
);}





export const getM2mRemoveFieldMutationKey = () => ['m2mRemoveField'] as const;

export const getM2mRemoveFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveField>>, TError,M2mRemoveFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveField>>, TError,M2mRemoveFieldMutationVariables, TContext> => {

const mutationKey = getM2mRemoveFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mRemoveField>>, M2mRemoveFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mRemoveField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mRemoveFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mRemoveField>>>
    export type M2mRemoveFieldMutationBody = RemoveFieldInput
    export type M2mRemoveFieldMutationError = Error
    export type M2mRemoveFieldMutationVariables = {data: RemoveFieldInput}

    export const useM2mRemoveField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveField>>, TError,M2mRemoveFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mRemoveField>>,
        TError,
        M2mRemoveFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mRemoveFieldMutationOptions(options), queryClient);
    }

export type m2mUpdateFieldResponse200 = {
  data: SectionField
  status: 200
}

export type m2mUpdateFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mUpdateFieldResponseSuccess = (m2mUpdateFieldResponse200) & {
  headers: Headers;
};
export type m2mUpdateFieldResponseError = (m2mUpdateFieldResponse400) & {
  headers: Headers;
};

export type m2mUpdateFieldResponse = (m2mUpdateFieldResponseSuccess | m2mUpdateFieldResponseError)

export const getM2mUpdateFieldUrl = () => {




  return `/api/basecamp/templates/fields/update`
}

/**
 * POST templates/fields/update — patch field attributes (partial).
 */
export const m2mUpdateField = async (updateFieldInput: UpdateFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mUpdateFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mUpdateFieldResponse>(getM2mUpdateFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFieldInput)
  }
);}





export const getM2mUpdateFieldMutationKey = () => ['m2mUpdateField'] as const;

export const getM2mUpdateFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateField>>, TError,M2mUpdateFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateField>>, TError,M2mUpdateFieldMutationVariables, TContext> => {

const mutationKey = getM2mUpdateFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mUpdateField>>, M2mUpdateFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mUpdateField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mUpdateFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mUpdateField>>>
    export type M2mUpdateFieldMutationBody = UpdateFieldInput
    export type M2mUpdateFieldMutationError = Error
    export type M2mUpdateFieldMutationVariables = {data: UpdateFieldInput}

    export const useM2mUpdateField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateField>>, TError,M2mUpdateFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mUpdateField>>,
        TError,
        M2mUpdateFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mUpdateFieldMutationOptions(options), queryClient);
    }

export type templateGenerationPresignResponse200 = {
  data: TemplateGenerationPresignOutput
  status: 200
}

export type templateGenerationPresignResponse400 = {
  data: Error
  status: 400
}

export type templateGenerationPresignResponseSuccess = (templateGenerationPresignResponse200) & {
  headers: Headers;
};
export type templateGenerationPresignResponseError = (templateGenerationPresignResponse400) & {
  headers: Headers;
};

export type templateGenerationPresignResponse = (templateGenerationPresignResponseSuccess | templateGenerationPresignResponseError)

export const getTemplateGenerationPresignUrl = () => {




  return `/api/basecamp/templates/generate/presign`
}

/**
 * Issue a presigned S3 PUT URL for one file in a template-generation build.
 *
 * The UI calls this once per file (template + each example), all sharing
 * the same `build_id`. Files land at:
 *     s3://REPORT_TEMPLATES_BUCKET/template-builds/<org_slug>/<build_id>/...
 *
 * The returned `s3_uri` is what the UI passes back to the start endpoint;
 * `upload_url` is a short-lived presigned PUT the UI uses to ship the file
 * directly to S3 (no proxying through Django).
 */
export const templateGenerationPresign = async (templateGenerationPresignInput: TemplateGenerationPresignInput, options?: Parameters<typeof customFetch>[1]): Promise<templateGenerationPresignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<templateGenerationPresignResponse>(getTemplateGenerationPresignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(templateGenerationPresignInput)
  }
);}





export const getTemplateGenerationPresignMutationKey = () => ['templateGenerationPresign'] as const;

export const getTemplateGenerationPresignMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof templateGenerationPresign>>, TError,TemplateGenerationPresignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof templateGenerationPresign>>, TError,TemplateGenerationPresignMutationVariables, TContext> => {

const mutationKey = getTemplateGenerationPresignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof templateGenerationPresign>>, TemplateGenerationPresignMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  templateGenerationPresign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TemplateGenerationPresignMutationResult = NonNullable<Awaited<ReturnType<typeof templateGenerationPresign>>>
    export type TemplateGenerationPresignMutationBody = TemplateGenerationPresignInput
    export type TemplateGenerationPresignMutationError = Error
    export type TemplateGenerationPresignMutationVariables = {data: TemplateGenerationPresignInput}

    export const useTemplateGenerationPresign = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof templateGenerationPresign>>, TError,TemplateGenerationPresignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof templateGenerationPresign>>,
        TError,
        TemplateGenerationPresignMutationVariables,
        TContext
      > => {
      return useMutation(getTemplateGenerationPresignMutationOptions(options), queryClient);
    }

export type templateGenerationStartResponse200 = {
  data: TemplateGenerationStartOutput
  status: 200
}

export type templateGenerationStartResponse400 = {
  data: Error
  status: 400
}

export type templateGenerationStartResponseSuccess = (templateGenerationStartResponse200) & {
  headers: Headers;
};
export type templateGenerationStartResponseError = (templateGenerationStartResponse400) & {
  headers: Headers;
};

export type templateGenerationStartResponse = (templateGenerationStartResponseSuccess | templateGenerationStartResponseError)

export const getTemplateGenerationStartUrl = () => {




  return `/api/basecamp/templates/generate/start`
}

/**
 * Start the BuildReportTemplateWorkflow against the basecamp-agentic
 * Temporal task queue using S3-resident input files.
 */
export const templateGenerationStart = async (templateGenerationStartInput: TemplateGenerationStartInput, options?: Parameters<typeof customFetch>[1]): Promise<templateGenerationStartResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<templateGenerationStartResponse>(getTemplateGenerationStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(templateGenerationStartInput)
  }
);}





export const getTemplateGenerationStartMutationKey = () => ['templateGenerationStart'] as const;

export const getTemplateGenerationStartMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof templateGenerationStart>>, TError,TemplateGenerationStartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof templateGenerationStart>>, TError,TemplateGenerationStartMutationVariables, TContext> => {

const mutationKey = getTemplateGenerationStartMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof templateGenerationStart>>, TemplateGenerationStartMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  templateGenerationStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TemplateGenerationStartMutationResult = NonNullable<Awaited<ReturnType<typeof templateGenerationStart>>>
    export type TemplateGenerationStartMutationBody = TemplateGenerationStartInput
    export type TemplateGenerationStartMutationError = Error
    export type TemplateGenerationStartMutationVariables = {data: TemplateGenerationStartInput}

    export const useTemplateGenerationStart = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof templateGenerationStart>>, TError,TemplateGenerationStartMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof templateGenerationStart>>,
        TError,
        TemplateGenerationStartMutationVariables,
        TContext
      > => {
      return useMutation(getTemplateGenerationStartMutationOptions(options), queryClient);
    }

export type templateGenerationStatusResponse200 = {
  data: TemplateGenerationStatusOutput
  status: 200
}

export type templateGenerationStatusResponse404 = {
  data: Error
  status: 404
}

export type templateGenerationStatusResponseSuccess = (templateGenerationStatusResponse200) & {
  headers: Headers;
};
export type templateGenerationStatusResponseError = (templateGenerationStatusResponse404) & {
  headers: Headers;
};

export type templateGenerationStatusResponse = (templateGenerationStatusResponseSuccess | templateGenerationStatusResponseError)

export const getTemplateGenerationStatusUrl = (buildId: string,) => {




  return `/api/basecamp/templates/generate/status/${buildId}`
}

/**
 * Lightweight status check the UI polls while waiting for the workflow
 * to finish. Returns the workflow's execution status (RUNNING /
 * COMPLETED / FAILED / etc.) plus the imported template's relay-encoded
 * id when complete, so the UI can deep-link straight to the new draft.
 */
export const templateGenerationStatus = async (buildId: string, options?: Parameters<typeof customFetch>[1]): Promise<templateGenerationStatusResponse> => {

  return customFetch<templateGenerationStatusResponse>(getTemplateGenerationStatusUrl(buildId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTemplateGenerationStatusQueryKey = (buildId: string,) => {
    return [
    `/api/basecamp/templates/generate/status/${buildId}`
    ] as const;
    }


export const getTemplateGenerationStatusQueryOptions = <TData = Awaited<ReturnType<typeof templateGenerationStatus>>, TError = Error>(buildId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templateGenerationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTemplateGenerationStatusQueryKey(buildId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof templateGenerationStatus>>> = ({ signal }) => templateGenerationStatus(buildId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: buildId !== null && buildId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof templateGenerationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TemplateGenerationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof templateGenerationStatus>>>
export type TemplateGenerationStatusQueryError = Error


export function useTemplateGenerationStatus<TData = Awaited<ReturnType<typeof templateGenerationStatus>>, TError = Error>(
 buildId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof templateGenerationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateGenerationStatus>>,
          TError,
          Awaited<ReturnType<typeof templateGenerationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplateGenerationStatus<TData = Awaited<ReturnType<typeof templateGenerationStatus>>, TError = Error>(
 buildId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templateGenerationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof templateGenerationStatus>>,
          TError,
          Awaited<ReturnType<typeof templateGenerationStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTemplateGenerationStatus<TData = Awaited<ReturnType<typeof templateGenerationStatus>>, TError = Error>(
 buildId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templateGenerationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTemplateGenerationStatus<TData = Awaited<ReturnType<typeof templateGenerationStatus>>, TError = Error>(
 buildId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof templateGenerationStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTemplateGenerationStatusQueryOptions(buildId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type importTemplateJsonResponse201 = {
  data: TemplateListItem
  status: 201
}

export type importTemplateJsonResponse400 = {
  data: Error
  status: 400
}

export type importTemplateJsonResponseSuccess = (importTemplateJsonResponse201) & {
  headers: Headers;
};
export type importTemplateJsonResponseError = (importTemplateJsonResponse400) & {
  headers: Headers;
};

export type importTemplateJsonResponse = (importTemplateJsonResponseSuccess | importTemplateJsonResponseError)

export const getImportTemplateJsonUrl = () => {




  return `/api/basecamp/templates/import-json`
}

export const importTemplateJson = async (importTemplateJsonInput: ImportTemplateJsonInput, options?: Parameters<typeof customFetch>[1]): Promise<importTemplateJsonResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<importTemplateJsonResponse>(getImportTemplateJsonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(importTemplateJsonInput)
  }
);}





export const getImportTemplateJsonMutationKey = () => ['importTemplateJson'] as const;

export const getImportTemplateJsonMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTemplateJson>>, TError,ImportTemplateJsonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importTemplateJson>>, TError,ImportTemplateJsonMutationVariables, TContext> => {

const mutationKey = getImportTemplateJsonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importTemplateJson>>, ImportTemplateJsonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  importTemplateJson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportTemplateJsonMutationResult = NonNullable<Awaited<ReturnType<typeof importTemplateJson>>>
    export type ImportTemplateJsonMutationBody = ImportTemplateJsonInput
    export type ImportTemplateJsonMutationError = Error
    export type ImportTemplateJsonMutationVariables = {data: ImportTemplateJsonInput}

    export const useImportTemplateJson = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importTemplateJson>>, TError,ImportTemplateJsonMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importTemplateJson>>,
        TError,
        ImportTemplateJsonMutationVariables,
        TContext
      > => {
      return useMutation(getImportTemplateJsonMutationOptions(options), queryClient);
    }

export type createTemplateLogoResponse200 = {
  data: CreateTemplateLogoOutput
  status: 200
}

export type createTemplateLogoResponse400 = {
  data: Error
  status: 400
}

export type createTemplateLogoResponseSuccess = (createTemplateLogoResponse200) & {
  headers: Headers;
};
export type createTemplateLogoResponseError = (createTemplateLogoResponse400) & {
  headers: Headers;
};

export type createTemplateLogoResponse = (createTemplateLogoResponseSuccess | createTemplateLogoResponseError)

export const getCreateTemplateLogoUrl = () => {




  return `/api/basecamp/templates/logo/create`
}

/**
 * Returns a presigned S3 upload URL for the template logo.
 */
export const createTemplateLogo = async (createTemplateLogoInput: CreateTemplateLogoInput, options?: Parameters<typeof customFetch>[1]): Promise<createTemplateLogoResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createTemplateLogoResponse>(getCreateTemplateLogoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTemplateLogoInput)
  }
);}





export const getCreateTemplateLogoMutationKey = () => ['createTemplateLogo'] as const;

export const getCreateTemplateLogoMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplateLogo>>, TError,CreateTemplateLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplateLogo>>, TError,CreateTemplateLogoMutationVariables, TContext> => {

const mutationKey = getCreateTemplateLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplateLogo>>, CreateTemplateLogoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTemplateLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateLogoMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplateLogo>>>
    export type CreateTemplateLogoMutationBody = CreateTemplateLogoInput
    export type CreateTemplateLogoMutationError = Error
    export type CreateTemplateLogoMutationVariables = {data: CreateTemplateLogoInput}

    export const useCreateTemplateLogo = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplateLogo>>, TError,CreateTemplateLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTemplateLogo>>,
        TError,
        CreateTemplateLogoMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTemplateLogoMutationOptions(options), queryClient);
    }

export type updateTemplateLogoResponse200 = {
  data: TemplateDetail
  status: 200
}

export type updateTemplateLogoResponse400 = {
  data: Error
  status: 400
}

export type updateTemplateLogoResponseSuccess = (updateTemplateLogoResponse200) & {
  headers: Headers;
};
export type updateTemplateLogoResponseError = (updateTemplateLogoResponse400) & {
  headers: Headers;
};

export type updateTemplateLogoResponse = (updateTemplateLogoResponseSuccess | updateTemplateLogoResponseError)

export const getUpdateTemplateLogoUrl = () => {




  return `/api/basecamp/templates/logo/update`
}

/**
 * Saves the logo S3 path on the template (or clears it when original_file_name is empty).
 */
export const updateTemplateLogo = async (updateTemplateLogoInput: UpdateTemplateLogoInput, options?: Parameters<typeof customFetch>[1]): Promise<updateTemplateLogoResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateTemplateLogoResponse>(getUpdateTemplateLogoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTemplateLogoInput)
  }
);}





export const getUpdateTemplateLogoMutationKey = () => ['updateTemplateLogo'] as const;

export const getUpdateTemplateLogoMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplateLogo>>, TError,UpdateTemplateLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplateLogo>>, TError,UpdateTemplateLogoMutationVariables, TContext> => {

const mutationKey = getUpdateTemplateLogoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplateLogo>>, UpdateTemplateLogoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTemplateLogo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateLogoMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplateLogo>>>
    export type UpdateTemplateLogoMutationBody = UpdateTemplateLogoInput
    export type UpdateTemplateLogoMutationError = Error
    export type UpdateTemplateLogoMutationVariables = {data: UpdateTemplateLogoInput}

    export const useUpdateTemplateLogo = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplateLogo>>, TError,UpdateTemplateLogoMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplateLogo>>,
        TError,
        UpdateTemplateLogoMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTemplateLogoMutationOptions(options), queryClient);
    }

export type m2mGetTemplateResponse200 = {
  data: TemplateDetail
  status: 200
}

export type m2mGetTemplateResponse400 = {
  data: Error
  status: 400
}

export type m2mGetTemplateResponseSuccess = (m2mGetTemplateResponse200) & {
  headers: Headers;
};
export type m2mGetTemplateResponseError = (m2mGetTemplateResponse400) & {
  headers: Headers;
};

export type m2mGetTemplateResponse = (m2mGetTemplateResponseSuccess | m2mGetTemplateResponseError)

export const getM2mGetTemplateUrl = (templateId: number,) => {




  return `/api/basecamp/templates/m2m/${templateId}`
}

/**
 * GET templates/<int:template_id> — return the full template snapshot
 * (sections + fields + prompts) by id alone, no org context required.
 *
 * Replaces the org-scoped FDM GraphQL fetch Rio used to do, which broke
 * on orgless templates and required Rio to know the org context up
 * front. Reuses TemplateDetailSerializer so the shape matches the
 * SPA's existing read.
 */
export const m2mGetTemplate = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<m2mGetTemplateResponse> => {

  return customFetch<m2mGetTemplateResponse>(getM2mGetTemplateUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getM2mGetTemplateQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/m2m/${templateId}`
    ] as const;
    }


export const getM2mGetTemplateQueryOptions = <TData = Awaited<ReturnType<typeof m2mGetTemplate>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getM2mGetTemplateQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof m2mGetTemplate>>> = ({ signal }) => m2mGetTemplate(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type M2mGetTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof m2mGetTemplate>>>
export type M2mGetTemplateQueryError = Error


export function useM2mGetTemplate<TData = Awaited<ReturnType<typeof m2mGetTemplate>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mGetTemplate>>,
          TError,
          Awaited<ReturnType<typeof m2mGetTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mGetTemplate<TData = Awaited<ReturnType<typeof m2mGetTemplate>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mGetTemplate>>,
          TError,
          Awaited<ReturnType<typeof m2mGetTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mGetTemplate<TData = Awaited<ReturnType<typeof m2mGetTemplate>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useM2mGetTemplate<TData = Awaited<ReturnType<typeof m2mGetTemplate>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getM2mGetTemplateQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type m2mGetTemplateMetaResponse200 = {
  data: M2MTemplateMetaOutput
  status: 200
}

export type m2mGetTemplateMetaResponse400 = {
  data: Error
  status: 400
}

export type m2mGetTemplateMetaResponseSuccess = (m2mGetTemplateMetaResponse200) & {
  headers: Headers;
};
export type m2mGetTemplateMetaResponseError = (m2mGetTemplateMetaResponse400) & {
  headers: Headers;
};

export type m2mGetTemplateMetaResponse = (m2mGetTemplateMetaResponseSuccess | m2mGetTemplateMetaResponseError)

export const getM2mGetTemplateMetaUrl = (templateId: number,) => {




  return `/api/basecamp/templates/m2m/${templateId}/meta`
}

/**
 * GET templates/m2m/<id>/meta — lightweight freshness probe.
 *
 * Returns just `{id, status, last_updated_date}` so Rio's workflow
 * can decide whether its cached full-template snapshot is still
 * valid. Used to avoid re-pulling the full sections+fields tree on
 * every turn when nothing changed.
 */
export const m2mGetTemplateMeta = async (templateId: number, options?: Parameters<typeof customFetch>[1]): Promise<m2mGetTemplateMetaResponse> => {

  return customFetch<m2mGetTemplateMetaResponse>(getM2mGetTemplateMetaUrl(templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getM2mGetTemplateMetaQueryKey = (templateId: number,) => {
    return [
    `/api/basecamp/templates/m2m/${templateId}/meta`
    ] as const;
    }


export const getM2mGetTemplateMetaQueryOptions = <TData = Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError = Error>(templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getM2mGetTemplateMetaQueryKey(templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof m2mGetTemplateMeta>>> = ({ signal }) => m2mGetTemplateMeta(templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type M2mGetTemplateMetaQueryResult = NonNullable<Awaited<ReturnType<typeof m2mGetTemplateMeta>>>
export type M2mGetTemplateMetaQueryError = Error


export function useM2mGetTemplateMeta<TData = Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError = Error>(
 templateId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mGetTemplateMeta>>,
          TError,
          Awaited<ReturnType<typeof m2mGetTemplateMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mGetTemplateMeta<TData = Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mGetTemplateMeta>>,
          TError,
          Awaited<ReturnType<typeof m2mGetTemplateMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mGetTemplateMeta<TData = Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useM2mGetTemplateMeta<TData = Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError = Error>(
 templateId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mGetTemplateMeta>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getM2mGetTemplateMetaQueryOptions(templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type m2mSearchPromptsResponse200 = {
  data: M2MSearchPromptsOutput
  status: 200
}

export type m2mSearchPromptsResponse400 = {
  data: Error
  status: 400
}

export type m2mSearchPromptsResponseSuccess = (m2mSearchPromptsResponse200) & {
  headers: Headers;
};
export type m2mSearchPromptsResponseError = (m2mSearchPromptsResponse400) & {
  headers: Headers;
};

export type m2mSearchPromptsResponse = (m2mSearchPromptsResponseSuccess | m2mSearchPromptsResponseError)

export const getM2mSearchPromptsUrl = (params?: M2mSearchPromptsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/templates/m2m/prompts/search?${stringifiedParams}` : `/api/basecamp/templates/m2m/prompts/search`
}

/**
 * GET templates/m2m/prompts/search — search for existing prompts so
 * Rio can assign one to a field via `apply_update_field(prompt_id=…)`.
 *
 * No org scoping — returns prompts across all organizations so Rio can
 * copy prompt assignments when working across templates. Rio never
 * creates prompts — only looks them up by name/key for assignment.
 */
export const m2mSearchPrompts = async (params?: M2mSearchPromptsParams, options?: Parameters<typeof customFetch>[1]): Promise<m2mSearchPromptsResponse> => {

  return customFetch<m2mSearchPromptsResponse>(getM2mSearchPromptsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getM2mSearchPromptsQueryKey = (params?: M2mSearchPromptsParams,) => {
    return [
    `/api/basecamp/templates/m2m/prompts/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getM2mSearchPromptsQueryOptions = <TData = Awaited<ReturnType<typeof m2mSearchPrompts>>, TError = Error>(params?: M2mSearchPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchPrompts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getM2mSearchPromptsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof m2mSearchPrompts>>> = ({ signal }) => m2mSearchPrompts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof m2mSearchPrompts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type M2mSearchPromptsQueryResult = NonNullable<Awaited<ReturnType<typeof m2mSearchPrompts>>>
export type M2mSearchPromptsQueryError = Error


export function useM2mSearchPrompts<TData = Awaited<ReturnType<typeof m2mSearchPrompts>>, TError = Error>(
 params: undefined |  M2mSearchPromptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchPrompts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mSearchPrompts>>,
          TError,
          Awaited<ReturnType<typeof m2mSearchPrompts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mSearchPrompts<TData = Awaited<ReturnType<typeof m2mSearchPrompts>>, TError = Error>(
 params?: M2mSearchPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchPrompts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mSearchPrompts>>,
          TError,
          Awaited<ReturnType<typeof m2mSearchPrompts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mSearchPrompts<TData = Awaited<ReturnType<typeof m2mSearchPrompts>>, TError = Error>(
 params?: M2mSearchPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchPrompts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useM2mSearchPrompts<TData = Awaited<ReturnType<typeof m2mSearchPrompts>>, TError = Error>(
 params?: M2mSearchPromptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchPrompts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getM2mSearchPromptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type m2mSearchTemplatesResponse200 = {
  data: M2MSearchTemplatesOutput
  status: 200
}

export type m2mSearchTemplatesResponse400 = {
  data: Error
  status: 400
}

export type m2mSearchTemplatesResponseSuccess = (m2mSearchTemplatesResponse200) & {
  headers: Headers;
};
export type m2mSearchTemplatesResponseError = (m2mSearchTemplatesResponse400) & {
  headers: Headers;
};

export type m2mSearchTemplatesResponse = (m2mSearchTemplatesResponseSuccess | m2mSearchTemplatesResponseError)

export const getM2mSearchTemplatesUrl = (params?: M2mSearchTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/templates/m2m/templates/search?${stringifiedParams}` : `/api/basecamp/templates/m2m/templates/search`
}

/**
 * GET templates/m2m/templates/search — search templates so Rio can
 * reference another template (e.g. "add a section like the one in
 * template X"). Read-only across all statuses; Rio writes only to the
 * current Draft template via the section/field mutation endpoints.
 */
export const m2mSearchTemplates = async (params?: M2mSearchTemplatesParams, options?: Parameters<typeof customFetch>[1]): Promise<m2mSearchTemplatesResponse> => {

  return customFetch<m2mSearchTemplatesResponse>(getM2mSearchTemplatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getM2mSearchTemplatesQueryKey = (params?: M2mSearchTemplatesParams,) => {
    return [
    `/api/basecamp/templates/m2m/templates/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getM2mSearchTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof m2mSearchTemplates>>, TError = Error>(params?: M2mSearchTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getM2mSearchTemplatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof m2mSearchTemplates>>> = ({ signal }) => m2mSearchTemplates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof m2mSearchTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type M2mSearchTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof m2mSearchTemplates>>>
export type M2mSearchTemplatesQueryError = Error


export function useM2mSearchTemplates<TData = Awaited<ReturnType<typeof m2mSearchTemplates>>, TError = Error>(
 params: undefined |  M2mSearchTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mSearchTemplates>>,
          TError,
          Awaited<ReturnType<typeof m2mSearchTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mSearchTemplates<TData = Awaited<ReturnType<typeof m2mSearchTemplates>>, TError = Error>(
 params?: M2mSearchTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof m2mSearchTemplates>>,
          TError,
          Awaited<ReturnType<typeof m2mSearchTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useM2mSearchTemplates<TData = Awaited<ReturnType<typeof m2mSearchTemplates>>, TError = Error>(
 params?: M2mSearchTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useM2mSearchTemplates<TData = Awaited<ReturnType<typeof m2mSearchTemplates>>, TError = Error>(
 params?: M2mSearchTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof m2mSearchTemplates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getM2mSearchTemplatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type m2mUpdateTemplateDescriptionResponse200 = {
  data: M2MUpdateTemplateDescriptionOutput
  status: 200
}

export type m2mUpdateTemplateDescriptionResponse400 = {
  data: Error
  status: 400
}

export type m2mUpdateTemplateDescriptionResponseSuccess = (m2mUpdateTemplateDescriptionResponse200) & {
  headers: Headers;
};
export type m2mUpdateTemplateDescriptionResponseError = (m2mUpdateTemplateDescriptionResponse400) & {
  headers: Headers;
};

export type m2mUpdateTemplateDescriptionResponse = (m2mUpdateTemplateDescriptionResponseSuccess | m2mUpdateTemplateDescriptionResponseError)

export const getM2mUpdateTemplateDescriptionUrl = () => {




  return `/api/basecamp/templates/m2m/update-description`
}

/**
 * POST templates/m2m/update-description — overwrite the description
 * on a Draft template. Used by Rio to roll up a session's structural
 * changes into a one-paragraph summary when the user signals
 * readiness to publish.
 *
 * Draft-only by design (uses `_get_editable_template_or_400`): Rio
 * must never rewrite a Published or Archived template's description.
 * Empty string is allowed (clears the description).
 */
export const m2mUpdateTemplateDescription = async (m2MUpdateTemplateDescriptionInput: M2MUpdateTemplateDescriptionInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mUpdateTemplateDescriptionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mUpdateTemplateDescriptionResponse>(getM2mUpdateTemplateDescriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MUpdateTemplateDescriptionInput)
  }
);}





export const getM2mUpdateTemplateDescriptionMutationKey = () => ['m2mUpdateTemplateDescription'] as const;

export const getM2mUpdateTemplateDescriptionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateTemplateDescription>>, TError,M2mUpdateTemplateDescriptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateTemplateDescription>>, TError,M2mUpdateTemplateDescriptionMutationVariables, TContext> => {

const mutationKey = getM2mUpdateTemplateDescriptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mUpdateTemplateDescription>>, M2mUpdateTemplateDescriptionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mUpdateTemplateDescription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mUpdateTemplateDescriptionMutationResult = NonNullable<Awaited<ReturnType<typeof m2mUpdateTemplateDescription>>>
    export type M2mUpdateTemplateDescriptionMutationBody = M2MUpdateTemplateDescriptionInput
    export type M2mUpdateTemplateDescriptionMutationError = Error
    export type M2mUpdateTemplateDescriptionMutationVariables = {data: M2MUpdateTemplateDescriptionInput}

    export const useM2mUpdateTemplateDescription = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateTemplateDescription>>, TError,M2mUpdateTemplateDescriptionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mUpdateTemplateDescription>>,
        TError,
        M2mUpdateTemplateDescriptionMutationVariables,
        TContext
      > => {
      return useMutation(getM2mUpdateTemplateDescriptionMutationOptions(options), queryClient);
    }

export type updateReportTemplateOrganizationFolderResponse200 = {
  data: UpdateReportTemplateOrganizationFolderOutput
  status: 200
}

export type updateReportTemplateOrganizationFolderResponse400 = {
  data: Error
  status: 400
}

export type updateReportTemplateOrganizationFolderResponseSuccess = (updateReportTemplateOrganizationFolderResponse200) & {
  headers: Headers;
};
export type updateReportTemplateOrganizationFolderResponseError = (updateReportTemplateOrganizationFolderResponse400) & {
  headers: Headers;
};

export type updateReportTemplateOrganizationFolderResponse = (updateReportTemplateOrganizationFolderResponseSuccess | updateReportTemplateOrganizationFolderResponseError)

export const getUpdateReportTemplateOrganizationFolderUrl = () => {




  return `/api/basecamp/templates/organizations/update-ehr-sync-folder`
}

/**
 * POST templates/organizations/update-ehr-sync-folder (INT-79 follow-up).
 *
 * Lets Basecamp admins set the CentralReach learning-tree parent folder
 * override for one org + template pair directly, instead of going through
 * Django admin. Validation reuses ReportTemplateOrganization.clean() via
 * full_clean(), so an org + template pair EHR sync wouldn't honor the
 * folder for gets a clear 400 instead of silently storing a no-op value.
 */
export const updateReportTemplateOrganizationFolder = async (updateReportTemplateOrganizationFolderInput: UpdateReportTemplateOrganizationFolderInput, options?: Parameters<typeof customFetch>[1]): Promise<updateReportTemplateOrganizationFolderResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateReportTemplateOrganizationFolderResponse>(getUpdateReportTemplateOrganizationFolderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateReportTemplateOrganizationFolderInput)
  }
);}





export const getUpdateReportTemplateOrganizationFolderMutationKey = () => ['updateReportTemplateOrganizationFolder'] as const;

export const getUpdateReportTemplateOrganizationFolderMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReportTemplateOrganizationFolder>>, TError,UpdateReportTemplateOrganizationFolderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReportTemplateOrganizationFolder>>, TError,UpdateReportTemplateOrganizationFolderMutationVariables, TContext> => {

const mutationKey = getUpdateReportTemplateOrganizationFolderMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReportTemplateOrganizationFolder>>, UpdateReportTemplateOrganizationFolderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateReportTemplateOrganizationFolder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReportTemplateOrganizationFolderMutationResult = NonNullable<Awaited<ReturnType<typeof updateReportTemplateOrganizationFolder>>>
    export type UpdateReportTemplateOrganizationFolderMutationBody = UpdateReportTemplateOrganizationFolderInput
    export type UpdateReportTemplateOrganizationFolderMutationError = Error
    export type UpdateReportTemplateOrganizationFolderMutationVariables = {data: UpdateReportTemplateOrganizationFolderInput}

    export const useUpdateReportTemplateOrganizationFolder = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReportTemplateOrganizationFolder>>, TError,UpdateReportTemplateOrganizationFolderMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateReportTemplateOrganizationFolder>>,
        TError,
        UpdateReportTemplateOrganizationFolderMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateReportTemplateOrganizationFolderMutationOptions(options), queryClient);
    }

export type promoteTemplateResponse200 = {
  data: PromoteTemplateOutput
  status: 200
}

export type promoteTemplateResponse400 = {
  data: Error
  status: 400
}

export type promoteTemplateResponseSuccess = (promoteTemplateResponse200) & {
  headers: Headers;
};
export type promoteTemplateResponseError = (promoteTemplateResponse400) & {
  headers: Headers;
};

export type promoteTemplateResponse = (promoteTemplateResponseSuccess | promoteTemplateResponseError)

export const getPromoteTemplateUrl = () => {




  return `/api/basecamp/templates/promote`
}

export const promoteTemplate = async (promoteTemplateInput: PromoteTemplateInput, options?: Parameters<typeof customFetch>[1]): Promise<promoteTemplateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<promoteTemplateResponse>(getPromoteTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoteTemplateInput)
  }
);}





export const getPromoteTemplateMutationKey = () => ['promoteTemplate'] as const;

export const getPromoteTemplateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteTemplate>>, TError,PromoteTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof promoteTemplate>>, TError,PromoteTemplateMutationVariables, TContext> => {

const mutationKey = getPromoteTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteTemplate>>, PromoteTemplateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  promoteTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PromoteTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof promoteTemplate>>>
    export type PromoteTemplateMutationBody = PromoteTemplateInput
    export type PromoteTemplateMutationError = Error
    export type PromoteTemplateMutationVariables = {data: PromoteTemplateInput}

    export const usePromoteTemplate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteTemplate>>, TError,PromoteTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof promoteTemplate>>,
        TError,
        PromoteTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getPromoteTemplateMutationOptions(options), queryClient);
    }

export type createTemplateQaCriteriaResponse201 = {
  data: QACriteria
  status: 201
}

export type createTemplateQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type createTemplateQaCriteriaResponseSuccess = (createTemplateQaCriteriaResponse201) & {
  headers: Headers;
};
export type createTemplateQaCriteriaResponseError = (createTemplateQaCriteriaResponse400) & {
  headers: Headers;
};

export type createTemplateQaCriteriaResponse = (createTemplateQaCriteriaResponseSuccess | createTemplateQaCriteriaResponseError)

export const getCreateTemplateQaCriteriaUrl = () => {




  return `/api/basecamp/templates/qa-criteria/create`
}

export const createTemplateQaCriteria = async (createTemplateQACriteriaInput: CreateTemplateQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<createTemplateQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createTemplateQaCriteriaResponse>(getCreateTemplateQaCriteriaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createTemplateQACriteriaInput)
  }
);}





export const getCreateTemplateQaCriteriaMutationKey = () => ['createTemplateQaCriteria'] as const;

export const getCreateTemplateQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplateQaCriteria>>, TError,CreateTemplateQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTemplateQaCriteria>>, TError,CreateTemplateQaCriteriaMutationVariables, TContext> => {

const mutationKey = getCreateTemplateQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTemplateQaCriteria>>, CreateTemplateQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTemplateQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTemplateQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof createTemplateQaCriteria>>>
    export type CreateTemplateQaCriteriaMutationBody = CreateTemplateQACriteriaInput
    export type CreateTemplateQaCriteriaMutationError = Error
    export type CreateTemplateQaCriteriaMutationVariables = {data: CreateTemplateQACriteriaInput}

    export const useCreateTemplateQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTemplateQaCriteria>>, TError,CreateTemplateQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTemplateQaCriteria>>,
        TError,
        CreateTemplateQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTemplateQaCriteriaMutationOptions(options), queryClient);
    }

export type deleteTemplateQaCriteriaResponse200 = {
  data: void
  status: 200
}

export type deleteTemplateQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type deleteTemplateQaCriteriaResponseSuccess = (deleteTemplateQaCriteriaResponse200) & {
  headers: Headers;
};
export type deleteTemplateQaCriteriaResponseError = (deleteTemplateQaCriteriaResponse400) & {
  headers: Headers;
};

export type deleteTemplateQaCriteriaResponse = (deleteTemplateQaCriteriaResponseSuccess | deleteTemplateQaCriteriaResponseError)

export const getDeleteTemplateQaCriteriaUrl = () => {




  return `/api/basecamp/templates/qa-criteria/delete`
}

export const deleteTemplateQaCriteria = async (deleteTemplateQACriteriaInput: DeleteTemplateQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<deleteTemplateQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<deleteTemplateQaCriteriaResponse>(getDeleteTemplateQaCriteriaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteTemplateQACriteriaInput)
  }
);}





export const getDeleteTemplateQaCriteriaMutationKey = () => ['deleteTemplateQaCriteria'] as const;

export const getDeleteTemplateQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplateQaCriteria>>, TError,DeleteTemplateQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTemplateQaCriteria>>, TError,DeleteTemplateQaCriteriaMutationVariables, TContext> => {

const mutationKey = getDeleteTemplateQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTemplateQaCriteria>>, DeleteTemplateQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteTemplateQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTemplateQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTemplateQaCriteria>>>
    export type DeleteTemplateQaCriteriaMutationBody = DeleteTemplateQACriteriaInput
    export type DeleteTemplateQaCriteriaMutationError = Error
    export type DeleteTemplateQaCriteriaMutationVariables = {data: DeleteTemplateQACriteriaInput}

    export const useDeleteTemplateQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTemplateQaCriteria>>, TError,DeleteTemplateQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTemplateQaCriteria>>,
        TError,
        DeleteTemplateQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTemplateQaCriteriaMutationOptions(options), queryClient);
    }

export type updateTemplateQaCriteriaResponse200 = {
  data: QACriteria
  status: 200
}

export type updateTemplateQaCriteriaResponse400 = {
  data: Error
  status: 400
}

export type updateTemplateQaCriteriaResponseSuccess = (updateTemplateQaCriteriaResponse200) & {
  headers: Headers;
};
export type updateTemplateQaCriteriaResponseError = (updateTemplateQaCriteriaResponse400) & {
  headers: Headers;
};

export type updateTemplateQaCriteriaResponse = (updateTemplateQaCriteriaResponseSuccess | updateTemplateQaCriteriaResponseError)

export const getUpdateTemplateQaCriteriaUrl = () => {




  return `/api/basecamp/templates/qa-criteria/update`
}

export const updateTemplateQaCriteria = async (updateTemplateQACriteriaInput: UpdateTemplateQACriteriaInput, options?: Parameters<typeof customFetch>[1]): Promise<updateTemplateQaCriteriaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateTemplateQaCriteriaResponse>(getUpdateTemplateQaCriteriaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTemplateQACriteriaInput)
  }
);}





export const getUpdateTemplateQaCriteriaMutationKey = () => ['updateTemplateQaCriteria'] as const;

export const getUpdateTemplateQaCriteriaMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplateQaCriteria>>, TError,UpdateTemplateQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplateQaCriteria>>, TError,UpdateTemplateQaCriteriaMutationVariables, TContext> => {

const mutationKey = getUpdateTemplateQaCriteriaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplateQaCriteria>>, UpdateTemplateQaCriteriaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTemplateQaCriteria(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateQaCriteriaMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplateQaCriteria>>>
    export type UpdateTemplateQaCriteriaMutationBody = UpdateTemplateQACriteriaInput
    export type UpdateTemplateQaCriteriaMutationError = Error
    export type UpdateTemplateQaCriteriaMutationVariables = {data: UpdateTemplateQACriteriaInput}

    export const useUpdateTemplateQaCriteria = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplateQaCriteria>>, TError,UpdateTemplateQaCriteriaMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplateQaCriteria>>,
        TError,
        UpdateTemplateQaCriteriaMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTemplateQaCriteriaMutationOptions(options), queryClient);
    }

export type m2mAddSectionResponse201 = {
  data: Section
  status: 201
}

export type m2mAddSectionResponse400 = {
  data: Error
  status: 400
}

export type m2mAddSectionResponseSuccess = (m2mAddSectionResponse201) & {
  headers: Headers;
};
export type m2mAddSectionResponseError = (m2mAddSectionResponse400) & {
  headers: Headers;
};

export type m2mAddSectionResponse = (m2mAddSectionResponseSuccess | m2mAddSectionResponseError)

export const getM2mAddSectionUrl = () => {




  return `/api/basecamp/templates/sections/add`
}

/**
 * POST templates/sections/add — create a new section on a template.
 */
export const m2mAddSection = async (addSectionInput: AddSectionInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mAddSectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mAddSectionResponse>(getM2mAddSectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addSectionInput)
  }
);}





export const getM2mAddSectionMutationKey = () => ['m2mAddSection'] as const;

export const getM2mAddSectionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddSection>>, TError,M2mAddSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mAddSection>>, TError,M2mAddSectionMutationVariables, TContext> => {

const mutationKey = getM2mAddSectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mAddSection>>, M2mAddSectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mAddSection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mAddSectionMutationResult = NonNullable<Awaited<ReturnType<typeof m2mAddSection>>>
    export type M2mAddSectionMutationBody = AddSectionInput
    export type M2mAddSectionMutationError = Error
    export type M2mAddSectionMutationVariables = {data: AddSectionInput}

    export const useM2mAddSection = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddSection>>, TError,M2mAddSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mAddSection>>,
        TError,
        M2mAddSectionMutationVariables,
        TContext
      > => {
      return useMutation(getM2mAddSectionMutationOptions(options), queryClient);
    }

export type m2mMoveSectionResponse200 = {
  data: Section
  status: 200
}

export type m2mMoveSectionResponse400 = {
  data: Error
  status: 400
}

export type m2mMoveSectionResponseSuccess = (m2mMoveSectionResponse200) & {
  headers: Headers;
};
export type m2mMoveSectionResponseError = (m2mMoveSectionResponse400) & {
  headers: Headers;
};

export type m2mMoveSectionResponse = (m2mMoveSectionResponseSuccess | m2mMoveSectionResponseError)

export const getM2mMoveSectionUrl = () => {




  return `/api/basecamp/templates/sections/move`
}

/**
 * POST templates/sections/move — set a section's rank_order.
 *
 * Does NOT renumber siblings. Callers are responsible for resolving
 * duplicate rank_orders if they care about consecutive ordering.
 */
export const m2mMoveSection = async (moveSectionInput: MoveSectionInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mMoveSectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mMoveSectionResponse>(getM2mMoveSectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(moveSectionInput)
  }
);}





export const getM2mMoveSectionMutationKey = () => ['m2mMoveSection'] as const;

export const getM2mMoveSectionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mMoveSection>>, TError,M2mMoveSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mMoveSection>>, TError,M2mMoveSectionMutationVariables, TContext> => {

const mutationKey = getM2mMoveSectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mMoveSection>>, M2mMoveSectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mMoveSection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mMoveSectionMutationResult = NonNullable<Awaited<ReturnType<typeof m2mMoveSection>>>
    export type M2mMoveSectionMutationBody = MoveSectionInput
    export type M2mMoveSectionMutationError = Error
    export type M2mMoveSectionMutationVariables = {data: MoveSectionInput}

    export const useM2mMoveSection = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mMoveSection>>, TError,M2mMoveSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mMoveSection>>,
        TError,
        M2mMoveSectionMutationVariables,
        TContext
      > => {
      return useMutation(getM2mMoveSectionMutationOptions(options), queryClient);
    }

export type m2mRemoveSectionResponse200 = {
  data: RemoveSectionOutput
  status: 200
}

export type m2mRemoveSectionResponse400 = {
  data: Error
  status: 400
}

export type m2mRemoveSectionResponseSuccess = (m2mRemoveSectionResponse200) & {
  headers: Headers;
};
export type m2mRemoveSectionResponseError = (m2mRemoveSectionResponse400) & {
  headers: Headers;
};

export type m2mRemoveSectionResponse = (m2mRemoveSectionResponseSuccess | m2mRemoveSectionResponseError)

export const getM2mRemoveSectionUrl = () => {




  return `/api/basecamp/templates/sections/remove`
}

/**
 * POST templates/sections/remove — delete a section (cascades to fields).
 */
export const m2mRemoveSection = async (removeSectionInput: RemoveSectionInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mRemoveSectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mRemoveSectionResponse>(getM2mRemoveSectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeSectionInput)
  }
);}





export const getM2mRemoveSectionMutationKey = () => ['m2mRemoveSection'] as const;

export const getM2mRemoveSectionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveSection>>, TError,M2mRemoveSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveSection>>, TError,M2mRemoveSectionMutationVariables, TContext> => {

const mutationKey = getM2mRemoveSectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mRemoveSection>>, M2mRemoveSectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mRemoveSection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mRemoveSectionMutationResult = NonNullable<Awaited<ReturnType<typeof m2mRemoveSection>>>
    export type M2mRemoveSectionMutationBody = RemoveSectionInput
    export type M2mRemoveSectionMutationError = Error
    export type M2mRemoveSectionMutationVariables = {data: RemoveSectionInput}

    export const useM2mRemoveSection = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveSection>>, TError,M2mRemoveSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mRemoveSection>>,
        TError,
        M2mRemoveSectionMutationVariables,
        TContext
      > => {
      return useMutation(getM2mRemoveSectionMutationOptions(options), queryClient);
    }

export type m2mUpdateSectionResponse200 = {
  data: Section
  status: 200
}

export type m2mUpdateSectionResponse400 = {
  data: Error
  status: 400
}

export type m2mUpdateSectionResponseSuccess = (m2mUpdateSectionResponse200) & {
  headers: Headers;
};
export type m2mUpdateSectionResponseError = (m2mUpdateSectionResponse400) & {
  headers: Headers;
};

export type m2mUpdateSectionResponse = (m2mUpdateSectionResponseSuccess | m2mUpdateSectionResponseError)

export const getM2mUpdateSectionUrl = () => {




  return `/api/basecamp/templates/sections/update`
}

/**
 * POST templates/sections/update — patch section metadata (no field changes).
 */
export const m2mUpdateSection = async (updateSectionInput: UpdateSectionInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mUpdateSectionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mUpdateSectionResponse>(getM2mUpdateSectionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSectionInput)
  }
);}





export const getM2mUpdateSectionMutationKey = () => ['m2mUpdateSection'] as const;

export const getM2mUpdateSectionMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateSection>>, TError,M2mUpdateSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateSection>>, TError,M2mUpdateSectionMutationVariables, TContext> => {

const mutationKey = getM2mUpdateSectionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mUpdateSection>>, M2mUpdateSectionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mUpdateSection(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mUpdateSectionMutationResult = NonNullable<Awaited<ReturnType<typeof m2mUpdateSection>>>
    export type M2mUpdateSectionMutationBody = UpdateSectionInput
    export type M2mUpdateSectionMutationError = Error
    export type M2mUpdateSectionMutationVariables = {data: UpdateSectionInput}

    export const useM2mUpdateSection = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateSection>>, TError,M2mUpdateSectionMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mUpdateSection>>,
        TError,
        M2mUpdateSectionMutationVariables,
        TContext
      > => {
      return useMutation(getM2mUpdateSectionMutationOptions(options), queryClient);
    }

export type m2mAddTreatmentPlanDomainResponse201 = {
  data: M2MTreatmentPlanDomain
  status: 201
}

export type m2mAddTreatmentPlanDomainResponse400 = {
  data: Error
  status: 400
}

export type m2mAddTreatmentPlanDomainResponseSuccess = (m2mAddTreatmentPlanDomainResponse201) & {
  headers: Headers;
};
export type m2mAddTreatmentPlanDomainResponseError = (m2mAddTreatmentPlanDomainResponse400) & {
  headers: Headers;
};

export type m2mAddTreatmentPlanDomainResponse = (m2mAddTreatmentPlanDomainResponseSuccess | m2mAddTreatmentPlanDomainResponseError)

export const getM2mAddTreatmentPlanDomainUrl = () => {




  return `/api/basecamp/templates/treatment-plan/domains/add`
}

/**
 * POST templates/treatment-plan/domains/add
 */
export const m2mAddTreatmentPlanDomain = async (m2MAddTPDomainInput: M2MAddTPDomainInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mAddTreatmentPlanDomainResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mAddTreatmentPlanDomainResponse>(getM2mAddTreatmentPlanDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MAddTPDomainInput)
  }
);}





export const getM2mAddTreatmentPlanDomainMutationKey = () => ['m2mAddTreatmentPlanDomain'] as const;

export const getM2mAddTreatmentPlanDomainMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddTreatmentPlanDomain>>, TError,M2mAddTreatmentPlanDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mAddTreatmentPlanDomain>>, TError,M2mAddTreatmentPlanDomainMutationVariables, TContext> => {

const mutationKey = getM2mAddTreatmentPlanDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mAddTreatmentPlanDomain>>, M2mAddTreatmentPlanDomainMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mAddTreatmentPlanDomain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mAddTreatmentPlanDomainMutationResult = NonNullable<Awaited<ReturnType<typeof m2mAddTreatmentPlanDomain>>>
    export type M2mAddTreatmentPlanDomainMutationBody = M2MAddTPDomainInput
    export type M2mAddTreatmentPlanDomainMutationError = Error
    export type M2mAddTreatmentPlanDomainMutationVariables = {data: M2MAddTPDomainInput}

    export const useM2mAddTreatmentPlanDomain = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddTreatmentPlanDomain>>, TError,M2mAddTreatmentPlanDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mAddTreatmentPlanDomain>>,
        TError,
        M2mAddTreatmentPlanDomainMutationVariables,
        TContext
      > => {
      return useMutation(getM2mAddTreatmentPlanDomainMutationOptions(options), queryClient);
    }

export type m2mRemoveTreatmentPlanDomainResponse200 = {
  data: void
  status: 200
}

export type m2mRemoveTreatmentPlanDomainResponse400 = {
  data: Error
  status: 400
}

export type m2mRemoveTreatmentPlanDomainResponseSuccess = (m2mRemoveTreatmentPlanDomainResponse200) & {
  headers: Headers;
};
export type m2mRemoveTreatmentPlanDomainResponseError = (m2mRemoveTreatmentPlanDomainResponse400) & {
  headers: Headers;
};

export type m2mRemoveTreatmentPlanDomainResponse = (m2mRemoveTreatmentPlanDomainResponseSuccess | m2mRemoveTreatmentPlanDomainResponseError)

export const getM2mRemoveTreatmentPlanDomainUrl = () => {




  return `/api/basecamp/templates/treatment-plan/domains/remove`
}

/**
 * POST templates/treatment-plan/domains/remove — deletes the domain
 * AND its goal fields (cascade).
 */
export const m2mRemoveTreatmentPlanDomain = async (m2MRemoveTPDomainInput: M2MRemoveTPDomainInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mRemoveTreatmentPlanDomainResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mRemoveTreatmentPlanDomainResponse>(getM2mRemoveTreatmentPlanDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MRemoveTPDomainInput)
  }
);}





export const getM2mRemoveTreatmentPlanDomainMutationKey = () => ['m2mRemoveTreatmentPlanDomain'] as const;

export const getM2mRemoveTreatmentPlanDomainMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveTreatmentPlanDomain>>, TError,M2mRemoveTreatmentPlanDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveTreatmentPlanDomain>>, TError,M2mRemoveTreatmentPlanDomainMutationVariables, TContext> => {

const mutationKey = getM2mRemoveTreatmentPlanDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mRemoveTreatmentPlanDomain>>, M2mRemoveTreatmentPlanDomainMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mRemoveTreatmentPlanDomain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mRemoveTreatmentPlanDomainMutationResult = NonNullable<Awaited<ReturnType<typeof m2mRemoveTreatmentPlanDomain>>>
    export type M2mRemoveTreatmentPlanDomainMutationBody = M2MRemoveTPDomainInput
    export type M2mRemoveTreatmentPlanDomainMutationError = Error
    export type M2mRemoveTreatmentPlanDomainMutationVariables = {data: M2MRemoveTPDomainInput}

    export const useM2mRemoveTreatmentPlanDomain = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveTreatmentPlanDomain>>, TError,M2mRemoveTreatmentPlanDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mRemoveTreatmentPlanDomain>>,
        TError,
        M2mRemoveTreatmentPlanDomainMutationVariables,
        TContext
      > => {
      return useMutation(getM2mRemoveTreatmentPlanDomainMutationOptions(options), queryClient);
    }

export type m2mUpdateTreatmentPlanDomainResponse200 = {
  data: M2MTreatmentPlanDomain
  status: 200
}

export type m2mUpdateTreatmentPlanDomainResponse400 = {
  data: Error
  status: 400
}

export type m2mUpdateTreatmentPlanDomainResponseSuccess = (m2mUpdateTreatmentPlanDomainResponse200) & {
  headers: Headers;
};
export type m2mUpdateTreatmentPlanDomainResponseError = (m2mUpdateTreatmentPlanDomainResponse400) & {
  headers: Headers;
};

export type m2mUpdateTreatmentPlanDomainResponse = (m2mUpdateTreatmentPlanDomainResponseSuccess | m2mUpdateTreatmentPlanDomainResponseError)

export const getM2mUpdateTreatmentPlanDomainUrl = () => {




  return `/api/basecamp/templates/treatment-plan/domains/update`
}

/**
 * POST templates/treatment-plan/domains/update
 */
export const m2mUpdateTreatmentPlanDomain = async (m2MUpdateTPDomainInput: M2MUpdateTPDomainInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mUpdateTreatmentPlanDomainResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mUpdateTreatmentPlanDomainResponse>(getM2mUpdateTreatmentPlanDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MUpdateTPDomainInput)
  }
);}





export const getM2mUpdateTreatmentPlanDomainMutationKey = () => ['m2mUpdateTreatmentPlanDomain'] as const;

export const getM2mUpdateTreatmentPlanDomainMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateTreatmentPlanDomain>>, TError,M2mUpdateTreatmentPlanDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateTreatmentPlanDomain>>, TError,M2mUpdateTreatmentPlanDomainMutationVariables, TContext> => {

const mutationKey = getM2mUpdateTreatmentPlanDomainMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mUpdateTreatmentPlanDomain>>, M2mUpdateTreatmentPlanDomainMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mUpdateTreatmentPlanDomain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mUpdateTreatmentPlanDomainMutationResult = NonNullable<Awaited<ReturnType<typeof m2mUpdateTreatmentPlanDomain>>>
    export type M2mUpdateTreatmentPlanDomainMutationBody = M2MUpdateTPDomainInput
    export type M2mUpdateTreatmentPlanDomainMutationError = Error
    export type M2mUpdateTreatmentPlanDomainMutationVariables = {data: M2MUpdateTPDomainInput}

    export const useM2mUpdateTreatmentPlanDomain = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateTreatmentPlanDomain>>, TError,M2mUpdateTreatmentPlanDomainMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mUpdateTreatmentPlanDomain>>,
        TError,
        M2mUpdateTreatmentPlanDomainMutationVariables,
        TContext
      > => {
      return useMutation(getM2mUpdateTreatmentPlanDomainMutationOptions(options), queryClient);
    }

export type m2mAddGoalFieldResponse201 = {
  data: M2MTreatmentPlanField
  status: 201
}

export type m2mAddGoalFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mAddGoalFieldResponseSuccess = (m2mAddGoalFieldResponse201) & {
  headers: Headers;
};
export type m2mAddGoalFieldResponseError = (m2mAddGoalFieldResponse400) & {
  headers: Headers;
};

export type m2mAddGoalFieldResponse = (m2mAddGoalFieldResponseSuccess | m2mAddGoalFieldResponseError)

export const getM2mAddGoalFieldUrl = () => {




  return `/api/basecamp/templates/treatment-plan/goal-fields/add`
}

/**
 * POST templates/treatment-plan/goal-fields/add — create a GOAL- or
 * TARGET-type field (``kind``), on a domain or as a default
 * (domain-less) field.
 *
 * Applies the same authoring guards as the SPA path: native-shadow
 * rejection, auto identifier from title, and org-AI-intent inheritance
 * for new GOAL fields (org AI switches are goal-level only).
 */
export const m2mAddGoalField = async (m2MAddGoalFieldInput: M2MAddGoalFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mAddGoalFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mAddGoalFieldResponse>(getM2mAddGoalFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MAddGoalFieldInput)
  }
);}





export const getM2mAddGoalFieldMutationKey = () => ['m2mAddGoalField'] as const;

export const getM2mAddGoalFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddGoalField>>, TError,M2mAddGoalFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mAddGoalField>>, TError,M2mAddGoalFieldMutationVariables, TContext> => {

const mutationKey = getM2mAddGoalFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mAddGoalField>>, M2mAddGoalFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mAddGoalField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mAddGoalFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mAddGoalField>>>
    export type M2mAddGoalFieldMutationBody = M2MAddGoalFieldInput
    export type M2mAddGoalFieldMutationError = Error
    export type M2mAddGoalFieldMutationVariables = {data: M2MAddGoalFieldInput}

    export const useM2mAddGoalField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mAddGoalField>>, TError,M2mAddGoalFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mAddGoalField>>,
        TError,
        M2mAddGoalFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mAddGoalFieldMutationOptions(options), queryClient);
    }

export type m2mRemoveGoalFieldResponse200 = {
  data: void
  status: 200
}

export type m2mRemoveGoalFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mRemoveGoalFieldResponseSuccess = (m2mRemoveGoalFieldResponse200) & {
  headers: Headers;
};
export type m2mRemoveGoalFieldResponseError = (m2mRemoveGoalFieldResponse400) & {
  headers: Headers;
};

export type m2mRemoveGoalFieldResponse = (m2mRemoveGoalFieldResponseSuccess | m2mRemoveGoalFieldResponseError)

export const getM2mRemoveGoalFieldUrl = () => {




  return `/api/basecamp/templates/treatment-plan/goal-fields/remove`
}

/**
 * POST templates/treatment-plan/goal-fields/remove — GOAL or TARGET
 * fields (``kind``). Custom fields delete; native-backed fields
 * disable instead (the column still exists on every goal/target).
 */
export const m2mRemoveGoalField = async (m2MRemoveGoalFieldInput: M2MRemoveGoalFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mRemoveGoalFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mRemoveGoalFieldResponse>(getM2mRemoveGoalFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MRemoveGoalFieldInput)
  }
);}





export const getM2mRemoveGoalFieldMutationKey = () => ['m2mRemoveGoalField'] as const;

export const getM2mRemoveGoalFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveGoalField>>, TError,M2mRemoveGoalFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveGoalField>>, TError,M2mRemoveGoalFieldMutationVariables, TContext> => {

const mutationKey = getM2mRemoveGoalFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mRemoveGoalField>>, M2mRemoveGoalFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mRemoveGoalField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mRemoveGoalFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mRemoveGoalField>>>
    export type M2mRemoveGoalFieldMutationBody = M2MRemoveGoalFieldInput
    export type M2mRemoveGoalFieldMutationError = Error
    export type M2mRemoveGoalFieldMutationVariables = {data: M2MRemoveGoalFieldInput}

    export const useM2mRemoveGoalField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mRemoveGoalField>>, TError,M2mRemoveGoalFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mRemoveGoalField>>,
        TError,
        M2mRemoveGoalFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mRemoveGoalFieldMutationOptions(options), queryClient);
    }

export type m2mUpdateGoalFieldResponse200 = {
  data: M2MTreatmentPlanField
  status: 200
}

export type m2mUpdateGoalFieldResponse400 = {
  data: Error
  status: 400
}

export type m2mUpdateGoalFieldResponseSuccess = (m2mUpdateGoalFieldResponse200) & {
  headers: Headers;
};
export type m2mUpdateGoalFieldResponseError = (m2mUpdateGoalFieldResponse400) & {
  headers: Headers;
};

export type m2mUpdateGoalFieldResponse = (m2mUpdateGoalFieldResponseSuccess | m2mUpdateGoalFieldResponseError)

export const getM2mUpdateGoalFieldUrl = () => {




  return `/api/basecamp/templates/treatment-plan/goal-fields/update`
}

/**
 * POST templates/treatment-plan/goal-fields/update — GOAL or TARGET
 * fields (``kind``).
 */
export const m2mUpdateGoalField = async (m2MUpdateGoalFieldInput: M2MUpdateGoalFieldInput, options?: Parameters<typeof customFetch>[1]): Promise<m2mUpdateGoalFieldResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<m2mUpdateGoalFieldResponse>(getM2mUpdateGoalFieldUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(m2MUpdateGoalFieldInput)
  }
);}





export const getM2mUpdateGoalFieldMutationKey = () => ['m2mUpdateGoalField'] as const;

export const getM2mUpdateGoalFieldMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateGoalField>>, TError,M2mUpdateGoalFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateGoalField>>, TError,M2mUpdateGoalFieldMutationVariables, TContext> => {

const mutationKey = getM2mUpdateGoalFieldMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof m2mUpdateGoalField>>, M2mUpdateGoalFieldMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  m2mUpdateGoalField(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type M2mUpdateGoalFieldMutationResult = NonNullable<Awaited<ReturnType<typeof m2mUpdateGoalField>>>
    export type M2mUpdateGoalFieldMutationBody = M2MUpdateGoalFieldInput
    export type M2mUpdateGoalFieldMutationError = Error
    export type M2mUpdateGoalFieldMutationVariables = {data: M2MUpdateGoalFieldInput}

    export const useM2mUpdateGoalField = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof m2mUpdateGoalField>>, TError,M2mUpdateGoalFieldMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof m2mUpdateGoalField>>,
        TError,
        M2mUpdateGoalFieldMutationVariables,
        TContext
      > => {
      return useMutation(getM2mUpdateGoalFieldMutationOptions(options), queryClient);
    }

export type updateTemplateResponse200 = {
  data: TemplateDetail
  status: 200
}

export type updateTemplateResponse400 = {
  data: Error
  status: 400
}

export type updateTemplateResponseSuccess = (updateTemplateResponse200) & {
  headers: Headers;
};
export type updateTemplateResponseError = (updateTemplateResponse400) & {
  headers: Headers;
};

export type updateTemplateResponse = (updateTemplateResponseSuccess | updateTemplateResponseError)

export const getUpdateTemplateUrl = () => {




  return `/api/basecamp/templates/update`
}

export const updateTemplate = async (updateTemplateInput: UpdateTemplateInput, options?: Parameters<typeof customFetch>[1]): Promise<updateTemplateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateTemplateResponse>(getUpdateTemplateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateTemplateInput)
  }
);}





export const getUpdateTemplateMutationKey = () => ['updateTemplate'] as const;

export const getUpdateTemplateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,UpdateTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,UpdateTemplateMutationVariables, TContext> => {

const mutationKey = getUpdateTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTemplate>>, UpdateTemplateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateTemplate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof updateTemplate>>>
    export type UpdateTemplateMutationBody = UpdateTemplateInput
    export type UpdateTemplateMutationError = Error
    export type UpdateTemplateMutationVariables = {data: UpdateTemplateInput}

    export const useUpdateTemplate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTemplate>>, TError,UpdateTemplateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTemplate>>,
        TError,
        UpdateTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTemplateMutationOptions(options), queryClient);
    }

export type deleteTestFileResponse200 = {
  data: void
  status: 200
}

export type deleteTestFileResponse400 = {
  data: Error
  status: 400
}

export type deleteTestFileResponseSuccess = (deleteTestFileResponse200) & {
  headers: Headers;
};
export type deleteTestFileResponseError = (deleteTestFileResponse400) & {
  headers: Headers;
};

export type deleteTestFileResponse = (deleteTestFileResponseSuccess | deleteTestFileResponseError)

export const getDeleteTestFileUrl = () => {




  return `/api/basecamp/test-files/delete`
}

/**
 * Delete all S3 objects for a test file.
 */
export const deleteTestFile = async (input: Input, options?: Parameters<typeof customFetch>[1]): Promise<deleteTestFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<deleteTestFileResponse>(getDeleteTestFileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(input)
  }
);}





export const getDeleteTestFileMutationKey = () => ['deleteTestFile'] as const;

export const getDeleteTestFileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTestFile>>, TError,DeleteTestFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTestFile>>, TError,DeleteTestFileMutationVariables, TContext> => {

const mutationKey = getDeleteTestFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTestFile>>, DeleteTestFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteTestFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTestFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTestFile>>>
    export type DeleteTestFileMutationBody = Input
    export type DeleteTestFileMutationError = Error
    export type DeleteTestFileMutationVariables = {data: Input}

    export const useDeleteTestFile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTestFile>>, TError,DeleteTestFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTestFile>>,
        TError,
        DeleteTestFileMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTestFileMutationOptions(options), queryClient);
    }

export type listTestFilesResponse200 = {
  data: ListTestFiles200Item[]
  status: 200
}

export type listTestFilesResponse400 = {
  data: Error
  status: 400
}

export type listTestFilesResponseSuccess = (listTestFilesResponse200) & {
  headers: Headers;
};
export type listTestFilesResponseError = (listTestFilesResponse400) & {
  headers: Headers;
};

export type listTestFilesResponse = (listTestFilesResponseSuccess | listTestFilesResponseError)

export const getListTestFilesUrl = () => {




  return `/api/basecamp/test-files/list`
}

/**
 * List persisted test files for a template + org.
 */
export const listTestFiles = async ( options?: Parameters<typeof customFetch>[1]): Promise<listTestFilesResponse> => {

  return customFetch<listTestFilesResponse>(getListTestFilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTestFilesQueryKey = () => {
    return [
    `/api/basecamp/test-files/list`
    ] as const;
    }


export const getListTestFilesQueryOptions = <TData = Awaited<ReturnType<typeof listTestFiles>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTestFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTestFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTestFiles>>> = ({ signal }) => listTestFiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTestFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTestFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listTestFiles>>>
export type ListTestFilesQueryError = Error


export function useListTestFiles<TData = Awaited<ReturnType<typeof listTestFiles>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTestFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTestFiles>>,
          TError,
          Awaited<ReturnType<typeof listTestFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTestFiles<TData = Awaited<ReturnType<typeof listTestFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTestFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTestFiles>>,
          TError,
          Awaited<ReturnType<typeof listTestFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTestFiles<TData = Awaited<ReturnType<typeof listTestFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTestFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListTestFiles<TData = Awaited<ReturnType<typeof listTestFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTestFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTestFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startTestFileParseResponse200 = {
  data: Output
  status: 200
}

export type startTestFileParseResponse400 = {
  data: Error
  status: 400
}

export type startTestFileParseResponseSuccess = (startTestFileParseResponse200) & {
  headers: Headers;
};
export type startTestFileParseResponseError = (startTestFileParseResponse400) & {
  headers: Headers;
};

export type startTestFileParseResponse = (startTestFileParseResponseSuccess | startTestFileParseResponseError)

export const getStartTestFileParseUrl = () => {




  return `/api/basecamp/test-files/parse`
}

/**
 * Start EphemeralFileParsingWorkflow for an uploaded test file.
 */
export const startTestFileParse = async (input: Input, options?: Parameters<typeof customFetch>[1]): Promise<startTestFileParseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startTestFileParseResponse>(getStartTestFileParseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(input)
  }
);}





export const getStartTestFileParseMutationKey = () => ['startTestFileParse'] as const;

export const getStartTestFileParseMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTestFileParse>>, TError,StartTestFileParseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startTestFileParse>>, TError,StartTestFileParseMutationVariables, TContext> => {

const mutationKey = getStartTestFileParseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startTestFileParse>>, StartTestFileParseMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startTestFileParse(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartTestFileParseMutationResult = NonNullable<Awaited<ReturnType<typeof startTestFileParse>>>
    export type StartTestFileParseMutationBody = Input
    export type StartTestFileParseMutationError = Error
    export type StartTestFileParseMutationVariables = {data: Input}

    export const useStartTestFileParse = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTestFileParse>>, TError,StartTestFileParseMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startTestFileParse>>,
        TError,
        StartTestFileParseMutationVariables,
        TContext
      > => {
      return useMutation(getStartTestFileParseMutationOptions(options), queryClient);
    }

export type getTestFileParseStatusResponse200 = {
  data: Output
  status: 200
}

export type getTestFileParseStatusResponse400 = {
  data: Error
  status: 400
}

export type getTestFileParseStatusResponseSuccess = (getTestFileParseStatusResponse200) & {
  headers: Headers;
};
export type getTestFileParseStatusResponseError = (getTestFileParseStatusResponse400) & {
  headers: Headers;
};

export type getTestFileParseStatusResponse = (getTestFileParseStatusResponseSuccess | getTestFileParseStatusResponseError)

export const getGetTestFileParseStatusUrl = (workflowId: string,) => {




  return `/api/basecamp/test-files/parse-status/${workflowId}`
}

/**
 * Poll the status of an EphemeralFileParsingWorkflow.
 * Returns cached S3 result if already complete; otherwise queries Temporal.
 * On first completion, writes parsed.json to S3 for future cache hits.
 */
export const getTestFileParseStatus = async (workflowId: string, options?: Parameters<typeof customFetch>[1]): Promise<getTestFileParseStatusResponse> => {

  return customFetch<getTestFileParseStatusResponse>(getGetTestFileParseStatusUrl(workflowId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTestFileParseStatusQueryKey = (workflowId: string,) => {
    return [
    `/api/basecamp/test-files/parse-status/${workflowId}`
    ] as const;
    }


export const getGetTestFileParseStatusQueryOptions = <TData = Awaited<ReturnType<typeof getTestFileParseStatus>>, TError = Error>(workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestFileParseStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTestFileParseStatusQueryKey(workflowId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTestFileParseStatus>>> = ({ signal }) => getTestFileParseStatus(workflowId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: workflowId !== null && workflowId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTestFileParseStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTestFileParseStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getTestFileParseStatus>>>
export type GetTestFileParseStatusQueryError = Error


export function useGetTestFileParseStatus<TData = Awaited<ReturnType<typeof getTestFileParseStatus>>, TError = Error>(
 workflowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestFileParseStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTestFileParseStatus>>,
          TError,
          Awaited<ReturnType<typeof getTestFileParseStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTestFileParseStatus<TData = Awaited<ReturnType<typeof getTestFileParseStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestFileParseStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTestFileParseStatus>>,
          TError,
          Awaited<ReturnType<typeof getTestFileParseStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTestFileParseStatus<TData = Awaited<ReturnType<typeof getTestFileParseStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestFileParseStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTestFileParseStatus<TData = Awaited<ReturnType<typeof getTestFileParseStatus>>, TError = Error>(
 workflowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTestFileParseStatus>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTestFileParseStatusQueryOptions(workflowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type startTestFileParseM2mResponse200 = {
  data: Output
  status: 200
}

export type startTestFileParseM2mResponse400 = {
  data: Error
  status: 400
}

export type startTestFileParseM2mResponseSuccess = (startTestFileParseM2mResponse200) & {
  headers: Headers;
};
export type startTestFileParseM2mResponseError = (startTestFileParseM2mResponse400) & {
  headers: Headers;
};

export type startTestFileParseM2mResponse = (startTestFileParseM2mResponseSuccess | startTestFileParseM2mResponseError)

export const getStartTestFileParseM2mUrl = () => {




  return `/api/basecamp/test-files/parse/m2m`
}

/**
 * M2M sibling of ``StartTestFileParseView``. Used by Rio to reparse
 * a test file when the cached parse looks empty or wrong.
 */
export const startTestFileParseM2m = async (input: Input, options?: Parameters<typeof customFetch>[1]): Promise<startTestFileParseM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<startTestFileParseM2mResponse>(getStartTestFileParseM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(input)
  }
);}





export const getStartTestFileParseM2mMutationKey = () => ['startTestFileParseM2m'] as const;

export const getStartTestFileParseM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTestFileParseM2m>>, TError,StartTestFileParseM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startTestFileParseM2m>>, TError,StartTestFileParseM2mMutationVariables, TContext> => {

const mutationKey = getStartTestFileParseM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startTestFileParseM2m>>, StartTestFileParseM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startTestFileParseM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartTestFileParseM2mMutationResult = NonNullable<Awaited<ReturnType<typeof startTestFileParseM2m>>>
    export type StartTestFileParseM2mMutationBody = Input
    export type StartTestFileParseM2mMutationError = Error
    export type StartTestFileParseM2mMutationVariables = {data: Input}

    export const useStartTestFileParseM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startTestFileParseM2m>>, TError,StartTestFileParseM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startTestFileParseM2m>>,
        TError,
        StartTestFileParseM2mMutationVariables,
        TContext
      > => {
      return useMutation(getStartTestFileParseM2mMutationOptions(options), queryClient);
    }

export type getParsedTestFileResponse200 = {
  data: GetParsedTestFileOutput
  status: 200
}

export type getParsedTestFileResponse400 = {
  data: Error
  status: 400
}

export type getParsedTestFileResponseSuccess = (getParsedTestFileResponse200) & {
  headers: Headers;
};
export type getParsedTestFileResponseError = (getParsedTestFileResponse400) & {
  headers: Headers;
};

export type getParsedTestFileResponse = (getParsedTestFileResponseSuccess | getParsedTestFileResponseError)

export const getGetParsedTestFileUrl = (params: GetParsedTestFileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/basecamp/test-files/parsed?${stringifiedParams}` : `/api/basecamp/test-files/parsed`
}

/**
 * Return the cached ``parsed.json`` string for a shared test file.
 *
 * Callers pass ``s3_prefix`` — same value we snapshot on a
 * LearnerTestProfile.test_files entry — and get back the parsed
 * content as a string. Used by the test bed's "view / edit parsed
 * values" flow so a BCBA can override the parsed payload for a
 * single run without re-uploading and re-parsing the source file.
 *
 * Returns ``{parsed_json: str | null}``; null when the parse cache
 * isn't present (either the file hasn't finished parsing yet or the
 * prefix doesn't exist).
 */
export const getParsedTestFile = async (params: GetParsedTestFileParams, options?: Parameters<typeof customFetch>[1]): Promise<getParsedTestFileResponse> => {

  return customFetch<getParsedTestFileResponse>(getGetParsedTestFileUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetParsedTestFileQueryKey = (params?: GetParsedTestFileParams,) => {
    return [
    `/api/basecamp/test-files/parsed`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetParsedTestFileQueryOptions = <TData = Awaited<ReturnType<typeof getParsedTestFile>>, TError = Error>(params: GetParsedTestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParsedTestFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParsedTestFileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getParsedTestFile>>> = ({ signal }) => getParsedTestFile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getParsedTestFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParsedTestFileQueryResult = NonNullable<Awaited<ReturnType<typeof getParsedTestFile>>>
export type GetParsedTestFileQueryError = Error


export function useGetParsedTestFile<TData = Awaited<ReturnType<typeof getParsedTestFile>>, TError = Error>(
 params: GetParsedTestFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParsedTestFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParsedTestFile>>,
          TError,
          Awaited<ReturnType<typeof getParsedTestFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParsedTestFile<TData = Awaited<ReturnType<typeof getParsedTestFile>>, TError = Error>(
 params: GetParsedTestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParsedTestFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParsedTestFile>>,
          TError,
          Awaited<ReturnType<typeof getParsedTestFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParsedTestFile<TData = Awaited<ReturnType<typeof getParsedTestFile>>, TError = Error>(
 params: GetParsedTestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParsedTestFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParsedTestFile<TData = Awaited<ReturnType<typeof getParsedTestFile>>, TError = Error>(
 params: GetParsedTestFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParsedTestFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetParsedTestFileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type putParsedTestFileResponse200 = {
  data: PutParsedTestFileOutput
  status: 200
}

export type putParsedTestFileResponse400 = {
  data: Error
  status: 400
}

export type putParsedTestFileResponseSuccess = (putParsedTestFileResponse200) & {
  headers: Headers;
};
export type putParsedTestFileResponseError = (putParsedTestFileResponse400) & {
  headers: Headers;
};

export type putParsedTestFileResponse = (putParsedTestFileResponseSuccess | putParsedTestFileResponseError)

export const getPutParsedTestFileUrl = () => {




  return `/api/basecamp/test-files/parsed`
}

/**
 * Return the cached ``parsed.json`` string for a shared test file.
 *
 * Callers pass ``s3_prefix`` — same value we snapshot on a
 * LearnerTestProfile.test_files entry — and get back the parsed
 * content as a string. Used by the test bed's "view / edit parsed
 * values" flow so a BCBA can override the parsed payload for a
 * single run without re-uploading and re-parsing the source file.
 *
 * Returns ``{parsed_json: str | null}``; null when the parse cache
 * isn't present (either the file hasn't finished parsing yet or the
 * prefix doesn't exist).
 */
export const putParsedTestFile = async (putParsedTestFileInput: PutParsedTestFileInput, options?: Parameters<typeof customFetch>[1]): Promise<putParsedTestFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<putParsedTestFileResponse>(getPutParsedTestFileUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putParsedTestFileInput)
  }
);}





export const getPutParsedTestFileMutationKey = () => ['putParsedTestFile'] as const;

export const getPutParsedTestFileMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putParsedTestFile>>, TError,PutParsedTestFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putParsedTestFile>>, TError,PutParsedTestFileMutationVariables, TContext> => {

const mutationKey = getPutParsedTestFileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putParsedTestFile>>, PutParsedTestFileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putParsedTestFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutParsedTestFileMutationResult = NonNullable<Awaited<ReturnType<typeof putParsedTestFile>>>
    export type PutParsedTestFileMutationBody = PutParsedTestFileInput
    export type PutParsedTestFileMutationError = Error
    export type PutParsedTestFileMutationVariables = {data: PutParsedTestFileInput}

    export const usePutParsedTestFile = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putParsedTestFile>>, TError,PutParsedTestFileMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putParsedTestFile>>,
        TError,
        PutParsedTestFileMutationVariables,
        TContext
      > => {
      return useMutation(getPutParsedTestFileMutationOptions(options), queryClient);
    }

export type putParsedTestFileM2mResponse200 = {
  data: PutParsedTestFileOutput
  status: 200
}

export type putParsedTestFileM2mResponse400 = {
  data: Error
  status: 400
}

export type putParsedTestFileM2mResponseSuccess = (putParsedTestFileM2mResponse200) & {
  headers: Headers;
};
export type putParsedTestFileM2mResponseError = (putParsedTestFileM2mResponse400) & {
  headers: Headers;
};

export type putParsedTestFileM2mResponse = (putParsedTestFileM2mResponseSuccess | putParsedTestFileM2mResponseError)

export const getPutParsedTestFileM2mUrl = () => {




  return `/api/basecamp/test-files/parsed/m2m`
}

/**
 * M2M sibling of ``GetParsedTestFileView.put``. Rio uses this to
 * populate ``parsed.json`` when parsing failed and the user provides
 * the content directly.
 *
 * Only PUT is exposed — the parent view also has ``get`` and leaving
 * it inherited would let M2M callers read parsed content from this
 * URL (a role they don't have on the SPA path). ``http_method_names``
 * narrows the accepted verbs; anything else returns 405.
 */
export const putParsedTestFileM2m = async (putParsedTestFileInput: PutParsedTestFileInput, options?: Parameters<typeof customFetch>[1]): Promise<putParsedTestFileM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<putParsedTestFileM2mResponse>(getPutParsedTestFileM2mUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(putParsedTestFileInput)
  }
);}





export const getPutParsedTestFileM2mMutationKey = () => ['putParsedTestFileM2m'] as const;

export const getPutParsedTestFileM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putParsedTestFileM2m>>, TError,PutParsedTestFileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putParsedTestFileM2m>>, TError,PutParsedTestFileM2mMutationVariables, TContext> => {

const mutationKey = getPutParsedTestFileM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putParsedTestFileM2m>>, PutParsedTestFileM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putParsedTestFileM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutParsedTestFileM2mMutationResult = NonNullable<Awaited<ReturnType<typeof putParsedTestFileM2m>>>
    export type PutParsedTestFileM2mMutationBody = PutParsedTestFileInput
    export type PutParsedTestFileM2mMutationError = Error
    export type PutParsedTestFileM2mMutationVariables = {data: PutParsedTestFileInput}

    export const usePutParsedTestFileM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putParsedTestFileM2m>>, TError,PutParsedTestFileM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putParsedTestFileM2m>>,
        TError,
        PutParsedTestFileM2mMutationVariables,
        TContext
      > => {
      return useMutation(getPutParsedTestFileM2mMutationOptions(options), queryClient);
    }

export type testFilePresignResponse200 = {
  data: Output
  status: 200
}

export type testFilePresignResponse400 = {
  data: Error
  status: 400
}

export type testFilePresignResponseSuccess = (testFilePresignResponse200) & {
  headers: Headers;
};
export type testFilePresignResponseError = (testFilePresignResponse400) & {
  headers: Headers;
};

export type testFilePresignResponse = (testFilePresignResponseSuccess | testFilePresignResponseError)

export const getTestFilePresignUrl = () => {




  return `/api/basecamp/test-files/presign`
}

/**
 * Generate a presigned S3 PUT URL for uploading a test file.
 */
export const testFilePresign = async (input: Input, options?: Parameters<typeof customFetch>[1]): Promise<testFilePresignResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<testFilePresignResponse>(getTestFilePresignUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(input)
  }
);}





export const getTestFilePresignMutationKey = () => ['testFilePresign'] as const;

export const getTestFilePresignMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testFilePresign>>, TError,TestFilePresignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testFilePresign>>, TError,TestFilePresignMutationVariables, TContext> => {

const mutationKey = getTestFilePresignMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testFilePresign>>, TestFilePresignMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  testFilePresign(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestFilePresignMutationResult = NonNullable<Awaited<ReturnType<typeof testFilePresign>>>
    export type TestFilePresignMutationBody = Input
    export type TestFilePresignMutationError = Error
    export type TestFilePresignMutationVariables = {data: Input}

    export const useTestFilePresign = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testFilePresign>>, TError,TestFilePresignMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testFilePresign>>,
        TError,
        TestFilePresignMutationVariables,
        TContext
      > => {
      return useMutation(getTestFilePresignMutationOptions(options), queryClient);
    }

export type getTestFileRawSignedUrlM2mResponse200 = {
  data: Output
  status: 200
}

export type getTestFileRawSignedUrlM2mResponse400 = {
  data: Error
  status: 400
}

export type getTestFileRawSignedUrlM2mResponse404 = {
  data: Error
  status: 404
}

export type getTestFileRawSignedUrlM2mResponseSuccess = (getTestFileRawSignedUrlM2mResponse200) & {
  headers: Headers;
};
export type getTestFileRawSignedUrlM2mResponseError = (getTestFileRawSignedUrlM2mResponse400 | getTestFileRawSignedUrlM2mResponse404) & {
  headers: Headers;
};

export type getTestFileRawSignedUrlM2mResponse = (getTestFileRawSignedUrlM2mResponseSuccess | getTestFileRawSignedUrlM2mResponseError)

export const getGetTestFileRawSignedUrlM2mUrl = () => {




  return `/api/basecamp/test-files/raw-url/m2m`
}

/**
 * Return a short-lived presigned GET URL for a test file's raw
 * upload.
 *
 * Resolves the S3 prefix from ``(template_id | shared, org_id)``,
 * reads ``meta.json`` for the ``s3_key`` + filename + mime, and
 * generates a presigned URL scoped to the raw object.
 */
export const getTestFileRawSignedUrlM2m = async (input: Input, options?: Parameters<typeof customFetch>[1]): Promise<getTestFileRawSignedUrlM2mResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<getTestFileRawSignedUrlM2mResponse>(getGetTestFileRawSignedUrlM2mUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(input)
  }
);}





export const getGetTestFileRawSignedUrlM2mMutationKey = () => ['getTestFileRawSignedUrlM2m'] as const;

export const getGetTestFileRawSignedUrlM2mMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTestFileRawSignedUrlM2m>>, TError,GetTestFileRawSignedUrlM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof getTestFileRawSignedUrlM2m>>, TError,GetTestFileRawSignedUrlM2mMutationVariables, TContext> => {

const mutationKey = getGetTestFileRawSignedUrlM2mMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTestFileRawSignedUrlM2m>>, GetTestFileRawSignedUrlM2mMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getTestFileRawSignedUrlM2m(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetTestFileRawSignedUrlM2mMutationResult = NonNullable<Awaited<ReturnType<typeof getTestFileRawSignedUrlM2m>>>
    export type GetTestFileRawSignedUrlM2mMutationBody = Input
    export type GetTestFileRawSignedUrlM2mMutationError = Error
    export type GetTestFileRawSignedUrlM2mMutationVariables = {data: Input}

    export const useGetTestFileRawSignedUrlM2m = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTestFileRawSignedUrlM2m>>, TError,GetTestFileRawSignedUrlM2mMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTestFileRawSignedUrlM2m>>,
        TError,
        GetTestFileRawSignedUrlM2mMutationVariables,
        TContext
      > => {
      return useMutation(getGetTestFileRawSignedUrlM2mMutationOptions(options), queryClient);
    }

export type listSharedTestFilesResponse200 = {
  data: ListSharedTestFiles200Item[]
  status: 200
}

export type listSharedTestFilesResponse400 = {
  data: Error
  status: 400
}

export type listSharedTestFilesResponseSuccess = (listSharedTestFilesResponse200) & {
  headers: Headers;
};
export type listSharedTestFilesResponseError = (listSharedTestFilesResponse400) & {
  headers: Headers;
};

export type listSharedTestFilesResponse = (listSharedTestFilesResponseSuccess | listSharedTestFilesResponseError)

export const getListSharedTestFilesUrl = () => {




  return `/api/basecamp/test-files/shared`
}

/**
 * List org-level shared test files from test-files/_global_/{org_id}/.
 *
 * When `org_id` is omitted the truly-global pool at
 * `test-files/_global_/global/` is returned (files usable by profiles that
 * aren't scoped to any org).
 */
export const listSharedTestFiles = async ( options?: Parameters<typeof customFetch>[1]): Promise<listSharedTestFilesResponse> => {

  return customFetch<listSharedTestFilesResponse>(getListSharedTestFilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSharedTestFilesQueryKey = () => {
    return [
    `/api/basecamp/test-files/shared`
    ] as const;
    }


export const getListSharedTestFilesQueryOptions = <TData = Awaited<ReturnType<typeof listSharedTestFiles>>, TError = Error>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedTestFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSharedTestFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSharedTestFiles>>> = ({ signal }) => listSharedTestFiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSharedTestFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSharedTestFilesQueryResult = NonNullable<Awaited<ReturnType<typeof listSharedTestFiles>>>
export type ListSharedTestFilesQueryError = Error


export function useListSharedTestFiles<TData = Awaited<ReturnType<typeof listSharedTestFiles>>, TError = Error>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedTestFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedTestFiles>>,
          TError,
          Awaited<ReturnType<typeof listSharedTestFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSharedTestFiles<TData = Awaited<ReturnType<typeof listSharedTestFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedTestFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSharedTestFiles>>,
          TError,
          Awaited<ReturnType<typeof listSharedTestFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSharedTestFiles<TData = Awaited<ReturnType<typeof listSharedTestFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedTestFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListSharedTestFiles<TData = Awaited<ReturnType<typeof listSharedTestFiles>>, TError = Error>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSharedTestFiles>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSharedTestFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type beaconRawlocationCreateResponse200 = {
  data: void
  status: 200
}

export type beaconRawlocationCreateResponseSuccess = (beaconRawlocationCreateResponse200) & {
  headers: Headers;
};
;

export type beaconRawlocationCreateResponse = (beaconRawlocationCreateResponseSuccess)

export const getBeaconRawlocationCreateUrl = () => {




  return `/api/beacon/rawlocation/`
}

export const beaconRawlocationCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<beaconRawlocationCreateResponse> => {

  return customFetch<beaconRawlocationCreateResponse>(getBeaconRawlocationCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBeaconRawlocationCreateMutationKey = () => ['beaconRawlocationCreate'] as const;

export const getBeaconRawlocationCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beaconRawlocationCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof beaconRawlocationCreate>>, TError,void, TContext> => {

const mutationKey = getBeaconRawlocationCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof beaconRawlocationCreate>>, void> = () => {


          return  beaconRawlocationCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BeaconRawlocationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof beaconRawlocationCreate>>>

    export type BeaconRawlocationCreateMutationError = unknown


    export const useBeaconRawlocationCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof beaconRawlocationCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof beaconRawlocationCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getBeaconRawlocationCreateMutationOptions(options), queryClient);
    }

export type careNavigationCancelOrgVerificationCreateResponse200 = {
  data: Success
  status: 200
}

export type careNavigationCancelOrgVerificationCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationCancelOrgVerificationCreateResponseSuccess = (careNavigationCancelOrgVerificationCreateResponse200) & {
  headers: Headers;
};
export type careNavigationCancelOrgVerificationCreateResponseError = (careNavigationCancelOrgVerificationCreateResponse400) & {
  headers: Headers;
};

export type careNavigationCancelOrgVerificationCreateResponse = (careNavigationCancelOrgVerificationCreateResponseSuccess | careNavigationCancelOrgVerificationCreateResponseError)

export const getCareNavigationCancelOrgVerificationCreateUrl = () => {




  return `/api/care-navigation/cancel-org-verification/`
}

export const careNavigationCancelOrgVerificationCreate = async (cancelClinicListingVerificationInput: CancelClinicListingVerificationInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationCancelOrgVerificationCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationCancelOrgVerificationCreateResponse>(getCareNavigationCancelOrgVerificationCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cancelClinicListingVerificationInput)
  }
);}





export const getCareNavigationCancelOrgVerificationCreateMutationKey = () => ['careNavigationCancelOrgVerificationCreate'] as const;

export const getCareNavigationCancelOrgVerificationCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationCancelOrgVerificationCreate>>, TError,CareNavigationCancelOrgVerificationCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationCancelOrgVerificationCreate>>, TError,CareNavigationCancelOrgVerificationCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationCancelOrgVerificationCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationCancelOrgVerificationCreate>>, CareNavigationCancelOrgVerificationCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationCancelOrgVerificationCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationCancelOrgVerificationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationCancelOrgVerificationCreate>>>
    export type CareNavigationCancelOrgVerificationCreateMutationBody = CancelClinicListingVerificationInput
    export type CareNavigationCancelOrgVerificationCreateMutationError = Error
    export type CareNavigationCancelOrgVerificationCreateMutationVariables = {data: CancelClinicListingVerificationInput}

    export const useCareNavigationCancelOrgVerificationCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationCancelOrgVerificationCreate>>, TError,CareNavigationCancelOrgVerificationCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationCancelOrgVerificationCreate>>,
        TError,
        CareNavigationCancelOrgVerificationCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationCancelOrgVerificationCreateMutationOptions(options), queryClient);
    }

export type careNavigationClinicCoverageStatusCreateResponse200 = {
  data: UpdateCoverageStatusOutput
  status: 200
}

export type careNavigationClinicCoverageStatusCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationClinicCoverageStatusCreateResponseSuccess = (careNavigationClinicCoverageStatusCreateResponse200) & {
  headers: Headers;
};
export type careNavigationClinicCoverageStatusCreateResponseError = (careNavigationClinicCoverageStatusCreateResponse400) & {
  headers: Headers;
};

export type careNavigationClinicCoverageStatusCreateResponse = (careNavigationClinicCoverageStatusCreateResponseSuccess | careNavigationClinicCoverageStatusCreateResponseError)

export const getCareNavigationClinicCoverageStatusCreateUrl = () => {




  return `/api/care-navigation/clinic-coverage-status/`
}

export const careNavigationClinicCoverageStatusCreate = async (updateCoverageStatusInput: UpdateCoverageStatusInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationClinicCoverageStatusCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationClinicCoverageStatusCreateResponse>(getCareNavigationClinicCoverageStatusCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCoverageStatusInput)
  }
);}





export const getCareNavigationClinicCoverageStatusCreateMutationKey = () => ['careNavigationClinicCoverageStatusCreate'] as const;

export const getCareNavigationClinicCoverageStatusCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicCoverageStatusCreate>>, TError,CareNavigationClinicCoverageStatusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicCoverageStatusCreate>>, TError,CareNavigationClinicCoverageStatusCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationClinicCoverageStatusCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationClinicCoverageStatusCreate>>, CareNavigationClinicCoverageStatusCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationClinicCoverageStatusCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationClinicCoverageStatusCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationClinicCoverageStatusCreate>>>
    export type CareNavigationClinicCoverageStatusCreateMutationBody = UpdateCoverageStatusInput
    export type CareNavigationClinicCoverageStatusCreateMutationError = Error
    export type CareNavigationClinicCoverageStatusCreateMutationVariables = {data: UpdateCoverageStatusInput}

    export const useCareNavigationClinicCoverageStatusCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicCoverageStatusCreate>>, TError,CareNavigationClinicCoverageStatusCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationClinicCoverageStatusCreate>>,
        TError,
        CareNavigationClinicCoverageStatusCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationClinicCoverageStatusCreateMutationOptions(options), queryClient);
    }

export type careNavigationClinicListingCreateResponse201 = {
  data: CreateClinicListingOutput
  status: 201
}

export type careNavigationClinicListingCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationClinicListingCreateResponseSuccess = (careNavigationClinicListingCreateResponse201) & {
  headers: Headers;
};
export type careNavigationClinicListingCreateResponseError = (careNavigationClinicListingCreateResponse400) & {
  headers: Headers;
};

export type careNavigationClinicListingCreateResponse = (careNavigationClinicListingCreateResponseSuccess | careNavigationClinicListingCreateResponseError)

export const getCareNavigationClinicListingCreateUrl = () => {




  return `/api/care-navigation/clinic-listing/`
}

export const careNavigationClinicListingCreate = async (createClinicListingInput: CreateClinicListingInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationClinicListingCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationClinicListingCreateResponse>(getCareNavigationClinicListingCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createClinicListingInput)
  }
);}





export const getCareNavigationClinicListingCreateMutationKey = () => ['careNavigationClinicListingCreate'] as const;

export const getCareNavigationClinicListingCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingCreate>>, TError,CareNavigationClinicListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingCreate>>, TError,CareNavigationClinicListingCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationClinicListingCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationClinicListingCreate>>, CareNavigationClinicListingCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationClinicListingCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationClinicListingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationClinicListingCreate>>>
    export type CareNavigationClinicListingCreateMutationBody = CreateClinicListingInput
    export type CareNavigationClinicListingCreateMutationError = Error
    export type CareNavigationClinicListingCreateMutationVariables = {data: CreateClinicListingInput}

    export const useCareNavigationClinicListingCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingCreate>>, TError,CareNavigationClinicListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationClinicListingCreate>>,
        TError,
        CareNavigationClinicListingCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationClinicListingCreateMutationOptions(options), queryClient);
    }

export type careNavigationClinicListingStagingBulkCreateResponse200 = {
  data: BulkInsertStagingClinicListingOutput
  status: 200
}

export type careNavigationClinicListingStagingBulkCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationClinicListingStagingBulkCreateResponseSuccess = (careNavigationClinicListingStagingBulkCreateResponse200) & {
  headers: Headers;
};
export type careNavigationClinicListingStagingBulkCreateResponseError = (careNavigationClinicListingStagingBulkCreateResponse400) & {
  headers: Headers;
};

export type careNavigationClinicListingStagingBulkCreateResponse = (careNavigationClinicListingStagingBulkCreateResponseSuccess | careNavigationClinicListingStagingBulkCreateResponseError)

export const getCareNavigationClinicListingStagingBulkCreateUrl = () => {




  return `/api/care-navigation/clinic-listing-staging/bulk/`
}

export const careNavigationClinicListingStagingBulkCreate = async (bulkInsertStagingClinicListingInput: BulkInsertStagingClinicListingInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationClinicListingStagingBulkCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationClinicListingStagingBulkCreateResponse>(getCareNavigationClinicListingStagingBulkCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkInsertStagingClinicListingInput)
  }
);}





export const getCareNavigationClinicListingStagingBulkCreateMutationKey = () => ['careNavigationClinicListingStagingBulkCreate'] as const;

export const getCareNavigationClinicListingStagingBulkCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingStagingBulkCreate>>, TError,CareNavigationClinicListingStagingBulkCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingStagingBulkCreate>>, TError,CareNavigationClinicListingStagingBulkCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationClinicListingStagingBulkCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationClinicListingStagingBulkCreate>>, CareNavigationClinicListingStagingBulkCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationClinicListingStagingBulkCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationClinicListingStagingBulkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationClinicListingStagingBulkCreate>>>
    export type CareNavigationClinicListingStagingBulkCreateMutationBody = BulkInsertStagingClinicListingInput
    export type CareNavigationClinicListingStagingBulkCreateMutationError = Error
    export type CareNavigationClinicListingStagingBulkCreateMutationVariables = {data: BulkInsertStagingClinicListingInput}

    export const useCareNavigationClinicListingStagingBulkCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingStagingBulkCreate>>, TError,CareNavigationClinicListingStagingBulkCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationClinicListingStagingBulkCreate>>,
        TError,
        CareNavigationClinicListingStagingBulkCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationClinicListingStagingBulkCreateMutationOptions(options), queryClient);
    }

export type careNavigationClinicListingStagingUpdateCreateResponse200 = {
  data: UpdateStagingClinicListingOutput
  status: 200
}

export type careNavigationClinicListingStagingUpdateCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationClinicListingStagingUpdateCreateResponseSuccess = (careNavigationClinicListingStagingUpdateCreateResponse200) & {
  headers: Headers;
};
export type careNavigationClinicListingStagingUpdateCreateResponseError = (careNavigationClinicListingStagingUpdateCreateResponse400) & {
  headers: Headers;
};

export type careNavigationClinicListingStagingUpdateCreateResponse = (careNavigationClinicListingStagingUpdateCreateResponseSuccess | careNavigationClinicListingStagingUpdateCreateResponseError)

export const getCareNavigationClinicListingStagingUpdateCreateUrl = () => {




  return `/api/care-navigation/clinic-listing-staging/update/`
}

export const careNavigationClinicListingStagingUpdateCreate = async (updateStagingClinicListingInput: UpdateStagingClinicListingInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationClinicListingStagingUpdateCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationClinicListingStagingUpdateCreateResponse>(getCareNavigationClinicListingStagingUpdateCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateStagingClinicListingInput)
  }
);}





export const getCareNavigationClinicListingStagingUpdateCreateMutationKey = () => ['careNavigationClinicListingStagingUpdateCreate'] as const;

export const getCareNavigationClinicListingStagingUpdateCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingStagingUpdateCreate>>, TError,CareNavigationClinicListingStagingUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingStagingUpdateCreate>>, TError,CareNavigationClinicListingStagingUpdateCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationClinicListingStagingUpdateCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationClinicListingStagingUpdateCreate>>, CareNavigationClinicListingStagingUpdateCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationClinicListingStagingUpdateCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationClinicListingStagingUpdateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationClinicListingStagingUpdateCreate>>>
    export type CareNavigationClinicListingStagingUpdateCreateMutationBody = UpdateStagingClinicListingInput
    export type CareNavigationClinicListingStagingUpdateCreateMutationError = Error
    export type CareNavigationClinicListingStagingUpdateCreateMutationVariables = {data: UpdateStagingClinicListingInput}

    export const useCareNavigationClinicListingStagingUpdateCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationClinicListingStagingUpdateCreate>>, TError,CareNavigationClinicListingStagingUpdateCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationClinicListingStagingUpdateCreate>>,
        TError,
        CareNavigationClinicListingStagingUpdateCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationClinicListingStagingUpdateCreateMutationOptions(options), queryClient);
    }

export type careNavigationClinicListingsRetrieveResponse200 = {
  data: PaginatedGetCareNavigationListingsOutput
  status: 200
}

export type careNavigationClinicListingsRetrieveResponse400 = {
  data: Error
  status: 400
}

export type careNavigationClinicListingsRetrieveResponseSuccess = (careNavigationClinicListingsRetrieveResponse200) & {
  headers: Headers;
};
export type careNavigationClinicListingsRetrieveResponseError = (careNavigationClinicListingsRetrieveResponse400) & {
  headers: Headers;
};

export type careNavigationClinicListingsRetrieveResponse = (careNavigationClinicListingsRetrieveResponseSuccess | careNavigationClinicListingsRetrieveResponseError)

export const getCareNavigationClinicListingsRetrieveUrl = (params: CareNavigationClinicListingsRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["modality_types","service_types"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/care-navigation/clinic-listings/?${stringifiedParams}` : `/api/care-navigation/clinic-listings/`
}

export const careNavigationClinicListingsRetrieve = async (params: CareNavigationClinicListingsRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationClinicListingsRetrieveResponse> => {

  return customFetch<careNavigationClinicListingsRetrieveResponse>(getCareNavigationClinicListingsRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCareNavigationClinicListingsRetrieveQueryKey = (params?: CareNavigationClinicListingsRetrieveParams,) => {
    return [
    `/api/care-navigation/clinic-listings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getCareNavigationClinicListingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError = Error>(params: CareNavigationClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCareNavigationClinicListingsRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>> = ({ signal }) => careNavigationClinicListingsRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CareNavigationClinicListingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>>
export type CareNavigationClinicListingsRetrieveQueryError = Error


export function useCareNavigationClinicListingsRetrieve<TData = Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError = Error>(
 params: CareNavigationClinicListingsRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCareNavigationClinicListingsRetrieve<TData = Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError = Error>(
 params: CareNavigationClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCareNavigationClinicListingsRetrieve<TData = Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError = Error>(
 params: CareNavigationClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCareNavigationClinicListingsRetrieve<TData = Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError = Error>(
 params: CareNavigationClinicListingsRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careNavigationClinicListingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCareNavigationClinicListingsRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type careNavigationCoverageEligibilityCreateResponse200 = {
  data: CareNavCoverageEligibilityOutput
  status: 200
}

export type careNavigationCoverageEligibilityCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationCoverageEligibilityCreateResponseSuccess = (careNavigationCoverageEligibilityCreateResponse200) & {
  headers: Headers;
};
export type careNavigationCoverageEligibilityCreateResponseError = (careNavigationCoverageEligibilityCreateResponse400) & {
  headers: Headers;
};

export type careNavigationCoverageEligibilityCreateResponse = (careNavigationCoverageEligibilityCreateResponseSuccess | careNavigationCoverageEligibilityCreateResponseError)

export const getCareNavigationCoverageEligibilityCreateUrl = () => {




  return `/api/care-navigation/coverage-eligibility/`
}

export const careNavigationCoverageEligibilityCreate = async (careNavCoverageEligibilityInput: CareNavCoverageEligibilityInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationCoverageEligibilityCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationCoverageEligibilityCreateResponse>(getCareNavigationCoverageEligibilityCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(careNavCoverageEligibilityInput)
  }
);}





export const getCareNavigationCoverageEligibilityCreateMutationKey = () => ['careNavigationCoverageEligibilityCreate'] as const;

export const getCareNavigationCoverageEligibilityCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationCoverageEligibilityCreate>>, TError,CareNavigationCoverageEligibilityCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationCoverageEligibilityCreate>>, TError,CareNavigationCoverageEligibilityCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationCoverageEligibilityCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationCoverageEligibilityCreate>>, CareNavigationCoverageEligibilityCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationCoverageEligibilityCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationCoverageEligibilityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationCoverageEligibilityCreate>>>
    export type CareNavigationCoverageEligibilityCreateMutationBody = CareNavCoverageEligibilityInput
    export type CareNavigationCoverageEligibilityCreateMutationError = Error
    export type CareNavigationCoverageEligibilityCreateMutationVariables = {data: CareNavCoverageEligibilityInput}

    export const useCareNavigationCoverageEligibilityCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationCoverageEligibilityCreate>>, TError,CareNavigationCoverageEligibilityCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationCoverageEligibilityCreate>>,
        TError,
        CareNavigationCoverageEligibilityCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationCoverageEligibilityCreateMutationOptions(options), queryClient);
    }

export type careNavigationUpdateClinicListingCreateResponse200 = {
  data: UpdateClinicListingOutput
  status: 200
}

export type careNavigationUpdateClinicListingCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationUpdateClinicListingCreateResponseSuccess = (careNavigationUpdateClinicListingCreateResponse200) & {
  headers: Headers;
};
export type careNavigationUpdateClinicListingCreateResponseError = (careNavigationUpdateClinicListingCreateResponse400) & {
  headers: Headers;
};

export type careNavigationUpdateClinicListingCreateResponse = (careNavigationUpdateClinicListingCreateResponseSuccess | careNavigationUpdateClinicListingCreateResponseError)

export const getCareNavigationUpdateClinicListingCreateUrl = () => {




  return `/api/care-navigation/update-clinic-listing/`
}

export const careNavigationUpdateClinicListingCreate = async (updateClinicListingInput: UpdateClinicListingInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationUpdateClinicListingCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationUpdateClinicListingCreateResponse>(getCareNavigationUpdateClinicListingCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateClinicListingInput)
  }
);}





export const getCareNavigationUpdateClinicListingCreateMutationKey = () => ['careNavigationUpdateClinicListingCreate'] as const;

export const getCareNavigationUpdateClinicListingCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationUpdateClinicListingCreate>>, TError,CareNavigationUpdateClinicListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationUpdateClinicListingCreate>>, TError,CareNavigationUpdateClinicListingCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationUpdateClinicListingCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationUpdateClinicListingCreate>>, CareNavigationUpdateClinicListingCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationUpdateClinicListingCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationUpdateClinicListingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationUpdateClinicListingCreate>>>
    export type CareNavigationUpdateClinicListingCreateMutationBody = UpdateClinicListingInput
    export type CareNavigationUpdateClinicListingCreateMutationError = Error
    export type CareNavigationUpdateClinicListingCreateMutationVariables = {data: UpdateClinicListingInput}

    export const useCareNavigationUpdateClinicListingCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationUpdateClinicListingCreate>>, TError,CareNavigationUpdateClinicListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationUpdateClinicListingCreate>>,
        TError,
        CareNavigationUpdateClinicListingCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationUpdateClinicListingCreateMutationOptions(options), queryClient);
    }

export type careNavigationVerifyOrgListingCreateResponse200 = {
  data: VerifyClinicListingOutput
  status: 200
}

export type careNavigationVerifyOrgListingCreateResponse400 = {
  data: Error
  status: 400
}

export type careNavigationVerifyOrgListingCreateResponseSuccess = (careNavigationVerifyOrgListingCreateResponse200) & {
  headers: Headers;
};
export type careNavigationVerifyOrgListingCreateResponseError = (careNavigationVerifyOrgListingCreateResponse400) & {
  headers: Headers;
};

export type careNavigationVerifyOrgListingCreateResponse = (careNavigationVerifyOrgListingCreateResponseSuccess | careNavigationVerifyOrgListingCreateResponseError)

export const getCareNavigationVerifyOrgListingCreateUrl = () => {




  return `/api/care-navigation/verify-org-listing/`
}

export const careNavigationVerifyOrgListingCreate = async (verifyClinicListingInput: VerifyClinicListingInput, options?: Parameters<typeof customFetch>[1]): Promise<careNavigationVerifyOrgListingCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<careNavigationVerifyOrgListingCreateResponse>(getCareNavigationVerifyOrgListingCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyClinicListingInput)
  }
);}





export const getCareNavigationVerifyOrgListingCreateMutationKey = () => ['careNavigationVerifyOrgListingCreate'] as const;

export const getCareNavigationVerifyOrgListingCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationVerifyOrgListingCreate>>, TError,CareNavigationVerifyOrgListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof careNavigationVerifyOrgListingCreate>>, TError,CareNavigationVerifyOrgListingCreateMutationVariables, TContext> => {

const mutationKey = getCareNavigationVerifyOrgListingCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careNavigationVerifyOrgListingCreate>>, CareNavigationVerifyOrgListingCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  careNavigationVerifyOrgListingCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CareNavigationVerifyOrgListingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof careNavigationVerifyOrgListingCreate>>>
    export type CareNavigationVerifyOrgListingCreateMutationBody = VerifyClinicListingInput
    export type CareNavigationVerifyOrgListingCreateMutationError = Error
    export type CareNavigationVerifyOrgListingCreateMutationVariables = {data: VerifyClinicListingInput}

    export const useCareNavigationVerifyOrgListingCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careNavigationVerifyOrgListingCreate>>, TError,CareNavigationVerifyOrgListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careNavigationVerifyOrgListingCreate>>,
        TError,
        CareNavigationVerifyOrgListingCreateMutationVariables,
        TContext
      > => {
      return useMutation(getCareNavigationVerifyOrgListingCreateMutationOptions(options), queryClient);
    }

export type communityEventsRetrieveResponse200 = {
  data: CommunityEventDetailOutput
  status: 200
}

export type communityEventsRetrieveResponse404 = {
  data: Error
  status: 404
}

export type communityEventsRetrieveResponse503 = {
  data: Error
  status: 503
}

export type communityEventsRetrieveResponseSuccess = (communityEventsRetrieveResponse200) & {
  headers: Headers;
};
export type communityEventsRetrieveResponseError = (communityEventsRetrieveResponse404 | communityEventsRetrieveResponse503) & {
  headers: Headers;
};

export type communityEventsRetrieveResponse = (communityEventsRetrieveResponseSuccess | communityEventsRetrieveResponseError)

export const getCommunityEventsRetrieveUrl = (circleEventId: string,) => {




  return `/api/community/events/${circleEventId}/`
}

/**
 * Return a single community live event by its Circle event ID.
 *
 * Called by the Temporal reminder workflow (Temporal M2M auth) right before
 * it fires, to re-verify the event. Returns 404 if the event was cancelled
 * so the workflow can skip the notification; a changed `starts_at` lets it
 * pick up a last-minute reschedule.
 */
export const communityEventsRetrieve = async (circleEventId: string, options?: Parameters<typeof customFetch>[1]): Promise<communityEventsRetrieveResponse> => {

  return customFetch<communityEventsRetrieveResponse>(getCommunityEventsRetrieveUrl(circleEventId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCommunityEventsRetrieveQueryKey = (circleEventId: string,) => {
    return [
    `/api/community/events/${circleEventId}/`
    ] as const;
    }


export const getCommunityEventsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof communityEventsRetrieve>>, TError = Error>(circleEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunityEventsRetrieveQueryKey(circleEventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof communityEventsRetrieve>>> = ({ signal }) => communityEventsRetrieve(circleEventId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: circleEventId !== null && circleEventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communityEventsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunityEventsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof communityEventsRetrieve>>>
export type CommunityEventsRetrieveQueryError = Error


export function useCommunityEventsRetrieve<TData = Awaited<ReturnType<typeof communityEventsRetrieve>>, TError = Error>(
 circleEventId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityEventsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communityEventsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof communityEventsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunityEventsRetrieve<TData = Awaited<ReturnType<typeof communityEventsRetrieve>>, TError = Error>(
 circleEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityEventsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communityEventsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof communityEventsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunityEventsRetrieve<TData = Awaited<ReturnType<typeof communityEventsRetrieve>>, TError = Error>(
 circleEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCommunityEventsRetrieve<TData = Awaited<ReturnType<typeof communityEventsRetrieve>>, TError = Error>(
 circleEventId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityEventsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunityEventsRetrieveQueryOptions(circleEventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type communityPreviewPostsListResponse200 = {
  data: CommunityPreviewPostsOutput[]
  status: 200
}

export type communityPreviewPostsListResponse400 = {
  data: Error
  status: 400
}

export type communityPreviewPostsListResponseSuccess = (communityPreviewPostsListResponse200) & {
  headers: Headers;
};
export type communityPreviewPostsListResponseError = (communityPreviewPostsListResponse400) & {
  headers: Headers;
};

export type communityPreviewPostsListResponse = (communityPreviewPostsListResponseSuccess | communityPreviewPostsListResponseError)

export const getCommunityPreviewPostsListUrl = (params?: CommunityPreviewPostsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/community/preview-posts/?${stringifiedParams}` : `/api/community/preview-posts/`
}

/**
 * Return a small number of trending community posts.
 *
 * Posts are sorted by comment count descending across all spaces.
 * Uses the Circle Admin API V2 — no per-member token is needed.
 *
 * Query params:
 *     limit (int, optional):
 *         Number of posts to return (1–10, default 2).
 */
export const communityPreviewPostsList = async (params?: CommunityPreviewPostsListParams, options?: Parameters<typeof customFetch>[1]): Promise<communityPreviewPostsListResponse> => {

  return customFetch<communityPreviewPostsListResponse>(getCommunityPreviewPostsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCommunityPreviewPostsListQueryKey = (params?: CommunityPreviewPostsListParams,) => {
    return [
    `/api/community/preview-posts/`, ...(params ? [params] : [])
    ] as const;
    }


export const getCommunityPreviewPostsListQueryOptions = <TData = Awaited<ReturnType<typeof communityPreviewPostsList>>, TError = Error>(params?: CommunityPreviewPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityPreviewPostsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunityPreviewPostsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof communityPreviewPostsList>>> = ({ signal }) => communityPreviewPostsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communityPreviewPostsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunityPreviewPostsListQueryResult = NonNullable<Awaited<ReturnType<typeof communityPreviewPostsList>>>
export type CommunityPreviewPostsListQueryError = Error


export function useCommunityPreviewPostsList<TData = Awaited<ReturnType<typeof communityPreviewPostsList>>, TError = Error>(
 params: undefined |  CommunityPreviewPostsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityPreviewPostsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communityPreviewPostsList>>,
          TError,
          Awaited<ReturnType<typeof communityPreviewPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunityPreviewPostsList<TData = Awaited<ReturnType<typeof communityPreviewPostsList>>, TError = Error>(
 params?: CommunityPreviewPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityPreviewPostsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communityPreviewPostsList>>,
          TError,
          Awaited<ReturnType<typeof communityPreviewPostsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunityPreviewPostsList<TData = Awaited<ReturnType<typeof communityPreviewPostsList>>, TError = Error>(
 params?: CommunityPreviewPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityPreviewPostsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCommunityPreviewPostsList<TData = Awaited<ReturnType<typeof communityPreviewPostsList>>, TError = Error>(
 params?: CommunityPreviewPostsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityPreviewPostsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunityPreviewPostsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type communityUpcomingEventsListResponse200 = {
  data: CommunityUpcomingEventsOutput[]
  status: 200
}

export type communityUpcomingEventsListResponse503 = {
  data: Error
  status: 503
}

export type communityUpcomingEventsListResponseSuccess = (communityUpcomingEventsListResponse200) & {
  headers: Headers;
};
export type communityUpcomingEventsListResponseError = (communityUpcomingEventsListResponse503) & {
  headers: Headers;
};

export type communityUpcomingEventsListResponse = (communityUpcomingEventsListResponseSuccess | communityUpcomingEventsListResponseError)

export const getCommunityUpcomingEventsListUrl = (params?: CommunityUpcomingEventsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/community/upcoming-events/?${stringifiedParams}` : `/api/community/upcoming-events/`
}

/**
 * Return upcoming community live events.
 *
 * Called by the Temporal discovery workflow (Temporal M2M auth). Accepts
 * an optional ``days`` query parameter (default 14) to control how far
 * ahead to look. Dedup is handled by Temporal workflow IDs.
 */
export const communityUpcomingEventsList = async (params?: CommunityUpcomingEventsListParams, options?: Parameters<typeof customFetch>[1]): Promise<communityUpcomingEventsListResponse> => {

  return customFetch<communityUpcomingEventsListResponse>(getCommunityUpcomingEventsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCommunityUpcomingEventsListQueryKey = (params?: CommunityUpcomingEventsListParams,) => {
    return [
    `/api/community/upcoming-events/`, ...(params ? [params] : [])
    ] as const;
    }


export const getCommunityUpcomingEventsListQueryOptions = <TData = Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError = Error>(params?: CommunityUpcomingEventsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCommunityUpcomingEventsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof communityUpcomingEventsList>>> = ({ signal }) => communityUpcomingEventsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CommunityUpcomingEventsListQueryResult = NonNullable<Awaited<ReturnType<typeof communityUpcomingEventsList>>>
export type CommunityUpcomingEventsListQueryError = Error


export function useCommunityUpcomingEventsList<TData = Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError = Error>(
 params: undefined |  CommunityUpcomingEventsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof communityUpcomingEventsList>>,
          TError,
          Awaited<ReturnType<typeof communityUpcomingEventsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunityUpcomingEventsList<TData = Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError = Error>(
 params?: CommunityUpcomingEventsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof communityUpcomingEventsList>>,
          TError,
          Awaited<ReturnType<typeof communityUpcomingEventsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCommunityUpcomingEventsList<TData = Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError = Error>(
 params?: CommunityUpcomingEventsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCommunityUpcomingEventsList<TData = Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError = Error>(
 params?: CommunityUpcomingEventsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof communityUpcomingEventsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommunityUpcomingEventsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type googleMapsAutocompleteRetrieveResponse200 = {
  data: GetGoogleMapsAutocompleteResultsOutput
  status: 200
}

export type googleMapsAutocompleteRetrieveResponse400 = {
  data: Error
  status: 400
}

export type googleMapsAutocompleteRetrieveResponseSuccess = (googleMapsAutocompleteRetrieveResponse200) & {
  headers: Headers;
};
export type googleMapsAutocompleteRetrieveResponseError = (googleMapsAutocompleteRetrieveResponse400) & {
  headers: Headers;
};

export type googleMapsAutocompleteRetrieveResponse = (googleMapsAutocompleteRetrieveResponseSuccess | googleMapsAutocompleteRetrieveResponseError)

export const getGoogleMapsAutocompleteRetrieveUrl = (params: GoogleMapsAutocompleteRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google/maps-autocomplete/?${stringifiedParams}` : `/api/google/maps-autocomplete/`
}

export const googleMapsAutocompleteRetrieve = async (params: GoogleMapsAutocompleteRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<googleMapsAutocompleteRetrieveResponse> => {

  return customFetch<googleMapsAutocompleteRetrieveResponse>(getGoogleMapsAutocompleteRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGoogleMapsAutocompleteRetrieveQueryKey = (params?: GoogleMapsAutocompleteRetrieveParams,) => {
    return [
    `/api/google/maps-autocomplete/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGoogleMapsAutocompleteRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError = Error>(params: GoogleMapsAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGoogleMapsAutocompleteRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>> = ({ signal }) => googleMapsAutocompleteRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GoogleMapsAutocompleteRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>>
export type GoogleMapsAutocompleteRetrieveQueryError = Error


export function useGoogleMapsAutocompleteRetrieve<TData = Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError = Error>(
 params: GoogleMapsAutocompleteRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>,
          TError,
          Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGoogleMapsAutocompleteRetrieve<TData = Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError = Error>(
 params: GoogleMapsAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>,
          TError,
          Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGoogleMapsAutocompleteRetrieve<TData = Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError = Error>(
 params: GoogleMapsAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGoogleMapsAutocompleteRetrieve<TData = Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError = Error>(
 params: GoogleMapsAutocompleteRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googleMapsAutocompleteRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGoogleMapsAutocompleteRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type googlePlaceMetadataRetrieveResponse200 = {
  data: GetPlaceMetadataOutput
  status: 200
}

export type googlePlaceMetadataRetrieveResponse400 = {
  data: Error
  status: 400
}

export type googlePlaceMetadataRetrieveResponseSuccess = (googlePlaceMetadataRetrieveResponse200) & {
  headers: Headers;
};
export type googlePlaceMetadataRetrieveResponseError = (googlePlaceMetadataRetrieveResponse400) & {
  headers: Headers;
};

export type googlePlaceMetadataRetrieveResponse = (googlePlaceMetadataRetrieveResponseSuccess | googlePlaceMetadataRetrieveResponseError)

export const getGooglePlaceMetadataRetrieveUrl = (params: GooglePlaceMetadataRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/google/place-metadata/?${stringifiedParams}` : `/api/google/place-metadata/`
}

export const googlePlaceMetadataRetrieve = async (params: GooglePlaceMetadataRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<googlePlaceMetadataRetrieveResponse> => {

  return customFetch<googlePlaceMetadataRetrieveResponse>(getGooglePlaceMetadataRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGooglePlaceMetadataRetrieveQueryKey = (params?: GooglePlaceMetadataRetrieveParams,) => {
    return [
    `/api/google/place-metadata/`, ...(params ? [params] : [])
    ] as const;
    }


export const getGooglePlaceMetadataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError = Error>(params: GooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGooglePlaceMetadataRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>> = ({ signal }) => googlePlaceMetadataRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GooglePlaceMetadataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>>
export type GooglePlaceMetadataRetrieveQueryError = Error


export function useGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError = Error>(
 params: GooglePlaceMetadataRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError = Error>(
 params: GooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>,
          TError,
          Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError = Error>(
 params: GooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGooglePlaceMetadataRetrieve<TData = Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError = Error>(
 params: GooglePlaceMetadataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof googlePlaceMetadataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGooglePlaceMetadataRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type helloWorldTemporalCreateResponse200 = {
  data: void
  status: 200
}

export type helloWorldTemporalCreateResponseSuccess = (helloWorldTemporalCreateResponse200) & {
  headers: Headers;
};
;

export type helloWorldTemporalCreateResponse = (helloWorldTemporalCreateResponseSuccess)

export const getHelloWorldTemporalCreateUrl = () => {




  return `/api/hello-world/temporal/`
}

export const helloWorldTemporalCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<helloWorldTemporalCreateResponse> => {

  return customFetch<helloWorldTemporalCreateResponse>(getHelloWorldTemporalCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getHelloWorldTemporalCreateMutationKey = () => ['helloWorldTemporalCreate'] as const;

export const getHelloWorldTemporalCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof helloWorldTemporalCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof helloWorldTemporalCreate>>, TError,void, TContext> => {

const mutationKey = getHelloWorldTemporalCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof helloWorldTemporalCreate>>, void> = () => {


          return  helloWorldTemporalCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HelloWorldTemporalCreateMutationResult = NonNullable<Awaited<ReturnType<typeof helloWorldTemporalCreate>>>

    export type HelloWorldTemporalCreateMutationError = unknown


    export const useHelloWorldTemporalCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof helloWorldTemporalCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof helloWorldTemporalCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getHelloWorldTemporalCreateMutationOptions(options), queryClient);
    }

export type internalReassignExpertChatCreateResponse200 = {
  data: ReassignExpertChatOutput
  status: 200
}

export type internalReassignExpertChatCreateResponse400 = {
  data: Error
  status: 400
}

export type internalReassignExpertChatCreateResponse409 = {
  data: Error
  status: 409
}

export type internalReassignExpertChatCreateResponseSuccess = (internalReassignExpertChatCreateResponse200) & {
  headers: Headers;
};
export type internalReassignExpertChatCreateResponseError = (internalReassignExpertChatCreateResponse400 | internalReassignExpertChatCreateResponse409) & {
  headers: Headers;
};

export type internalReassignExpertChatCreateResponse = (internalReassignExpertChatCreateResponseSuccess | internalReassignExpertChatCreateResponseError)

export const getInternalReassignExpertChatCreateUrl = () => {




  return `/api/internal/reassign-expert-chat/`
}

/**
 * Reassign a learner's open expert chat to a different Clarity provider.
 */
export const internalReassignExpertChatCreate = async (reassignExpertChatInput: ReassignExpertChatInput, options?: Parameters<typeof customFetch>[1]): Promise<internalReassignExpertChatCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<internalReassignExpertChatCreateResponse>(getInternalReassignExpertChatCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reassignExpertChatInput)
  }
);}





export const getInternalReassignExpertChatCreateMutationKey = () => ['internalReassignExpertChatCreate'] as const;

export const getInternalReassignExpertChatCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalReassignExpertChatCreate>>, TError,InternalReassignExpertChatCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof internalReassignExpertChatCreate>>, TError,InternalReassignExpertChatCreateMutationVariables, TContext> => {

const mutationKey = getInternalReassignExpertChatCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalReassignExpertChatCreate>>, InternalReassignExpertChatCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  internalReassignExpertChatCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InternalReassignExpertChatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof internalReassignExpertChatCreate>>>
    export type InternalReassignExpertChatCreateMutationBody = ReassignExpertChatInput
    export type InternalReassignExpertChatCreateMutationError = Error
    export type InternalReassignExpertChatCreateMutationVariables = {data: ReassignExpertChatInput}

    export const useInternalReassignExpertChatCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalReassignExpertChatCreate>>, TError,InternalReassignExpertChatCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof internalReassignExpertChatCreate>>,
        TError,
        InternalReassignExpertChatCreateMutationVariables,
        TContext
      > => {
      return useMutation(getInternalReassignExpertChatCreateMutationOptions(options), queryClient);
    }

export type learnerFileListResponse200 = {
  data: LearnerFile[]
  status: 200
}

export type learnerFileListResponseSuccess = (learnerFileListResponse200) & {
  headers: Headers;
};
;

export type learnerFileListResponse = (learnerFileListResponseSuccess)

export const getLearnerFileListUrl = () => {




  return `/api/learner-file/`
}

/**
 * API endpoint for learner file veiws and uploads
 */
export const learnerFileList = async ( options?: Parameters<typeof customFetch>[1]): Promise<learnerFileListResponse> => {

  return customFetch<learnerFileListResponse>(getLearnerFileListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLearnerFileListQueryKey = () => {
    return [
    `/api/learner-file/`
    ] as const;
    }


export const getLearnerFileListQueryOptions = <TData = Awaited<ReturnType<typeof learnerFileList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearnerFileListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learnerFileList>>> = ({ signal }) => learnerFileList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learnerFileList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearnerFileListQueryResult = NonNullable<Awaited<ReturnType<typeof learnerFileList>>>
export type LearnerFileListQueryError = unknown


export function useLearnerFileList<TData = Awaited<ReturnType<typeof learnerFileList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learnerFileList>>,
          TError,
          Awaited<ReturnType<typeof learnerFileList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearnerFileList<TData = Awaited<ReturnType<typeof learnerFileList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learnerFileList>>,
          TError,
          Awaited<ReturnType<typeof learnerFileList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearnerFileList<TData = Awaited<ReturnType<typeof learnerFileList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLearnerFileList<TData = Awaited<ReturnType<typeof learnerFileList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearnerFileListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type learnerFileCreateResponse201 = {
  data: LearnerFile
  status: 201
}

export type learnerFileCreateResponseSuccess = (learnerFileCreateResponse201) & {
  headers: Headers;
};
;

export type learnerFileCreateResponse = (learnerFileCreateResponseSuccess)

export const getLearnerFileCreateUrl = () => {




  return `/api/learner-file/`
}

/**
 * API endpoint for learner file veiws and uploads
 */
export const learnerFileCreate = async (learnerFile: NonReadonly<LearnerFile>, options?: Parameters<typeof customFetch>[1]): Promise<learnerFileCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<learnerFileCreateResponse>(getLearnerFileCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(learnerFile)
  }
);}





export const getLearnerFileCreateMutationKey = () => ['learnerFileCreate'] as const;

export const getLearnerFileCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFileCreate>>, TError,LearnerFileCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof learnerFileCreate>>, TError,LearnerFileCreateMutationVariables, TContext> => {

const mutationKey = getLearnerFileCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learnerFileCreate>>, LearnerFileCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  learnerFileCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearnerFileCreateMutationResult = NonNullable<Awaited<ReturnType<typeof learnerFileCreate>>>
    export type LearnerFileCreateMutationBody = NonReadonly<LearnerFile>
    export type LearnerFileCreateMutationError = unknown
    export type LearnerFileCreateMutationVariables = {data: NonReadonly<LearnerFile>}

    export const useLearnerFileCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFileCreate>>, TError,LearnerFileCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learnerFileCreate>>,
        TError,
        LearnerFileCreateMutationVariables,
        TContext
      > => {
      return useMutation(getLearnerFileCreateMutationOptions(options), queryClient);
    }

export type learnerFileRetrieveResponse200 = {
  data: LearnerFile
  status: 200
}

export type learnerFileRetrieveResponseSuccess = (learnerFileRetrieveResponse200) & {
  headers: Headers;
};
;

export type learnerFileRetrieveResponse = (learnerFileRetrieveResponseSuccess)

export const getLearnerFileRetrieveUrl = (id: number,) => {




  return `/api/learner-file/${id}/`
}

/**
 * API endpoint for learner file veiws and uploads
 */
export const learnerFileRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<learnerFileRetrieveResponse> => {

  return customFetch<learnerFileRetrieveResponse>(getLearnerFileRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLearnerFileRetrieveQueryKey = (id: number,) => {
    return [
    `/api/learner-file/${id}/`
    ] as const;
    }


export const getLearnerFileRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof learnerFileRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearnerFileRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof learnerFileRetrieve>>> = ({ signal }) => learnerFileRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learnerFileRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearnerFileRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof learnerFileRetrieve>>>
export type LearnerFileRetrieveQueryError = unknown


export function useLearnerFileRetrieve<TData = Awaited<ReturnType<typeof learnerFileRetrieve>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learnerFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof learnerFileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearnerFileRetrieve<TData = Awaited<ReturnType<typeof learnerFileRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learnerFileRetrieve>>,
          TError,
          Awaited<ReturnType<typeof learnerFileRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearnerFileRetrieve<TData = Awaited<ReturnType<typeof learnerFileRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLearnerFileRetrieve<TData = Awaited<ReturnType<typeof learnerFileRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learnerFileRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearnerFileRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type learnerFileUpdateResponse200 = {
  data: LearnerFile
  status: 200
}

export type learnerFileUpdateResponseSuccess = (learnerFileUpdateResponse200) & {
  headers: Headers;
};
;

export type learnerFileUpdateResponse = (learnerFileUpdateResponseSuccess)

export const getLearnerFileUpdateUrl = (id: number,) => {




  return `/api/learner-file/${id}/`
}

/**
 * API endpoint for learner file veiws and uploads
 */
export const learnerFileUpdate = async (id: number,
    learnerFile: NonReadonly<LearnerFile>, options?: Parameters<typeof customFetch>[1]): Promise<learnerFileUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<learnerFileUpdateResponse>(getLearnerFileUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(learnerFile)
  }
);}





export const getLearnerFileUpdateMutationKey = () => ['learnerFileUpdate'] as const;

export const getLearnerFileUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFileUpdate>>, TError,LearnerFileUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof learnerFileUpdate>>, TError,LearnerFileUpdateMutationVariables, TContext> => {

const mutationKey = getLearnerFileUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learnerFileUpdate>>, LearnerFileUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  learnerFileUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearnerFileUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof learnerFileUpdate>>>
    export type LearnerFileUpdateMutationBody = NonReadonly<LearnerFile>
    export type LearnerFileUpdateMutationError = unknown
    export type LearnerFileUpdateMutationVariables = {id: number;data: NonReadonly<LearnerFile>}

    export const useLearnerFileUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFileUpdate>>, TError,LearnerFileUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learnerFileUpdate>>,
        TError,
        LearnerFileUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLearnerFileUpdateMutationOptions(options), queryClient);
    }

export type learnerFilePartialUpdateResponse200 = {
  data: LearnerFile
  status: 200
}

export type learnerFilePartialUpdateResponseSuccess = (learnerFilePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type learnerFilePartialUpdateResponse = (learnerFilePartialUpdateResponseSuccess)

export const getLearnerFilePartialUpdateUrl = (id: number,) => {




  return `/api/learner-file/${id}/`
}

/**
 * API endpoint for learner file veiws and uploads
 */
export const learnerFilePartialUpdate = async (id: number,
    patchedLearnerFile?: NonReadonly<PatchedLearnerFile>, options?: Parameters<typeof customFetch>[1]): Promise<learnerFilePartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<learnerFilePartialUpdateResponse>(getLearnerFilePartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedLearnerFile)
  }
);}





export const getLearnerFilePartialUpdateMutationKey = () => ['learnerFilePartialUpdate'] as const;

export const getLearnerFilePartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFilePartialUpdate>>, TError,LearnerFilePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof learnerFilePartialUpdate>>, TError,LearnerFilePartialUpdateMutationVariables, TContext> => {

const mutationKey = getLearnerFilePartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learnerFilePartialUpdate>>, LearnerFilePartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  learnerFilePartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearnerFilePartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof learnerFilePartialUpdate>>>
    export type LearnerFilePartialUpdateMutationBody = NonReadonly<PatchedLearnerFile> | undefined
    export type LearnerFilePartialUpdateMutationError = unknown
    export type LearnerFilePartialUpdateMutationVariables = {id: number;data?: NonReadonly<PatchedLearnerFile>}

    export const useLearnerFilePartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFilePartialUpdate>>, TError,LearnerFilePartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learnerFilePartialUpdate>>,
        TError,
        LearnerFilePartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getLearnerFilePartialUpdateMutationOptions(options), queryClient);
    }

export type learnerFileDestroyResponse204 = {
  data: void
  status: 204
}

export type learnerFileDestroyResponseSuccess = (learnerFileDestroyResponse204) & {
  headers: Headers;
};
;

export type learnerFileDestroyResponse = (learnerFileDestroyResponseSuccess)

export const getLearnerFileDestroyUrl = (id: number,) => {




  return `/api/learner-file/${id}/`
}

/**
 * API endpoint for learner file veiws and uploads
 */
export const learnerFileDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<learnerFileDestroyResponse> => {

  return customFetch<learnerFileDestroyResponse>(getLearnerFileDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLearnerFileDestroyMutationKey = () => ['learnerFileDestroy'] as const;

export const getLearnerFileDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFileDestroy>>, TError,LearnerFileDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof learnerFileDestroy>>, TError,LearnerFileDestroyMutationVariables, TContext> => {

const mutationKey = getLearnerFileDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learnerFileDestroy>>, LearnerFileDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  learnerFileDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LearnerFileDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof learnerFileDestroy>>>

    export type LearnerFileDestroyMutationError = unknown
    export type LearnerFileDestroyMutationVariables = {id: number}

    export const useLearnerFileDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learnerFileDestroy>>, TError,LearnerFileDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learnerFileDestroy>>,
        TError,
        LearnerFileDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getLearnerFileDestroyMutationOptions(options), queryClient);
    }

export type mediaListResponse200 = {
  data: Media[]
  status: 200
}

export type mediaListResponseSuccess = (mediaListResponse200) & {
  headers: Headers;
};
;

export type mediaListResponse = (mediaListResponseSuccess)

export const getMediaListUrl = () => {




  return `/api/media/`
}

/**
 * API endpoint that allows videos to be viewed or edited.
 */
export const mediaList = async ( options?: Parameters<typeof customFetch>[1]): Promise<mediaListResponse> => {

  return customFetch<mediaListResponse>(getMediaListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaListQueryKey = () => {
    return [
    `/api/media/`
    ] as const;
    }


export const getMediaListQueryOptions = <TData = Awaited<ReturnType<typeof mediaList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaList>>> = ({ signal }) => mediaList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaListQueryResult = NonNullable<Awaited<ReturnType<typeof mediaList>>>
export type MediaListQueryError = unknown


export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaList>>,
          TError,
          Awaited<ReturnType<typeof mediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaList>>,
          TError,
          Awaited<ReturnType<typeof mediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMediaList<TData = Awaited<ReturnType<typeof mediaList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type mediaCreateResponse201 = {
  data: Media
  status: 201
}

export type mediaCreateResponseSuccess = (mediaCreateResponse201) & {
  headers: Headers;
};
;

export type mediaCreateResponse = (mediaCreateResponseSuccess)

export const getMediaCreateUrl = () => {




  return `/api/media/`
}

/**
 * API endpoint that allows videos to be viewed or edited.
 */
export const mediaCreate = async (media: NonReadonly<Media>, options?: Parameters<typeof customFetch>[1]): Promise<mediaCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<mediaCreateResponse>(getMediaCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(media)
  }
);}





export const getMediaCreateMutationKey = () => ['mediaCreate'] as const;

export const getMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaCreate>>, TError,MediaCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mediaCreate>>, TError,MediaCreateMutationVariables, TContext> => {

const mutationKey = getMediaCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mediaCreate>>, MediaCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  mediaCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof mediaCreate>>>
    export type MediaCreateMutationBody = NonReadonly<Media>
    export type MediaCreateMutationError = unknown
    export type MediaCreateMutationVariables = {data: NonReadonly<Media>}

    export const useMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaCreate>>, TError,MediaCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mediaCreate>>,
        TError,
        MediaCreateMutationVariables,
        TContext
      > => {
      return useMutation(getMediaCreateMutationOptions(options), queryClient);
    }

export type mediaRetrieveResponse200 = {
  data: Media
  status: 200
}

export type mediaRetrieveResponseSuccess = (mediaRetrieveResponse200) & {
  headers: Headers;
};
;

export type mediaRetrieveResponse = (mediaRetrieveResponseSuccess)

export const getMediaRetrieveUrl = (id: number,) => {




  return `/api/media/${id}/`
}

/**
 * API endpoint that allows videos to be viewed or edited.
 */
export const mediaRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<mediaRetrieveResponse> => {

  return customFetch<mediaRetrieveResponse>(getMediaRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMediaRetrieveQueryKey = (id: number,) => {
    return [
    `/api/media/${id}/`
    ] as const;
    }


export const getMediaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof mediaRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMediaRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mediaRetrieve>>> = ({ signal }) => mediaRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mediaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MediaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof mediaRetrieve>>>
export type MediaRetrieveQueryError = unknown


export function useMediaRetrieve<TData = Awaited<ReturnType<typeof mediaRetrieve>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRetrieve<TData = Awaited<ReturnType<typeof mediaRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof mediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMediaRetrieve<TData = Awaited<ReturnType<typeof mediaRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useMediaRetrieve<TData = Awaited<ReturnType<typeof mediaRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMediaRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type mediaUpdateResponse200 = {
  data: Media
  status: 200
}

export type mediaUpdateResponseSuccess = (mediaUpdateResponse200) & {
  headers: Headers;
};
;

export type mediaUpdateResponse = (mediaUpdateResponseSuccess)

export const getMediaUpdateUrl = (id: number,) => {




  return `/api/media/${id}/`
}

/**
 * API endpoint that allows videos to be viewed or edited.
 */
export const mediaUpdate = async (id: number,
    media: NonReadonly<Media>, options?: Parameters<typeof customFetch>[1]): Promise<mediaUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<mediaUpdateResponse>(getMediaUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(media)
  }
);}





export const getMediaUpdateMutationKey = () => ['mediaUpdate'] as const;

export const getMediaUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError,MediaUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError,MediaUpdateMutationVariables, TContext> => {

const mutationKey = getMediaUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mediaUpdate>>, MediaUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  mediaUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MediaUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mediaUpdate>>>
    export type MediaUpdateMutationBody = NonReadonly<Media>
    export type MediaUpdateMutationError = unknown
    export type MediaUpdateMutationVariables = {id: number;data: NonReadonly<Media>}

    export const useMediaUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaUpdate>>, TError,MediaUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mediaUpdate>>,
        TError,
        MediaUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getMediaUpdateMutationOptions(options), queryClient);
    }

export type mediaPartialUpdateResponse200 = {
  data: Media
  status: 200
}

export type mediaPartialUpdateResponseSuccess = (mediaPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type mediaPartialUpdateResponse = (mediaPartialUpdateResponseSuccess)

export const getMediaPartialUpdateUrl = (id: number,) => {




  return `/api/media/${id}/`
}

/**
 * API endpoint that allows videos to be viewed or edited.
 */
export const mediaPartialUpdate = async (id: number,
    patchedMedia?: NonReadonly<PatchedMedia>, options?: Parameters<typeof customFetch>[1]): Promise<mediaPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<mediaPartialUpdateResponse>(getMediaPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedMedia)
  }
);}





export const getMediaPartialUpdateMutationKey = () => ['mediaPartialUpdate'] as const;

export const getMediaPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaPartialUpdate>>, TError,MediaPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mediaPartialUpdate>>, TError,MediaPartialUpdateMutationVariables, TContext> => {

const mutationKey = getMediaPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mediaPartialUpdate>>, MediaPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  mediaPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MediaPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof mediaPartialUpdate>>>
    export type MediaPartialUpdateMutationBody = NonReadonly<PatchedMedia> | undefined
    export type MediaPartialUpdateMutationError = unknown
    export type MediaPartialUpdateMutationVariables = {id: number;data?: NonReadonly<PatchedMedia>}

    export const useMediaPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaPartialUpdate>>, TError,MediaPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mediaPartialUpdate>>,
        TError,
        MediaPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getMediaPartialUpdateMutationOptions(options), queryClient);
    }

export type mediaDestroyResponse204 = {
  data: void
  status: 204
}

export type mediaDestroyResponseSuccess = (mediaDestroyResponse204) & {
  headers: Headers;
};
;

export type mediaDestroyResponse = (mediaDestroyResponseSuccess)

export const getMediaDestroyUrl = (id: number,) => {




  return `/api/media/${id}/`
}

/**
 * API endpoint that allows videos to be viewed or edited.
 */
export const mediaDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<mediaDestroyResponse> => {

  return customFetch<mediaDestroyResponse>(getMediaDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMediaDestroyMutationKey = () => ['mediaDestroy'] as const;

export const getMediaDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaDestroy>>, TError,MediaDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mediaDestroy>>, TError,MediaDestroyMutationVariables, TContext> => {

const mutationKey = getMediaDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mediaDestroy>>, MediaDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  mediaDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MediaDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof mediaDestroy>>>

    export type MediaDestroyMutationError = unknown
    export type MediaDestroyMutationVariables = {id: number}

    export const useMediaDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mediaDestroy>>, TError,MediaDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mediaDestroy>>,
        TError,
        MediaDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getMediaDestroyMutationOptions(options), queryClient);
    }

export type publicClinicLeadRetrieveResponse200 = {
  data: ClinicLead
  status: 200
}

export type publicClinicLeadRetrieveResponse400 = {
  data: Error
  status: 400
}

export type publicClinicLeadRetrieveResponseSuccess = (publicClinicLeadRetrieveResponse200) & {
  headers: Headers;
};
export type publicClinicLeadRetrieveResponseError = (publicClinicLeadRetrieveResponse400) & {
  headers: Headers;
};

export type publicClinicLeadRetrieveResponse = (publicClinicLeadRetrieveResponseSuccess | publicClinicLeadRetrieveResponseError)

export const getPublicClinicLeadRetrieveUrl = (params: PublicClinicLeadRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/public/clinic-lead?${stringifiedParams}` : `/api/public/clinic-lead`
}

export const publicClinicLeadRetrieve = async (params: PublicClinicLeadRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<publicClinicLeadRetrieveResponse> => {

  return customFetch<publicClinicLeadRetrieveResponse>(getPublicClinicLeadRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getPublicClinicLeadRetrieveQueryKey = (params?: PublicClinicLeadRetrieveParams,) => {
    return [
    `/api/public/clinic-lead`, ...(params ? [params] : [])
    ] as const;
    }


export const getPublicClinicLeadRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError = Error>(params: PublicClinicLeadRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPublicClinicLeadRetrieveQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>> = ({ signal }) => publicClinicLeadRetrieve(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PublicClinicLeadRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>>
export type PublicClinicLeadRetrieveQueryError = Error


export function usePublicClinicLeadRetrieve<TData = Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError = Error>(
 params: PublicClinicLeadRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicClinicLeadRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicClinicLeadRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicClinicLeadRetrieve<TData = Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError = Error>(
 params: PublicClinicLeadRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicClinicLeadRetrieve>>,
          TError,
          Awaited<ReturnType<typeof publicClinicLeadRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePublicClinicLeadRetrieve<TData = Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError = Error>(
 params: PublicClinicLeadRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePublicClinicLeadRetrieve<TData = Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError = Error>(
 params: PublicClinicLeadRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicClinicLeadRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicClinicLeadRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type publicVerifyListingCreateResponse200 = {
  data: VerifyClinicListingOutput
  status: 200
}

export type publicVerifyListingCreateResponse400 = {
  data: Error
  status: 400
}

export type publicVerifyListingCreateResponseSuccess = (publicVerifyListingCreateResponse200) & {
  headers: Headers;
};
export type publicVerifyListingCreateResponseError = (publicVerifyListingCreateResponse400) & {
  headers: Headers;
};

export type publicVerifyListingCreateResponse = (publicVerifyListingCreateResponseSuccess | publicVerifyListingCreateResponseError)

export const getPublicVerifyListingCreateUrl = () => {




  return `/api/public/verify-listing`
}

export const publicVerifyListingCreate = async (verifyClinicListingPublicInput: VerifyClinicListingPublicInput, options?: Parameters<typeof customFetch>[1]): Promise<publicVerifyListingCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<publicVerifyListingCreateResponse>(getPublicVerifyListingCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyClinicListingPublicInput)
  }
);}





export const getPublicVerifyListingCreateMutationKey = () => ['publicVerifyListingCreate'] as const;

export const getPublicVerifyListingCreateMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicVerifyListingCreate>>, TError,PublicVerifyListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof publicVerifyListingCreate>>, TError,PublicVerifyListingCreateMutationVariables, TContext> => {

const mutationKey = getPublicVerifyListingCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publicVerifyListingCreate>>, PublicVerifyListingCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  publicVerifyListingCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublicVerifyListingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof publicVerifyListingCreate>>>
    export type PublicVerifyListingCreateMutationBody = VerifyClinicListingPublicInput
    export type PublicVerifyListingCreateMutationError = Error
    export type PublicVerifyListingCreateMutationVariables = {data: VerifyClinicListingPublicInput}

    export const usePublicVerifyListingCreate = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publicVerifyListingCreate>>, TError,PublicVerifyListingCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof publicVerifyListingCreate>>,
        TError,
        PublicVerifyListingCreateMutationVariables,
        TContext
      > => {
      return useMutation(getPublicVerifyListingCreateMutationOptions(options), queryClient);
    }

export type sessionUploadUrlCreateResponse200 = {
  data: void
  status: 200
}

export type sessionUploadUrlCreateResponseSuccess = (sessionUploadUrlCreateResponse200) & {
  headers: Headers;
};
;

export type sessionUploadUrlCreateResponse = (sessionUploadUrlCreateResponseSuccess)

export const getSessionUploadUrlCreateUrl = () => {




  return `/api/session/upload-url/`
}

/**
 * POST with JSON: start_time (ISO8601), user_email. Requires Auth0 Bearer.
 * Returns { "audio_url": "<presigned S3 put URL>" }.
 */
export const sessionUploadUrlCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<sessionUploadUrlCreateResponse> => {

  return customFetch<sessionUploadUrlCreateResponse>(getSessionUploadUrlCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSessionUploadUrlCreateMutationKey = () => ['sessionUploadUrlCreate'] as const;

export const getSessionUploadUrlCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionUploadUrlCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sessionUploadUrlCreate>>, TError,void, TContext> => {

const mutationKey = getSessionUploadUrlCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sessionUploadUrlCreate>>, void> = () => {


          return  sessionUploadUrlCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SessionUploadUrlCreateMutationResult = NonNullable<Awaited<ReturnType<typeof sessionUploadUrlCreate>>>

    export type SessionUploadUrlCreateMutationError = unknown


    export const useSessionUploadUrlCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sessionUploadUrlCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sessionUploadUrlCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSessionUploadUrlCreateMutationOptions(options), queryClient);
    }

export type videoSessionListResponse200 = {
  data: VideoSession[]
  status: 200
}

export type videoSessionListResponseSuccess = (videoSessionListResponse200) & {
  headers: Headers;
};
;

export type videoSessionListResponse = (videoSessionListResponseSuccess)

export const getVideoSessionListUrl = () => {




  return `/api/video-session/`
}

/**
 * wrap the veiw set with our role logic and use this as our default
 */
export const videoSessionList = async ( options?: Parameters<typeof customFetch>[1]): Promise<videoSessionListResponse> => {

  return customFetch<videoSessionListResponse>(getVideoSessionListUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVideoSessionListQueryKey = () => {
    return [
    `/api/video-session/`
    ] as const;
    }


export const getVideoSessionListQueryOptions = <TData = Awaited<ReturnType<typeof videoSessionList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVideoSessionListQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof videoSessionList>>> = ({ signal }) => videoSessionList({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof videoSessionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VideoSessionListQueryResult = NonNullable<Awaited<ReturnType<typeof videoSessionList>>>
export type VideoSessionListQueryError = unknown


export function useVideoSessionList<TData = Awaited<ReturnType<typeof videoSessionList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoSessionList>>,
          TError,
          Awaited<ReturnType<typeof videoSessionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVideoSessionList<TData = Awaited<ReturnType<typeof videoSessionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoSessionList>>,
          TError,
          Awaited<ReturnType<typeof videoSessionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVideoSessionList<TData = Awaited<ReturnType<typeof videoSessionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVideoSessionList<TData = Awaited<ReturnType<typeof videoSessionList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVideoSessionListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type videoSessionCreateResponse201 = {
  data: VideoSession
  status: 201
}

export type videoSessionCreateResponseSuccess = (videoSessionCreateResponse201) & {
  headers: Headers;
};
;

export type videoSessionCreateResponse = (videoSessionCreateResponseSuccess)

export const getVideoSessionCreateUrl = () => {




  return `/api/video-session/`
}

/**
 * wrap the veiw set with our role logic and use this as our default
 */
export const videoSessionCreate = async (videoSession: NonReadonly<VideoSession>, options?: Parameters<typeof customFetch>[1]): Promise<videoSessionCreateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<videoSessionCreateResponse>(getVideoSessionCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(videoSession)
  }
);}





export const getVideoSessionCreateMutationKey = () => ['videoSessionCreate'] as const;

export const getVideoSessionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionCreate>>, TError,VideoSessionCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof videoSessionCreate>>, TError,VideoSessionCreateMutationVariables, TContext> => {

const mutationKey = getVideoSessionCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof videoSessionCreate>>, VideoSessionCreateMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  videoSessionCreate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VideoSessionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof videoSessionCreate>>>
    export type VideoSessionCreateMutationBody = NonReadonly<VideoSession>
    export type VideoSessionCreateMutationError = unknown
    export type VideoSessionCreateMutationVariables = {data: NonReadonly<VideoSession>}

    export const useVideoSessionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionCreate>>, TError,VideoSessionCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof videoSessionCreate>>,
        TError,
        VideoSessionCreateMutationVariables,
        TContext
      > => {
      return useMutation(getVideoSessionCreateMutationOptions(options), queryClient);
    }

export type videoSessionRetrieveResponse200 = {
  data: VideoSession
  status: 200
}

export type videoSessionRetrieveResponseSuccess = (videoSessionRetrieveResponse200) & {
  headers: Headers;
};
;

export type videoSessionRetrieveResponse = (videoSessionRetrieveResponseSuccess)

export const getVideoSessionRetrieveUrl = (id: number,) => {




  return `/api/video-session/${id}/`
}

/**
 * wrap the veiw set with our role logic and use this as our default
 */
export const videoSessionRetrieve = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<videoSessionRetrieveResponse> => {

  return customFetch<videoSessionRetrieveResponse>(getVideoSessionRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVideoSessionRetrieveQueryKey = (id: number,) => {
    return [
    `/api/video-session/${id}/`
    ] as const;
    }


export const getVideoSessionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof videoSessionRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVideoSessionRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof videoSessionRetrieve>>> = ({ signal }) => videoSessionRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof videoSessionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VideoSessionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof videoSessionRetrieve>>>
export type VideoSessionRetrieveQueryError = unknown


export function useVideoSessionRetrieve<TData = Awaited<ReturnType<typeof videoSessionRetrieve>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoSessionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof videoSessionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVideoSessionRetrieve<TData = Awaited<ReturnType<typeof videoSessionRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoSessionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof videoSessionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVideoSessionRetrieve<TData = Awaited<ReturnType<typeof videoSessionRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVideoSessionRetrieve<TData = Awaited<ReturnType<typeof videoSessionRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVideoSessionRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







export type videoSessionUpdateResponse200 = {
  data: VideoSession
  status: 200
}

export type videoSessionUpdateResponseSuccess = (videoSessionUpdateResponse200) & {
  headers: Headers;
};
;

export type videoSessionUpdateResponse = (videoSessionUpdateResponseSuccess)

export const getVideoSessionUpdateUrl = (id: number,) => {




  return `/api/video-session/${id}/`
}

/**
 * wrap the veiw set with our role logic and use this as our default
 */
export const videoSessionUpdate = async (id: number,
    videoSession: NonReadonly<VideoSession>, options?: Parameters<typeof customFetch>[1]): Promise<videoSessionUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<videoSessionUpdateResponse>(getVideoSessionUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(videoSession)
  }
);}





export const getVideoSessionUpdateMutationKey = () => ['videoSessionUpdate'] as const;

export const getVideoSessionUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionUpdate>>, TError,VideoSessionUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof videoSessionUpdate>>, TError,VideoSessionUpdateMutationVariables, TContext> => {

const mutationKey = getVideoSessionUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof videoSessionUpdate>>, VideoSessionUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  videoSessionUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VideoSessionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof videoSessionUpdate>>>
    export type VideoSessionUpdateMutationBody = NonReadonly<VideoSession>
    export type VideoSessionUpdateMutationError = unknown
    export type VideoSessionUpdateMutationVariables = {id: number;data: NonReadonly<VideoSession>}

    export const useVideoSessionUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionUpdate>>, TError,VideoSessionUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof videoSessionUpdate>>,
        TError,
        VideoSessionUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVideoSessionUpdateMutationOptions(options), queryClient);
    }

export type videoSessionPartialUpdateResponse200 = {
  data: VideoSession
  status: 200
}

export type videoSessionPartialUpdateResponseSuccess = (videoSessionPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type videoSessionPartialUpdateResponse = (videoSessionPartialUpdateResponseSuccess)

export const getVideoSessionPartialUpdateUrl = (id: number,) => {




  return `/api/video-session/${id}/`
}

/**
 * wrap the veiw set with our role logic and use this as our default
 */
export const videoSessionPartialUpdate = async (id: number,
    patchedVideoSession?: NonReadonly<PatchedVideoSession>, options?: Parameters<typeof customFetch>[1]): Promise<videoSessionPartialUpdateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<videoSessionPartialUpdateResponse>(getVideoSessionPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedVideoSession)
  }
);}





export const getVideoSessionPartialUpdateMutationKey = () => ['videoSessionPartialUpdate'] as const;

export const getVideoSessionPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionPartialUpdate>>, TError,VideoSessionPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof videoSessionPartialUpdate>>, TError,VideoSessionPartialUpdateMutationVariables, TContext> => {

const mutationKey = getVideoSessionPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof videoSessionPartialUpdate>>, VideoSessionPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  videoSessionPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VideoSessionPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof videoSessionPartialUpdate>>>
    export type VideoSessionPartialUpdateMutationBody = NonReadonly<PatchedVideoSession> | undefined
    export type VideoSessionPartialUpdateMutationError = unknown
    export type VideoSessionPartialUpdateMutationVariables = {id: number;data?: NonReadonly<PatchedVideoSession>}

    export const useVideoSessionPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionPartialUpdate>>, TError,VideoSessionPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof videoSessionPartialUpdate>>,
        TError,
        VideoSessionPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getVideoSessionPartialUpdateMutationOptions(options), queryClient);
    }

export type videoSessionDestroyResponse204 = {
  data: void
  status: 204
}

export type videoSessionDestroyResponseSuccess = (videoSessionDestroyResponse204) & {
  headers: Headers;
};
;

export type videoSessionDestroyResponse = (videoSessionDestroyResponseSuccess)

export const getVideoSessionDestroyUrl = (id: number,) => {




  return `/api/video-session/${id}/`
}

/**
 * wrap the veiw set with our role logic and use this as our default
 */
export const videoSessionDestroy = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<videoSessionDestroyResponse> => {

  return customFetch<videoSessionDestroyResponse>(getVideoSessionDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getVideoSessionDestroyMutationKey = () => ['videoSessionDestroy'] as const;

export const getVideoSessionDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionDestroy>>, TError,VideoSessionDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof videoSessionDestroy>>, TError,VideoSessionDestroyMutationVariables, TContext> => {

const mutationKey = getVideoSessionDestroyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof videoSessionDestroy>>, VideoSessionDestroyMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  videoSessionDestroy(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VideoSessionDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof videoSessionDestroy>>>

    export type VideoSessionDestroyMutationError = unknown
    export type VideoSessionDestroyMutationVariables = {id: number}

    export const useVideoSessionDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof videoSessionDestroy>>, TError,VideoSessionDestroyMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof videoSessionDestroy>>,
        TError,
        VideoSessionDestroyMutationVariables,
        TContext
      > => {
      return useMutation(getVideoSessionDestroyMutationOptions(options), queryClient);
    }

export type videoSessionLanguageRetrieveResponse200 = {
  data: void
  status: 200
}

export type videoSessionLanguageRetrieveResponseSuccess = (videoSessionLanguageRetrieveResponse200) & {
  headers: Headers;
};
;

export type videoSessionLanguageRetrieveResponse = (videoSessionLanguageRetrieveResponseSuccess)

export const getVideoSessionLanguageRetrieveUrl = (videoSessionId: number,) => {




  return `/api/video-session/language/${videoSessionId}/`
}

/**
 * Gets learner language given video session id
 */
export const videoSessionLanguageRetrieve = async (videoSessionId: number, options?: Parameters<typeof customFetch>[1]): Promise<videoSessionLanguageRetrieveResponse> => {

  return customFetch<videoSessionLanguageRetrieveResponse>(getVideoSessionLanguageRetrieveUrl(videoSessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getVideoSessionLanguageRetrieveQueryKey = (videoSessionId: number,) => {
    return [
    `/api/video-session/language/${videoSessionId}/`
    ] as const;
    }


export const getVideoSessionLanguageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError = unknown>(videoSessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getVideoSessionLanguageRetrieveQueryKey(videoSessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>> = ({ signal }) => videoSessionLanguageRetrieve(videoSessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: videoSessionId !== null && videoSessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type VideoSessionLanguageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>>
export type VideoSessionLanguageRetrieveQueryError = unknown


export function useVideoSessionLanguageRetrieve<TData = Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError = unknown>(
 videoSessionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVideoSessionLanguageRetrieve<TData = Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError = unknown>(
 videoSessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useVideoSessionLanguageRetrieve<TData = Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError = unknown>(
 videoSessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useVideoSessionLanguageRetrieve<TData = Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError = unknown>(
 videoSessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videoSessionLanguageRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVideoSessionLanguageRetrieveQueryOptions(videoSessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
